(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecfe2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecfe2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("99uU9", function(module, exports) {

$parcel$export(module.exports, "capture", function () { return $6a9ced5d0566b27e$export$6f6534ba0edb1cf4; });
$parcel$export(module.exports, "getFeatureFlagVariant", function () { return $6a9ced5d0566b27e$export$817a67b76d2edb25; });
$parcel$export(module.exports, "watchFeatureFlagVariant", function () { return $6a9ced5d0566b27e$export$3fb822aa96f510db; });
$parcel$export(module.exports, "init", function () { return $6a9ced5d0566b27e$export$2cd8252107eb640b; });
$parcel$export(module.exports, "recordClsMutation", function () { return $6a9ced5d0566b27e$export$694bf1eac6b0d55c; });
$parcel$export(module.exports, "captureException", function () { return $6a9ced5d0566b27e$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $6a9ced5d0566b27e$export$45654777c133ae80; });

var $jThtn = parcelRequire("jThtn");
parcelRequire("35uzy");
var $3tWZA = parcelRequire("3tWZA");

var $2ySnN = parcelRequire("2ySnN");

var $9f8N2 = parcelRequire("9f8N2");

var $f3UsM = parcelRequire("f3UsM");

var $eE0qw = parcelRequire("eE0qw");

var $H9wys = parcelRequire("H9wys");
// Exception types and message substrings confirmed as third-party / browser
// noise: zero stack frames and no actionable signal in our code.
const $6a9ced5d0566b27e$var$NOISE_EXCEPTION_TYPES = new Set([
    "HTMLScriptElement",
    "HTMLLinkElement",
    "CustomEvent",
    "Event"
]);
const $6a9ced5d0566b27e$var$NOISE_MESSAGE_SUBSTRINGS = [
    "ResizeObserver loop completed",
    "Object Not Found Matching Id",
    "runtime.sendMessage",
    "Script error.",
    // Brave Shields cosmetic-filtering content script (MTN-1238).
    "standardSelectors",
    // Cross-realm browser-extension search widget (MTN-1238).
    "showSearchResults",
    // iOS Safari extension content script (MTN-1310).
    "contentScriptData",
    // Android WebView bridge in in-app browsers (Facebook, for example): the
    // host app tears down the WebView while its injected @JavascriptInterface
    // handler is still running (MTN-1310).
    "Java object is gone",
    // iOS/macOS counterpart: WKWebView's injected postMessage handler outlives
    // the host app's API client during teardown (MTN-1310).
    "WKWebView API client did not respond",
    // Third message variant of the same WKWebView teardown (MTN-1350).
    "WKWebView was deallocated"
];
// Stack frames that are by construction never first-party code. WebKit
// reports scripts it can't attribute to the page as
// "webkit-masked-url://hidden/" (MTN-1310); Safari can also hand over an
// extension's real on-disk file:// path (for example PayPal Honey's
// Extension.appex bundle), and other browsers use their extension schemes
// (MTN-1350). The server fingerprints on minified frame offsets, so each
// extension release mints a fresh issue.
const $6a9ced5d0566b27e$var$NON_PAGE_FRAME_PREFIXES = [
    "webkit-masked-url://",
    // Safe to treat as non-page even though it isn't an extension scheme:
    // first-party MTN pages never use file://. beforeSend also drops cookieless
    // file contexts because their payload has no $host.
    "file://",
    "safari-extension://",
    "safari-web-extension://",
    "chrome-extension://",
    "moz-extension://"
];
// Runtime-internal frames that attribute to no script; they must not veto the
// non-page verdict (extension async rejections interleave them, MTN-1350) and
// must not establish it either. Missing and empty filenames are likewise
// neutral, via the truthiness check in the loop below.
const $6a9ced5d0566b27e$var$NEUTRAL_FRAME_FILENAMES = new Set([
    "[native code]",
    "<anonymous>"
]);
// True when the stack has at least one non-page frame and every other
// frame is neutral. Keep a mixed stack that has any attributable frame;
// that could be first-party code.
const $6a9ced5d0566b27e$var$hasOnlyNonPageFrames = (exception)=>{
    const frames = exception.stacktrace?.frames;
    if (!frames?.length) return false;
    let sawNonPage = false;
    for (const { filename: filename } of frames){
        if ($6a9ced5d0566b27e$var$NON_PAGE_FRAME_PREFIXES.some((p)=>filename?.startsWith(p))) sawNonPage = true;
        else if (filename && !$6a9ced5d0566b27e$var$NEUTRAL_FRAME_FILENAMES.has(filename)) return false;
    }
    return sawNonPage;
};
// Frame-less ObjectCoercer-wrapped messages confirmed as extension /
// third-party noise (MTN-1297, MTN-1310). Exact inner-message match gated on
// the frame-less synthetic wrapper shape below, so a stack-bearing application
// error with the same text still captures.
const $6a9ced5d0566b27e$var$NOISE_COERCED_MESSAGES = new Set([
    // Safari 26 web-vitals@5.3.0 interaction-cleanup crash (MTN-1297);
    // hasOnlyNonPageFrames covers the stack-bearing native shape of the same
    // crash, whose frames are all webkit-masked.
    "null is not an object (evaluating 'o.id')",
    // Frame-less twins of webkit-masked Safari extension errors (MTN-1310).
    "operation timed out",
    "Cannot call a class as a function",
    "Can't find variable: observer",
    "Message Timeout",
    // Brave Shields cosmetic-filtering content script (MTN-1310).
    "undefined is not an object (evaluating 't[r]')"
]);
// Browser-native messages for an aborted/failed fetch network request: tab
// closing mid-flight, ad-blocker / antivirus interception, captive portal,
// CSP violation, etc. Each browser uses a fixed message, so we match exactly
// to avoid catching application-level messages that happen to begin with
// "Failed to fetch" (an app-thrown Error whose message starts that way, say).
//
// Tradeoff: real operational regressions (CORS misconfig, origin outage,
// endpoint deletion) at fetch call sites also surface with these messages, and
// this filter suppresses them. Net win because user-side noise dominates by
// orders of magnitude; if we need to investigate a real outage, server-side
// signals (Cloudflare, Pagely, PostHog server-side) are the right source.
const $6a9ced5d0566b27e$var$NOISE_NETWORK_TYPEERROR_MESSAGES = new Set([
    "Failed to fetch",
    "Load failed",
    "NetworkError when attempting to fetch resource.",
    "cancelled"
]);
// Recommender Errors from util/recommender.js for edge-bot / rate-limit
// statuses — symmetric to SUPPRESSED_NON_JSON_STATUSES in util/fetch.js.
// Other 4xx and all 5xx still surface so real outages remain visible.
const $6a9ced5d0566b27e$var$NOISE_MTN_API_ERROR_MESSAGES = new Set([
    "MTN API error: 401",
    "MTN API error: 403",
    "MTN API error: 429"
]);
// posthog-js ObjectCoercer wraps non-standard/cross-realm Error-like values in
// two quoted fields. PostHog server fingerprint v2 masks both quoted fields,
// collapsing unrelated frame-less errors into one issue (MTN-956).
const $6a9ced5d0566b27e$var$OBJECT_COERCER_FINGERPRINT_PREFIX = "mtn-object-coercer-v1:";
const $6a9ced5d0566b27e$var$OBJECT_COERCER_VALUE_PATTERN = /^'([\s\S]*)' captured as exception with message: '([\s\S]*)'$/;
const $6a9ced5d0566b27e$var$getObjectCoercerException = (value)=>{
    const match = value.match($6a9ced5d0566b27e$var$OBJECT_COERCER_VALUE_PATTERN);
    return match ? {
        message: match[2],
        type: match[1]
    } : null;
};
// The shape posthog-js produces from window.onerror when the browser reports
// an error it can't attribute to any script.
const $6a9ced5d0566b27e$var$isFramelessSynthetic = (exception)=>exception.mechanism?.synthetic === true && exception.mechanism?.type === "generic" && !exception.stacktrace?.frames?.length;
// Browser-level messages with no stack to act on, mapped to their exception
// type. Exact match gated on the frame-less synthetic shape below, so a
// stack-bearing error with the same message still captures.
const $6a9ced5d0566b27e$var$NOISE_FRAMELESS_MESSAGES = new Map([
    // Firefox allocation failure (MTN-1350).
    [
        "out of memory",
        "Error"
    ],
    // Firefox raises this only for add-on code that touches a DOM object from a
    // destroyed document. One extension fired it on timers in every open MTN
    // tab, as often as every 72 seconds (MTN-1813).
    [
        "can't access dead object",
        "TypeError"
    ]
]);
const $6a9ced5d0566b27e$var$isObjectCoercerFingerprintCollision = (exception, type, value)=>type === "Error" && $6a9ced5d0566b27e$var$isFramelessSynthetic(exception) && $6a9ced5d0566b27e$var$OBJECT_COERCER_VALUE_PATTERN.test(value);
// Automated/headless clients: crawlers and preview renderers (syndication
// partners re-rendering our slideshows, for example) that drive real Chrome
// under automation.
// They present a clean UA, so PostHog's UA-based bot filter misses them, but
// they paint ~16s late under CPU starvation and wrecked $web_vitals percentiles
// on low-traffic pages — three slideshow URLs read p75 LCP 21–25s that was 100%
// this cohort, while real users on the same pages saw <1s (MTN-953).
// navigator.webdriver is the WebDriver-spec automation flag: false for real
// users, true for Puppeteer/Playwright/Selenium/CDP-driven Chrome — so dropping
// on it has no real-user false positives (`=== true` also no-ops when the
// property is undefined on older browsers). This also drops our own headless
// smoke / critical-CSS runs, which is desirable. Caveat: it drops local
// capture-pipeline testing via headless Puppeteer too — exercise capture in dev
// from a non-automated browser.
const $6a9ced5d0566b27e$var$isAutomatedClient = ()=>typeof navigator !== "undefined" && navigator.webdriver === true;
// posthog.test.js checks this list against the SDK's own CAMPAIGN_PARAMS.
const $6a9ced5d0566b27e$var$CHANNEL_TAGS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid",
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "oppref",
    "irclid",
    "_kx"
];
// A PostHog session can start during site navigation. Its new session-entry
// referrer then points back to MTN, which PostHog classifies as Referral unless
// we mark that untagged self-referral as direct (MTN-1397).
const $6a9ced5d0566b27e$var$normalizeSelfReferral = (properties)=>{
    const currentHost = properties?.$host;
    if (!currentHost || properties.$session_entry_referring_domain !== currentHost || $6a9ced5d0566b27e$var$CHANNEL_TAGS.some((tag)=>properties[`$session_entry_${tag}`])) return;
    if (properties.$referring_domain === currentHost) {
        properties.$referrer = "$direct";
        properties.$referring_domain = "$direct";
    }
    properties.$session_entry_referrer = "$direct";
    properties.$session_entry_referring_domain = "$direct";
};
const $6a9ced5d0566b27e$var$shouldCaptureWebVitals = (sessionId)=>{
    if (!sessionId) return false;
    let bucket = 7;
    for (const character of sessionId)bucket = (bucket * 37 + character.charCodeAt(0)) % 10;
    return bucket === 0;
};
const $6a9ced5d0566b27e$var$shouldDropPreCaptureEvent = (event)=>{
    const properties = event?.properties;
    // Cookieless identification hashes $host + IP + UA, so an absent host would
    // assign traffic to the wrong site (MTN-1310).
    if (properties?.$cookieless_mode && !properties.$host) return true;
    return event?.event === "$web_vitals" && !$6a9ced5d0566b27e$var$shouldCaptureWebVitals(properties?.$session_id);
};
const $6a9ced5d0566b27e$var$addDefaultEventProperties = (properties)=>{
    if (!properties) return;
    if (properties.environment === undefined) properties.environment = (0, $eE0qw.getEnvironment)();
    if (properties.release === undefined) properties.release = `mtn@${0, $2ySnN.version}`;
};
const $6a9ced5d0566b27e$export$37d234770c55da75 = (event)=>{
    // The SDK sends its initial pageview before loaded() can register super
    // properties. Add defaults here so automatic events receive the same tags
    // without a second, manual pageview.
    $6a9ced5d0566b27e$var$addDefaultEventProperties(event?.properties);
    if ($6a9ced5d0566b27e$var$isAutomatedClient()) return null;
    if ($6a9ced5d0566b27e$var$shouldDropPreCaptureEvent(event)) return null;
    $6a9ced5d0566b27e$var$normalizeSelfReferral(event?.properties);
    if (event?.event !== "$exception") return event;
    // PostHog parses UA into $browser/$os but strips the raw string, so in-app
    // WebViews (Facebook, Instagram, TikTok) are indistinguishable from Mobile
    // Safari at triage time. Tag exceptions only — keeps the cost off pageviews.
    if (event.properties) event.properties.mtn_raw_user_agent = navigator.userAgent;
    const ex = event.properties?.$exception_list?.[0];
    if (!ex) return event;
    const type = ex.type ?? ex.$exception_type ?? "";
    const value = ex.value ?? ex.$exception_value ?? "";
    const objectCoercerException = $6a9ced5d0566b27e$var$getObjectCoercerException(value);
    // Drop chunk-reload duplicates. The handler in util/chunk-reload.js arms a
    // flag when it triggers a reload; parallel or later dynamic-import failures
    // in the same page load are duplicates with no diagnostic value, and the
    // first event on a post-reload page passes through as the kill metric.
    // posthog-js v1.372 captures via `window.onunhandledrejection` (property
    // assignment), so this is the only layer that can suppress the duplicates —
    // see MTN-366. Browser chunk fetches are TypeErrors; Parcel's synchronous
    // missing-module runtime throw is an Error (MTN-1201).
    if ((type === "TypeError" || type === "Error") && (0, $9f8N2.shouldDropChunkException)(value)) return null;
    if ($6a9ced5d0566b27e$var$NOISE_EXCEPTION_TYPES.has(type) || $6a9ced5d0566b27e$var$NOISE_MESSAGE_SUBSTRINGS.some((s)=>value.includes(s)) || $6a9ced5d0566b27e$var$hasOnlyNonPageFrames(ex) || $6a9ced5d0566b27e$var$isFramelessSynthetic(ex) && $6a9ced5d0566b27e$var$NOISE_FRAMELESS_MESSAGES.get(value) === type || type === "TypeError" && $6a9ced5d0566b27e$var$NOISE_NETWORK_TYPEERROR_MESSAGES.has(value) || objectCoercerException?.type === "TypeError" && $6a9ced5d0566b27e$var$NOISE_NETWORK_TYPEERROR_MESSAGES.has(objectCoercerException.message) || $6a9ced5d0566b27e$var$isObjectCoercerFingerprintCollision(ex, type, value) && $6a9ced5d0566b27e$var$NOISE_COERCED_MESSAGES.has(objectCoercerException.message) || type === "Error" && $6a9ced5d0566b27e$var$NOISE_MTN_API_ERROR_MESSAGES.has(value)) return null;
    if (// biome-ignore lint/suspicious/noPrototypeBuiltins: Object.hasOwn is unavailable in some browsers targeted by browserslist defaults.
    !Object.prototype.hasOwnProperty.call(event.properties, "$exception_fingerprint") && $6a9ced5d0566b27e$var$isObjectCoercerFingerprintCollision(ex, type, value)) event.properties.$exception_fingerprint = `${$6a9ced5d0566b27e$var$OBJECT_COERCER_FINGERPRINT_PREFIX}${type}:${value}`;
    return event;
};
// Mirrors PostHog's distinct_id into an mtn-* cookie so Tune-Out can attach it
// to affiliate clicks, letting Tune-Postback fire conversions with the same
// distinct_id. Called only after Termly confirms analytics consent.
const $6a9ced5d0566b27e$var$clearDistinctIdCookie = ()=>{
    (0, $f3UsM.remove)("mtn-posthog-distinct-id");
};
const $6a9ced5d0566b27e$var$syncDistinctIdCookie = ()=>{
    const distinctId = (0, $jThtn.default).get_distinct_id();
    if (!distinctId) return;
    // Host-only since MTN-321: the sole consumer, the Tune-Out Worker at
    // /out/*, reads it on the page's own host. A pre-MTN-321 parent-domain
    // copy keeps satisfying setIfChanged (and Tune-Out) until it ages out,
    // then the next load writes host-only. setIfChanged keeps a page load
    // alone from renewing the 91-day retention — the cookie refreshes only
    // when PostHog rotates the distinct ID or after the mirror itself expires.
    (0, $f3UsM.setIfChanged)("mtn-posthog-distinct-id", distinctId, {
        days: 91
    });
};
const $6a9ced5d0566b27e$var$CLS_DIAGNOSTIC_THRESHOLD = 0.1;
const $6a9ced5d0566b27e$var$CLS_DIAGNOSTIC_MIN_DELTA = 0.05;
const $6a9ced5d0566b27e$var$CLS_DIAGNOSTIC_LATE_SHIFT_MS = 5000;
const $6a9ced5d0566b27e$var$CLS_DIAGNOSTIC_MUTATION_WINDOW_MS = 15000;
const $6a9ced5d0566b27e$var$CLS_DIAGNOSTIC_MUTATION_LIMIT = 20;
const $6a9ced5d0566b27e$var$clsMutationMarks = [];
let $6a9ced5d0566b27e$var$clsDiagnosticReports = 0;
let $6a9ced5d0566b27e$var$clsDiagnosticLastValue = 0;
let $6a9ced5d0566b27e$var$clsDiagnosticReportedHidden = false;
// Tag every cookieless-mode entry path so the cookieless/cookied mix is
// diagnosable in PostHog: a HogQL group-by on
// `properties.mtn_opt_out_reason` for cookieless distinct_ids reveals which
// path dominates (timer firing, real load failure, or genuine user reject).
// posthog.register() writes to in-memory persistence, so the property rides
// every event the SDK fires after the call — including the cookieless
// _captureInitialPageview() that opt_out_capturing triggers.
const $6a9ced5d0566b27e$var$optOutWithReason = (reason)=>{
    $6a9ced5d0566b27e$var$clearDistinctIdCookie();
    (0, $jThtn.default).set_config({
        advanced_disable_feature_flags: true
    });
    (0, $jThtn.default).register({
        mtn_opt_out_reason: reason
    });
    (0, $jThtn.default).opt_out_capturing({
        captureEventName: null
    });
};
const $6a9ced5d0566b27e$var$now = ()=>Math.round(window.performance?.now?.() || 0);
const $6a9ced5d0566b27e$var$ensureArrayAt = ()=>{
    if (Array.prototype.at) return;
    Object.defineProperty(Array.prototype, "at", {
        configurable: true,
        enumerable: false,
        value (index) {
            const length = Number(this.length) || 0;
            if (length === 0) return;
            const relativeIndex = Math.trunc(Number(index) || 0);
            const targetIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
            if (targetIndex < 0 || targetIndex >= length) return;
            return this[targetIndex];
        },
        writable: true
    });
};
const $6a9ced5d0566b27e$var$roundMetric = (value)=>{
    if (typeof value !== "number" || Number.isNaN(value)) return null;
    return Math.round(value * 1000) / 1000;
};
const $6a9ced5d0566b27e$var$cleanMarkerValue = (value)=>{
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean" || value === null) return value;
};
const $6a9ced5d0566b27e$var$recentClsMutations = ()=>{
    const pageAge = $6a9ced5d0566b27e$var$now();
    return $6a9ced5d0566b27e$var$clsMutationMarks.filter((mark)=>pageAge - mark.page_age_ms <= $6a9ced5d0566b27e$var$CLS_DIAGNOSTIC_MUTATION_WINDOW_MS);
};
const $6a9ced5d0566b27e$var$rectProperties = (prefix, rect)=>{
    if (!rect) return {};
    return {
        [`${prefix}_top`]: $6a9ced5d0566b27e$var$roundMetric(rect.top),
        [`${prefix}_right`]: $6a9ced5d0566b27e$var$roundMetric(rect.right),
        [`${prefix}_bottom`]: $6a9ced5d0566b27e$var$roundMetric(rect.bottom),
        [`${prefix}_left`]: $6a9ced5d0566b27e$var$roundMetric(rect.left),
        [`${prefix}_width`]: $6a9ced5d0566b27e$var$roundMetric(rect.width),
        [`${prefix}_height`]: $6a9ced5d0566b27e$var$roundMetric(rect.height)
    };
};
const $6a9ced5d0566b27e$var$shouldCaptureClsDiagnostic = (metric)=>{
    if (metric.value < $6a9ced5d0566b27e$var$CLS_DIAGNOSTIC_THRESHOLD) return false;
    const pageIsHidden = document.visibilityState === "hidden";
    if (pageIsHidden && !$6a9ced5d0566b27e$var$clsDiagnosticReportedHidden) {
        $6a9ced5d0566b27e$var$clsDiagnosticReportedHidden = true;
        return true;
    }
    if ($6a9ced5d0566b27e$var$clsDiagnosticReports === 0) return true;
    return metric.value - $6a9ced5d0566b27e$var$clsDiagnosticLastValue >= $6a9ced5d0566b27e$var$CLS_DIAGNOSTIC_MIN_DELTA;
};
const $6a9ced5d0566b27e$var$captureClsDiagnostic = (metric)=>{
    if (!$6a9ced5d0566b27e$var$shouldCaptureClsDiagnostic(metric)) return;
    $6a9ced5d0566b27e$var$clsDiagnosticReports += 1;
    $6a9ced5d0566b27e$var$clsDiagnosticLastValue = metric.value;
    const attribution = metric.attribution || {};
    const source = attribution.largestShiftSource || {};
    const recentMutations = $6a9ced5d0566b27e$var$recentClsMutations();
    const [latestMutation] = recentMutations.slice(-1);
    const { largestShiftTime: largestShiftTime } = attribution;
    $6a9ced5d0566b27e$export$6f6534ba0edb1cf4("cls_diagnostic_recorded", {
        had_recent_adsense: recentMutations.some((mark)=>mark.type.startsWith("adsense_")),
        had_recent_auto_block: recentMutations.some((mark)=>mark.type === "auto_block_populated"),
        had_recent_smartasset_iframe: recentMutations.some((mark)=>mark.type === "smartasset_iframe_inserted"),
        is_late_shift: typeof largestShiftTime === "number" && largestShiftTime >= $6a9ced5d0566b27e$var$CLS_DIAGNOSTIC_LATE_SHIFT_MS || attribution.loadState === "complete",
        largest_shift_load_state: attribution.loadState,
        largest_shift_target: attribution.largestShiftTarget,
        largest_shift_time_ms: $6a9ced5d0566b27e$var$roundMetric(largestShiftTime),
        largest_shift_value: $6a9ced5d0566b27e$var$roundMetric(attribution.largestShiftValue),
        latest_mutation_age_ms: latestMutation ? $6a9ced5d0566b27e$var$now() - latestMutation.page_age_ms : null,
        latest_mutation_type: latestMutation?.type,
        metric_delta: $6a9ced5d0566b27e$var$roundMetric(metric.delta),
        metric_entries_count: metric.entries?.length || 0,
        metric_id: metric.id,
        metric_rating: metric.rating,
        metric_value: $6a9ced5d0566b27e$var$roundMetric(metric.value),
        mtn_ads_enabled: !!window.mtnAdsEnabled,
        page_age_ms: $6a9ced5d0566b27e$var$now(),
        page_visibility_state: document.visibilityState,
        path: window.location.pathname,
        recent_mutation_count: recentMutations.length,
        recent_mutation_types: recentMutations.map((mark)=>mark.type),
        recent_mutations: recentMutations.slice(-6),
        scroll_y: Math.round(window.scrollY),
        shift_source_node_name: source.node?.nodeName,
        url: `${window.location.origin}${window.location.pathname}`,
        viewport_height: window.innerHeight,
        viewport_width: window.innerWidth,
        ...$6a9ced5d0566b27e$var$rectProperties("source_previous", source.previousRect),
        ...$6a9ced5d0566b27e$var$rectProperties("source_current", source.currentRect)
    }, {
        send_instantly: true,
        transport: "sendBeacon"
    });
};
const $6a9ced5d0566b27e$var$initClsDiagnostics = (environment)=>{
    if (![
        "production",
        "staging"
    ].includes(environment)) return;
    $6a9ced5d0566b27e$var$ensureArrayAt();
    (0, $3tWZA.onCLS)($6a9ced5d0566b27e$var$captureClsDiagnostic, {
        reportAllChanges: true
    });
};
let $6a9ced5d0566b27e$var$initialized = false;
let $6a9ced5d0566b27e$var$featureFlagsReady = false;
let $6a9ced5d0566b27e$var$hasAnalyticsConsent = false;
const $6a9ced5d0566b27e$var$clearFeatureFlags = ()=>{
    $6a9ced5d0566b27e$var$featureFlagsReady = false;
};
const $6a9ced5d0566b27e$export$817a67b76d2edb25 = (key, safeFallback)=>{
    if (!($6a9ced5d0566b27e$var$hasAnalyticsConsent && $6a9ced5d0566b27e$var$featureFlagsReady)) return safeFallback;
    const variant = (0, $jThtn.default).getFeatureFlag(key);
    return typeof variant === "string" || typeof variant === "boolean" ? variant : safeFallback;
};
const $6a9ced5d0566b27e$export$3fb822aa96f510db = (key, callback)=>{
    const check = (_flags, _variants, { errorsLoading: errorsLoading } = {})=>{
        if (errorsLoading) callback(null);
        else if ($6a9ced5d0566b27e$var$hasAnalyticsConsent && $6a9ced5d0566b27e$var$featureFlagsReady) callback((0, $jThtn.default).is_capturing() && (0, $jThtn.default).get_distinct_id() ? (0, $jThtn.default).getFeatureFlag(key, {
            send_event: false
        }) ?? null : null);
    };
    const stopFlags = (0, $jThtn.default).onFeatureFlags(check);
    const stopConsent = (0, $H9wys.watchCategory)((0, $H9wys.CATEGORIES).ANALYTICS, (allowed)=>{
        if (!allowed) callback(null);
    });
    check();
    return ()=>{
        stopFlags();
        stopConsent();
    };
};
// Pre-consent capture buffer (MTN-620). With cookieless_mode "on_reject" the
// SDK's is_capturing() is false while explicit consent is pending, so every
// capture fired before Termly resolves — early exceptions, CLS diagnostics,
// newsletter_subscribed on /thank-you/ for first-time visitors — was silently
// dropped. (chunk_reload_triggered stays lost in the pending window: its
// caller reloads the page 50ms after capturing, long before any drain.)
// The capture family buffers those calls and drains the buffer exactly once
// when consent resolves:
//   grant → flush cookied; explicit reject → discard (parity with the SDK's
//   own drop-on-reject); CMP-failure fallback → flush cookieless, matching
//   the anonymous initial-pageview replay the SDK already does there.
// A single drain means a late Termly grant after the fallback can't
// double-fire buffered events. Null marks the buffer as drained.
let $6a9ced5d0566b27e$var$pendingCaptures = [];
const $6a9ced5d0566b27e$var$MEMBERFUL_ORDER_UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const $6a9ced5d0566b27e$var$clearMemberfulOrderUuid = ()=>{
    Reflect.deleteProperty(window, "mtnMemberfulOrderUuid");
};
const $6a9ced5d0566b27e$var$captureMemberfulOrderReturn = ()=>{
    const orderUuid = window.mtnMemberfulOrderUuid;
    $6a9ced5d0566b27e$var$clearMemberfulOrderUuid();
    if (typeof orderUuid === "string" && $6a9ced5d0566b27e$var$MEMBERFUL_ORDER_UUID_PATTERN.test(orderUuid)) (0, $jThtn.default).capture("memberful_checkout_returned", {
        memberful_order_uuid: orderUuid.toLowerCase()
    });
};
const $6a9ced5d0566b27e$var$runOrBuffer = (fn)=>{
    // Visitors whose SDK consent is already stored (returning grant, returning
    // reject → cookieless, DNT) capture immediately, exactly as before.
    if ($6a9ced5d0566b27e$var$pendingCaptures && !($6a9ced5d0566b27e$var$initialized && (0, $jThtn.default).is_capturing())) {
        $6a9ced5d0566b27e$var$pendingCaptures.push(fn);
        return;
    }
    fn();
};
const $6a9ced5d0566b27e$var$drainPendingCaptures = (flush)=>{
    const buffered = $6a9ced5d0566b27e$var$pendingCaptures;
    $6a9ced5d0566b27e$var$pendingCaptures = null;
    if (flush) for (const fn of buffered ?? [])fn();
};
const $6a9ced5d0566b27e$export$2cd8252107eb640b = ()=>{
    if ($6a9ced5d0566b27e$var$initialized) return;
    $6a9ced5d0566b27e$var$initialized = true;
    const environment = (0, $eE0qw.getEnvironment)();
    (0, $jThtn.default).init("phc_sF3C2mVidswocgru8rfmPb47k7QLaCTPx3aDzzALRnFN", {
        advanced_disable_feature_flags: true,
        advanced_disable_feature_flags_on_first_load: true,
        advanced_feature_flags_dedup_per_session: true,
        api_host: "https://hg.moneytalksnews.com",
        autocapture: false,
        before_send: $6a9ced5d0566b27e$export$37d234770c55da75,
        capture_pageleave: true,
        capture_pageview: "history_change",
        cookieless_mode: "on_reject",
        debug: environment === "development",
        defaults: "2026-01-30",
        disable_session_recording: true,
        feature_flag_cache_ttl_ms: 300000,
        loaded: ()=>{
            // Register super properties before wiring the consent watchers: when
            // Termly has already resolved, watchCategory reports synchronously and
            // the buffer flush below would otherwise ship events without
            // environment/release.
            (0, $jThtn.default).register({
                environment: environment,
                release: `mtn@${(0, $2ySnN.version)}`
            });
            (0, $jThtn.default).onFeatureFlags((_flags, _variants, { errorsLoading: errorsLoading } = {})=>{
                $6a9ced5d0566b27e$var$featureFlagsReady = !errorsLoading;
            });
            (0, $H9wys.onUnavailable)((reason)=>{
                $6a9ced5d0566b27e$var$clearMemberfulOrderUuid();
                if ((0, $jThtn.default).get_explicit_consent_status() === "pending") {
                    $6a9ced5d0566b27e$var$hasAnalyticsConsent = false;
                    $6a9ced5d0566b27e$var$clearFeatureFlags();
                    $6a9ced5d0566b27e$var$optOutWithReason(reason);
                }
                $6a9ced5d0566b27e$var$drainPendingCaptures(true);
            }, {
                timeoutMs: 8000
            });
            (0, $H9wys.watchCategory)((0, $H9wys.CATEGORIES).ANALYTICS, (hasAnalytics)=>{
                if (hasAnalytics) {
                    $6a9ced5d0566b27e$export$f23d971332d318c6();
                    $6a9ced5d0566b27e$var$captureMemberfulOrderReturn();
                    $6a9ced5d0566b27e$var$drainPendingCaptures(true);
                } else {
                    $6a9ced5d0566b27e$var$clearMemberfulOrderUuid();
                    $6a9ced5d0566b27e$var$hasAnalyticsConsent = false;
                    $6a9ced5d0566b27e$var$clearFeatureFlags();
                    $6a9ced5d0566b27e$var$optOutWithReason("termly_reject");
                    $6a9ced5d0566b27e$var$drainPendingCaptures(false);
                }
            });
        },
        person_profiles: "identified_only"
    });
    $6a9ced5d0566b27e$var$initClsDiagnostics(environment);
};
const $6a9ced5d0566b27e$export$f23d971332d318c6 = ()=>{
    $6a9ced5d0566b27e$var$clearFeatureFlags();
    const currentUserId = window.mtnUser?.id === undefined ? undefined : String(window.mtnUser.id);
    const persistedUserId = (0, $jThtn.default).get_property("$user_id");
    if (persistedUserId && String(persistedUserId) !== currentUserId) {
        (0, $jThtn.default).reset();
        $6a9ced5d0566b27e$var$clearDistinctIdCookie();
        $6a9ced5d0566b27e$var$clearFeatureFlags();
    }
    $6a9ced5d0566b27e$var$hasAnalyticsConsent = true;
    // Clear any stale opt-out reason from a prior cookieless session in the
    // same tab — without this, events fired post-upgrade would carry the
    // earlier reason and skew the diagnostic group-by.
    (0, $jThtn.default).unregister("mtn_opt_out_reason");
    // Suppress $opt_in re-emission on page-load reapplies; only emit on new grants.
    if ((0, $jThtn.default).has_opted_in_capturing()) (0, $jThtn.default).opt_in_capturing({
        captureEventName: null
    });
    else (0, $jThtn.default).opt_in_capturing();
    if (window.mtnUser?.id) (0, $jThtn.default).identify(String(window.mtnUser.id), {
        is_member: !!window.mtnUser.hasPaidPlan,
        is_staff: !!window.mtnUser.isStaff
    });
    $6a9ced5d0566b27e$var$syncDistinctIdCookie();
    (0, $jThtn.default).set_config({
        advanced_disable_feature_flags: false
    });
    (0, $jThtn.default).reloadFeatureFlags();
};
const $6a9ced5d0566b27e$export$694bf1eac6b0d55c = (type, properties = {})=>{
    const cleanProperties = {};
    for (const [key, value] of Object.entries(properties)){
        const cleanValue = $6a9ced5d0566b27e$var$cleanMarkerValue(value);
        if (cleanValue !== undefined) cleanProperties[key] = cleanValue;
    }
    $6a9ced5d0566b27e$var$clsMutationMarks.push({
        page_age_ms: $6a9ced5d0566b27e$var$now(),
        type: type,
        ...cleanProperties
    });
    if ($6a9ced5d0566b27e$var$clsMutationMarks.length > $6a9ced5d0566b27e$var$CLS_DIAGNOSTIC_MUTATION_LIMIT) $6a9ced5d0566b27e$var$clsMutationMarks.splice(0, $6a9ced5d0566b27e$var$clsMutationMarks.length - $6a9ced5d0566b27e$var$CLS_DIAGNOSTIC_MUTATION_LIMIT);
};
const $6a9ced5d0566b27e$export$6f6534ba0edb1cf4 = (eventName, properties, options)=>$6a9ced5d0566b27e$var$runOrBuffer(()=>(0, $jThtn.default).capture(eventName, properties, options));
const $6a9ced5d0566b27e$export$f5282963edea4a68 = (error, properties)=>$6a9ced5d0566b27e$var$runOrBuffer(()=>(0, $jThtn.default).captureException(error, properties));
const $6a9ced5d0566b27e$export$45654777c133ae80 = (message, properties)=>{
    // Construct the Error at call time so a buffered flush keeps the
    // caller's stack instead of the drain loop's.
    const error = new Error(message);
    $6a9ced5d0566b27e$var$runOrBuffer(()=>(0, $jThtn.default).captureException(error, {
            level: "error",
            ...properties
        }));
};
const $6a9ced5d0566b27e$export$8b6bb3dd62a01be2 = (userId, properties)=>(0, $jThtn.default).identify(String(userId), properties);

});
parcelRegister("jThtn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fb0e9cf977607be$export$2e2bcd8739ae039; });
const $0fb0e9cf977607be$var$t = "u" > typeof window ? window : void 0, $0fb0e9cf977607be$var$i = "u" > typeof globalThis ? globalThis : $0fb0e9cf977607be$var$t, $0fb0e9cf977607be$var$e = null == $0fb0e9cf977607be$var$i ? void 0 : $0fb0e9cf977607be$var$i.navigator, $0fb0e9cf977607be$var$s = null == $0fb0e9cf977607be$var$i ? void 0 : $0fb0e9cf977607be$var$i.document, $0fb0e9cf977607be$var$n = null == $0fb0e9cf977607be$var$i ? void 0 : $0fb0e9cf977607be$var$i.location, $0fb0e9cf977607be$var$r = null == $0fb0e9cf977607be$var$i ? void 0 : $0fb0e9cf977607be$var$i.fetch, $0fb0e9cf977607be$var$o = (null == $0fb0e9cf977607be$var$i ? void 0 : $0fb0e9cf977607be$var$i.XMLHttpRequest) && "withCredentials" in new $0fb0e9cf977607be$var$i.XMLHttpRequest ? $0fb0e9cf977607be$var$i.XMLHttpRequest : void 0, $0fb0e9cf977607be$var$l = null == $0fb0e9cf977607be$var$i ? void 0 : $0fb0e9cf977607be$var$i.AbortController, $0fb0e9cf977607be$var$a = null == $0fb0e9cf977607be$var$i ? void 0 : $0fb0e9cf977607be$var$i.CompressionStream, $0fb0e9cf977607be$var$u = null == $0fb0e9cf977607be$var$e ? void 0 : $0fb0e9cf977607be$var$e.userAgent;
function $0fb0e9cf977607be$var$h() {
    return !(!$0fb0e9cf977607be$var$t || !1 === $0fb0e9cf977607be$var$t.navigator.onLine);
}
const $0fb0e9cf977607be$var$d = "undefined" != typeof globalThis ? globalThis : $0fb0e9cf977607be$var$t;
$0fb0e9cf977607be$var$d && "undefined" == typeof self && ($0fb0e9cf977607be$var$d.self = $0fb0e9cf977607be$var$d), $0fb0e9cf977607be$var$d && "undefined" == typeof File && ($0fb0e9cf977607be$var$d.File = function() {});
const $0fb0e9cf977607be$var$c = null != $0fb0e9cf977607be$var$t ? $0fb0e9cf977607be$var$t : {}, $0fb0e9cf977607be$var$v = "0.9.1", $0fb0e9cf977607be$var$f = {
    DEBUG: !1,
    LIB_VERSION: $0fb0e9cf977607be$var$v,
    LIB_NAME: "browser-common",
    JS_SDK_VERSION: $0fb0e9cf977607be$var$v
};
var $0fb0e9cf977607be$var$p = function(t) {
    return t.AnonymousId = "anonymous_id", t.DistinctId = "distinct_id", t.Props = "props", t.EnablePersonProcessing = "enable_person_processing", t.PersonMode = "person_mode", t.FeatureFlagDetails = "feature_flag_details", t.FeatureFlags = "feature_flags", t.FeatureFlagPayloads = "feature_flag_payloads", t.BootstrapFeatureFlagDetails = "bootstrap_feature_flag_details", t.BootstrapFeatureFlags = "bootstrap_feature_flags", t.BootstrapFeatureFlagPayloads = "bootstrap_feature_flag_payloads", t.OverrideFeatureFlags = "override_feature_flags", t.Queue = "queue", t.AiQueue = "ai_queue", t.AiCaptureQueue = "ai_capture_queue", t.LogsQueue = "logs_queue", t.OptedOut = "opted_out", t.SessionId = "session_id", t.SessionStartTimestamp = "session_start_timestamp", t.SessionLastTimestamp = "session_timestamp", t.PersonProperties = "person_properties", t.GroupProperties = "group_properties", t.InstalledAppBuild = "installed_app_build", t.InstalledAppVersion = "installed_app_version", t.SessionReplay = "session_replay", t.PushRegistered = "push_registered", t.SessionReplayEventTriggerActivatedSession = "session_replay_event_trigger_activated_session", t.SurveyLastSeenDate = "survey_last_seen_date", t.SurveysInProgress = "surveys_in_progress", t.SurveysSeen = "surveys_seen", t.Surveys = "surveys", t.RemoteConfig = "remote_config", t.FlagsEndpointWasHit = "flags_endpoint_was_hit", t.DeviceId = "device_id", t;
}({}), $0fb0e9cf977607be$var$_ = function(t) {
    return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
}({});
const $0fb0e9cf977607be$var$g = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
], $0fb0e9cf977607be$var$m = [
    "token"
];
function $0fb0e9cf977607be$var$b(t, i) {
    return -1 !== t.indexOf(i);
}
const $0fb0e9cf977607be$var$y = function(t) {
    return t.trim();
}, $0fb0e9cf977607be$var$w = function(t) {
    return t.replace(/^\$/, "");
};
function $0fb0e9cf977607be$var$S(t) {
    var i;
    const e = [];
    return null !== (i = JSON.stringify(t, function(t, i) {
        if ("bigint" == typeof i) return i.toString();
        if ("function" != typeof i && "symbol" != typeof i) {
            if (i instanceof Error) return {
                name: i.name,
                message: i.message,
                stack: i.stack
            };
            if (i && "object" == typeof i) {
                for(; e.length > 0 && e[e.length - 1] !== this;)e.pop();
                if (e.includes(i)) return "[Circular]";
                e.push(i);
            }
            return i;
        }
    })) && void 0 !== i ? i : "null";
}
const $0fb0e9cf977607be$var$x = Object.prototype, $0fb0e9cf977607be$var$E = $0fb0e9cf977607be$var$x.hasOwnProperty, $0fb0e9cf977607be$var$k = $0fb0e9cf977607be$var$x.toString, $0fb0e9cf977607be$var$T = Array.isArray || function(t) {
    return "[object Array]" === $0fb0e9cf977607be$var$k.call(t);
}, $0fb0e9cf977607be$var$P = (t)=>"function" == typeof t, $0fb0e9cf977607be$var$C = (t)=>t === Object(t) && !$0fb0e9cf977607be$var$T(t), $0fb0e9cf977607be$var$O = (t)=>{
    if ($0fb0e9cf977607be$var$C(t)) {
        for(const i in t)if ($0fb0e9cf977607be$var$E.call(t, i)) return !1;
        return !0;
    }
    return !1;
}, $0fb0e9cf977607be$var$R = (t)=>void 0 === t, $0fb0e9cf977607be$var$I = (t)=>"[object String]" == $0fb0e9cf977607be$var$k.call(t), $0fb0e9cf977607be$var$M = (t)=>$0fb0e9cf977607be$var$I(t) && 0 === t.trim().length, $0fb0e9cf977607be$var$A = (t)=>null === t, $0fb0e9cf977607be$var$F = (t)=>$0fb0e9cf977607be$var$R(t) || $0fb0e9cf977607be$var$A(t), $0fb0e9cf977607be$var$D = (t)=>"[object Number]" == $0fb0e9cf977607be$var$k.call(t) && t == t, $0fb0e9cf977607be$var$N = (t)=>$0fb0e9cf977607be$var$D(t) && t > 0, $0fb0e9cf977607be$var$j = (t)=>"[object Boolean]" === $0fb0e9cf977607be$var$k.call(t), $0fb0e9cf977607be$var$L = (t)=>$0fb0e9cf977607be$var$b($0fb0e9cf977607be$var$g, t), $0fb0e9cf977607be$var$B = (t)=>$0fb0e9cf977607be$var$b($0fb0e9cf977607be$var$m, t);
function $0fb0e9cf977607be$var$U(t) {
    return null === t || "object" != typeof t;
}
function $0fb0e9cf977607be$var$z(t, i) {
    return ({}).toString.call(t) === `[object ${i}]`;
}
function $0fb0e9cf977607be$var$H(t) {
    switch(({}).toString.call(t)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object DOMError]":
        case "[object WebAssembly.Exception]":
            return !0;
        default:
            return $0fb0e9cf977607be$var$V(t, Error);
    }
}
function $0fb0e9cf977607be$var$q(t) {
    return "u" > typeof Event && $0fb0e9cf977607be$var$V(t, Event);
}
function $0fb0e9cf977607be$var$V(t, i) {
    try {
        return t instanceof i;
    } catch (t) {
        return !1;
    }
}
const $0fb0e9cf977607be$var$W = [
    !0,
    "true",
    1,
    "1",
    "yes"
], $0fb0e9cf977607be$var$G = (t)=>$0fb0e9cf977607be$var$b($0fb0e9cf977607be$var$W, t), $0fb0e9cf977607be$var$K = [
    !1,
    "false",
    0,
    "0",
    "no"
];
function $0fb0e9cf977607be$var$J(t, i, e, s, n, r, o) {
    try {
        var l = t[r](o), a = l.value;
    } catch (t) {
        return void e(t);
    }
    l.done ? i(a) : Promise.resolve(a).then(s, n);
}
function $0fb0e9cf977607be$var$Y(t) {
    return function() {
        var i = this, e = arguments;
        return new Promise(function(s, n) {
            var r = t.apply(i, e);
            function o(t) {
                $0fb0e9cf977607be$var$J(r, s, n, o, l, "next", t);
            }
            function l(t) {
                $0fb0e9cf977607be$var$J(r, s, n, o, l, "throw", t);
            }
            o(void 0);
        });
    };
}
const $0fb0e9cf977607be$var$X = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "leikibot",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterestbot",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercel-screenshot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleother",
    "google-cloudvertexbot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "google-inspectiontool",
    "bytespider"
], $0fb0e9cf977607be$var$Q = function(t, i = []) {
    if (!t) return !1;
    const e = t.toLowerCase();
    return $0fb0e9cf977607be$var$X.concat(i).some((t)=>{
        const i = t.toLowerCase();
        return -1 !== e.indexOf(i);
    });
};
function $0fb0e9cf977607be$var$Z(t, i, e, s, n) {
    return i > e && (s.warn("min cannot be greater than max."), i = e), $0fb0e9cf977607be$var$D(t) ? t > e ? (s.warn(" cannot be  greater than max: " + e + ". Using max value instead."), e) : i > t ? (s.warn(" cannot be less than min: " + i + ". Using min value instead."), i) : t : (s.warn(" must be a number. using max or fallback. max: " + e + ", fallback: " + n), $0fb0e9cf977607be$var$Z(null != n ? n : e, i, e, s));
}
var $0fb0e9cf977607be$var$tt = class {
    constructor(t){
        this.C = {}, this.I = t.I, this.R = $0fb0e9cf977607be$var$Z(t.bucketSize, 0, 100, t.A), this.$ = $0fb0e9cf977607be$var$Z(t.refillRate, 0, this.R, t.A), this.O = $0fb0e9cf977607be$var$Z(t.refillInterval, 0, 864e5, t.A);
    }
    F(t, i) {
        const e = Math.floor((i - t.lastAccess) / this.O);
        e > 0 && (t.tokens = Math.min(t.tokens + e * this.$, this.R), t.lastAccess = t.lastAccess + e * this.O);
    }
    consumeRateLimit(t) {
        var i;
        const e = Date.now(), s = String(t);
        let n = this.C[s];
        return n ? this.F(n, e) : (n = {
            tokens: this.R,
            lastAccess: e
        }, this.C[s] = n), 0 === n.tokens || (n.tokens--, 0 === n.tokens && (null === (i = this.I) || void 0 === i || i.call(this, t)), 0 === n.tokens);
    }
    stop() {
        this.C = {};
    }
};
const $0fb0e9cf977607be$var$it = "Mobile", $0fb0e9cf977607be$var$et = "Android", $0fb0e9cf977607be$var$st = "Tablet", $0fb0e9cf977607be$var$nt = "Android Tablet", $0fb0e9cf977607be$var$rt = "iPad", $0fb0e9cf977607be$var$ot = "Apple Watch", $0fb0e9cf977607be$var$lt = "Safari", $0fb0e9cf977607be$var$at = "BlackBerry", $0fb0e9cf977607be$var$ut = "Samsung Internet", $0fb0e9cf977607be$var$ht = "Chrome", $0fb0e9cf977607be$var$dt = "Chrome iOS", $0fb0e9cf977607be$var$ct = "Internet Explorer", $0fb0e9cf977607be$var$vt = "Internet Explorer Mobile", $0fb0e9cf977607be$var$ft = "Opera", $0fb0e9cf977607be$var$pt = "Microsoft Edge", $0fb0e9cf977607be$var$_t = "Firefox", $0fb0e9cf977607be$var$gt = "Firefox iOS", $0fb0e9cf977607be$var$mt = "Nintendo", $0fb0e9cf977607be$var$bt = "PlayStation", $0fb0e9cf977607be$var$yt = "Xbox", $0fb0e9cf977607be$var$wt = "Android Mobile", $0fb0e9cf977607be$var$$t = "Mobile Safari", $0fb0e9cf977607be$var$St = "Windows", $0fb0e9cf977607be$var$xt = "Windows Phone", $0fb0e9cf977607be$var$Et = "Nokia", $0fb0e9cf977607be$var$kt = "Ouya", $0fb0e9cf977607be$var$Tt = "Generic " + $0fb0e9cf977607be$var$it.toLowerCase(), $0fb0e9cf977607be$var$Pt = "Generic " + $0fb0e9cf977607be$var$st.toLowerCase(), $0fb0e9cf977607be$var$Ct = "Konqueror", $0fb0e9cf977607be$var$Ot = "Oculus Browser", $0fb0e9cf977607be$var$Rt = "Vivaldi", $0fb0e9cf977607be$var$It = "Yandex", $0fb0e9cf977607be$var$Mt = "Whale", $0fb0e9cf977607be$var$At = "DuckDuckGo", $0fb0e9cf977607be$var$Ft = "Pale Moon", $0fb0e9cf977607be$var$Dt = "Waterfox", $0fb0e9cf977607be$var$Nt = "Brave", $0fb0e9cf977607be$var$jt = "Claude", $0fb0e9cf977607be$var$Lt = "Codex", $0fb0e9cf977607be$var$Bt = "ChatGPT", $0fb0e9cf977607be$var$Ut = "Google Search App", $0fb0e9cf977607be$var$zt = new RegExp("Version/(\\d+(\\.\\d+)?)"), $0fb0e9cf977607be$var$Ht = new RegExp("(Claude|Codex|ChatGPT)\\/(\\d+(\\.\\d+)?)"), $0fb0e9cf977607be$var$qt = new RegExp($0fb0e9cf977607be$var$yt, "i"), $0fb0e9cf977607be$var$Vt = new RegExp("PlayStation \\w+", "i"), $0fb0e9cf977607be$var$Wt = new RegExp("Nintendo \\w+", "i"), $0fb0e9cf977607be$var$Gt = new RegExp("BlackBerry|PlayBook|BB10", "i"), $0fb0e9cf977607be$var$Kt = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
}, $0fb0e9cf977607be$var$Jt = function(t, i, e, s) {
    i = i || "";
    const n = function(t) {
        return (null == t ? void 0 : t.brave) ? $0fb0e9cf977607be$var$Nt : null;
    }(e);
    return n || ((null == s ? void 0 : s.detectGoogleSearchApp) && $0fb0e9cf977607be$var$b(t, "GSA/") ? $0fb0e9cf977607be$var$Ut : $0fb0e9cf977607be$var$b(t, " OPR/") && $0fb0e9cf977607be$var$b(t, "Mini") ? "Opera Mini" : $0fb0e9cf977607be$var$b(t, " OPR/") ? $0fb0e9cf977607be$var$ft : $0fb0e9cf977607be$var$Gt.test(t) ? $0fb0e9cf977607be$var$at : $0fb0e9cf977607be$var$b(t, "IEMobile") || $0fb0e9cf977607be$var$b(t, "WPDesktop") ? $0fb0e9cf977607be$var$vt : $0fb0e9cf977607be$var$b(t, "OculusBrowser") ? $0fb0e9cf977607be$var$Ot : $0fb0e9cf977607be$var$b(t, "SamsungBrowser") ? $0fb0e9cf977607be$var$ut : $0fb0e9cf977607be$var$b(t, "Edge") || $0fb0e9cf977607be$var$b(t, "Edg/") ? $0fb0e9cf977607be$var$pt : $0fb0e9cf977607be$var$b(t, "Vivaldi/") ? $0fb0e9cf977607be$var$Rt : $0fb0e9cf977607be$var$b(t, "YaBrowser/") ? $0fb0e9cf977607be$var$It : $0fb0e9cf977607be$var$b(t, "Whale/") ? $0fb0e9cf977607be$var$Mt : $0fb0e9cf977607be$var$b(t, "DuckDuckGo/") || $0fb0e9cf977607be$var$b(t, "Ddg/") ? $0fb0e9cf977607be$var$At : $0fb0e9cf977607be$var$b(t, "Claude/") ? $0fb0e9cf977607be$var$jt : $0fb0e9cf977607be$var$b(t, "Codex/") ? $0fb0e9cf977607be$var$Lt : $0fb0e9cf977607be$var$b(t, "ChatGPT/") ? $0fb0e9cf977607be$var$Bt : $0fb0e9cf977607be$var$b(t, "FBIOS") ? "Facebook Mobile" : $0fb0e9cf977607be$var$b(t, "UCWEB") || $0fb0e9cf977607be$var$b(t, "UCBrowser") ? "UC Browser" : $0fb0e9cf977607be$var$b(t, "CriOS") ? $0fb0e9cf977607be$var$dt : $0fb0e9cf977607be$var$b(t, "CrMo") || $0fb0e9cf977607be$var$b(t, $0fb0e9cf977607be$var$ht) ? $0fb0e9cf977607be$var$ht : $0fb0e9cf977607be$var$b(t, $0fb0e9cf977607be$var$et) && $0fb0e9cf977607be$var$b(t, $0fb0e9cf977607be$var$lt) ? $0fb0e9cf977607be$var$wt : $0fb0e9cf977607be$var$b(t, "FxiOS") ? $0fb0e9cf977607be$var$gt : $0fb0e9cf977607be$var$b(t.toLowerCase(), $0fb0e9cf977607be$var$Ct.toLowerCase()) ? $0fb0e9cf977607be$var$Ct : $0fb0e9cf977607be$var$b(t, "Brave/") ? $0fb0e9cf977607be$var$Nt : ((t, i)=>i && $0fb0e9cf977607be$var$b(i, "Apple") || function(t) {
            return $0fb0e9cf977607be$var$b(t, $0fb0e9cf977607be$var$lt) && !$0fb0e9cf977607be$var$b(t, $0fb0e9cf977607be$var$ht) && !$0fb0e9cf977607be$var$b(t, $0fb0e9cf977607be$var$et);
        }(t))(t, i) ? $0fb0e9cf977607be$var$b(t, $0fb0e9cf977607be$var$it) ? $0fb0e9cf977607be$var$$t : $0fb0e9cf977607be$var$lt : $0fb0e9cf977607be$var$b(t, "PaleMoon/") ? $0fb0e9cf977607be$var$Ft : $0fb0e9cf977607be$var$b(t, "Waterfox/") ? $0fb0e9cf977607be$var$Dt : $0fb0e9cf977607be$var$b(t, $0fb0e9cf977607be$var$_t) ? $0fb0e9cf977607be$var$_t : $0fb0e9cf977607be$var$b(t, "MSIE") || $0fb0e9cf977607be$var$b(t, "Trident/") ? $0fb0e9cf977607be$var$ct : $0fb0e9cf977607be$var$b(t, "Gecko") ? $0fb0e9cf977607be$var$_t : "");
}, $0fb0e9cf977607be$var$Yt = {
    [$0fb0e9cf977607be$var$vt]: [
        new RegExp("rv:(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$pt]: [
        new RegExp("Edge?\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$ht]: [
        new RegExp("(Chrome|CrMo)\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$dt]: [
        new RegExp("CriOS\\/(\\d+(\\.\\d+)?)")
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$lt]: [
        $0fb0e9cf977607be$var$zt
    ],
    [$0fb0e9cf977607be$var$$t]: [
        $0fb0e9cf977607be$var$zt
    ],
    [$0fb0e9cf977607be$var$ft]: [
        new RegExp("(Opera|OPR)\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$_t]: [
        new RegExp("Firefox\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$gt]: [
        new RegExp("FxiOS\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$Ct]: [
        new RegExp("Konqueror[:/]?(\\d+(\\.\\d+)?)", "i")
    ],
    [$0fb0e9cf977607be$var$at]: [
        new RegExp("BlackBerry (\\d+(\\.\\d+)?)"),
        $0fb0e9cf977607be$var$zt
    ],
    [$0fb0e9cf977607be$var$wt]: [
        new RegExp("android\\s(\\d+(\\.\\d+)?)", "i")
    ],
    [$0fb0e9cf977607be$var$ut]: [
        new RegExp("SamsungBrowser\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$Ot]: [
        new RegExp("OculusBrowser\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$Rt]: [
        new RegExp("Vivaldi\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$It]: [
        new RegExp("YaBrowser\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$Mt]: [
        new RegExp("Whale\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$Nt]: [
        new RegExp("Brave\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$jt]: [
        $0fb0e9cf977607be$var$Ht
    ],
    [$0fb0e9cf977607be$var$Lt]: [
        $0fb0e9cf977607be$var$Ht
    ],
    [$0fb0e9cf977607be$var$Bt]: [
        $0fb0e9cf977607be$var$Ht
    ],
    [$0fb0e9cf977607be$var$At]: [
        new RegExp("(DuckDuckGo|Ddg)\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$Ft]: [
        new RegExp("PaleMoon\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$Dt]: [
        new RegExp("Waterfox\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$Ut]: [
        new RegExp("GSA\\/(\\d+(\\.\\d+)?)")
    ],
    [$0fb0e9cf977607be$var$ct]: [
        new RegExp("(rv:|MSIE )(\\d+(\\.\\d+)?)")
    ],
    Mozilla: [
        new RegExp("rv:(\\d+(\\.\\d+)?)")
    ]
}, $0fb0e9cf977607be$var$Xt = function(t, i, e, s) {
    const n = $0fb0e9cf977607be$var$Jt(t, i, e, s), r = $0fb0e9cf977607be$var$Yt[n];
    if ($0fb0e9cf977607be$var$R(r)) return null;
    for(let i = 0; r.length > i; i++){
        const e = t.match(r[i]);
        if (e) return parseFloat(e[e.length - 2]);
    }
    return null;
}, $0fb0e9cf977607be$var$Qt = [
    [
        new RegExp("Xbox; Xbox (.*?)[);]", "i"),
        (t)=>[
                $0fb0e9cf977607be$var$yt,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($0fb0e9cf977607be$var$mt, "i"),
        [
            $0fb0e9cf977607be$var$mt,
            ""
        ]
    ],
    [
        new RegExp($0fb0e9cf977607be$var$bt, "i"),
        [
            $0fb0e9cf977607be$var$bt,
            ""
        ]
    ],
    [
        $0fb0e9cf977607be$var$Gt,
        [
            $0fb0e9cf977607be$var$at,
            ""
        ]
    ],
    [
        new RegExp($0fb0e9cf977607be$var$St, "i"),
        (t, i)=>{
            if (/Phone/.test(i) || /WPDesktop/.test(i)) return [
                $0fb0e9cf977607be$var$xt,
                ""
            ];
            if (new RegExp($0fb0e9cf977607be$var$it).test(i) && !/IEMobile\b/.test(i)) return [
                "Windows Mobile",
                ""
            ];
            const e = /Windows NT ([0-9.]+)/i.exec(i);
            if (e && e[1]) {
                let t = $0fb0e9cf977607be$var$Kt[e[1]] || "";
                return /arm/i.test(i) && (t = "RT"), [
                    $0fb0e9cf977607be$var$St,
                    t
                ];
            }
            return [
                $0fb0e9cf977607be$var$St,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>t && t[3] ? [
                "iOS",
                [
                    t[3],
                    t[4],
                    t[5] || "0"
                ].join(".")
            ] : [
                "iOS",
                ""
            ]
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            let i = "";
            return t && t.length >= 3 && (i = $0fb0e9cf977607be$var$R(t[2]) ? t[3] : t[2]), [
                "watchOS",
                i
            ];
        }
    ],
    [
        new RegExp("(Android (\\d+)\\.(\\d+)\\.?(\\d+)?|Android)", "i"),
        (t)=>t && t[2] ? [
                $0fb0e9cf977607be$var$et,
                [
                    t[2],
                    t[3],
                    t[4] || "0"
                ].join(".")
            ] : [
                $0fb0e9cf977607be$var$et,
                ""
            ]
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            const i = [
                "Mac OS X",
                ""
            ];
            return t && t[1] && (i[1] = [
                t[1],
                t[2],
                t[3] || "0"
            ].join(".")), i;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            "Chrome OS",
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $0fb0e9cf977607be$var$Zt = function(t) {
    for(let i = 0; $0fb0e9cf977607be$var$Qt.length > i; i++){
        const [e, s] = $0fb0e9cf977607be$var$Qt[i], n = e.exec(t), r = n && ($0fb0e9cf977607be$var$P(s) ? s(n, t) : s);
        if (r) return r;
    }
    return [
        "",
        ""
    ];
}, $0fb0e9cf977607be$var$ti = function(t) {
    return $0fb0e9cf977607be$var$Wt.test(t) ? $0fb0e9cf977607be$var$mt : $0fb0e9cf977607be$var$Vt.test(t) ? $0fb0e9cf977607be$var$bt : $0fb0e9cf977607be$var$qt.test(t) ? $0fb0e9cf977607be$var$yt : new RegExp($0fb0e9cf977607be$var$kt, "i").test(t) ? $0fb0e9cf977607be$var$kt : new RegExp("(Windows Phone|WPDesktop)", "i").test(t) ? $0fb0e9cf977607be$var$xt : /iPad/.test(t) ? $0fb0e9cf977607be$var$rt : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $0fb0e9cf977607be$var$ot : $0fb0e9cf977607be$var$Gt.test(t) ? $0fb0e9cf977607be$var$at : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($0fb0e9cf977607be$var$Et, "i").test(t) ? $0fb0e9cf977607be$var$Et : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? new RegExp($0fb0e9cf977607be$var$it).test(t) && !/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) || /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $0fb0e9cf977607be$var$et : $0fb0e9cf977607be$var$nt : new RegExp("(pda|Mobile)", "i").test(t) ? $0fb0e9cf977607be$var$Tt : new RegExp($0fb0e9cf977607be$var$st, "i").test(t) && !new RegExp("Tablet pc", "i").test(t) ? $0fb0e9cf977607be$var$Pt : "";
}, $0fb0e9cf977607be$var$ii = function(t, i) {
    var e;
    const s = $0fb0e9cf977607be$var$ti(t);
    var n, r, o;
    return s === $0fb0e9cf977607be$var$rt || s === $0fb0e9cf977607be$var$nt || "Kobo" === s || "Kindle Fire" === s || s === $0fb0e9cf977607be$var$Pt ? $0fb0e9cf977607be$var$st : s === $0fb0e9cf977607be$var$mt || s === $0fb0e9cf977607be$var$yt || s === $0fb0e9cf977607be$var$bt || s === $0fb0e9cf977607be$var$kt ? "Console" : s === $0fb0e9cf977607be$var$ot ? "Wearable" : s ? $0fb0e9cf977607be$var$it : "Android" === (null == i ? void 0 : i.userAgentDataPlatform) && (null !== (e = null == i ? void 0 : i.maxTouchPoints) && void 0 !== e ? e : 0) > 0 ? 600 > Math.min(null !== (n = null == i ? void 0 : i.screenWidth) && void 0 !== n ? n : 0, null !== (r = null == i ? void 0 : i.screenHeight) && void 0 !== r ? r : 0) / (null !== (o = null == i ? void 0 : i.devicePixelRatio) && void 0 !== o ? o : 1) ? $0fb0e9cf977607be$var$it : $0fb0e9cf977607be$var$st : "Desktop";
}, $0fb0e9cf977607be$var$ei = /\bFBAV\/(\d+(?:\.\d+)*)/i, $0fb0e9cf977607be$var$si = [
    [
        /\bInstagram(?:[ /](\d+(?:\.\d+)*))?\b/i,
        "Instagram"
    ],
    [
        /\bBarcelona[ /](\d+(?:\.\d+)*)?/i,
        "Threads"
    ],
    [
        /\b(?:MessengerForiOS|(?:FBAN|FB_IAB)\/Orca-Android)\b/i,
        "Messenger",
        $0fb0e9cf977607be$var$ei
    ],
    [
        /\bFBAN\/EMA\b/i,
        "Facebook Lite",
        $0fb0e9cf977607be$var$ei
    ],
    [
        /\b(?:FBIOS|(?:FBAN|FB_IAB)\/(?:FB4A|FBIOS))\b/i,
        "Facebook",
        $0fb0e9cf977607be$var$ei
    ],
    [
        /\bLinkedInApp(?:\]?\/(\d+(?:\.\d+)*))?\b/i,
        "LinkedIn"
    ],
    [
        /\bTwitter(?:Android| for (?:iPhone|iPad|Android))(?:\/(\d+(?:\.\d+)*))?\b/i,
        "Twitter"
    ],
    [
        /\b(?:musical_ly|trill)(?:[_/](\d+\.\d+(?:\.\d+)*))?(?=\b|_)/i,
        "TikTok",
        /\bapp_version\/(\d+(?:\.\d+)*)/i
    ],
    [
        /\b(?:MicroMessenger|WeChat)\/(\d+(?:\.\d+)*)?/i,
        "WeChat"
    ],
    [
        /\bLine\/(\d+(?:\.\d+)*)?/i,
        "Line"
    ],
    [
        /\bGSA\/(\d+(?:\.\d+)*)?/i,
        "Google"
    ],
    [
        /\[Pinterest\/(?:iOS|Android)\b|\bPinterest(?: for (?:Android(?: Tablet)?|iOS))?\/(\d+(?:\.\d+)*)/i,
        "Pinterest"
    ],
    [
        /\b(?:WA4A|WAiOS)\/(\d+(?:\.\d+)*)?/i,
        "WhatsApp"
    ],
    [
        /\bSnapchat[ /](\d+(?:\.\d+)*)?/i,
        "Snapchat"
    ],
    [
        /\bBing(?:Web|Sapphire)\/(\d+(?:\.\d+)*)?/i,
        "Bing"
    ],
    [
        /\bNAVER\(inapp; search;/i,
        "Naver",
        /\bNAVER\(inapp; search;[^;)]*; (\d+(?:\.\d+)*)/i
    ],
    [
        /\bKAKAOTALK[ /](\d+\.\d+(?:\.\d+)*)?/i,
        "KakaoTalk"
    ]
], $0fb0e9cf977607be$var$ni = "[Truncated]", $0fb0e9cf977607be$var$ri = "[Unserializable]";
function $0fb0e9cf977607be$var$oi(t) {
    let i = "";
    for(let e = 0; t.length > e; e++){
        const s = t.charCodeAt(e);
        if (55296 > s || s > 56319) i += 56320 > s || s > 57343 ? t[e] : "\uFFFD";
        else {
            const s = t.charCodeAt(e + 1);
            56320 > s || s > 57343 ? i += "\uFFFD" : (i += t[e] + t[e + 1], e++);
        }
    }
    return i;
}
function $0fb0e9cf977607be$var$li(t, i) {
    if (!i) return t;
    let e = [];
    try {
        e = Object.keys(i);
    } catch (t) {
        e = [];
    }
    for (const s of e){
        let e;
        try {
            e = i[s];
        } catch (t) {
            e = $0fb0e9cf977607be$var$ri;
        }
        Object.defineProperty(t, s, {
            value: e,
            enumerable: !0,
            writable: !0,
            configurable: !0
        });
    }
    return t;
}
Date, Date;
const $0fb0e9cf977607be$var$ai = 3e5;
var $0fb0e9cf977607be$var$ui = class {
    record(t) {
        if ("too-large" === t.kind) return;
        if ("retry-later" !== t.kind) return void this.reset();
        if (!t.retryAfterMs) return;
        const i = this.isOpen(), e = Date.now(), s = Math.min(t.retryAfterMs, $0fb0e9cf977607be$var$ai);
        if (!i) return this.ts = e, void (this.es = e + s);
        this.es = Math.max(this.es, Math.min(e + s, this.ts + $0fb0e9cf977607be$var$ai));
    }
    remainingMs() {
        const t = Date.now();
        if (this.ts - 5e3 > t) return this.reset(), 0;
        const i = Math.min($0fb0e9cf977607be$var$ai, Math.max(0, this.es - t));
        return 0 === i && this.reset(), i;
    }
    isOpen() {
        return this.remainingMs() > 0;
    }
    reset() {
        this.es = 0, this.ts = 0;
    }
    constructor(){
        this.es = 0, this.ts = 0;
    }
};
const $0fb0e9cf977607be$var$hi = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function $0fb0e9cf977607be$var$di(t, i) {
    var e;
    return "string" == typeof (e = t) && $0fb0e9cf977607be$var$hi.test(e) ? t : i();
}
function $0fb0e9cf977607be$var$ci(t, i) {
    const e = new Error(i);
    try {
        Object.defineProperty(e, "name", {
            value: t,
            writable: !0,
            enumerable: !0,
            configurable: !0
        });
    } catch (t) {}
    return e;
}
function $0fb0e9cf977607be$var$vi(t) {
    return t ? t.split("#")[0] : t;
}
function $0fb0e9cf977607be$var$fi(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}
function $0fb0e9cf977607be$var$pi(t, i) {
    const e = setTimeout(t, i);
    return null != e && e.unref && (null == e || e.unref()), e;
}
function $0fb0e9cf977607be$var$_i(t, i, e) {
    return $0fb0e9cf977607be$var$gi.apply(this, arguments);
}
function $0fb0e9cf977607be$var$gi() {
    return ($0fb0e9cf977607be$var$gi = $0fb0e9cf977607be$var$Y(function*(t, i, e) {
        let s;
        try {
            return yield Promise.race([
                t,
                new Promise((t, n)=>{
                    s = $0fb0e9cf977607be$var$pi(()=>{
                        try {
                            null == e || e(), t();
                        } catch (t) {
                            n(t);
                        }
                    }, i);
                })
            ]);
        } finally{
            clearTimeout(s);
        }
    })).apply(this, arguments);
}
let $0fb0e9cf977607be$var$mi, $0fb0e9cf977607be$var$bi, $0fb0e9cf977607be$var$yi;
function $0fb0e9cf977607be$var$wi(t) {
    const i = globalThis._posthogChunkIds;
    if (!i) return;
    const e = Object.keys(i);
    return $0fb0e9cf977607be$var$yi && e.length === $0fb0e9cf977607be$var$bi || ($0fb0e9cf977607be$var$bi = e.length, $0fb0e9cf977607be$var$yi = e.reduce((e, s)=>{
        $0fb0e9cf977607be$var$mi || ($0fb0e9cf977607be$var$mi = {});
        const n = $0fb0e9cf977607be$var$mi[s];
        if (n) e[n[0]] = n[1];
        else {
            const n = t(s);
            for(let t = n.length - 1; t >= 0; t--){
                const r = n[t], o = null == r ? void 0 : r.filename, l = i[s];
                if (o && l) {
                    e[o] = l, $0fb0e9cf977607be$var$mi[s] = [
                        o,
                        l
                    ];
                    break;
                }
            }
        }
        return e;
    }, {})), $0fb0e9cf977607be$var$yi;
}
function $0fb0e9cf977607be$var$$i(t) {
    return $0fb0e9cf977607be$var$$i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $0fb0e9cf977607be$var$$i(t);
}
function $0fb0e9cf977607be$var$Si(t, i, e) {
    return (i = function(t) {
        var i = function(t) {
            if ("object" != $0fb0e9cf977607be$var$$i(t) || !t) return t;
            var i = t[Symbol.toPrimitive];
            if (void 0 !== i) {
                var e = i.call(t, "string");
                if ("object" != $0fb0e9cf977607be$var$$i(e)) return e;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(t);
        }(t);
        return "symbol" == $0fb0e9cf977607be$var$$i(i) ? i : i + "";
    }(i)) in t ? Object.defineProperty(t, i, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[i] = e, t;
}
function $0fb0e9cf977607be$var$xi(t, i) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(t);
        i && (s = s.filter(function(i) {
            return Object.getOwnPropertyDescriptor(t, i).enumerable;
        })), e.push.apply(e, s);
    }
    return e;
}
function $0fb0e9cf977607be$var$Ei(t) {
    for(var i = 1; arguments.length > i; i++){
        var e = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0fb0e9cf977607be$var$xi(Object(e), !0).forEach(function(i) {
            $0fb0e9cf977607be$var$Si(t, i, e[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $0fb0e9cf977607be$var$xi(Object(e)).forEach(function(i) {
            Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(e, i));
        });
    }
    return t;
}
var $0fb0e9cf977607be$var$ki = class {
    constructor(t, i, e = []){
        this.coercers = t, this.stackParser = i, this.modifiers = e;
    }
    buildFromUnknown(t, i = {}) {
        const e = i && i.mechanism || {
            handled: !0,
            type: "generic"
        }, s = this.buildCoercingContext(e, i, 0).apply(t), n = this.buildParsingContext(i), r = this.parseStacktrace(s, n);
        return {
            $exception_list: this.convertToExceptionList(r, e),
            $exception_level: "error"
        };
    }
    modifyFrames(t) {
        var i = this;
        return $0fb0e9cf977607be$var$Y(function*() {
            for (const e of t)e.stacktrace && e.stacktrace.frames && $0fb0e9cf977607be$var$T(e.stacktrace.frames) && (e.stacktrace.frames = yield i.applyModifiers(e.stacktrace.frames));
            return t;
        })();
    }
    coerceFallback(t) {
        var i;
        return {
            type: "Error",
            value: "Unknown error",
            stack: null === (i = t.syntheticException) || void 0 === i ? void 0 : i.stack,
            synthetic: !0
        };
    }
    parseStacktrace(t, i) {
        var e;
        let s, n;
        if (null != t.cause && (s = this.parseStacktrace(t.cause, i)), "" != t.stack && null != t.stack) try {
            n = this.applyChunkIds(this.stackParser(t.stack, t.synthetic ? i.skipFirstLines : 0), i.chunkIdMap);
        } catch (t) {}
        return $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
            cause: s,
            stack: n,
            errors: null === (e = t.errors) || void 0 === e ? void 0 : e.map((t)=>this.parseStacktrace(t, i))
        });
    }
    applyChunkIds(t, i) {
        return t.map((t)=>(t.filename && i && (t.chunk_id = i[t.filename]), t));
    }
    applyCoercers(t, i) {
        for (const e of this.coercers)if (e.match(t)) return e.coerce(t, i);
        return this.coerceFallback(i);
    }
    applyModifiers(t) {
        var i = this;
        return $0fb0e9cf977607be$var$Y(function*() {
            let e = t;
            for (const t of i.modifiers)e = yield t(e);
            return e;
        })();
    }
    convertToExceptionList(t, i) {
        const e = [], s = (t, n, r)=>{
            var o;
            const l = e.length, a = void 0 === n ? $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({
                type: "string" == typeof i.type && i.type.length > 0 ? i.type : "generic"
            }, "boolean" == typeof i.handled ? {
                handled: i.handled
            } : void 0 === i.handled ? {
                handled: !0
            } : {}), {}, {
                synthetic: "boolean" == typeof i.synthetic ? i.synthetic : t.synthetic,
                exception_id: l
            }) : {
                type: "chained",
                source: r,
                synthetic: t.synthetic,
                exception_id: l,
                parent_id: n
            }, u = {
                type: t.type,
                value: t.value,
                mechanism: a
            };
            t.stack && (u.stacktrace = {
                type: "raw",
                frames: t.stack
            }), e.push(u), t.cause && s(t.cause, l, "cause");
            for (const i of null !== (o = t.errors) && void 0 !== o ? o : [])s(i, l, "member");
        };
        return s(t), e;
    }
    buildParsingContext(t) {
        var i;
        return {
            chunkIdMap: $0fb0e9cf977607be$var$wi(this.stackParser),
            skipFirstLines: null !== (i = t.skipFirstLines) && void 0 !== i ? i : 1
        };
    }
    getAggregateErrors(t) {
        try {
            if ($0fb0e9cf977607be$var$H(t)) {
                let e = Object.getPrototypeOf(t);
                for(let s = 0; e && 100 > s; s++){
                    var i;
                    const s = null === (i = Object.getOwnPropertyDescriptor(e, "constructor")) || void 0 === i ? void 0 : i.value;
                    if ("function" == typeof s && "AggregateError" === s.name) {
                        const i = t.errors;
                        return $0fb0e9cf977607be$var$T(i) ? i : void 0;
                    }
                    e = Object.getPrototypeOf(e);
                }
            }
        } catch (t) {}
    }
    buildCoercingContext(t, i, e = 0) {
        let s = 0, n = 0, r = !1;
        const o = new Set, l = [], a = {}, u = (t, i, e = 0)=>{
            const u = h(i, e), d = u.apply;
            if (u.apply = (i)=>{
                l.push(t);
                try {
                    return d(i);
                } finally{
                    l.pop();
                }
            }, e > 4 || e > 0 && -1 !== l.indexOf(t)) return this.coerceFallback(u);
            const c = "object" == typeof t && null !== t || "function" == typeof t;
            if (0 === e && s >= 50 || c && o.has(t)) return;
            c && o.add(t), 0 === e && s++;
            const v = this.getAggregateErrors(t);
            let f, p;
            r || (r = !!v);
            try {
                if (f = this.applyCoercers(t, u), !f) throw a;
            } catch (t) {
                if (t === a) return void (0 === e && s--);
                if (!r) throw t;
                f = this.coerceFallback(u);
            }
            if (!v || s >= 50) return f;
            try {
                p = v.length;
            } catch (t) {
                return f;
            }
            if (!Number.isInteger(p) || 0 > p || p > 4294967295) return f;
            const _ = [];
            for(let t = 0; 50 > s && 1e3 > n && p > t; t++){
                let e;
                n++;
                try {
                    e = u.next(v[t]);
                } catch (t) {
                    s++, e = this.coerceFallback(h(i + 1));
                }
                e && _.push(e);
            }
            return $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, f), {}, {
                errors: _
            });
        }, h = (e, s = 0)=>$0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i), {}, {
                syntheticException: 0 == e ? i.syntheticException : void 0,
                mechanism: 0 == e ? t : {},
                apply (t) {
                    const i = u(t, e, s + 1);
                    if (!i) throw a;
                    return i;
                },
                next: (t)=>u(t, e + 1)
            }), d = h(e);
        return $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, d), {}, {
            apply: (t)=>{
                var i;
                return null !== (i = u(t, e)) && void 0 !== i ? i : this.coerceFallback(d);
            }
        });
    }
};
const $0fb0e9cf977607be$var$Ti = /^([a-z][a-z0-9.+-]+):/i, $0fb0e9cf977607be$var$Pi = [
    "http",
    "https",
    "file",
    "blob",
    "app",
    "capacitor",
    "ionic",
    "webpack",
    "webpack-internal",
    "ng"
];
function $0fb0e9cf977607be$var$Ci(t) {
    if (!t || "<anonymous>" === t) return !1;
    const i = $0fb0e9cf977607be$var$Ti.exec(t);
    return !i || $0fb0e9cf977607be$var$Pi.includes(i[1].toLowerCase());
}
function $0fb0e9cf977607be$var$Oi(t, i, e, s, n) {
    const r = {
        platform: t,
        filename: i,
        function: "<anonymous>" === e ? "?" : e,
        in_app: $0fb0e9cf977607be$var$Ci(i)
    };
    return $0fb0e9cf977607be$var$R(s) || (r.lineno = s), $0fb0e9cf977607be$var$R(n) || (r.colno = n), r;
}
const $0fb0e9cf977607be$var$Ri = (t, i)=>{
    const e = -1 !== t.indexOf("safari-extension"), s = -1 !== t.indexOf("safari-web-extension");
    return e || s ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : "?",
        e ? `safari-extension:${i}` : `safari-web-extension:${i}`
    ] : [
        t,
        i
    ];
}, $0fb0e9cf977607be$var$Ii = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $0fb0e9cf977607be$var$Mi = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $0fb0e9cf977607be$var$Ai = /\((\S*)(?::(\d+))(?::(\d+))\)/, $0fb0e9cf977607be$var$Fi = (t, i)=>{
    const e = $0fb0e9cf977607be$var$Ii.exec(t);
    if (e) {
        const [, t, s, n] = e;
        return $0fb0e9cf977607be$var$Oi(i, t, "?", +s, +n);
    }
    const s = $0fb0e9cf977607be$var$Mi.exec(t);
    if (s) {
        if (s[2] && 0 === s[2].indexOf("eval")) {
            const t = $0fb0e9cf977607be$var$Ai.exec(s[2]);
            t && (s[2] = t[1], s[3] = t[2], s[4] = t[3]);
        }
        const [t, e] = $0fb0e9cf977607be$var$Ri(s[1] || "?", s[2]);
        return $0fb0e9cf977607be$var$Oi(i, e, t, s[3] ? +s[3] : void 0, s[4] ? +s[4] : void 0);
    }
}, $0fb0e9cf977607be$var$Di = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $0fb0e9cf977607be$var$Ni = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $0fb0e9cf977607be$var$ji = (t, i)=>{
    const e = $0fb0e9cf977607be$var$Di.exec(t);
    if (e) {
        if (e[3] && e[3].indexOf(" > eval") > -1) {
            const t = $0fb0e9cf977607be$var$Ni.exec(e[3]);
            t && (e[1] = e[1] || "eval", e[3] = t[1], e[4] = t[2], e[5] = "");
        }
        let t = e[3], s = e[1] || "?";
        return [s, t] = $0fb0e9cf977607be$var$Ri(s, t), $0fb0e9cf977607be$var$Oi(i, t, s, e[4] ? +e[4] : void 0, e[5] ? +e[5] : void 0);
    }
}, $0fb0e9cf977607be$var$Li = /\(error: (.*)\)/;
function $0fb0e9cf977607be$var$Bi(t, i) {
    return t.filename === i.filename && t.function === i.function && t.module === i.module && t.lineno === i.lineno && t.colno === i.colno;
}
function $0fb0e9cf977607be$var$Ui(t) {
    for(let i = 1; 10 >= i; i++){
        const e = t.length - 2 * i;
        if (0 > e) break;
        let s = !0;
        for(let n = 0; i > n; n++)if (!$0fb0e9cf977607be$var$Bi(t[e + n], t[e + i + n])) {
            s = !1;
            break;
        }
        if (s) {
            for(let s = 0; i > s; s++)t[e + s] = t[e + i + s];
            return t.length = e + i, {
                start: e,
                length: i
            };
        }
    }
}
function $0fb0e9cf977607be$var$zi(t, i) {
    const e = i.start + i.length, s = $0fb0e9cf977607be$var$qi(t, i);
    s && t.splice(e + s === t.length ? e : i.start, s);
}
function $0fb0e9cf977607be$var$Hi(t, i) {
    let e = i.start;
    for(; e > 0 && $0fb0e9cf977607be$var$Bi(t[e - 1], t[e - 1 + i.length]);)e--;
    return i.start - e;
}
function $0fb0e9cf977607be$var$qi(t, i) {
    const e = i.start + i.length;
    let s = e;
    for(; t.length > s && $0fb0e9cf977607be$var$Bi(t[s], t[s - i.length]);)s++;
    return s - e;
}
function $0fb0e9cf977607be$var$Vi(t, i) {
    const e = i[0];
    let s = t.length - (e ? $0fb0e9cf977607be$var$Hi(t, e) : 0);
    for (const e of i)s -= $0fb0e9cf977607be$var$qi(t, e);
    return s;
}
function $0fb0e9cf977607be$var$Wi(t, i, e) {
    for(let s = 0; t.length > s; s++){
        const n = t[(i + s) % t.length], r = t[(e + s) % t.length];
        if (n !== r) return r > n;
    }
    return !1;
}
var $0fb0e9cf977607be$var$Gi = class {
    match(t) {
        return this.isDOMException(t) || this.isDOMError(t);
    }
    coerce(t, i) {
        const e = $0fb0e9cf977607be$var$I(t.stack);
        return {
            type: this.getType(t),
            value: this.getValue(t),
            stack: e ? t.stack : void 0,
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return this.isDOMError(t) ? "DOMError" : "DOMException";
    }
    getValue(t) {
        const i = t.name || (this.isDOMError(t) ? "DOMError" : "DOMException");
        return t.message ? `${i}: ${t.message}` : i;
    }
    isDOMException(t) {
        return $0fb0e9cf977607be$var$z(t, "DOMException");
    }
    isDOMError(t) {
        return $0fb0e9cf977607be$var$z(t, "DOMError");
    }
}, $0fb0e9cf977607be$var$Ki = class {
    match(t) {
        return $0fb0e9cf977607be$var$H(t);
    }
    coerce(t, i) {
        var e;
        const s = this.getStack(t), n = void 0 === s ? null === (e = i.syntheticException) || void 0 === e ? void 0 : e.stack : void 0, r = !!n;
        return {
            type: this.getType(t),
            value: this.getMessage(t, i),
            stack: null != s ? s : n,
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: r
        };
    }
    getType(t) {
        return t.name || t.constructor.name;
    }
    getMessage(t, i) {
        const e = t.message;
        return String(e.error && "string" == typeof e.error.message ? e.error.message : e);
    }
    getStack(t) {
        try {
            const i = t.stacktrace;
            if ("string" == typeof i && i.length > 0) return i;
            const e = t.stack;
            return "string" == typeof e && e.length > 0 ? e : void 0;
        } catch (t) {
            return;
        }
    }
}, $0fb0e9cf977607be$var$Ji = class {
    match(t) {
        return !!$0fb0e9cf977607be$var$z(t, "ErrorEvent") && (null != t.error || this.ar(t));
    }
    coerce(t, i) {
        var e;
        if (null != t.error) return i.apply(t.error);
        const s = i.apply(t.message);
        return $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, s), {}, {
            stack: null !== (e = this.lr(t)) && void 0 !== e ? e : s.stack,
            synthetic: !0
        });
    }
    ar(t) {
        return $0fb0e9cf977607be$var$I(t.message) && t.message.length > 0;
    }
    lr(t) {
        var i, e;
        const s = t, n = null !== (i = s.lineno) && void 0 !== i ? i : 0, r = null !== (e = s.colno) && void 0 !== e ? e : 0;
        if ($0fb0e9cf977607be$var$I(s.filename) && 0 !== s.filename.length && 0 !== n) return `Error\n    at ${s.filename}:${n}:${r}`;
    }
};
const $0fb0e9cf977607be$var$Yi = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
var $0fb0e9cf977607be$var$Xi = class {
    match(t) {
        return "string" == typeof t;
    }
    coerce(t, i) {
        var e;
        const [s, n] = this.getInfos(t);
        return {
            type: null != s ? s : "Error",
            value: null != n ? n : t,
            stack: null === (e = i.syntheticException) || void 0 === e ? void 0 : e.stack,
            synthetic: !0
        };
    }
    getInfos(t) {
        let i = "Error", e = t;
        const s = t.match($0fb0e9cf977607be$var$Yi);
        return s && (i = s[1], e = s[2]), [
            i,
            e
        ];
    }
};
const $0fb0e9cf977607be$var$Qi = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $0fb0e9cf977607be$var$Zi(t, i = 40) {
    const e = Object.keys(t);
    if (e.sort(), !e.length) return "[object has no keys]";
    for(let t = e.length; t > 0; t--){
        const s = e.slice(0, t).join(", ");
        if (i >= s.length) return t === e.length ? s : s.length > i ? `${s.slice(0, i)}...` : s;
    }
    return "";
}
var $0fb0e9cf977607be$var$te = class {
    match(t) {
        return "object" == typeof t && null !== t;
    }
    coerce(t, i) {
        var e, s;
        const n = this.getErrorPropertyFromObject(t);
        return n ? i.apply(n) : {
            type: this.getType(t),
            value: this.getValue(t),
            stack: null !== (e = this.getStack(t)) && void 0 !== e ? e : null === (s = i.syntheticException) || void 0 === s ? void 0 : s.stack,
            level: this.isSeverityLevel(t.level) ? t.level : "error",
            synthetic: !0
        };
    }
    getType(t) {
        if ($0fb0e9cf977607be$var$q(t)) return t.constructor.name;
        const i = "name" in t ? t.name : void 0;
        return $0fb0e9cf977607be$var$I(i) && !$0fb0e9cf977607be$var$M(i) ? i : "Error";
    }
    getValue(t) {
        if ("name" in t && "string" == typeof t.name) {
            let i = `'${t.name}' captured as exception`;
            return "message" in t && "string" == typeof t.message && (i += ` with message: '${t.message}'`), i;
        }
        if ("message" in t && "string" == typeof t.message) return t.message;
        const i = this.getObjectClassName(t);
        return `${i && "Object" !== i ? `'${i}'` : "Object"} captured as exception with keys: ${$0fb0e9cf977607be$var$Zi(t)}`;
    }
    isSeverityLevel(t) {
        return $0fb0e9cf977607be$var$I(t) && !$0fb0e9cf977607be$var$M(t) && $0fb0e9cf977607be$var$Qi.indexOf(t) >= 0;
    }
    getStack(t) {
        try {
            return $0fb0e9cf977607be$var$I(t.stacktrace) && t.stacktrace.length > 0 ? t.stacktrace : $0fb0e9cf977607be$var$I(t.stack) && t.stack.length > 0 ? t.stack : void 0;
        } catch (t) {
            return;
        }
    }
    getErrorPropertyFromObject(t) {
        for(const i in t)if (({}).hasOwnProperty.call(t, i)) {
            const e = t[i];
            if ($0fb0e9cf977607be$var$H(e)) return e;
        }
    }
    getObjectClassName(t) {
        try {
            const i = Object.getPrototypeOf(t);
            return i ? i.constructor.name : void 0;
        } catch (t) {
            return;
        }
    }
}, $0fb0e9cf977607be$var$ie = class {
    match(t) {
        return $0fb0e9cf977607be$var$q(t);
    }
    coerce(t, i) {
        var e;
        const s = t.constructor.name;
        return {
            type: s,
            value: `${s} captured as exception with keys: ${$0fb0e9cf977607be$var$Zi(t)}`,
            stack: null === (e = i.syntheticException) || void 0 === e ? void 0 : e.stack,
            synthetic: !0
        };
    }
}, $0fb0e9cf977607be$var$ee = class {
    match(t) {
        return $0fb0e9cf977607be$var$U(t);
    }
    coerce(t, i) {
        var e;
        return {
            type: "Error",
            value: `Primitive value captured as exception: ${String(t)}`,
            stack: null === (e = i.syntheticException) || void 0 === e ? void 0 : e.stack,
            synthetic: !0
        };
    }
}, $0fb0e9cf977607be$var$se = class {
    match(t) {
        return $0fb0e9cf977607be$var$z(t, "PromiseRejectionEvent") || this.isCustomEventWrappingRejection(t);
    }
    isCustomEventWrappingRejection(t) {
        if (!$0fb0e9cf977607be$var$q(t)) return !1;
        try {
            const i = t.detail;
            return null != i && "object" == typeof i && "reason" in i;
        } catch (t) {
            return !1;
        }
    }
    coerce(t, i) {
        var e;
        const s = this.getUnhandledRejectionReason(t);
        return $0fb0e9cf977607be$var$U(s) ? {
            type: "UnhandledRejection",
            value: `Non-Error promise rejection captured with value: ${String(s)}`,
            stack: null === (e = i.syntheticException) || void 0 === e ? void 0 : e.stack,
            synthetic: !0
        } : i.apply(s);
    }
    getUnhandledRejectionReason(t) {
        try {
            if ("reason" in t) return t.reason;
            if ("detail" in t && null != t.detail && "object" == typeof t.detail && "reason" in t.detail) return t.detail.reason;
        } catch (t) {}
        return t;
    }
};
const $0fb0e9cf977607be$var$ne = "$message", $0fb0e9cf977607be$var$re = "$timestamp", $0fb0e9cf977607be$var$oe = new Set([
    $0fb0e9cf977607be$var$ne,
    $0fb0e9cf977607be$var$re
]), $0fb0e9cf977607be$var$le = {
    enabled: !0,
    max_bytes: 32768
};
function $0fb0e9cf977607be$var$ae(t) {
    var i;
    return t ? {
        enabled: null !== (i = t.enabled) && void 0 !== i ? i : $0fb0e9cf977607be$var$le.enabled,
        max_bytes: $0fb0e9cf977607be$var$he(t.max_bytes, $0fb0e9cf977607be$var$le.max_bytes)
    } : $0fb0e9cf977607be$var$Ei({}, $0fb0e9cf977607be$var$le);
}
var $0fb0e9cf977607be$var$ue = class {
    constructor(t){
        this.ns = [], this.ss = 0, this.Mr = $0fb0e9cf977607be$var$ae(t);
    }
    setConfig(t) {
        this.Mr = $0fb0e9cf977607be$var$ae(t), this.rs();
    }
    add(t) {
        const i = function(t) {
            let i;
            try {
                i = $0fb0e9cf977607be$var$S(t);
            } catch (t) {
                return;
            }
            try {
                const t = JSON.parse(i);
                if (!$0fb0e9cf977607be$var$C(t)) return;
                const e = t, s = e[$0fb0e9cf977607be$var$ne], n = e[$0fb0e9cf977607be$var$re];
                if (!$0fb0e9cf977607be$var$I(s) || 0 === s.trim().length) return;
                if (!$0fb0e9cf977607be$var$I(n) && !$0fb0e9cf977607be$var$D(n)) return;
                return {
                    step: e,
                    json: i
                };
            } catch (t) {
                return;
            }
        }(t);
        if (!i) return;
        const e = function(t) {
            if ("u" > typeof TextEncoder) return (new TextEncoder).encode(t).length;
            const i = encodeURIComponent(t);
            let e = 0;
            for(let t = 0; i.length > t; t++)"%" === i[t] ? (e += 1, t += 2) : e += 1;
            return e;
        }(i.json);
        e > this.Mr.max_bytes || (this.ns.push({
            step: i.step,
            bytes: e
        }), this.ss += e, this.rs());
    }
    getAttachable() {
        return this.ns.map((t)=>t.step);
    }
    clear() {
        this.ns = [], this.ss = 0;
    }
    size() {
        return this.ns.length;
    }
    rs() {
        for(; this.ss > this.Mr.max_bytes && this.ns.length > 0;){
            const t = this.ns.shift();
            t && (this.ss -= t.bytes);
        }
    }
};
function $0fb0e9cf977607be$var$he(t, i) {
    if (!$0fb0e9cf977607be$var$D(t) || 1 / 0 === t || -1 / 0 === t) return i;
    const e = Math.floor(t);
    return 0 > e ? i : e;
}
const $0fb0e9cf977607be$var$de = (t)=>{
    if ("string" != typeof t) return t;
    try {
        return JSON.parse(t);
    } catch (i) {
        return t;
    }
};
function $0fb0e9cf977607be$var$ce(t) {
    return "string" == typeof t || t;
}
function $0fb0e9cf977607be$var$ve(t) {
    return "string" == typeof t ? t : void 0;
}
const $0fb0e9cf977607be$var$fe = [
    "$feature_flag",
    "$feature_flag_response",
    "$feature_flag_has_experiment",
    "$feature_flag_id",
    "$feature_flag_version",
    "$feature_flag_reason",
    "$feature_flag_request_id",
    "$feature_flag_evaluated_at",
    "$feature_flag_error",
    "locally_evaluated",
    "$groups",
    "$process_person_profile",
    "$geoip_disable",
    "$current_url",
    "$pathname",
    "$referring_domain",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid",
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "oppref",
    "irclid",
    "_kx",
    "$session_id",
    "$window_id",
    "$lib",
    "$lib_version",
    "$device_id",
    "$is_server"
], $0fb0e9cf977607be$var$pe = "NativeGzipValidationError", $0fb0e9cf977607be$var$_e = (t)=>t.length >= 2 && 31 === t[0] && 139 === t[1], $0fb0e9cf977607be$var$ge = (t, i)=>t === $0fb0e9cf977607be$var$_.GZipJS || i === $0fb0e9cf977607be$var$_.GZipJS || "gzip" === i, $0fb0e9cf977607be$var$me = (t)=>!(!t || "object" != typeof t) && "NotReadableError" === ("name" in t ? String(t.name) : "");
let $0fb0e9cf977607be$var$be;
const $0fb0e9cf977607be$var$ye = (t)=>{
    throw $0fb0e9cf977607be$var$ci($0fb0e9cf977607be$var$pe, `Native gzip produced invalid output: ${t}`);
}, $0fb0e9cf977607be$var$we = ($0fb0e9cf977607be$var$$e = $0fb0e9cf977607be$var$Y(function*(t, i) {
    18 > t.size && $0fb0e9cf977607be$var$ye("too-short");
    const e = new Uint8Array((yield t.slice(0, 10).arrayBuffer()));
    $0fb0e9cf977607be$var$_e(e) && 8 === e[2] || $0fb0e9cf977607be$var$ye("invalid-header");
    const s = new DataView((yield t.slice(t.size - 8).arrayBuffer()));
    s.getUint32(0, !0) !== ((t)=>{
        const i = (()=>{
            if ($0fb0e9cf977607be$var$be) return $0fb0e9cf977607be$var$be;
            $0fb0e9cf977607be$var$be = [];
            for(let t = 0; 256 > t; t++){
                let i = t;
                for(let t = 0; 8 > t; t++)i = 1 & i ? 3988292384 ^ i >>> 1 : i >>> 1;
                $0fb0e9cf977607be$var$be[t] = i >>> 0;
            }
            return $0fb0e9cf977607be$var$be;
        })();
        let e = 4294967295;
        for(let s = 0; t.length > s; s++)e = i[255 & (e ^ t[s])] ^ e >>> 8;
        return (4294967295 ^ e) >>> 0;
    })(i) && $0fb0e9cf977607be$var$ye("invalid-crc");
    const n = i.length >>> 0;
    s.getUint32(4, !0) !== n && $0fb0e9cf977607be$var$ye("invalid-size");
}), function(t, i) {
    return $0fb0e9cf977607be$var$$e.apply(this, arguments);
});
var $0fb0e9cf977607be$var$$e;
function $0fb0e9cf977607be$var$Se() {
    return $0fb0e9cf977607be$var$Se = $0fb0e9cf977607be$var$Y(function*(t, i = !0, e) {
        try {
            const i = (new TextEncoder).encode(t), e = new globalThis.CompressionStream("gzip"), n = e.writable.getWriter(), r = n.write(i).then(()=>n.close()).catch((s = $0fb0e9cf977607be$var$Y(function*(t) {
                try {
                    yield n.abort(t);
                } catch (t) {}
                throw t;
            }), function(t) {
                return s.apply(this, arguments);
            })), o = new Response(e.readable).blob(), [l] = yield Promise.all([
                o,
                r
            ]);
            return yield $0fb0e9cf977607be$var$we(l, i), l;
        } catch (t) {
            if (null == e ? void 0 : e.rethrow) throw t;
            return i && console.error("Failed to gzip compress data", t), null;
        }
        var s;
    }), $0fb0e9cf977607be$var$Se.apply(this, arguments);
}
function $0fb0e9cf977607be$var$xe(t, i) {
    if (null == t) return {};
    var e, s, n = function(t, i) {
        if (null == t) return {};
        var e = {};
        for(var s in t)if (({}).hasOwnProperty.call(t, s)) {
            if (i.includes(s)) continue;
            e[s] = t[s];
        }
        return e;
    }(t, i);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        for(s = 0; r.length > s; s++)i.includes(e = r[s]) || ({}).propertyIsEnumerable.call(t, e) && (n[e] = t[e]);
    }
    return n;
}
const $0fb0e9cf977607be$var$Ee = {}.propertyIsEnumerable;
function $0fb0e9cf977607be$var$ke(t, i) {
    try {
        return $0fb0e9cf977607be$var$Ce(t, i, {
            ancestors: new WeakSet,
            remainingNodes: 1e4
        }, 0);
    } catch (t) {
        return [];
    }
}
function $0fb0e9cf977607be$var$Te(t, i, e, s) {
    if (0 >= e.remainingNodes) return {
        stringValue: $0fb0e9cf977607be$var$ni
    };
    if (e.remainingNodes--, $0fb0e9cf977607be$var$j(t)) return {
        boolValue: t
    };
    if ("bigint" == typeof t) return function(t, i) {
        const e = t.toString(), s = BigInt("9223372036854775808");
        return t >= s || -s > t ? (null == i || i.debug(`Attribute ${e} is outside the int64 range; encoding it as a string`), {
            stringValue: e
        }) : {
            intValue: e
        };
    }(t, i);
    if ("number" == typeof t) {
        if (!Number.isFinite(t)) return {
            stringValue: String(t)
        };
        if (Number.isInteger(t)) {
            if (Number.isSafeInteger(t)) return {
                intValue: String(t)
            };
            if (typeof BigInt > "u") return {
                stringValue: String(t)
            };
            const e = BigInt(t).toString();
            return t >= 0x8000000000000000 || -9223372036854776000 > t ? (null == i || i.debug(`Attribute ${e} is outside the int64 range; encoding it as a string`), {
                stringValue: e
            }) : {
                intValue: e
            };
        }
        return {
            doubleValue: t
        };
    }
    if ("string" == typeof t) return {
        stringValue: $0fb0e9cf977607be$var$oi(t)
    };
    if ("function" == typeof t) return {
        stringValue: "[Function]"
    };
    if ("symbol" == typeof t) return {
        stringValue: String(t)
    };
    if ("object" == typeof t && null !== t) {
        if (e.ancestors.has(t)) return {
            stringValue: "[Circular]"
        };
        if (s >= 20) return {
            stringValue: $0fb0e9cf977607be$var$ni
        };
        if (t instanceof Date) {
            const i = t.getTime(), e = Number.isFinite(i) ? t.toISOString() : String(t);
            return {
                stringValue: "string" == typeof e ? $0fb0e9cf977607be$var$oi(e) : String(e)
            };
        }
        e.ancestors.add(t);
        try {
            try {
                const n = t.toJSON;
                if ("function" == typeof n) return $0fb0e9cf977607be$var$Te(n.call(t), i, e, s + 1);
            } catch (t) {}
            return $0fb0e9cf977607be$var$T(t) ? {
                arrayValue: {
                    values: $0fb0e9cf977607be$var$Pe(t, i, e, s + 1)
                }
            } : {
                kvlistValue: {
                    values: $0fb0e9cf977607be$var$Ce(t, i, e, s + 1)
                }
            };
        } finally{
            e.ancestors.delete(t);
        }
    }
    return {
        stringValue: $0fb0e9cf977607be$var$oi(String(t))
    };
}
function $0fb0e9cf977607be$var$Pe(t, i, e, s) {
    const n = [], r = Math.min(t.length, 1e3);
    let o = 0;
    for(; r > o && e.remainingNodes > 0; o++)try {
        const r = o in t ? t[o] : void 0;
        if ($0fb0e9cf977607be$var$F(r)) continue;
        n.push($0fb0e9cf977607be$var$Te(r, i, e, s));
    } catch (t) {
        n.push({
            stringValue: $0fb0e9cf977607be$var$ri
        });
    }
    return t.length > o && n.push({
        stringValue: $0fb0e9cf977607be$var$ni
    }), n;
}
function $0fb0e9cf977607be$var$Ce(t, i, e, s) {
    const n = [];
    for(const r in t)if ($0fb0e9cf977607be$var$Ee.call(t, r)) {
        if (!r) {
            null == i || i.debug("Dropping an attribute with an empty key");
            continue;
        }
        if (n.length >= 1e3 || 0 >= e.remainingNodes) {
            null == i || i.debug("Attributes truncated: the value exceeds the OTLP encoder budget");
            break;
        }
        try {
            const o = t[r];
            if ($0fb0e9cf977607be$var$A(o) || $0fb0e9cf977607be$var$R(o)) continue;
            n.push({
                key: $0fb0e9cf977607be$var$oi(r),
                value: $0fb0e9cf977607be$var$Te(o, i, e, s)
            });
        } catch (t) {
            n.push({
                key: $0fb0e9cf977607be$var$oi(r),
                value: {
                    stringValue: $0fb0e9cf977607be$var$ri
                }
            });
        }
    }
    return n;
}
function $0fb0e9cf977607be$var$Oe(t, i, e) {
    return $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, $0fb0e9cf977607be$var$li({}, t.resourceAttributes)), {}, {
        "service.name": t.serviceName || "unknown_service"
    }, t.environment && {
        "deployment.environment": t.environment
    }), t.serviceVersion && {
        "service.version": t.serviceVersion
    }), {}, {
        "telemetry.sdk.name": i,
        "telemetry.sdk.version": e
    });
}
const $0fb0e9cf977607be$var$Re = [
    "service.name",
    "deployment.environment",
    "service.version",
    "telemetry.sdk.name",
    "telemetry.sdk.version"
];
function $0fb0e9cf977607be$var$Ie(t, i) {
    const e = $0fb0e9cf977607be$var$li({}, t), s = {};
    for (const t of $0fb0e9cf977607be$var$Re)({}).hasOwnProperty.call(e, t) && (s[t] = e[t], delete e[t]);
    return [
        ...$0fb0e9cf977607be$var$ke(e, i),
        ...$0fb0e9cf977607be$var$ke(s, i)
    ];
}
const $0fb0e9cf977607be$var$Me = {
    darwin: "macOS",
    win32: "Windows",
    cygwin: "Windows",
    linux: "Linux",
    android: "Android",
    freebsd: "FreeBSD",
    openbsd: "OpenBSD",
    netbsd: "NetBSD",
    sunos: "SunOS",
    aix: "AIX",
    haiku: "Haiku",
    "Mac OS X": "macOS"
};
const $0fb0e9cf977607be$var$Ae = {
    trace: {
        text: "TRACE",
        number: 1
    },
    debug: {
        text: "DEBUG",
        number: 5
    },
    info: {
        text: "INFO",
        number: 9
    },
    warn: {
        text: "WARN",
        number: 13
    },
    error: {
        text: "ERROR",
        number: 17
    },
    fatal: {
        text: "FATAL",
        number: 21
    }
}, $0fb0e9cf977607be$var$Fe = $0fb0e9cf977607be$var$Ae.info;
function $0fb0e9cf977607be$var$De(t) {
    try {
        return $0fb0e9cf977607be$var$oi(String(t));
    } catch (t) {
        return $0fb0e9cf977607be$var$ri;
    }
}
function $0fb0e9cf977607be$var$Ne(t, i, e, s) {
    const n = t.level || "info", { text: r, number: o } = $0fb0e9cf977607be$var$Ae[n] || $0fb0e9cf977607be$var$Fe, l = function(t = Date.now()) {
        return String(t) + "000000";
    }($0fb0e9cf977607be$var$D(s) ? s : void 0), a = {};
    i.distinctId && (a.posthogDistinctId = i.distinctId), i.sessionId && (a.sessionId = i.sessionId), i.windowId && (a["window.id"] = i.windowId), $0fb0e9cf977607be$var$F(i.sessionStartTimestamp) || (a.sessionStartTimestamp = String(i.sessionStartTimestamp)), $0fb0e9cf977607be$var$F(i.lastActivityTimestamp) || (a.lastActivityTimestamp = String(i.lastActivityTimestamp)), i.currentUrl && (a["url.full"] = i.currentUrl), i.screenName && (a["screen.name"] = i.screenName), i.appState && (a["app.state"] = i.appState), i.activeFeatureFlags && i.activeFeatureFlags.length > 0 && (a.feature_flags = i.activeFeatureFlags);
    const u = $0fb0e9cf977607be$var$Ei({}, a), h = t.attributes;
    if (h) {
        let t = [];
        try {
            t = Object.keys(h);
        } catch (i) {
            t = [];
        }
        for (const i of t){
            let t;
            try {
                t = h[i];
            } catch (i) {
                t = $0fb0e9cf977607be$var$ri;
            }
            Object.defineProperty(u, i, {
                value: t,
                enumerable: !0,
                writable: !0,
                configurable: !0
            });
        }
    }
    const d = {
        timeUnixNano: l,
        observedTimeUnixNano: l,
        severityNumber: o,
        severityText: r,
        body: {
            stringValue: $0fb0e9cf977607be$var$De(t.body)
        },
        attributes: $0fb0e9cf977607be$var$ke(u, e)
    };
    return t.trace_id && (d.traceId = t.trace_id), t.span_id && (d.spanId = t.span_id), $0fb0e9cf977607be$var$R(t.trace_flags) || (d.flags = t.trace_flags), d;
}
function $0fb0e9cf977607be$var$je(t, i, e) {
    return $0fb0e9cf977607be$var$Oe(t, i, e);
}
function $0fb0e9cf977607be$var$Le(t, i, e, s) {
    return {
        resourceLogs: [
            {
                resource: {
                    attributes: $0fb0e9cf977607be$var$Ie(i)
                },
                scopeLogs: [
                    {
                        scope: {
                            name: e,
                            version: s
                        },
                        logRecords: t
                    }
                ]
            }
        ]
    };
}
var $0fb0e9cf977607be$var$Be = class {
    constructor(t){
        this.ls = t, this.us = 0;
    }
    get pending() {
        return !!this.hs;
    }
    arm(t) {
        this.clear(), this.us = Date.now() + t, this.hs = $0fb0e9cf977607be$var$pi(()=>{
            this.hs = void 0, this.ls();
        }, t);
    }
    armNoEarlierThan(t) {
        this.hs && Date.now() + t <= this.us || this.arm(t);
    }
    clear() {
        this.hs && (clearTimeout(this.hs), this.hs = void 0);
    }
};
function $0fb0e9cf977607be$var$Ue() {
    return .75 + .5 * Math.random();
}
function $0fb0e9cf977607be$var$ze(t, i, e, s) {
    const n = Math.min(Math.max(0, i - 1), 6), r = t * Math.pow(2, n);
    return Math.round((void 0 === s ? r : Math.min(r, Math.max(s, t))) * e);
}
var $0fb0e9cf977607be$var$He = class {
    constructor(t, i, e, s, n, r = ()=>Promise.resolve(), o){
        var l;
        this._instance = t, this.Mr = i, this.A = e, this.cs = s, this.ds = n, this.vs = r, this.fs = o, this.ps = new $0fb0e9cf977607be$var$Be(()=>this.gs()), this.ys = null, this.bs = 0, this._s = 0, this.ws = new $0fb0e9cf977607be$var$ui, this.ks = 0, this.Ss = 1, this.xs = 0, this.$s = 0, this.Cs = !1, this.Ts = i.maxBufferSize, this.Is = Math.max(null !== (l = i.maxQueueSize) && void 0 !== l ? l : i.maxBufferSize, i.maxBufferSize), this.Ms = i.flushIntervalMs, this.Es = i.maxBatchRecordsPerPost, this.Ps = i.rateCapWindowMs, this.Rs = i.maxLogsPerInterval;
    }
    clearQueue() {
        this._s++, this._instance.setPersistedProperty($0fb0e9cf977607be$var$p.LogsQueue, []);
    }
    reset() {
        this.ps.clear(), this.xs = 0, this.$s = 0, this.Cs = !1, this.ks = 0, this.Ss = 1, this.ws.reset(), this.Es = this.Mr.maxBatchRecordsPerPost;
    }
    onReconnect() {
        this.ks = 0, this.Ss = 1, this.ws.isOpen() ? this.As() && this.Os() : this.gs();
    }
    captureLog(t, i) {
        var e;
        if (this._instance.isDisabled) return;
        if (this._instance.optedOut) return;
        if (!(null == t ? void 0 : t.body)) return;
        const s = this.Fs(t);
        if (null === s) return;
        if (!s.body) return void this.A.info("Log was rejected in beforeSend function");
        if (!this.Ds()) return;
        const n = {
            record: $0fb0e9cf977607be$var$Ne(s, null !== (e = null == i ? void 0 : i.context) && void 0 !== e ? e : this.cs(), this.A, null == i ? void 0 : i.occurredAtMs)
        };
        this.ds(()=>this.Ls(n));
    }
    Fs(t) {
        const i = this.Mr.beforeSend;
        if (!i) return t;
        const e = $0fb0e9cf977607be$var$T(i) ? i : [
            i
        ];
        let s = t;
        for (const t of e)try {
            const i = t(s);
            if (!i) return this.A.info("Log was rejected in beforeSend function"), null;
            s = i;
        } catch (t) {
            return this.A.error("Error in beforeSend function for log:", t), null;
        }
        return s;
    }
    Ds() {
        if (void 0 === this.Rs) return !0;
        const t = Date.now(), i = t - this.xs;
        return this.Ps > i && i >= 0 || (this.xs = t, this.$s = 0, this.Cs = !1), this.Rs > this.$s ? (this.$s++, !0) : (this.Cs || (this.A.warn(`captureLog dropping logs: exceeded ${this.Rs} logs per ${this.Ps}ms`), this.Cs = !0), !1);
    }
    flush() {
        var t = this;
        return $0fb0e9cf977607be$var$Y(function*() {
            if (!t._instance.isDisabled) return t.ys || (t.ys = t.Ns().finally(()=>{
                t.ys = null;
            })), t.ys;
        })();
    }
    Ns() {
        var t = this;
        return $0fb0e9cf977607be$var$Y(function*() {
            var i;
            t.ps.clear();
            let e = null !== (i = t._instance.getPersistedProperty($0fb0e9cf977607be$var$p.LogsQueue)) && void 0 !== i ? i : [];
            if (0 === e.length) return;
            const s = e.length;
            let n = 0;
            for(; e.length > 0 && s > n;){
                var r, o;
                const i = t._s;
                t.bs = 0;
                const s = Math.min(e.length, t.Es), l = e.slice(0, s), a = $0fb0e9cf977607be$var$Le(l.map((t)=>t.record), t.qs(), null !== (r = t.fs) && void 0 !== r ? r : t._instance.getLibraryId(), t._instance.getLibraryVersion()), u = yield t._instance.js(a);
                if (t._s !== i) return;
                if ("too-large" === u.kind && l.length > 1) t.Es = Math.max(1, Math.floor(l.length / 2)), t.A.warn(`Logs batch of size ${l.length} was too large for the ingestion endpoint, reducing batch size to ${t.Es}`);
                else {
                    if (t.ws.record(u), t.ps.pending && t.ps.arm(Math.max(t.Ms, t.ws.remainingMs())), "retry-later" === u.kind) throw u.error;
                    if ("too-large" === u.kind ? t.A.warn("Dropping a single log record with batch size 1 \u2014 the record is larger than the server cap and cannot be split further.") : "ok" === u.kind && t.Mr.maxBatchRecordsPerPost > t.Es && (t.Es = Math.min(t.Mr.maxBatchRecordsPerPost, t.Es + 1)), yield t.Bs(l.length), e = null !== (o = t._instance.getPersistedProperty($0fb0e9cf977607be$var$p.LogsQueue)) && void 0 !== o ? o : [], n += l.length, "fatal" === u.kind) throw u.error;
                }
            }
        })();
    }
    Bs(t) {
        var i = this;
        return $0fb0e9cf977607be$var$Y(function*() {
            var e;
            const s = Math.max(0, t - i.bs), n = null !== (e = i._instance.getPersistedProperty($0fb0e9cf977607be$var$p.LogsQueue)) && void 0 !== e ? e : [];
            i._instance.setPersistedProperty($0fb0e9cf977607be$var$p.LogsQueue, n.slice(s)), yield i.vs();
        })();
    }
    qs() {
        return $0fb0e9cf977607be$var$je(this.Mr, this._instance.getLibraryId(), this._instance.getLibraryVersion());
    }
    Ls(t) {
        var i;
        if (this._instance.optedOut) return;
        const e = null !== (i = this._instance.getPersistedProperty($0fb0e9cf977607be$var$p.LogsQueue)) && void 0 !== i ? i : [];
        this.Is > e.length || (e.shift(), this.bs++, this.A.info("Logs queue is full, dropping oldest record.")), e.push(t), this._instance.setPersistedProperty($0fb0e9cf977607be$var$p.LogsQueue, e), this.Ts > e.length || this.ws.isOpen() ? this.Os() : this.gs();
    }
    Os() {
        this.ps.pending || this.ps.arm(Math.max(this.Ms, this.ws.remainingMs()));
    }
    Hs() {
        return Math.max($0fb0e9cf977607be$var$ze(this.Ms, this.ks, this.Ss, 3e4), this.ws.remainingMs());
    }
    As() {
        const t = this._instance.getPersistedProperty($0fb0e9cf977607be$var$p.LogsQueue);
        return !!t && t.length > 0;
    }
    shutdown(t) {
        var i = this;
        return $0fb0e9cf977607be$var$Y(function*() {
            i.ps.clear();
            const e = i.flush().catch(()=>{});
            void 0 !== t ? yield $0fb0e9cf977607be$var$_i(e, t) : yield e;
        })();
    }
    flushWithTimeout(t) {
        var i = this;
        return $0fb0e9cf977607be$var$Y(function*() {
            const e = i.flush();
            yield $0fb0e9cf977607be$var$_i(e, t, ()=>{
                e.catch(()=>{});
            });
        })();
    }
    gs() {
        this.flush().then(()=>{
            this.ks = 0, this.Ss = 1;
        }, (t)=>{
            this.ks++, this.Ss = $0fb0e9cf977607be$var$Ue(), this.A.error("PostHog logs flush failed:", t);
        }).finally(()=>{
            !this._instance.isDisabled && this.As() && this.ps.armNoEarlierThan(this.Hs());
        });
    }
};
const $0fb0e9cf977607be$var$qe = [
    0,
    5,
    10,
    25,
    50,
    75,
    100,
    250,
    500,
    750,
    1e3,
    2500,
    5e3,
    7500,
    1e4
];
function $0fb0e9cf977607be$var$Ve(t) {
    return String(t) + "000000";
}
function $0fb0e9cf977607be$var$We(t, i, e, s) {
    let n = "";
    return s && (n = Object.keys(s).sort().map((t)=>`${JSON.stringify(t)}:${JSON.stringify(s[t])}`).join(",")), `${t}\0${i}\0${null != e ? e : ""}\0${n}`;
}
var $0fb0e9cf977607be$var$Ge = class {
    constructor(t, i, e){
        this._instance = t, this.Mr = i, this.A = e, this.zs = new Map, this.ps = new $0fb0e9cf977607be$var$Be(()=>this.flush().catch((t)=>{
                this.A.error("Metrics flush failed:", t);
            })), this.ys = null, this.Us = !1, this.Ws = new Map, this.Vs = new Set, this.ws = new $0fb0e9cf977607be$var$ui, this.ks = 0, this.Ss = 1, this.Gs = 0;
    }
    count(t, i = 1, e) {
        this.Qs({
            name: t,
            type: "count",
            value: i,
            unit: null == e ? void 0 : e.unit,
            attributes: null == e ? void 0 : e.attributes
        });
    }
    gauge(t, i, e) {
        this.Qs({
            name: t,
            type: "gauge",
            value: i,
            unit: null == e ? void 0 : e.unit,
            attributes: null == e ? void 0 : e.attributes
        });
    }
    histogram(t, i, e) {
        this.Qs({
            name: t,
            type: "histogram",
            value: i,
            unit: null == e ? void 0 : e.unit,
            attributes: null == e ? void 0 : e.attributes
        });
    }
    flush() {
        var t = this;
        const i = this.ys, e = (function() {
            var e = $0fb0e9cf977607be$var$Y(function*() {
                i && (yield i.catch(()=>{})), yield t.Js();
            });
            return function() {
                return e.apply(this, arguments);
            };
        })()().finally(()=>{
            this.ys === e && (this.ys = null);
        });
        return this.ys = e, e;
    }
    drainWindow() {
        if (0 === this.zs.size) return null;
        const t = this.zs;
        return this.zs = new Map, this.Us = !1, this.Ws = new Map, this.Vs = new Set, this.Zs(t);
    }
    reset() {
        this.Gs++, this.ws.reset(), this.ks = 0, this.Ss = 1, this.ps.clear(), this.zs = new Map, this.ys = null, this.Us = !1, this.Ws = new Map, this.Vs = new Set;
    }
    Qs(t) {
        if (this._instance.isDisabled || this._instance.optedOut) return;
        const i = this.Fs(t);
        if (null === i) return;
        if (!i.name || "string" != typeof i.name) return void this.A.warn("Dropping metric with empty name");
        if ("number" != typeof i.value || !Number.isFinite(i.value)) return void this.A.warn(`Dropping metric '${i.name}': value must be a finite number`);
        if ("count" === i.type && 0 > i.value) return void this.A.warn(`Dropping count '${i.name}': counters are monotonic, value must be >= 0`);
        let e, s;
        try {
            e = i.attributes ? $0fb0e9cf977607be$var$Ei({}, i.attributes) : void 0, s = $0fb0e9cf977607be$var$We(i.type, i.name, i.unit, e);
        } catch (t) {
            return void this.A.warn(`Dropping metric '${i.name}': attributes could not be serialized`, t);
        }
        let n = this.zs.get(s);
        if (!n) {
            if (!this.Ks()) return;
            n = {
                name: i.name,
                type: i.type,
                unit: i.unit,
                attributes: e,
                windowStartMs: Date.now()
            }, this.zs.set(s, n);
        }
        const r = this.Ws.get(i.name);
        void 0 === r ? this.Ws.set(i.name, i.type) : r === i.type || this.Vs.has(i.name) || (this.Vs.add(i.name), this.A.warn(`Metric name '${i.name}' is already used as a ${r}; recording it as a ${i.type} too will blend both series in charts. Use a distinct name.`)), this.Xs(n, i.value), this.Os();
    }
    Ks() {
        return this.Mr.maxSeriesPerFlush > this.zs.size || (this.Us || (this.Us = !0, this.A.warn(`Metric series cap reached (${this.Mr.maxSeriesPerFlush} per flush window); dropping new series until the next flush. Reduce attribute cardinality.`)), !1);
    }
    Xs(t, i) {
        switch(t.type){
            case "count":
                var e;
                t.total = (null !== (e = t.total) && void 0 !== e ? e : 0) + i;
                break;
            case "gauge":
                t.last = i;
                break;
            case "histogram":
                {
                    t.hist || (t.hist = {
                        count: 0,
                        sum: 0,
                        min: i,
                        max: i,
                        bucketCounts: new Array($0fb0e9cf977607be$var$qe.length + 1).fill(0)
                    });
                    const e = t.hist;
                    e.count += 1, e.sum += i, e.min = Math.min(e.min, i), e.max = Math.max(e.max, i), e.bucketCounts[function(t, i) {
                        for(let e = 0; i.length > e; e++)if (i[e] >= t) return e;
                        return i.length;
                    }(i, $0fb0e9cf977607be$var$qe)] += 1;
                    break;
                }
        }
    }
    Fs(t) {
        const i = this.Mr.beforeSend;
        if (!i) return t;
        const e = $0fb0e9cf977607be$var$T(i) ? i : [
            i
        ];
        let s = t;
        for (const t of e)try {
            const i = t(s);
            if (!i) return this.A.info("Metric was rejected in beforeSend function"), null;
            s = i;
        } catch (t) {
            return this.A.error("Error in beforeSend function for metric:", t), null;
        }
        return s;
    }
    Os() {
        this.ps.pending || this.ps.arm(this.Hs());
    }
    Hs() {
        return Math.max($0fb0e9cf977607be$var$ze(this.Mr.flushIntervalMs, this.ks, this.Ss, 3e4), this.ws.remainingMs());
    }
    Js() {
        var t = this;
        return $0fb0e9cf977607be$var$Y(function*() {
            if (t.ps.clear(), 0 === t.zs.size) return;
            const i = t.zs;
            t.zs = new Map, t.Us = !1, t.Ws = new Map, t.Vs = new Set;
            const e = t.Gs, s = yield t._instance.Ys(t.Zs(i));
            if (e === t.Gs) switch(t.ws.record(s), "retry-later" === s.kind ? (t.ks++, t.Ss = $0fb0e9cf977607be$var$Ue()) : (t.ks = 0, t.Ss = 1), t.ps.pending && t.ps.arm(t.Hs()), s.kind){
                case "ok":
                    return;
                case "retry-later":
                    return t.ho(i), void t.ps.armNoEarlierThan(t.Hs());
                case "too-large":
                    return void t.A.warn("Metrics batch exceeded the server size limit and was dropped");
                case "fatal":
                    return void t.A.error("Failed to send metrics batch:", s.error);
            }
        })();
    }
    Zs(t) {
        var i, e, s, n;
        return i = this.co(t), e = function(t, i, e) {
            return $0fb0e9cf977607be$var$Oe(t, i, e);
        }(this.Mr, this._instance.getLibraryId(), this._instance.getLibraryVersion()), s = this._instance.getLibraryId(), n = this._instance.getLibraryVersion(), {
            resourceMetrics: [
                {
                    resource: {
                        attributes: $0fb0e9cf977607be$var$Ie(e)
                    },
                    scopeMetrics: [
                        {
                            scope: {
                                name: s,
                                version: n
                            },
                            metrics: i
                        }
                    ]
                }
            ]
        };
    }
    co(t) {
        const i = $0fb0e9cf977607be$var$Ve(Date.now()), e = new Map;
        for (const o of t.values()){
            var s;
            const t = $0fb0e9cf977607be$var$We(o.type, o.name, o.unit, void 0);
            let l = e.get(t);
            l || (l = $0fb0e9cf977607be$var$Ei({
                name: o.name
            }, o.unit && {
                unit: o.unit
            }), "count" === o.type ? l.sum = {
                aggregationTemporality: 1,
                isMonotonic: !0,
                dataPoints: []
            } : "gauge" === o.type ? l.gauge = {
                dataPoints: []
            } : l.histogram = {
                aggregationTemporality: 1,
                dataPoints: []
            }, e.set(t, l));
            const a = $0fb0e9cf977607be$var$ke(null !== (s = o.attributes) && void 0 !== s ? s : {}, this.A), u = $0fb0e9cf977607be$var$Ve(o.windowStartMs);
            if ("count" === o.type) {
                var n;
                const t = {
                    attributes: a,
                    startTimeUnixNano: u,
                    timeUnixNano: i,
                    asDouble: null !== (n = o.total) && void 0 !== n ? n : 0
                };
                l.sum.dataPoints.push(t);
            } else if ("gauge" === o.type) {
                var r;
                const t = {
                    attributes: a,
                    timeUnixNano: i,
                    asDouble: null !== (r = o.last) && void 0 !== r ? r : 0
                };
                l.gauge.dataPoints.push(t);
            } else o.hist && l.histogram.dataPoints.push({
                attributes: a,
                startTimeUnixNano: u,
                timeUnixNano: i,
                count: o.hist.count,
                sum: o.hist.sum,
                min: o.hist.min,
                max: o.hist.max,
                bucketCounts: o.hist.bucketCounts,
                explicitBounds: $0fb0e9cf977607be$var$qe
            });
        }
        return Array.from(e.values());
    }
    ho(t) {
        for (const [s, n] of t){
            const t = this.zs.get(s);
            if (t) switch(t.windowStartMs = Math.min(t.windowStartMs, n.windowStartMs), t.type){
                case "count":
                    var i, e;
                    t.total = (null !== (i = t.total) && void 0 !== i ? i : 0) + (null !== (e = n.total) && void 0 !== e ? e : 0);
                    break;
                case "gauge":
                    break;
                case "histogram":
                    if (n.hist) {
                        if (t.hist) {
                            t.hist.count += n.hist.count, t.hist.sum += n.hist.sum, t.hist.min = Math.min(t.hist.min, n.hist.min), t.hist.max = Math.max(t.hist.max, n.hist.max);
                            for(let i = 0; t.hist.bucketCounts.length > i; i++)t.hist.bucketCounts[i] += n.hist.bucketCounts[i];
                        } else t.hist = n.hist;
                    }
            }
            else this.Ks() && this.zs.set(s, n);
        }
    }
};
const $0fb0e9cf977607be$var$Ke = (i, { debugEnabled: e } = {})=>{
    const s = {
        N (s, ...n) {
            $0fb0e9cf977607be$var$t && ($0fb0e9cf977607be$var$f.DEBUG || $0fb0e9cf977607be$var$t.POSTHOG_DEBUG || e) && !$0fb0e9cf977607be$var$R($0fb0e9cf977607be$var$t.console) && $0fb0e9cf977607be$var$t.console && ("__rrweb_original__" in $0fb0e9cf977607be$var$t.console[s] ? $0fb0e9cf977607be$var$t.console[s].__rrweb_original__ : $0fb0e9cf977607be$var$t.console[s])(i, ...n);
        },
        debug (...t) {
            s.N("debug", ...t);
        },
        info (...t) {
            s.N("log", ...t);
        },
        warn (...t) {
            s.N("warn", ...t);
        },
        error (...t) {
            s.N("error", ...t);
        },
        critical (...t) {
            console.error(i, ...t);
        },
        uninitializedWarning (t) {
            s.error(`You must initialize PostHog before calling ${t}`);
        },
        createLogger: (t, e)=>$0fb0e9cf977607be$var$Ke(`${i} ${t}`, e)
    };
    return s;
}, $0fb0e9cf977607be$var$Je = $0fb0e9cf977607be$var$Ke("[PostHog.js]"), $0fb0e9cf977607be$var$Ye = $0fb0e9cf977607be$var$Je.createLogger, $0fb0e9cf977607be$var$Xe = $0fb0e9cf977607be$var$Ye("[ExternalScriptsLoader]"), $0fb0e9cf977607be$var$Qe = (t)=>{
    const i = null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.querySelectorAll("script");
    if (i) {
        for(let e = 0; i.length > e; e++)if (i[e].src === t || i[e].getAttribute("src") === t) return i[e];
    }
}, $0fb0e9cf977607be$var$Ze = (t, i, e)=>{
    if (t.config.disable_external_dependency_loading) return $0fb0e9cf977607be$var$Xe.warn(`${i} was requested but loading of external scripts is disabled.`), e("Loading of external scripts is disabled");
    const n = $0fb0e9cf977607be$var$Qe(i);
    if (n) {
        if (n.__posthog_loading_callback_fired) return e();
        const t = n.__posthog_loading_error;
        return t ? e(t) : (n.addEventListener("load", (t)=>{
            n.__posthog_loading_callback_fired = !0, e(void 0, t);
        }), void n.addEventListener("error", (t)=>{
            n.__posthog_loading_error = t, e(t);
        }));
    }
    const r = ()=>{
        if (!$0fb0e9cf977607be$var$s) return e("document not found");
        if ($0fb0e9cf977607be$var$Qe(i)) return $0fb0e9cf977607be$var$Ze(t, i, e);
        let n = $0fb0e9cf977607be$var$s.createElement("script");
        if (n.type = "text/javascript", n.crossOrigin = "anonymous", n.src = i, n.onload = (t)=>{
            n.__posthog_loading_callback_fired = !0, e(void 0, t);
        }, n.onerror = (t)=>{
            n.__posthog_loading_error = t, e(t);
        }, t.config.prepare_external_dependency_script && (n = t.config.prepare_external_dependency_script(n)), !n) return e("prepare_external_dependency_script returned null");
        if ("head" === t.config.external_scripts_inject_target) $0fb0e9cf977607be$var$s.head.appendChild(n);
        else {
            const t = $0fb0e9cf977607be$var$s.querySelectorAll("body > script");
            var r;
            t.length > 0 ? null === (r = t[0].parentNode) || void 0 === r || r.insertBefore(n, t[0]) : $0fb0e9cf977607be$var$s.body.appendChild(n);
        }
    };
    (null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.body) ? r() : null == $0fb0e9cf977607be$var$s || $0fb0e9cf977607be$var$s.addEventListener("DOMContentLoaded", r);
}, $0fb0e9cf977607be$var$ts = {}, $0fb0e9cf977607be$var$is = (t, i)=>{
    let e = `/static/${i}.js?v=${t.version}`;
    if ("toolbar" === i) {
        const t = 3e5;
        e = `${e}&t=${Math.floor(Date.now() / t) * t}`;
    }
    return t.requestRouter.endpointFor("assets", e);
};
$0fb0e9cf977607be$var$c.__PosthogExtensions__ = $0fb0e9cf977607be$var$c.__PosthogExtensions__ || {}, $0fb0e9cf977607be$var$c.__PosthogExtensions__.loadExternalDependency = (t, i, e)=>{
    if ("remote-config" === i) {
        const i = t.requestRouter.endpointFor("assets", `/array/${t.config.token}/config.js`);
        return void $0fb0e9cf977607be$var$Ze(t, i, e);
    }
    const s = t.config.strict_script_versioning;
    if (s) {
        const n = t.requestRouter.endpointFor("assets", `/static/${t.version}/${i}.js`), r = $0fb0e9cf977607be$var$ts[n];
        if ("fallback" === s && r) {
            if ($0fb0e9cf977607be$var$Qe(r)) return void $0fb0e9cf977607be$var$Ze(t, r, e);
            delete $0fb0e9cf977607be$var$ts[n];
        }
        return void $0fb0e9cf977607be$var$Ze(t, n, "fallback" === s ? (s, r)=>{
            if (s) {
                if ("string" == typeof s) e(s);
                else {
                    var o;
                    const s = $0fb0e9cf977607be$var$is(t, i);
                    $0fb0e9cf977607be$var$ts[n] = s;
                    const r = $0fb0e9cf977607be$var$Qe(n);
                    null == r || null === (o = r.parentNode) || void 0 === o || o.removeChild(r), $0fb0e9cf977607be$var$Ze(t, s, e);
                }
            } else e(void 0, r);
        } : e);
    }
    $0fb0e9cf977607be$var$Ze(t, $0fb0e9cf977607be$var$is(t, i), e);
}, $0fb0e9cf977607be$var$c.__PosthogExtensions__.loadSiteApp = (t, i, e)=>{
    const s = t.requestRouter.endpointFor("api", i);
    $0fb0e9cf977607be$var$Ze(t, s, e);
}, $0fb0e9cf977607be$var$f.DEBUG = !1, $0fb0e9cf977607be$var$f.LIB_VERSION = "1.435.9", $0fb0e9cf977607be$var$f.LIB_NAME = "web";
var $0fb0e9cf977607be$var$es = $0fb0e9cf977607be$var$f;
const $0fb0e9cf977607be$var$ss = "$people_distinct_id", $0fb0e9cf977607be$var$ns = "distinct_id", $0fb0e9cf977607be$var$rs = "$device_id", $0fb0e9cf977607be$var$os = "$device_model", $0fb0e9cf977607be$var$ls = "__alias", $0fb0e9cf977607be$var$as = "__cmpns", $0fb0e9cf977607be$var$us = "$fbc", $0fb0e9cf977607be$var$hs = "$fbc_persistence", $0fb0e9cf977607be$var$ds = "$fbp", $0fb0e9cf977607be$var$cs = "$fbp_persistence", $0fb0e9cf977607be$var$vs = "__timers", $0fb0e9cf977607be$var$fs = "$autocapture_disabled_server_side", $0fb0e9cf977607be$var$ps = "$heatmaps_enabled_server_side", $0fb0e9cf977607be$var$_s = "$exception_capture_enabled_server_side", $0fb0e9cf977607be$var$gs = "$error_tracking_suppression_rules", $0fb0e9cf977607be$var$ms = "$error_tracking_capture_extension_exceptions", $0fb0e9cf977607be$var$bs = "$web_vitals_enabled_server_side", $0fb0e9cf977607be$var$ys = "$dead_clicks_enabled_server_side", $0fb0e9cf977607be$var$ws = "$product_tours_enabled_server_side", $0fb0e9cf977607be$var$$s = "$logs_capture_enabled_server_side", $0fb0e9cf977607be$var$Ss = "$web_vitals_allowed_metrics", $0fb0e9cf977607be$var$xs = "$session_recording_remote_config", $0fb0e9cf977607be$var$Es = "$session_recording_enabled_server_side", $0fb0e9cf977607be$var$ks = "$replay_sample_rate", $0fb0e9cf977607be$var$Ts = "$replay_override_sampling", $0fb0e9cf977607be$var$Ps = "$replay_override_linked_flag", $0fb0e9cf977607be$var$Cs = "$replay_override_url_trigger", $0fb0e9cf977607be$var$Os = "$replay_override_event_trigger", $0fb0e9cf977607be$var$Rs = "$sesid", $0fb0e9cf977607be$var$Is = "$session_is_sampled", $0fb0e9cf977607be$var$Ms = "$session_past_minimum_duration", $0fb0e9cf977607be$var$As = "$session_recording_url_trigger_activated_session", $0fb0e9cf977607be$var$Fs = "$session_recording_event_trigger_activated_session", $0fb0e9cf977607be$var$Ds = "$debug_first_full_snapshot_timestamp", $0fb0e9cf977607be$var$Ns = "$sess_rec_flush_size", $0fb0e9cf977607be$var$js = "$enabled_feature_flags", $0fb0e9cf977607be$var$Ls = "$active_feature_flags", $0fb0e9cf977607be$var$Bs = "$early_access_features", $0fb0e9cf977607be$var$Us = "$feature_flag_details", $0fb0e9cf977607be$var$zs = "$feature_flag_payloads", $0fb0e9cf977607be$var$Hs = "$feature_flag_request_id", $0fb0e9cf977607be$var$qs = "$minimal_flag_called_events", $0fb0e9cf977607be$var$Vs = "$override_feature_flags", $0fb0e9cf977607be$var$Ws = "$override_feature_flag_payloads", $0fb0e9cf977607be$var$Gs = "$stored_person_properties", $0fb0e9cf977607be$var$Ks = "$stored_group_properties", $0fb0e9cf977607be$var$Js = "$groups", $0fb0e9cf977607be$var$Ys = "$surveys", $0fb0e9cf977607be$var$Xs = "$surveys_loaded_at", $0fb0e9cf977607be$var$Qs = "$surveys_activated", $0fb0e9cf977607be$var$Zs = "$surveys_activated_session", $0fb0e9cf977607be$var$tn = "$surveys_activated_timestamps", $0fb0e9cf977607be$var$en = "ph_product_tours", $0fb0e9cf977607be$var$sn = "$product_tours_activated", $0fb0e9cf977607be$var$nn = "$product_tours_activated_session", $0fb0e9cf977607be$var$rn = "$conversations_widget_session_id", $0fb0e9cf977607be$var$on = "$conversations_ticket_id", $0fb0e9cf977607be$var$ln = "$conversations_widget_state", $0fb0e9cf977607be$var$an = "$conversations_user_traits", $0fb0e9cf977607be$var$un = "$flag_call_reported", $0fb0e9cf977607be$var$hn = "$flag_call_reported_session_id", $0fb0e9cf977607be$var$dn = "$feature_flag_errors", $0fb0e9cf977607be$var$cn = "$feature_flag_evaluated_at", $0fb0e9cf977607be$var$vn = "$user_state", $0fb0e9cf977607be$var$fn = "$client_session_props", $0fb0e9cf977607be$var$pn = "$capture_rate_limit", $0fb0e9cf977607be$var$_n = "$initial_campaign_params", $0fb0e9cf977607be$var$gn = "$initial_referrer_info", $0fb0e9cf977607be$var$mn = "$initial_person_info", $0fb0e9cf977607be$var$bn = "$epp", $0fb0e9cf977607be$var$yn = "$posthog_cookieless", $0fb0e9cf977607be$var$wn = "$cookieless_mode", $0fb0e9cf977607be$var$$n = "$sdk_debug_extensions_init_method", $0fb0e9cf977607be$var$Sn = "$sdk_debug_extensions_init_time_ms", $0fb0e9cf977607be$var$xn = "$sdk_debug_recording_script_not_loaded", $0fb0e9cf977607be$var$En = "$sdk_debug_replay_stale_config", $0fb0e9cf977607be$var$kn = "$sdk_debug_replay_event_trigger_status", $0fb0e9cf977607be$var$Tn = "$sdk_debug_replay_linked_flag_trigger_status", $0fb0e9cf977607be$var$Pn = "$sdk_debug_replay_matched_recording_trigger_groups", $0fb0e9cf977607be$var$Cn = "$sdk_debug_replay_pending_trigger_conditions", $0fb0e9cf977607be$var$On = "$sdk_debug_replay_remote_trigger_matching_config", $0fb0e9cf977607be$var$Rn = "$sdk_debug_replay_trigger_groups_count", $0fb0e9cf977607be$var$In = "$sdk_debug_replay_url_trigger_status", $0fb0e9cf977607be$var$Mn = "$session_recording_start_reason", $0fb0e9cf977607be$var$An = "PostHog loadExternalDependency extension not found.", $0fb0e9cf977607be$var$Fn = "anonymous", $0fb0e9cf977607be$var$Dn = "identified", $0fb0e9cf977607be$var$Nn = "identified_only", $0fb0e9cf977607be$var$jn = "visibilitychange", $0fb0e9cf977607be$var$Ln = "beforeunload", $0fb0e9cf977607be$var$Bn = "$pageview", $0fb0e9cf977607be$var$Un = "$pageleave", $0fb0e9cf977607be$var$zn = "$identify", $0fb0e9cf977607be$var$Hn = "$groupidentify";
function $0fb0e9cf977607be$var$qn(t, i) {
    $0fb0e9cf977607be$var$T(t) && t.forEach(i);
}
function $0fb0e9cf977607be$var$Vn(t, i) {
    if (!$0fb0e9cf977607be$var$F(t)) {
        if ($0fb0e9cf977607be$var$T(t)) t.forEach(i);
        else if (((t)=>t instanceof FormData)(t)) t.forEach((t, e)=>i(t, e));
        else for(const e in t)$0fb0e9cf977607be$var$E.call(t, e) && i(t[e], e);
    }
}
const $0fb0e9cf977607be$var$Wn = function(t, ...i) {
    for (const e of i)for(const i in e)void 0 !== e[i] && (t[i] = e[i]);
    return t;
};
function $0fb0e9cf977607be$var$Gn(t) {
    const i = Object.keys(t);
    let e = i.length;
    const s = new Array(e);
    for(; e--;)s[e] = [
        i[e],
        t[i[e]]
    ];
    return s;
}
const $0fb0e9cf977607be$var$Kn = function(t) {
    return function(...i) {
        try {
            return t.apply(this, i);
        } catch (t) {
            $0fb0e9cf977607be$var$Je.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $0fb0e9cf977607be$var$Je.critical(t);
        }
    };
}, $0fb0e9cf977607be$var$Jn = function(t) {
    const i = {};
    return $0fb0e9cf977607be$var$Vn(t, function(t, e) {
        ($0fb0e9cf977607be$var$I(t) && t.length > 0 || $0fb0e9cf977607be$var$D(t)) && (i[e] = t);
    }), i;
};
function $0fb0e9cf977607be$var$Yn(t) {
    const i = $0fb0e9cf977607be$var$Ei({}, t);
    for (const e of [
        "name",
        "message",
        "stack",
        "cause",
        "errors"
    ])try {
        e in t && (i[e] = t[e]);
    } catch (t) {}
    return i;
}
const $0fb0e9cf977607be$var$Xn = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $0fb0e9cf977607be$var$Qn(t) {
    const i = null == t ? void 0 : t.hostname;
    if (!$0fb0e9cf977607be$var$I(i)) return !1;
    const e = i.split(".").slice(-2).join(".");
    for (const t of $0fb0e9cf977607be$var$Xn)if (e === t) return !1;
    return !0;
}
function $0fb0e9cf977607be$var$Zn(t, i, e, s) {
    const { capture: n = !1, passive: r = !0 } = null != s ? s : {};
    null == t || t.addEventListener(i, e, {
        capture: n,
        passive: r
    });
}
function $0fb0e9cf977607be$var$tr(t) {
    return "ph_toolbar_internal" === t.name;
}
const $0fb0e9cf977607be$var$ir = (t)=>{
    if ($0fb0e9cf977607be$var$s) {
        try {
            const i = t + "=", e = $0fb0e9cf977607be$var$s.cookie.split(";").filter((t)=>t.length);
            for(let t = 0; e.length > t; t++){
                let s = e[t];
                for(; " " == s.charAt(0);)s = s.substring(1, s.length);
                if (0 === s.indexOf(i)) return decodeURIComponent(s.substring(i.length, s.length));
            }
        } catch (t) {}
        return null;
    }
};
Math.trunc || (Math.trunc = function(t) {
    return 0 > t ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $0fb0e9cf977607be$var$D(t) && isFinite(t) && Math.floor(t) === t;
});
var $0fb0e9cf977607be$var$er = class t {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(i, e, s, n) {
        if (!Number.isInteger(i) || !Number.isInteger(e) || !Number.isInteger(s) || !Number.isInteger(n) || 0 > i || 0 > e || 0 > s || 0 > n || i > 0xffffffffffff || e > 4095 || s > 1073741823 || n > 4294967295) throw new RangeError("invalid field value");
        const r = new Uint8Array(16);
        return r[0] = i / Math.pow(2, 40), r[1] = i / Math.pow(2, 32), r[2] = i / Math.pow(2, 24), r[3] = i / Math.pow(2, 16), r[4] = i / 256, r[5] = i, r[6] = 112 | e >>> 8, r[7] = e, r[8] = 128 | s >>> 24, r[9] = s >>> 16, r[10] = s >>> 8, r[11] = s, r[12] = n >>> 24, r[13] = n >>> 16, r[14] = n >>> 8, r[15] = n, new t(r);
    }
    toString() {
        let t = "";
        for(let i = 0; this.bytes.length > i; i++)t = t + (this.bytes[i] >>> 4).toString(16) + (15 & this.bytes[i]).toString(16), 3 !== i && 5 !== i && 7 !== i && 9 !== i || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new t(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(let i = 0; 16 > i; i++){
            const e = this.bytes[i] - t.bytes[i];
            if (0 !== e) return Math.sign(e);
        }
        return 0;
    }
}, $0fb0e9cf977607be$var$sr = class {
    generate() {
        const t = this.generateOrAbort();
        if (!$0fb0e9cf977607be$var$R(t)) return t;
        {
            this.Ct = 0;
            const t = this.generateOrAbort();
            if ($0fb0e9cf977607be$var$R(t)) throw new Error("Could not generate UUID after timestamp reset");
            return t;
        }
    }
    generateOrAbort() {
        const t = (()=>{
            const t = Date.now();
            return $0fb0e9cf977607be$var$D(t) && isFinite(t) ? Math.min(Math.max(Math.floor(t), 0), 0xffffffffffff) : 0;
        })();
        if (t > this.Ct) this.Ct = t, this.It();
        else {
            if (this.Ct >= t + 1e4) return;
            this.Mt++, this.Mt > 4398046511103 && (this.Ct++, this.It());
        }
        return $0fb0e9cf977607be$var$er.fromFieldsV7(this.Ct, Math.trunc(this.Mt / Math.pow(2, 30)), this.Mt & Math.pow(2, 30) - 1, this.Tt.nextUint32());
    }
    It() {
        this.Mt = 1024 * this.Tt.nextUint32() + (1023 & this.Tt.nextUint32());
    }
    constructor(){
        this.Ct = 0, this.Mt = 0, this.Tt = new $0fb0e9cf977607be$var$rr;
    }
};
let $0fb0e9cf977607be$var$nr = (t)=>{
    if ("u" > typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(let i = 0; t.length > i; i++)t[i] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$0fb0e9cf977607be$var$t && !$0fb0e9cf977607be$var$R($0fb0e9cf977607be$var$t.crypto) && crypto.getRandomValues && ($0fb0e9cf977607be$var$nr = (t)=>crypto.getRandomValues(t));
var $0fb0e9cf977607be$var$rr = class {
    nextUint32() {
        return this.Rt.length > this.At || ($0fb0e9cf977607be$var$nr(this.Rt), this.At = 0), this.Rt[this.At++];
    }
    constructor(){
        this.Rt = new Uint32Array(8), this.At = 1 / 0;
    }
};
let $0fb0e9cf977607be$var$or;
const $0fb0e9cf977607be$var$lr = ()=>$0fb0e9cf977607be$var$ar().toString(), $0fb0e9cf977607be$var$ar = ()=>($0fb0e9cf977607be$var$or || ($0fb0e9cf977607be$var$or = new $0fb0e9cf977607be$var$sr)).generate();
let $0fb0e9cf977607be$var$ur = "";
const $0fb0e9cf977607be$var$hr = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
let $0fb0e9cf977607be$var$dr = null;
const $0fb0e9cf977607be$var$cr = {
    Et () {
        if (!$0fb0e9cf977607be$var$A($0fb0e9cf977607be$var$dr)) return $0fb0e9cf977607be$var$dr;
        if ($0fb0e9cf977607be$var$dr = !1, $0fb0e9cf977607be$var$s) try {
            const t = `__ph_cookie_support_${$0fb0e9cf977607be$var$lr()}`;
            $0fb0e9cf977607be$var$cr.$t(t, "xyz"), $0fb0e9cf977607be$var$dr = '"xyz"' === $0fb0e9cf977607be$var$ir(t), $0fb0e9cf977607be$var$cr.Pt(t);
        } catch (t) {
            $0fb0e9cf977607be$var$dr = !1;
        }
        return $0fb0e9cf977607be$var$dr;
    },
    Dt (t) {
        $0fb0e9cf977607be$var$Je.error("cookieStore error: " + t);
    },
    Ot: $0fb0e9cf977607be$var$ir,
    Lt (t) {
        let i;
        try {
            i = JSON.parse($0fb0e9cf977607be$var$cr.Ot(t)) || {};
        } catch (t) {}
        return i;
    },
    $t (t, i, e, n, r) {
        if (!$0fb0e9cf977607be$var$s) return !1;
        try {
            let o = "", l = "";
            const a = function(t, i) {
                if (i) {
                    let i = function(t, i = $0fb0e9cf977607be$var$s) {
                        if ($0fb0e9cf977607be$var$ur) return $0fb0e9cf977607be$var$ur;
                        if (!i) return "";
                        if ([
                            "localhost",
                            "127.0.0.1"
                        ].includes(t)) return "";
                        const e = t.split(".");
                        let n = Math.min(e.length, 8);
                        const r = "dmn_chk_" + $0fb0e9cf977607be$var$lr();
                        for(; !$0fb0e9cf977607be$var$ur && n--;){
                            const t = e.slice(n).join("."), s = r + "=1;domain=." + t + ";path=/";
                            i.cookie = s + ";max-age=3", i.cookie.includes(r) && (i.cookie = s + ";max-age=0", $0fb0e9cf977607be$var$ur = t);
                        }
                        return $0fb0e9cf977607be$var$ur;
                    }(t);
                    if (!i) {
                        const e = ((t)=>{
                            const i = t.match($0fb0e9cf977607be$var$hr);
                            return i ? i[0] : "";
                        })(t);
                        e !== i && $0fb0e9cf977607be$var$Je.info("Warning: cookie subdomain discovery mismatch", e, i), i = e;
                    }
                    return i ? "; domain=." + i : "";
                }
                return "";
            }($0fb0e9cf977607be$var$s.location.hostname, n);
            if (e) {
                const t = new Date;
                t.setTime(t.getTime() + 864e5 * e), o = "; expires=" + t.toUTCString();
            }
            r && (l = "; secure");
            const u = t + "=" + encodeURIComponent(JSON.stringify(i)) + o + "; SameSite=Lax; path=/" + a + l;
            return u.length > 3686.4 && $0fb0e9cf977607be$var$Je.warn("cookieStore warning: large cookie, len=" + u.length), $0fb0e9cf977607be$var$s.cookie = u, !0;
        } catch (t) {
            return !1;
        }
    },
    Pt (t, i) {
        if ((null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.cookie) && (!i || !$0fb0e9cf977607be$var$A($0fb0e9cf977607be$var$ir(t)))) try {
            $0fb0e9cf977607be$var$cr.$t(t, "", -1, i);
        } catch (t) {
            return;
        }
    }
};
let $0fb0e9cf977607be$var$vr = null;
const $0fb0e9cf977607be$var$fr = {
    Et () {
        if (!$0fb0e9cf977607be$var$A($0fb0e9cf977607be$var$vr)) return $0fb0e9cf977607be$var$vr;
        let i = !0;
        if ($0fb0e9cf977607be$var$R($0fb0e9cf977607be$var$t)) i = !1;
        else try {
            const t = "__mplssupport__";
            $0fb0e9cf977607be$var$fr.$t(t, "xyz"), '"xyz"' !== $0fb0e9cf977607be$var$fr.Ot(t) && (i = !1), $0fb0e9cf977607be$var$fr.Pt(t);
        } catch (t) {
            i = !1;
        }
        return i || $0fb0e9cf977607be$var$Je.error("localStorage unsupported; falling back to cookie store"), $0fb0e9cf977607be$var$vr = i, i;
    },
    Dt (t) {
        $0fb0e9cf977607be$var$Je.error("localStorage error: " + t);
    },
    Ot (i) {
        try {
            return null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.localStorage.getItem(i);
        } catch (t) {
            $0fb0e9cf977607be$var$fr.Dt(t);
        }
        return null;
    },
    Lt (t) {
        try {
            return JSON.parse($0fb0e9cf977607be$var$fr.Ot(t)) || {};
        } catch (t) {}
        return null;
    },
    $t (i, e) {
        try {
            return null == $0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$t.localStorage.setItem(i, JSON.stringify(e)), !0;
        } catch (t) {
            $0fb0e9cf977607be$var$fr.Dt(t);
        }
        return !1;
    },
    Pt (i) {
        try {
            null == $0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$t.localStorage.removeItem(i);
        } catch (t) {
            $0fb0e9cf977607be$var$fr.Dt(t);
        }
    }
}, $0fb0e9cf977607be$var$pr = [
    $0fb0e9cf977607be$var$Gs,
    $0fb0e9cf977607be$var$Ls,
    $0fb0e9cf977607be$var$js,
    $0fb0e9cf977607be$var$Us,
    $0fb0e9cf977607be$var$zs,
    $0fb0e9cf977607be$var$Hs,
    $0fb0e9cf977607be$var$cn,
    $0fb0e9cf977607be$var$dn,
    $0fb0e9cf977607be$var$un
], $0fb0e9cf977607be$var$_r = [
    $0fb0e9cf977607be$var$rs,
    $0fb0e9cf977607be$var$ns,
    $0fb0e9cf977607be$var$Rs,
    $0fb0e9cf977607be$var$Is,
    $0fb0e9cf977607be$var$bn,
    $0fb0e9cf977607be$var$mn,
    $0fb0e9cf977607be$var$hs,
    $0fb0e9cf977607be$var$vn
], $0fb0e9cf977607be$var$gr = (t)=>t + "_cpm", $0fb0e9cf977607be$var$mr = [
    "__proto__",
    "constructor",
    "prototype"
], $0fb0e9cf977607be$var$br = (t)=>{
    if (!$0fb0e9cf977607be$var$C(t)) return {};
    const i = {};
    return Object.keys(t).forEach((e)=>{
        -1 === $0fb0e9cf977607be$var$mr.indexOf(e) && (i[e] = t[e]);
    }), i;
}, $0fb0e9cf977607be$var$yr = (t, i = [])=>{
    const e = {};
    return [
        ...$0fb0e9cf977607be$var$_r,
        ...i
    ].forEach((i)=>{
        const s = t[i];
        $0fb0e9cf977607be$var$R(s) || $0fb0e9cf977607be$var$A(s) || "" === s || (e[i] = s);
    }), e;
}, $0fb0e9cf977607be$var$wr = (t)=>{
    let i = 5381, e = 2166136261;
    for(let s = 0; t.length > s; s++){
        const n = t.charCodeAt(s);
        i = 33 * i ^ n, e = Math.imul(e ^ n, 16777619);
    }
    return t.length.toString(36) + "." + (i >>> 0).toString(36) + "." + (e >>> 0).toString(36);
}, $0fb0e9cf977607be$var$$r = (t, i)=>({
        p: i,
        f: $0fb0e9cf977607be$var$wr(JSON.stringify(t))
    }), $0fb0e9cf977607be$var$Sr = (t, i)=>{
    if (!i) return {
        properties: [],
        isValid: !1
    };
    try {
        const e = $0fb0e9cf977607be$var$cr.Lt($0fb0e9cf977607be$var$gr(t)), s = (null == e ? void 0 : e.f) === $0fb0e9cf977607be$var$wr(i) && $0fb0e9cf977607be$var$T(e.p);
        return {
            properties: s ? e.p : [],
            isValid: s
        };
    } catch (t) {
        return {
            properties: [],
            isValid: !1
        };
    }
}, $0fb0e9cf977607be$var$xr = (t, i)=>i + "|" + ($0fb0e9cf977607be$var$cr.Ot($0fb0e9cf977607be$var$gr(t)) || ""), $0fb0e9cf977607be$var$Er = {}, $0fb0e9cf977607be$var$kr = {
    Et: ()=>!0,
    Dt (t) {
        $0fb0e9cf977607be$var$Je.error("memoryStorage error: " + t);
    },
    Ot: (t)=>t in $0fb0e9cf977607be$var$Er ? $0fb0e9cf977607be$var$Er[t] : null,
    Lt: (t)=>t in $0fb0e9cf977607be$var$Er ? $0fb0e9cf977607be$var$Er[t] : null,
    $t: (t, i)=>($0fb0e9cf977607be$var$Er[t] = i, !0),
    Pt (t) {
        delete $0fb0e9cf977607be$var$Er[t];
    }
};
let $0fb0e9cf977607be$var$Tr = null;
const $0fb0e9cf977607be$var$Pr = {
    Et () {
        if (!$0fb0e9cf977607be$var$A($0fb0e9cf977607be$var$Tr)) return $0fb0e9cf977607be$var$Tr;
        if ($0fb0e9cf977607be$var$Tr = !0, $0fb0e9cf977607be$var$R($0fb0e9cf977607be$var$t)) $0fb0e9cf977607be$var$Tr = !1;
        else try {
            const t = "__support__";
            $0fb0e9cf977607be$var$Pr.$t(t, "xyz"), '"xyz"' !== $0fb0e9cf977607be$var$Pr.Ot(t) && ($0fb0e9cf977607be$var$Tr = !1), $0fb0e9cf977607be$var$Pr.Pt(t);
        } catch (t) {
            $0fb0e9cf977607be$var$Tr = !1;
        }
        return $0fb0e9cf977607be$var$Tr;
    },
    Dt (t) {
        $0fb0e9cf977607be$var$Je.error("sessionStorage error: ", t);
    },
    Ot (i) {
        try {
            return null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.sessionStorage.getItem(i);
        } catch (t) {
            $0fb0e9cf977607be$var$Pr.Dt(t);
        }
        return null;
    },
    Lt (t) {
        try {
            return JSON.parse($0fb0e9cf977607be$var$Pr.Ot(t)) || null;
        } catch (t) {}
        return null;
    },
    $t (i, e) {
        try {
            return null == $0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$t.sessionStorage.setItem(i, JSON.stringify(e)), !0;
        } catch (t) {
            $0fb0e9cf977607be$var$Pr.Dt(t);
        }
        return !1;
    },
    Pt (i) {
        try {
            null == $0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$t.sessionStorage.removeItem(i);
        } catch (t) {
            $0fb0e9cf977607be$var$Pr.Dt(t);
        }
    }
};
var $0fb0e9cf977607be$var$Cr = class {
    constructor(t){
        this._instance = t;
    }
    get Mr() {
        return this._instance.config;
    }
    get consent() {
        return this.Do() ? 0 : this.Lo;
    }
    isOptedOut() {
        return "always" === this.Mr.cookieless_mode || this.isRejected() || -1 === this.consent && "on_reject" === this.Mr.cookieless_mode;
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    isExplicitlyOptedOut() {
        return 0 === this.consent;
    }
    isRejected() {
        return 0 === this.consent || -1 === this.consent && this.Mr.opt_out_capturing_by_default;
    }
    optInOut(t) {
        this.No.$t(this.qo, t ? 1 : 0, this.Mr.cookie_expiration, this.Mr.cross_subdomain_cookie, this.Mr.secure_cookie);
    }
    reset() {
        this.No.Pt(this.qo, this.Mr.cross_subdomain_cookie);
    }
    get qo() {
        const { token: t, opt_out_capturing_cookie_prefix: i, consent_persistence_name: e } = this._instance.config;
        return e || (i ? i + t : "__ph_opt_in_out_" + t);
    }
    get Lo() {
        const t = this.No.Ot(this.qo);
        return $0fb0e9cf977607be$var$G(t) ? 1 : $0fb0e9cf977607be$var$b($0fb0e9cf977607be$var$K, t) ? 0 : -1;
    }
    get No() {
        const t = this.Mr.opt_out_capturing_persistence_type, i = "localStorage" === t ? $0fb0e9cf977607be$var$fr : $0fb0e9cf977607be$var$cr, e = i.Et() ? i : $0fb0e9cf977607be$var$kr;
        if (!this.jo || this.jo !== e) {
            this.jo = e;
            const i = "localStorage" === t ? $0fb0e9cf977607be$var$cr : $0fb0e9cf977607be$var$fr;
            i.Ot(this.qo) && (this.jo.Ot(this.qo) || this.optInOut($0fb0e9cf977607be$var$G(i.Ot(this.qo))), i.Pt(this.qo, this.Mr.cross_subdomain_cookie));
        }
        return this.jo;
    }
    Do() {
        return !!this.Mr.respect_dnt && [
            null == $0fb0e9cf977607be$var$e ? void 0 : $0fb0e9cf977607be$var$e.doNotTrack,
            null == $0fb0e9cf977607be$var$e ? void 0 : $0fb0e9cf977607be$var$e.msDoNotTrack,
            $0fb0e9cf977607be$var$c.doNotTrack,
            null == $0fb0e9cf977607be$var$e ? void 0 : $0fb0e9cf977607be$var$e.globalPrivacyControl
        ].some((t)=>$0fb0e9cf977607be$var$G(t));
    }
};
function $0fb0e9cf977607be$var$Or(t, i) {
    var e;
    const s = null == t || null === (e = t.config) || void 0 === e ? void 0 : e.get_current_url;
    if (!$0fb0e9cf977607be$var$P(s)) return i;
    try {
        const t = s(i);
        return $0fb0e9cf977607be$var$I(t) && t ? t : i;
    } catch (t) {
        return $0fb0e9cf977607be$var$Je.error("Error in get_current_url, falling back to window.location.href", t), i;
    }
}
function $0fb0e9cf977607be$var$Rr(t) {
    var i;
    return t instanceof Element && ("__POSTHOG_TOOLBAR__" === t.id || !!(null === (i = t.closest) || void 0 === i ? void 0 : i.call(t, ".toolbar-global-fade-container")));
}
function $0fb0e9cf977607be$var$Ir(t) {
    return !!t && 1 === t.nodeType;
}
function $0fb0e9cf977607be$var$Mr(t, i) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === i.toLowerCase();
}
function $0fb0e9cf977607be$var$Ar(t) {
    return !!t && 3 === t.nodeType;
}
function $0fb0e9cf977607be$var$Fr(t) {
    return !!t && 11 === t.nodeType && $0fb0e9cf977607be$var$Ir(t.host);
}
function $0fb0e9cf977607be$var$Dr(t) {
    return t ? $0fb0e9cf977607be$var$y(t).split(/\s+/) : [];
}
function $0fb0e9cf977607be$var$Nr(i, e) {
    const s = function(i) {
        var e;
        const s = null == $0fb0e9cf977607be$var$t || null === (e = $0fb0e9cf977607be$var$t.location) || void 0 === e ? void 0 : e.href;
        return $0fb0e9cf977607be$var$R(s) ? void 0 : $0fb0e9cf977607be$var$Or(i, s);
    }(e);
    return !!(s && i && i.some((t)=>s.match(t)));
}
function $0fb0e9cf977607be$var$jr(t) {
    let i = "";
    switch(typeof t.className){
        case "string":
            i = t.className;
            break;
        case "object":
            i = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            i = "";
    }
    return $0fb0e9cf977607be$var$Dr(i);
}
function $0fb0e9cf977607be$var$Lr(t) {
    return $0fb0e9cf977607be$var$F(t) ? null : $0fb0e9cf977607be$var$y(t).split(/(\s+)/).filter((t)=>$0fb0e9cf977607be$var$ho(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $0fb0e9cf977607be$var$Br(t) {
    let i = "";
    return $0fb0e9cf977607be$var$io(t) && !$0fb0e9cf977607be$var$eo(t) && t.childNodes && t.childNodes.length && $0fb0e9cf977607be$var$Vn(t.childNodes, function(t) {
        var e;
        $0fb0e9cf977607be$var$Ar(t) && t.textContent && (i += null !== (e = $0fb0e9cf977607be$var$Lr(t.textContent)) && void 0 !== e ? e : "");
    }), $0fb0e9cf977607be$var$y(i);
}
function $0fb0e9cf977607be$var$Ur(t) {
    var i;
    return $0fb0e9cf977607be$var$R(t.target) ? t.srcElement || null : (null === (i = t.target) || void 0 === i ? void 0 : i.shadowRoot) ? t.composedPath()[0] || null : t.target || null;
}
const $0fb0e9cf977607be$var$zr = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $0fb0e9cf977607be$var$Hr(t, i) {
    const e = t.matches || t.matchesSelector || t.msMatchesSelector || t.mozMatchesSelector || t.webkitMatchesSelector || t.oMatchesSelector;
    try {
        return !!e && e.call(t, i);
    } catch (t) {
        return !1;
    }
}
function $0fb0e9cf977607be$var$qr(t, i) {
    if ($0fb0e9cf977607be$var$R(i)) return !0;
    for (const e of t)if (i.some((t)=>$0fb0e9cf977607be$var$Hr(e, t))) return !0;
    return !1;
}
function $0fb0e9cf977607be$var$Vr(t) {
    const i = t.parentNode;
    return !(!i || !$0fb0e9cf977607be$var$Ir(i)) && i;
}
const $0fb0e9cf977607be$var$Wr = [
    ".ph-no-autocapture",
    "[data-ph-no-autocapture]"
], $0fb0e9cf977607be$var$Gr = [
    "next",
    "previous",
    "prev",
    ">",
    "<"
], $0fb0e9cf977607be$var$Kr = [
    ...$0fb0e9cf977607be$var$Gr,
    "+",
    "-",
    "\u2212",
    "\u2013"
], $0fb0e9cf977607be$var$Jr = (t, i)=>/[a-z0-9]/i.test(i) ? t.includes(i) : t === i, $0fb0e9cf977607be$var$Yr = [
    ".ph-no-rageclick",
    ".ph-no-capture"
], $0fb0e9cf977607be$var$Xr = [
    "",
    "text",
    "search",
    "email",
    "password",
    "url",
    "tel",
    "number"
];
function $0fb0e9cf977607be$var$Qr(i, e) {
    if (!$0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$Zr(i)) return !1;
    let s, n, r;
    var o, l;
    if ($0fb0e9cf977607be$var$j(e) ? (s = !!e && $0fb0e9cf977607be$var$Yr, n = void 0, r = !1) : (s = null !== (o = null == e ? void 0 : e.css_selector_ignorelist) && void 0 !== o ? o : $0fb0e9cf977607be$var$Yr, n = null == e ? void 0 : e.content_ignorelist, r = null !== (l = null == e ? void 0 : e.ignore_text_selection) && void 0 !== l && l), !1 === s) return !1;
    if (r && function(t) {
        return !(!t || !$0fb0e9cf977607be$var$Ir(t)) && (!!$0fb0e9cf977607be$var$Mr(t, "textarea") || ($0fb0e9cf977607be$var$Mr(t, "input") ? $0fb0e9cf977607be$var$b($0fb0e9cf977607be$var$Xr, (t.getAttribute("type") || "").toLowerCase()) : function(t) {
            var i;
            if (t.isContentEditable) return !0;
            const e = null === (i = t.getAttribute) || void 0 === i ? void 0 : i.call(t, "contenteditable");
            return "true" === e || "" === e;
        }(t)));
    }(i)) return !1;
    const { targetElementList: a } = $0fb0e9cf977607be$var$to(i, !1);
    return !function(t, i) {
        if (!1 === t || $0fb0e9cf977607be$var$R(t)) return !1;
        let e;
        if (!0 === t) e = $0fb0e9cf977607be$var$Gr;
        else {
            if (!$0fb0e9cf977607be$var$T(t)) return !1;
            if (t.length > 10) return $0fb0e9cf977607be$var$Je.error("[PostHog] content_ignorelist array cannot exceed 10 items. Use css_selector_ignorelist for more complex matching."), !1;
            e = t.map((t)=>t.toLowerCase());
        }
        return i.some(({ safeText: t, ariaLabel: i })=>e.some((e)=>$0fb0e9cf977607be$var$Jr(t, e) || $0fb0e9cf977607be$var$Jr(i, e)));
    }(n, a.map((t)=>{
        var i;
        return {
            safeText: $0fb0e9cf977607be$var$Br(t).toLowerCase(),
            ariaLabel: (null === (i = t.getAttribute("aria-label")) || void 0 === i ? void 0 : i.toLowerCase().trim()) || ""
        };
    })) && !$0fb0e9cf977607be$var$qr(a, s);
}
const $0fb0e9cf977607be$var$Zr = (t)=>!t || $0fb0e9cf977607be$var$Mr(t, "html") || !$0fb0e9cf977607be$var$Ir(t), $0fb0e9cf977607be$var$to = (i, e)=>{
    if (!$0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$Zr(i)) return {
        parentIsUsefulElement: !1,
        targetElementList: []
    };
    let s = !1;
    const n = [
        i
    ];
    let r = i;
    for(; r.parentNode && !$0fb0e9cf977607be$var$Mr(r, "body");){
        if ($0fb0e9cf977607be$var$Fr(r.parentNode)) {
            n.push(r.parentNode.host), r = r.parentNode.host;
            continue;
        }
        const i = $0fb0e9cf977607be$var$Vr(r);
        if (!i) break;
        if (e || $0fb0e9cf977607be$var$zr.indexOf(i.tagName.toLowerCase()) > -1) s = !0;
        else try {
            const e = $0fb0e9cf977607be$var$t.getComputedStyle(i);
            e && "pointer" === e.getPropertyValue("cursor") && (s = !0);
        } catch (t) {}
        n.push(i), r = i;
    }
    return {
        parentIsUsefulElement: s,
        targetElementList: n
    };
};
function $0fb0e9cf977607be$var$io(t) {
    const i = new Set;
    let e = 0;
    for(let s = t; s.parentNode && !$0fb0e9cf977607be$var$Mr(s, "body"); s = s.parentNode){
        if (e++ >= 1e3 || i.has(s)) return !1;
        i.add(s);
        const t = $0fb0e9cf977607be$var$jr(s);
        if ($0fb0e9cf977607be$var$b(t, "ph-sensitive") || $0fb0e9cf977607be$var$b(t, "ph-no-capture")) return !1;
    }
    if ($0fb0e9cf977607be$var$b($0fb0e9cf977607be$var$jr(t), "ph-include")) return !0;
    const s = t.type || "";
    if ($0fb0e9cf977607be$var$I(s)) switch(s.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    const n = t.name || t.id || "";
    return !$0fb0e9cf977607be$var$I(n) || !/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(n.replace(/[^a-zA-Z0-9]/g, ""));
}
function $0fb0e9cf977607be$var$eo(t) {
    return !!($0fb0e9cf977607be$var$Mr(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $0fb0e9cf977607be$var$Mr(t, "select") || $0fb0e9cf977607be$var$Mr(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
const $0fb0e9cf977607be$var$so = new RegExp("^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$"), $0fb0e9cf977607be$var$no = /(^|[^0-9A-Za-z_])([0-9][0-9 -]*[0-9])(?=$|[^0-9A-Za-z_])/g, $0fb0e9cf977607be$var$ro = [
    16,
    15,
    14,
    13
], $0fb0e9cf977607be$var$oo = new RegExp("^(\\d{3}-?\\d{2}-?\\d{4})$"), $0fb0e9cf977607be$var$lo = new RegExp("(^|[^0-9])((?!000|666)[0-9]{3}-?(?!00)[0-9]{2}-?(?!0000)[0-9]{4})(?=$|([^0-9]))", "g"), $0fb0e9cf977607be$var$ao = /[0-9A-Za-z_]/;
function $0fb0e9cf977607be$var$uo(t) {
    let i = 0, e = !1;
    for(let s = t.length - 1; s >= 0; s--){
        let n = t.charCodeAt(s) - 48;
        e && (n *= 2, n > 9 && (n -= 9)), i += n, e = !e;
    }
    return i % 10 == 0;
}
function $0fb0e9cf977607be$var$ho(t, i = !0) {
    if ($0fb0e9cf977607be$var$F(t)) return !1;
    if ($0fb0e9cf977607be$var$I(t)) {
        if (t = $0fb0e9cf977607be$var$y(t), i ? $0fb0e9cf977607be$var$so.test((t || "").replace(/[- ]/g, "")) : function(t) {
            let i;
            for($0fb0e9cf977607be$var$no.lastIndex = 0; i = $0fb0e9cf977607be$var$no.exec(t);){
                const t = i[2];
                if (!t) continue;
                const e = t.replace(/[- ]/g, "");
                for(let t = 0; e.length > t; t++)for (const i of $0fb0e9cf977607be$var$ro){
                    const s = t + i;
                    if (e.length >= s) {
                        const i = e.slice(t, s);
                        if ($0fb0e9cf977607be$var$so.test(i) && $0fb0e9cf977607be$var$uo(i)) return !0;
                    }
                }
            }
            return !1;
        }(t)) return !1;
        if (i ? $0fb0e9cf977607be$var$oo.test(t) : function(t) {
            let i;
            for($0fb0e9cf977607be$var$lo.lastIndex = 0; i = $0fb0e9cf977607be$var$lo.exec(t);){
                const t = i[1], e = i[3];
                if (!(t && e && $0fb0e9cf977607be$var$ao.test(t) && $0fb0e9cf977607be$var$ao.test(e))) return !0;
            }
            return !1;
        }(t)) return !1;
    }
    return !0;
}
function $0fb0e9cf977607be$var$co(t) {
    let i = $0fb0e9cf977607be$var$Br(t);
    return i = `${i} ${$0fb0e9cf977607be$var$vo(t)}`.trim(), $0fb0e9cf977607be$var$ho(i) ? i : "";
}
function $0fb0e9cf977607be$var$vo(t) {
    let i = "";
    return t && t.childNodes && t.childNodes.length && $0fb0e9cf977607be$var$Vn(t.childNodes, function(t) {
        var e;
        if (t && "span" === (null === (e = t.tagName) || void 0 === e ? void 0 : e.toLowerCase())) try {
            const e = $0fb0e9cf977607be$var$Br(t);
            i = `${i} ${e}`.trim(), t.childNodes && t.childNodes.length && (i = `${i} ${$0fb0e9cf977607be$var$vo(t)}`.trim());
        } catch (t) {
            $0fb0e9cf977607be$var$Je.error("[AutoCapture]", t);
        }
    }), i;
}
function $0fb0e9cf977607be$var$fo(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $0fb0e9cf977607be$var$po(t) {
    const i = t.attr__class;
    if (i) return $0fb0e9cf977607be$var$T(i) ? i : $0fb0e9cf977607be$var$Dr(i);
}
const $0fb0e9cf977607be$var$_o = $0fb0e9cf977607be$var$Ye("[Dead Clicks]"), $0fb0e9cf977607be$var$go = ()=>!0, $0fb0e9cf977607be$var$mo = (t)=>{
    var i;
    const e = !!(null === (i = t.instance.persistence) || void 0 === i ? void 0 : i.get_property($0fb0e9cf977607be$var$ys)), s = t.instance.config.capture_dead_clicks;
    return $0fb0e9cf977607be$var$j(s) ? s : !!$0fb0e9cf977607be$var$C(s) || e;
};
var $0fb0e9cf977607be$var$bo = class {
    get lazyLoadedDeadClicksAutocapture() {
        return this.Bo;
    }
    constructor(t, i, e){
        this.instance = t, this.isEnabled = i, this.onCapture = e, this.startIfEnabledOrStop();
    }
    onRemoteConfig(t) {
        if (!t.ok) return;
        const i = t.config;
        "captureDeadClicks" in i && (this.instance.persistence && this.instance.persistence.register({
            [$0fb0e9cf977607be$var$ys]: i.captureDeadClicks
        }), this.startIfEnabledOrStop());
    }
    startIfEnabledOrStop() {
        this.isEnabled(this) ? this.Ho(()=>{
            this.zo();
        }) : this.stop();
    }
    Ho(t) {
        var i, e, s;
        (null === (i = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.initDeadClicksAutocapture) ? t() : null === (e = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === e || null === (s = e.loadExternalDependency) || void 0 === s || s.call(e, this.instance, "dead-clicks-autocapture", (i)=>{
            i ? $0fb0e9cf977607be$var$_o.error("failed to load script", i) : t();
        });
    }
    zo() {
        var t;
        if ($0fb0e9cf977607be$var$s) {
            if (!this.Bo && (null === (t = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === t ? void 0 : t.initDeadClicksAutocapture)) {
                const t = $0fb0e9cf977607be$var$C(this.instance.config.capture_dead_clicks) ? $0fb0e9cf977607be$var$Ei({}, this.instance.config.capture_dead_clicks) : {};
                t.__onCapture = this.onCapture, this.onCapture && (t.capture_dead_swipes = !1), this.Bo = $0fb0e9cf977607be$var$c.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, t), this.Bo.start($0fb0e9cf977607be$var$s), $0fb0e9cf977607be$var$_o.info("starting...");
            }
        } else $0fb0e9cf977607be$var$_o.error("`document` not found. Cannot start.");
    }
    stop() {
        this.Bo && (this.Bo.stop(), this.Bo = void 0, $0fb0e9cf977607be$var$_o.info("stopping..."));
    }
};
const $0fb0e9cf977607be$var$yo = $0fb0e9cf977607be$var$Ye("[SegmentIntegration]");
function $0fb0e9cf977607be$var$wo(t, i, e = !0) {
    const s = t.config.segment;
    if (!s) return i();
    const { analytics: n, filterProperties: r } = ((t)=>$0fb0e9cf977607be$var$P(t.register))(o = s) ? {
        analytics: o
    } : o;
    var o;
    !function(t, i, e, s) {
        const n = (i)=>{
            const n = ()=>i.anonymousId() || $0fb0e9cf977607be$var$lr();
            t.config.get_device_id = n, s && i.id() && (t.register({
                distinct_id: i.id(),
                $device_id: n()
            }), t.persistence.set_property($0fb0e9cf977607be$var$vn, $0fb0e9cf977607be$var$Dn)), e(s ? void 0 : i.anonymousId() || void 0);
        }, r = i.user();
        "then" in r && $0fb0e9cf977607be$var$P(r.then) ? r.then(n) : n(r);
    }(t, n, (e)=>{
        n.register(((t, i, { filterProperties: e } = {})=>{
            "undefined" != typeof Promise && Promise.resolve || $0fb0e9cf977607be$var$yo.warn("This browser does not have Promise support, and can not use the segment integration");
            const s = (s, n)=>{
                if (!n) return s;
                const r = !!i && s.event.anonymousId === i && !s.event.userId;
                r || s.event.userId || s.event.anonymousId === t.get_distinct_id() || ($0fb0e9cf977607be$var$yo.info("No userId set, resetting PostHog"), t.reset()), r || (i = void 0), s.event.userId && s.event.userId !== t.get_distinct_id() && ($0fb0e9cf977607be$var$yo.info("UserId set, identifying with PostHog"), t.identify(s.event.userId));
                let o = t.calculateEventProperties(n, s.event.properties);
                if (!$0fb0e9cf977607be$var$F(e)) {
                    const t = s.event.properties || {}, i = {};
                    for (const e of Object.keys(o))$0fb0e9cf977607be$var$E.call(t, e) || (i[e] = o[e]);
                    const n = ((t, i)=>{
                        const e = $0fb0e9cf977607be$var$T(t) ? t : [
                            t
                        ];
                        let s = $0fb0e9cf977607be$var$Ei({}, i);
                        for (const t of e)try {
                            if (s = t(s), $0fb0e9cf977607be$var$F(s)) return null;
                        } catch (t) {
                            return $0fb0e9cf977607be$var$yo.error("Error in Segment filterProperties:", t), null;
                        }
                        return s;
                    })(e, i);
                    if ($0fb0e9cf977607be$var$F(n)) return s;
                    o = n;
                }
                return s.event.properties = Object.assign({}, o, s.event.properties), s;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded () {
                    return !0;
                },
                load () {
                    return Promise.resolve();
                },
                track (t) {
                    return s(t, t.event.event);
                },
                page (t) {
                    return s(t, $0fb0e9cf977607be$var$Bn);
                },
                identify (t) {
                    return s(t, $0fb0e9cf977607be$var$zn);
                },
                screen (t) {
                    return s(t, "$screen");
                }
            };
        })(t, e, {
            filterProperties: r
        })).then(()=>{
            i();
        }, (t)=>{
            $0fb0e9cf977607be$var$yo.error("Failed to register the Segment integration", t), i();
        });
    }, e);
}
const $0fb0e9cf977607be$var$$o = "posthog-js";
function $0fb0e9cf977607be$var$So(t, { organization: i, projectId: e, prefix: s, severityAllowList: n = [
    "error"
], sendExceptionsToPostHog: r = !0 } = {}) {
    return (o)=>{
        var l, a, u, h, d;
        if ("*" !== n && !n.includes(o.level) || !t.__loaded) return o;
        o.tags || (o.tags = {});
        const c = t.requestRouter.endpointFor("ui", `/project/${t.config.token}/person/${t.get_distinct_id()}`);
        o.tags["PostHog Person URL"] = c, t.sessionRecordingStarted() && (o.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        const v = (null === (l = o.exception) || void 0 === l ? void 0 : l.values) || [], f = v.map((t)=>$0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                stacktrace: t.stacktrace ? $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t.stacktrace), {}, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), p = {
            $exception_message: (null === (a = v[0]) || void 0 === a ? void 0 : a.value) || o.message,
            $exception_type: null === (u = v[0]) || void 0 === u ? void 0 : u.type,
            $exception_level: o.level,
            $exception_list: f,
            $sentry_event_id: o.event_id,
            $sentry_exception: o.exception,
            $sentry_exception_message: (null === (h = v[0]) || void 0 === h ? void 0 : h.value) || o.message,
            $sentry_exception_type: null === (d = v[0]) || void 0 === d ? void 0 : d.type,
            $sentry_tags: o.tags
        };
        var _;
        return i && e && (p.$sentry_url = (s || "https://sentry.io/organizations/") + i + "/issues/?project=" + e + "&query=" + o.event_id), r && (null === (_ = t.exceptions) || void 0 === _ || _.sendExceptionEvent(p)), o;
    };
}
var $0fb0e9cf977607be$var$xo = class {
    constructor(t, i, e, s, n, r){
        this.name = $0fb0e9cf977607be$var$$o, this.setupOnce = function(o) {
            o($0fb0e9cf977607be$var$So(t, {
                organization: i,
                projectId: e,
                prefix: s,
                severityAllowList: n,
                sendExceptionsToPostHog: null == r || r
            }));
        };
    }
}, $0fb0e9cf977607be$var$Eo = class {
    constructor(t){
        this.Uo = (t, i, e)=>{
            e && (e.noSessionId || e.activityTimeout || e.sessionPastMaximumLength || e.crossTabAdoption) && ($0fb0e9cf977607be$var$Je.info("[PageViewManager] Session rotated, clearing pageview state", {
                sessionId: t,
                changeReason: e
            }), this.Wo = void 0, this._instance.scrollManager.resetContext());
        }, this._instance = t, this.Vo();
    }
    Vo() {
        var t;
        this.Go = null === (t = this._instance.sessionManager) || void 0 === t ? void 0 : t.onSessionId(this.Uo);
    }
    destroy() {
        var t;
        null === (t = this.Go) || void 0 === t || t.call(this), this.Go = void 0;
    }
    doPageView(i, e) {
        var s;
        const n = this.Qo(i, e);
        return this.Wo = {
            pathname: null !== (s = null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.location.pathname) && void 0 !== s ? s : "",
            pageViewId: e,
            timestamp: i
        }, this._instance.scrollManager.resetContext(), n;
    }
    doPageLeave(t) {
        var i;
        return this.Qo(t, null === (i = this.Wo) || void 0 === i ? void 0 : i.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null === (t = this.Wo) || void 0 === t ? void 0 : t.pageViewId
        };
    }
    Qo(t, i) {
        const e = this.Wo;
        if (!e) return {
            $pageview_id: i
        };
        let s = {
            $pageview_id: i,
            $prev_pageview_id: e.pageViewId
        };
        const n = this._instance.scrollManager.getContext();
        if (n && !this._instance.config.disable_scroll_properties) {
            let { maxScrollHeight: t, lastScrollY: i, maxScrollY: e, maxContentHeight: r, lastContentY: o, maxContentY: l } = n;
            if (!($0fb0e9cf977607be$var$R(t) || $0fb0e9cf977607be$var$R(i) || $0fb0e9cf977607be$var$R(e) || $0fb0e9cf977607be$var$R(r) || $0fb0e9cf977607be$var$R(o) || $0fb0e9cf977607be$var$R(l))) {
                t = Math.ceil(t), i = Math.ceil(i), e = Math.ceil(e), r = Math.ceil(r), o = Math.ceil(o), l = Math.ceil(l);
                const n = t > 1 ? $0fb0e9cf977607be$var$Z(i / t, 0, 1, $0fb0e9cf977607be$var$Je) : 1, a = t > 1 ? $0fb0e9cf977607be$var$Z(e / t, 0, 1, $0fb0e9cf977607be$var$Je) : 1, u = r > 1 ? $0fb0e9cf977607be$var$Z(o / r, 0, 1, $0fb0e9cf977607be$var$Je) : 1, h = r > 1 ? $0fb0e9cf977607be$var$Z(l / r, 0, 1, $0fb0e9cf977607be$var$Je) : 1;
                s = $0fb0e9cf977607be$var$Wn(s, {
                    $prev_pageview_last_scroll: i,
                    $prev_pageview_last_scroll_percentage: n,
                    $prev_pageview_max_scroll: e,
                    $prev_pageview_max_scroll_percentage: a,
                    $prev_pageview_last_content: o,
                    $prev_pageview_last_content_percentage: u,
                    $prev_pageview_max_content: l,
                    $prev_pageview_max_content_percentage: h
                });
            }
        }
        return e.pathname && (s.$prev_pageview_pathname = e.pathname), e.timestamp && (s.$prev_pageview_duration = (t.getTime() - e.timestamp.getTime()) / 1e3), s;
    }
};
const $0fb0e9cf977607be$var$ko = [
    "flags",
    "surveys"
], $0fb0e9cf977607be$var$To = {
    [$0fb0e9cf977607be$var$ss]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$ls]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$as]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$vs]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$hs]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$cs]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$fs]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$ps]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$$s]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$_s]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$gs]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$ms]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$bs]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$ys]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$ws]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Ss]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$xs]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Es]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Rs]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Is]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$ks]: {
        exposure: "event",
        shouldSkipFromEventProperties: (t)=>$0fb0e9cf977607be$var$A(t)
    },
    [$0fb0e9cf977607be$var$Ms]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$As]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$Fs]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$Ds]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$Ns]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$js]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$0fb0e9cf977607be$var$Ls]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$0fb0e9cf977607be$var$Bs]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Us]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$0fb0e9cf977607be$var$zs]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$0fb0e9cf977607be$var$Hs]: {
        exposure: "hidden",
        storageGroup: "flags",
        volatile: !0
    },
    [$0fb0e9cf977607be$var$qs]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$0fb0e9cf977607be$var$Vs]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Ws]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Gs]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Ks]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Ys]: {
        exposure: "hidden",
        storageGroup: "surveys"
    },
    [$0fb0e9cf977607be$var$Xs]: {
        exposure: "hidden",
        storageGroup: "surveys",
        volatile: !0
    },
    [$0fb0e9cf977607be$var$Qs]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$Zs]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$tn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$en]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$sn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$nn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$rn]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$on]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$ln]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$an]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$un]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$hn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Js]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$dn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$cn]: {
        exposure: "hidden",
        storageGroup: "flags",
        volatile: !0
    },
    [$0fb0e9cf977607be$var$vn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$fn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$pn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$_n]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$gn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$mn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$bn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Ts]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$Ps]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$Cs]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$Os]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$$n]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$Sn]: {
        exposure: "event"
    },
    [$0fb0e9cf977607be$var$xn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$En]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$kn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Tn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Pn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Cn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$On]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Rn]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$In]: {
        exposure: "hidden"
    },
    [$0fb0e9cf977607be$var$Mn]: {
        exposure: "event"
    }
}, $0fb0e9cf977607be$var$Po = [
    [
        "$posthog_sr_group_event_trigger_",
        {
            exposure: "hidden"
        }
    ],
    [
        "$posthog_sr_group_url_trigger_",
        {
            exposure: "hidden"
        }
    ],
    [
        "$posthog_sr_group_sampling_",
        {
            exposure: "hidden"
        }
    ]
], $0fb0e9cf977607be$var$Co = (t)=>{
    const i = $0fb0e9cf977607be$var$To[t];
    if (i) return i;
    for (const [i, e] of $0fb0e9cf977607be$var$Po)if (0 === t.indexOf(i)) return e;
}, $0fb0e9cf977607be$var$Oo = (t, i)=>{
    try {
        let e;
        return JSON.stringify(t, (t, i)=>{
            var s;
            return $0fb0e9cf977607be$var$H(i) ? (null !== (s = e) && void 0 !== s || (e = new WeakMap), e.has(i) || e.set(i, $0fb0e9cf977607be$var$Yn(i)), e.get(i)) : "bigint" == typeof i ? i.toString() : i;
        }, i);
    } catch (i) {
        return $0fb0e9cf977607be$var$S(t);
    }
}, $0fb0e9cf977607be$var$Ro = (t)=>{
    const i = null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.createElement("a");
    return $0fb0e9cf977607be$var$R(i) ? null : (i.href = t, i);
}, $0fb0e9cf977607be$var$Io = function(t, i) {
    const e = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&");
    let s;
    for(let t = 0; e.length > t; t++){
        const n = e[t].split("=");
        if (n[0] === i) {
            s = n;
            break;
        }
    }
    if (!$0fb0e9cf977607be$var$T(s) || 2 > s.length) return "";
    {
        let t = s[1];
        try {
            t = decodeURIComponent(t);
        } catch (i) {
            $0fb0e9cf977607be$var$Je.error("Skipping decoding for malformed query param: " + t);
        }
        return t.replace(/\+/g, " ");
    }
}, $0fb0e9cf977607be$var$Mo = function(t, i, e) {
    if (!t || !i || !i.length) return t;
    const s = t.split("#"), n = s[1], r = (s[0] || "").split("?"), o = r[1], l = r[0], a = (o || "").split("&"), u = [];
    for(let t = 0; a.length > t; t++){
        const s = a[t].split("=");
        $0fb0e9cf977607be$var$T(s) && (i.includes(s[0]) ? u.push(s[0] + "=" + e) : u.push(a[t]));
    }
    let h = l;
    return null != o && (h += "?" + u.join("&")), null != n && (h += "#" + n), h;
}, $0fb0e9cf977607be$var$Ao = function(t, i) {
    const e = t.match(new RegExp(i + "=([^&]*)"));
    return e ? e[1] : null;
}, $0fb0e9cf977607be$var$Fo = (t, i)=>t >= i && $0fb0e9cf977607be$var$h(), $0fb0e9cf977607be$var$Do = (t, i, e, s)=>{
    if (0 === t) {
        if ($0fb0e9cf977607be$var$h()) {
            const t = i + 1;
            return t === e && s(), t;
        }
        return i;
    }
    return 0;
}, $0fb0e9cf977607be$var$No = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "oppref",
    "irclid",
    "_kx"
], $0fb0e9cf977607be$var$jo = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid",
    ...$0fb0e9cf977607be$var$No
], $0fb0e9cf977607be$var$Lo = "<masked>", $0fb0e9cf977607be$var$Bo = [
    "li_fat_id"
];
function $0fb0e9cf977607be$var$Uo(t, i, e) {
    if (!$0fb0e9cf977607be$var$s) return {};
    const n = i ? [
        ...$0fb0e9cf977607be$var$No,
        ...e || []
    ] : [], r = $0fb0e9cf977607be$var$zo($0fb0e9cf977607be$var$Mo($0fb0e9cf977607be$var$s.URL, n, $0fb0e9cf977607be$var$Lo), t), o = function() {
        const t = {};
        return $0fb0e9cf977607be$var$Vn($0fb0e9cf977607be$var$Bo, function(i) {
            const e = $0fb0e9cf977607be$var$ir(i);
            t[i] = e || null;
        }), t;
    }();
    return $0fb0e9cf977607be$var$Wn(o, r);
}
function $0fb0e9cf977607be$var$zo(t, i) {
    const e = $0fb0e9cf977607be$var$jo.concat(i || []), s = {};
    return $0fb0e9cf977607be$var$Vn(e, function(i) {
        const e = $0fb0e9cf977607be$var$Io(t, i);
        s[i] = e || null;
    }), s;
}
function $0fb0e9cf977607be$var$Ho(t) {
    const i = function(t) {
        return t ? 0 === t.search("https?://(.*)google.([^/?]*)") ? "google" : 0 === t.search("https?://(.*)bing.com") ? "bing" : 0 === t.search("https?://(.*)yahoo.com") ? "yahoo" : 0 === t.search("https?://(.*)duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), e = "yahoo" != i ? "q" : "p", n = {};
    if (!$0fb0e9cf977607be$var$A(i)) {
        n.$search_engine = i;
        const t = $0fb0e9cf977607be$var$s ? $0fb0e9cf977607be$var$Io($0fb0e9cf977607be$var$s.referrer, e) : "";
        t.length && (n.ph_keyword = t);
    }
    return n;
}
function $0fb0e9cf977607be$var$qo() {
    return navigator.language || navigator.userLanguage;
}
function $0fb0e9cf977607be$var$Vo() {
    const t = $0fb0e9cf977607be$var$qo();
    return "string" == typeof t ? t.split("-")[0] : void 0;
}
const $0fb0e9cf977607be$var$Wo = "$direct";
function $0fb0e9cf977607be$var$Go() {
    return (null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.referrer) || $0fb0e9cf977607be$var$Wo;
}
function $0fb0e9cf977607be$var$Ko(t, i, e = !1) {
    const s = t ? [
        ...$0fb0e9cf977607be$var$No,
        ...i || []
    ] : [], r = e ? $0fb0e9cf977607be$var$vi(null == $0fb0e9cf977607be$var$n ? void 0 : $0fb0e9cf977607be$var$n.href) : null == $0fb0e9cf977607be$var$n ? void 0 : $0fb0e9cf977607be$var$n.href, o = null == r ? void 0 : r.substring(0, 1e3);
    return {
        r: $0fb0e9cf977607be$var$Go().substring(0, 1e3),
        u: o ? $0fb0e9cf977607be$var$Mo(o, s, $0fb0e9cf977607be$var$Lo) : void 0
    };
}
function $0fb0e9cf977607be$var$Jo(t, i = !1) {
    var e;
    const { r: s, u: n } = t, r = i ? $0fb0e9cf977607be$var$vi(n) : n, o = {
        $referrer: s,
        $referring_domain: null == s ? void 0 : s == $0fb0e9cf977607be$var$Wo ? $0fb0e9cf977607be$var$Wo : null === (e = $0fb0e9cf977607be$var$Ro(s)) || void 0 === e ? void 0 : e.host
    };
    if (r) {
        o.$current_url = r;
        const t = $0fb0e9cf977607be$var$Ro(r);
        o.$host = null == t ? void 0 : t.host, o.$pathname = null == t ? void 0 : t.pathname;
        const i = $0fb0e9cf977607be$var$zo(r);
        $0fb0e9cf977607be$var$Wn(o, i);
    }
    if (s) {
        const t = $0fb0e9cf977607be$var$Ho(s);
        $0fb0e9cf977607be$var$Wn(o, t);
    }
    return o;
}
function $0fb0e9cf977607be$var$Yo() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $0fb0e9cf977607be$var$Xo() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
const $0fb0e9cf977607be$var$Qo = {
    flags: $0fb0e9cf977607be$var$cn,
    surveys: $0fb0e9cf977607be$var$Xs
}, $0fb0e9cf977607be$var$Zo = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
], $0fb0e9cf977607be$var$tl = (t)=>`${t}_cookie_identity_change_pending`, $0fb0e9cf977607be$var$il = (t)=>{
    let i = "", e = 0;
    for (const s of t){
        const t = encodeURIComponent(JSON.stringify(s).slice(1, -1)).length;
        if (e + t > 1e3) break;
        i += s, e += t;
    }
    return i;
}, $0fb0e9cf977607be$var$el = "main", $0fb0e9cf977607be$var$sl = [
    $0fb0e9cf977607be$var$js,
    $0fb0e9cf977607be$var$Ls,
    $0fb0e9cf977607be$var$Us,
    $0fb0e9cf977607be$var$zs,
    $0fb0e9cf977607be$var$Hs,
    $0fb0e9cf977607be$var$cn,
    $0fb0e9cf977607be$var$qs,
    $0fb0e9cf977607be$var$Gs
], $0fb0e9cf977607be$var$nl = (t)=>-1 !== $0fb0e9cf977607be$var$sl.indexOf(t), $0fb0e9cf977607be$var$rl = [
    $0fb0e9cf977607be$var$hs,
    $0fb0e9cf977607be$var$cs
], $0fb0e9cf977607be$var$ol = (t)=>-1 !== $0fb0e9cf977607be$var$rl.indexOf(t), $0fb0e9cf977607be$var$ll = (t, i)=>{
    try {
        return JSON.stringify(t) === JSON.stringify(i);
    } catch (e) {
        return t === i;
    }
}, $0fb0e9cf977607be$var$al = (t)=>{
    if (!t) return {};
    const i = JSON.parse(t);
    return $0fb0e9cf977607be$var$C(i) ? i : {};
}, $0fb0e9cf977607be$var$ul = (t, i)=>{
    $0fb0e9cf977607be$var$Vn(t, (e, s)=>{
        const n = $0fb0e9cf977607be$var$Co(s);
        n && "event" !== n.exposure || ({}).hasOwnProperty.call(i, s) || delete t[s];
    });
};
var $0fb0e9cf977607be$var$hl = class {
    constructor(i, e, s = !0, n = !i.cookieless_mode){
        if (this.Jo = {}, this.Zo = !1, this.Ko = !1, this.Xo = !1, this.Yo = !1, this.ta = !1, this.ea = new Map, this.ia = !1, this.na = !1, this.sa = !1, this.ra = new Set, this.oa = new Set, this.Mr = i, this.aa = s, this.props = {}, this.la = void 0, this.ua = ((t)=>{
            let i = "";
            return t.token && (i = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + i + "_posthog";
        })(i), this.hi = i.disable_persistence || !!e, this.No = this.ha(i), this.Xo = this.ca(i), this.load(n), this.da(), i.debug && $0fb0e9cf977607be$var$Je.info("Persistence loaded", i.persistence, $0fb0e9cf977607be$var$Ei({}, this.props)), this.update_config(i, i, e), this.save(), $0fb0e9cf977607be$var$t) {
            const i = ()=>this.flush();
            $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "beforeunload", i, {
                capture: !1
            }), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "pagehide", i, {
                capture: !1
            }), this.va = (i)=>{
                if (this.Zo && (!i.storageArea || i.storageArea === (null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.localStorage)) && i.key) {
                    if (i.key !== this.ua) {
                        if (this.Xo) {
                            const t = $0fb0e9cf977607be$var$ko.find((t)=>i.key === this.fa(t));
                            t && this.pa(i.key, t);
                        }
                    } else this.pa(i.key, $0fb0e9cf977607be$var$el);
                }
            }, $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "storage", this.va);
        }
    }
    markCrossTabFeatureFlagChanges(t) {
        Object.entries(t).forEach(([t, i])=>{
            const e = this.ea.get(t);
            if (!$0fb0e9cf977607be$var$nl(t) || !0 === e) return;
            if (!0 === i) return void this.ga(t, !0);
            const s = new Set(e || []);
            i.forEach((t)=>s.add(t)), s.size && this.ga(t, s);
        });
    }
    onCrossTabFeatureFlagChange(t) {
        return this.oa.add(t), ()=>this.oa.delete(t);
    }
    destroy() {
        this.va && $0fb0e9cf977607be$var$t && ($0fb0e9cf977607be$var$t.removeEventListener("storage", this.va), this.va = void 0), this.oa.clear();
    }
    pa(t, i, e = !0) {
        if (this.hi) return !1;
        let s, n;
        try {
            if (n = $0fb0e9cf977607be$var$fr.Ot(t), $0fb0e9cf977607be$var$A(n)) {
                const t = this.ma(i);
                return t.storageValue = null, i !== $0fb0e9cf977607be$var$el && (t.persisted = !1), !1;
            }
            s = $0fb0e9cf977607be$var$al(n);
        } catch (t) {
            return !1;
        }
        const r = i === $0fb0e9cf977607be$var$el ? s : $0fb0e9cf977607be$var$fr.Lt(this.ua);
        if (r && this.ya(r)) return !1;
        const o = this.ba(s, i, e);
        return i === $0fb0e9cf977607be$var$el && this.Xo && !$0fb0e9cf977607be$var$ll(this._a().main, s) || this.wa(s, i, !0, n), o;
    }
    ya(t) {
        const i = this.props[$0fb0e9cf977607be$var$ns], e = t[$0fb0e9cf977607be$var$ns];
        return !$0fb0e9cf977607be$var$R(i) && !$0fb0e9cf977607be$var$R(e) && i !== e;
    }
    wa(t, i, e, s) {
        const n = this.ma(i);
        n.storageValue = s, i !== $0fb0e9cf977607be$var$el && (n.persisted = e);
        try {
            n.fingerprint = this.ka(t, i);
        } catch (t) {
            n.fingerprint = void 0;
        }
    }
    ba(t, i, e) {
        let s = !1;
        return $0fb0e9cf977607be$var$sl.forEach((e)=>{
            var n;
            const r = null === (n = $0fb0e9cf977607be$var$Co(e)) || void 0 === n ? void 0 : n.storageGroup;
            if (i === $0fb0e9cf977607be$var$el && this.Xo && r || i !== $0fb0e9cf977607be$var$el && r !== i) return;
            const o = e in t, l = this.Sa(e, o ? t[e] : void 0), a = this.ea.has(e) ? e in this.props : o;
            a === e in this.props && $0fb0e9cf977607be$var$ll(l, this.props[e]) || (a ? this.xa(e, l, !1) : this.$a(e, !1), s = !0);
        }), s && e && this.oa.forEach((t)=>t()), s;
    }
    Ca() {
        if (!this.Zo) return !1;
        try {
            this.sa = !1;
            const t = $0fb0e9cf977607be$var$fr.Ot(this.ua), i = this.ma($0fb0e9cf977607be$var$el);
            let e, s = !1, n = !1;
            if (t !== i.storageValue) {
                if ($0fb0e9cf977607be$var$A(t)) i.storageValue = null;
                else {
                    if (e = $0fb0e9cf977607be$var$al(t), this.sa = !this.na && this.ya(e), this.sa) return !1;
                    n = this.ba(e, $0fb0e9cf977607be$var$el, !1), !this.Xo || $0fb0e9cf977607be$var$ll(this._a().main, e) ? this.wa(e, $0fb0e9cf977607be$var$el, !0, t) : i.storageValue = t, s = !0;
                }
            }
            return this.Xo && $0fb0e9cf977607be$var$ko.forEach((t)=>{
                const i = $0fb0e9cf977607be$var$fr.Ot(this.fa(t)), r = this.ma(t), o = e || {}, l = s && $0fb0e9cf977607be$var$sl.some((i)=>{
                    var e;
                    return (null === (e = $0fb0e9cf977607be$var$Co(i)) || void 0 === e ? void 0 : e.storageGroup) === t && i in o;
                });
                if (i === r.storageValue && !l) return;
                if ($0fb0e9cf977607be$var$A(i)) return r.storageValue = null, r.persisted = !1, void (l && (n = this.ba(o, t, !1) || n));
                const a = $0fb0e9cf977607be$var$al(i);
                n = this.ba(a, t, !1) || n, this.wa(a, t, !0, i);
            }), n;
        } catch (t) {
            return !1;
        }
    }
    ga(t, i) {
        this.ea.set(t, i);
        const e = $0fb0e9cf977607be$var$Co(t);
        (null == e ? void 0 : e.volatile) || (this.ma((this.Xo ? null == e ? void 0 : e.storageGroup : void 0) || $0fb0e9cf977607be$var$el).fingerprint = void 0, this.Ta(t));
    }
    Ia() {
        $0fb0e9cf977607be$var$sl.forEach((t)=>this.ea.set(t, !0));
    }
    da() {
        if (this.Zo) try {
            const t = $0fb0e9cf977607be$var$fr.Ot(this.ua), i = $0fb0e9cf977607be$var$al(t);
            this.ma($0fb0e9cf977607be$var$el).storageValue = t, $0fb0e9cf977607be$var$sl.forEach((t)=>{
                var e;
                const s = this.Xo ? null === (e = $0fb0e9cf977607be$var$Co(t)) || void 0 === e ? void 0 : e.storageGroup : void 0, n = s ? $0fb0e9cf977607be$var$fr.Ot(this.fa(s)) : null;
                if (s) {
                    const t = this.ma(s);
                    t.storageValue = n, t.persisted = !$0fb0e9cf977607be$var$A(n);
                }
                const r = s && !$0fb0e9cf977607be$var$A(n) ? $0fb0e9cf977607be$var$al(n) : i;
                t in this.props ? this.Ma(t, r[t], this.props[t]) : t in r && this.ga(t, !0);
            });
        } catch (t) {}
    }
    Sa(t, i) {
        const e = this.ea.get(t);
        if (!e) return i;
        if (!0 === e) return this.props[t];
        if ("$active_feature_flags" === t) {
            const s = new Set($0fb0e9cf977607be$var$T(i) ? i : []), n = new Set($0fb0e9cf977607be$var$T(this.props[t]) ? this.props[t] : []);
            return e.forEach((t)=>n.has(t) ? s.add(t) : s.delete(t)), Array.from(s);
        }
        const s = $0fb0e9cf977607be$var$C(i) ? $0fb0e9cf977607be$var$Ei({}, i) : {}, n = $0fb0e9cf977607be$var$C(this.props[t]) ? this.props[t] : {};
        return e.forEach((t)=>{
            t in n ? s[t] = n[t] : delete s[t];
        }), s;
    }
    Ma(t, i, e) {
        if (!$0fb0e9cf977607be$var$nl(t)) return;
        const s = this.ea.get(t);
        if (!0 === s) return;
        let n = i;
        if (this.Zo) try {
            var r;
            const i = this.Xo ? null === (r = $0fb0e9cf977607be$var$Co(t)) || void 0 === r ? void 0 : r.storageGroup : void 0, e = i ? this.fa(i) : this.ua;
            n = $0fb0e9cf977607be$var$al($0fb0e9cf977607be$var$fr.Ot(e))[t];
        } catch (t) {}
        const o = new Set(s || []);
        if ("$active_feature_flags" === t) {
            if (!$0fb0e9cf977607be$var$R(i) && !$0fb0e9cf977607be$var$T(i) || !$0fb0e9cf977607be$var$R(n) && !$0fb0e9cf977607be$var$T(n) || !$0fb0e9cf977607be$var$T(e)) return void this.ga(t, !0);
            const s = new Set(i || []), r = new Set(n || []), l = new Set(e);
            new Set([
                ...s,
                ...l
            ]).forEach((t)=>{
                s.has(t) !== l.has(t) && o.add(t);
            }), o.forEach((t)=>{
                r.has(t) === l.has(t) && o.delete(t);
            });
        } else {
            if (!$0fb0e9cf977607be$var$C(e)) return void ($0fb0e9cf977607be$var$ll(n, e) ? this.ea.delete(t) : this.ga(t, !0));
            {
                if (!$0fb0e9cf977607be$var$R(i) && !$0fb0e9cf977607be$var$C(i) || $0fb0e9cf977607be$var$R(i) && $0fb0e9cf977607be$var$O(e) && $0fb0e9cf977607be$var$R(n)) return void this.ga(t, !0);
                const s = $0fb0e9cf977607be$var$C(i) ? i : {}, r = $0fb0e9cf977607be$var$C(n) ? n : {};
                new Set([
                    ...Object.keys(s),
                    ...Object.keys(e)
                ]).forEach((t)=>{
                    t in s == t in e && $0fb0e9cf977607be$var$ll(s[t], e[t]) || o.add(t);
                }), o.forEach((t)=>{
                    t in r == t in e && $0fb0e9cf977607be$var$ll(r[t], e[t]) && o.delete(t);
                });
            }
        }
        o.size ? this.ga(t, o) : this.ea.delete(t);
    }
    Ea() {
        var t;
        const i = null === (t = this.Mr) || void 0 === t ? void 0 : t.persistence_save_debounce_ms;
        return $0fb0e9cf977607be$var$D(i) && i > 0 ? i : 0;
    }
    Pa(t) {
        if (this.Mr.cookieWinsOnConflict && "localstorage+cookie" === this.Mr.persistence.toLowerCase()) {
            if (t) try {
                const i = $0fb0e9cf977607be$var$yr(t, this.Mr.cookie_persisted_properties || []), e = $0fb0e9cf977607be$var$$r(i, this.Mr.cookie_persisted_properties || []), s = JSON.stringify(i) + "|" + JSON.stringify(e), n = $0fb0e9cf977607be$var$cr.Ot(this.ua) || void 0;
                n && $0fb0e9cf977607be$var$xr(this.ua, n) === s && (this.Ra = s, this.Aa = n);
            } catch (t) {}
            else try {
                const t = $0fb0e9cf977607be$var$cr.Ot(this.ua) || void 0;
                this.Ra = t ? $0fb0e9cf977607be$var$xr(this.ua, t) : void 0, this.Aa = t;
            } catch (t) {}
        }
    }
    syncCookieProperties() {
        return this.Oa(this.Mr);
    }
    Oa(t, i = !1) {
        if (this.hi && !i || this.ta || !t.cookieWinsOnConflict || "localstorage+cookie" !== t.persistence.toLowerCase()) return !1;
        let e;
        try {
            e = $0fb0e9cf977607be$var$cr.Ot(this.ua) || void 0;
        } catch (t) {}
        if (!e || e === this.Aa) return !1;
        const s = $0fb0e9cf977607be$var$xr(this.ua, e);
        let n;
        try {
            n = $0fb0e9cf977607be$var$br(JSON.parse(e));
        } catch (t) {
            return !1;
        }
        if (($0fb0e9cf977607be$var$cr.Ot(this.ua) || void 0) !== e) return !1;
        this.Ra = s, this.Aa = e;
        const r = $0fb0e9cf977607be$var$Sr(this.ua, e), o = [
            ...$0fb0e9cf977607be$var$_r,
            ...r.properties
        ], l = {};
        if (Object.keys(n).forEach((t)=>{
            const i = n[t];
            ($0fb0e9cf977607be$var$R(i) || $0fb0e9cf977607be$var$A(i) || "" === i || "$user_state" === t && "anonymous" !== i && "identified" !== i) && (l[t] = !0, delete n[t]);
        }), $0fb0e9cf977607be$var$O(n)) return !1;
        const a = "distinct_id" in n || "anonymous" === n.$user_state || "identified" === n.$user_state, u = this.props, h = u[$0fb0e9cf977607be$var$ns], d = u[$0fb0e9cf977607be$var$vn], c = $0fb0e9cf977607be$var$Wn({}, u);
        [
            ...$0fb0e9cf977607be$var$_r,
            ...t.cookie_persisted_properties || []
        ].forEach((t)=>{
            if (-1 !== o.indexOf(t) && !(t in n) && !l[t] && (a || "distinct_id" !== t && "$user_state" !== t)) {
                const i = c[t];
                (r.isValid || -1 === $0fb0e9cf977607be$var$_r.indexOf(t) || !1 !== i && 0 !== i) && delete c[t];
            }
        }), this.props = $0fb0e9cf977607be$var$Wn(c, n), $0fb0e9cf977607be$var$sl.forEach((t)=>{
            const i = t in this.props;
            t in u === i && $0fb0e9cf977607be$var$ll(u[t], this.props[t]) || (i ? this.Ma(t, u[t], this.props[t]) : this.ga(t, !0));
        }), !a || "$user_state" in n || "$user_state" in this.props || this.xa($0fb0e9cf977607be$var$vn, $0fb0e9cf977607be$var$Fn);
        const v = this.props[$0fb0e9cf977607be$var$ns], f = this.props[$0fb0e9cf977607be$var$vn];
        return !a || v === h && f === d || (this.na = !0, this.Yo = !0, $0fb0e9cf977607be$var$Pr.$t($0fb0e9cf977607be$var$tl(this.ua), !0), this.$a($0fb0e9cf977607be$var$Gs), this.$a($0fb0e9cf977607be$var$Ls), this.$a($0fb0e9cf977607be$var$js), this.$a($0fb0e9cf977607be$var$Us), this.$a($0fb0e9cf977607be$var$zs), this.$a($0fb0e9cf977607be$var$Hs), this.$a($0fb0e9cf977607be$var$cn), this.$a($0fb0e9cf977607be$var$dn), this.$a($0fb0e9cf977607be$var$un), "anonymous" !== f || "identified" !== d && "anonymous" !== n.$user_state && ($0fb0e9cf977607be$var$R(h) || v === h) || ($0fb0e9cf977607be$var$ul(this.props, n), this.$a($0fb0e9cf977607be$var$Ks)), "identified" === f ? this.props.$user_id = v : delete this.props.$user_id, this.$a($0fb0e9cf977607be$var$ls)), !0;
    }
    consumeCookieIdentityChange() {
        const t = $0fb0e9cf977607be$var$tl(this.ua), i = this.Yo || !!$0fb0e9cf977607be$var$Pr.Ot(t);
        return this.Yo = !1, i && $0fb0e9cf977607be$var$Pr.Pt(t), i;
    }
    Fa(t = !1) {
        return !(this.ta || this.hi && !t || !this.Mr.cookieWinsOnConflict || "localstorage+cookie" !== this.Mr.persistence.toLowerCase() || (this.ta = !0, 0));
    }
    Da() {
        this.ta && ($0fb0e9cf977607be$var$R(this.La) || (clearTimeout(this.La), this.La = void 0), delete this.Jo[$0fb0e9cf977607be$var$el], this.Na(!0));
    }
    qa(t = !0) {
        if (this.ta) try {
            t ? this.Da() : $0fb0e9cf977607be$var$R(this.La) || (clearTimeout(this.La), this.La = void 0);
        } finally{
            this.ta = !1;
        }
    }
    isDisabled() {
        return !!this.hi;
    }
    ha(i) {
        -1 === $0fb0e9cf977607be$var$Zo.indexOf(i.persistence.toLowerCase()) && ($0fb0e9cf977607be$var$Je.critical("Unknown persistence type " + i.persistence + "; falling back to localStorage+cookie"), i.persistence = "localStorage+cookie");
        const e = ((i = [], e = !1, s = ()=>!1)=>{
            const n = [
                ...$0fb0e9cf977607be$var$_r,
                ...i
            ];
            return $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, $0fb0e9cf977607be$var$fr), {}, {
                Lt (t) {
                    try {
                        let r, o = {};
                        try {
                            r = $0fb0e9cf977607be$var$cr.Ot(t) || void 0, o = r ? $0fb0e9cf977607be$var$br(JSON.parse(r)) : {};
                        } catch (t) {}
                        const l = JSON.parse($0fb0e9cf977607be$var$fr.Ot(t) || "{}");
                        let a;
                        if (e) {
                            const e = $0fb0e9cf977607be$var$Sr(t, r), s = [
                                ...$0fb0e9cf977607be$var$_r,
                                ...e.properties
                            ], u = {};
                            Object.keys(o).forEach((t)=>{
                                const i = o[t];
                                $0fb0e9cf977607be$var$A(i) || "" === i || "$user_state" === t && "anonymous" !== i && "identified" !== i || (u[t] = i);
                            });
                            const h = "distinct_id" in u || "anonymous" === u.$user_state || "identified" === u.$user_state;
                            if (Object.keys(u).length > 0) {
                                var i;
                                const t = l[$0fb0e9cf977607be$var$ns], r = null !== (i = l.$user_state) && void 0 !== i ? i : $0fb0e9cf977607be$var$Fn;
                                n.forEach((t)=>{
                                    if (-1 !== s.indexOf(t) && !(t in o) && (h || "distinct_id" !== t && "$user_state" !== t)) {
                                        const i = l[t];
                                        (e.isValid || -1 === $0fb0e9cf977607be$var$_r.indexOf(t) || !1 !== i && 0 !== i) && delete l[t];
                                    }
                                }), !h || "$user_state" in o || "$user_state" in l || (l[$0fb0e9cf977607be$var$vn] = $0fb0e9cf977607be$var$Fn), !h || ("distinct_id" in u ? u[$0fb0e9cf977607be$var$ns] : l[$0fb0e9cf977607be$var$ns]) === t && ("$user_state" in u ? u[$0fb0e9cf977607be$var$vn] : l[$0fb0e9cf977607be$var$vn]) === r || ($0fb0e9cf977607be$var$pr.forEach((t)=>delete l[t]), "identified" === u.$user_state && "distinct_id" in u ? l.$user_id = u[$0fb0e9cf977607be$var$ns] : delete l.$user_id, "identified" !== u.$user_state && (delete l[$0fb0e9cf977607be$var$Js], delete l[$0fb0e9cf977607be$var$Ks]), delete l.__alias);
                            }
                            a = $0fb0e9cf977607be$var$Wn(l, u);
                        } else a = $0fb0e9cf977607be$var$Wn(o, l);
                        return s() || $0fb0e9cf977607be$var$fr.$t(t, a), a;
                    } catch (t) {}
                    return null;
                },
                $t (t, s, n, r, o, l) {
                    const a = $0fb0e9cf977607be$var$fr.$t(t, s, void 0, void 0, l);
                    try {
                        const u = $0fb0e9cf977607be$var$yr(s, i);
                        if (Object.keys(u).length) {
                            if (e) {
                                const e = $0fb0e9cf977607be$var$gr(t), h = $0fb0e9cf977607be$var$$r(u, i);
                                if ($0fb0e9cf977607be$var$cr.$t(e, h, n, r, o, l), $0fb0e9cf977607be$var$cr.Ot(e) !== JSON.stringify(h)) {
                                    $0fb0e9cf977607be$var$cr.Pt(e, r);
                                    const i = $0fb0e9cf977607be$var$yr(s);
                                    return $0fb0e9cf977607be$var$cr.$t(t, i, n, r, o, l), a;
                                }
                            }
                            $0fb0e9cf977607be$var$cr.$t(t, u, n, r, o, l);
                        }
                    } catch (t) {
                        $0fb0e9cf977607be$var$fr.Dt(t);
                    }
                    return a;
                },
                Pt (i, e) {
                    try {
                        null == $0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$t.localStorage.removeItem(i), $0fb0e9cf977607be$var$cr.Pt(i, e), $0fb0e9cf977607be$var$cr.Pt($0fb0e9cf977607be$var$gr(i), e);
                    } catch (t) {
                        $0fb0e9cf977607be$var$fr.Dt(t);
                    }
                }
            });
        })(i.cookie_persisted_properties || [], i.cookieWinsOnConflict, ()=>!!this.hi);
        let s, n = !1, r = !1;
        const o = i.persistence.toLowerCase();
        return "localstorage" === o && $0fb0e9cf977607be$var$fr.Et() ? (s = $0fb0e9cf977607be$var$fr, r = !0) : "localstorage+cookie" === o && e.Et() ? (s = e, r = !0, n = !0) : "sessionstorage" === o && $0fb0e9cf977607be$var$Pr.Et() ? s = $0fb0e9cf977607be$var$Pr : "memory" === o ? s = $0fb0e9cf977607be$var$kr : "cookie" === o && $0fb0e9cf977607be$var$cr.Et() ? (s = $0fb0e9cf977607be$var$cr, n = !0) : e.Et() ? (s = e, r = !0, n = !0) : $0fb0e9cf977607be$var$cr.Et() ? (s = $0fb0e9cf977607be$var$cr, n = !0) : s = $0fb0e9cf977607be$var$kr, this.Zo = r, this.Ko = n, s;
    }
    fa(t) {
        return `${this.ua}__${t}`;
    }
    ca(t) {
        return this.Zo && !!t.split_storage;
    }
    properties() {
        const t = {};
        return $0fb0e9cf977607be$var$Vn(this.props, (i, e)=>{
            const s = $0fb0e9cf977607be$var$Co(e);
            if (!s || "event" === s.exposure) {
                var n;
                if (null == s || null === (n = s.shouldSkipFromEventProperties) || void 0 === n ? void 0 : n.call(s, i)) return;
                t[e] = i;
            }
        }), t;
    }
    load(t = !1) {
        if (this.hi && !t) return;
        const i = this.Mr.cookieWinsOnConflict && "localstorage+cookie" === this.Mr.persistence.toLowerCase(), e = i ? $0fb0e9cf977607be$var$fr.Lt(this.ua) : null;
        let s = {};
        if (i) try {
            s = $0fb0e9cf977607be$var$br($0fb0e9cf977607be$var$cr.Lt(this.ua)), $0fb0e9cf977607be$var$Vn(s, (t, i)=>{
                ($0fb0e9cf977607be$var$R(t) || $0fb0e9cf977607be$var$A(t) || "" === t) && delete s[i];
            });
        } catch (t) {}
        const n = this.No.Lt(this.ua);
        if (n && (this.props = $0fb0e9cf977607be$var$Wn({}, n)), this.Xo && this.ja(), i && n) {
            var r, o;
            const t = null == e ? void 0 : e[$0fb0e9cf977607be$var$ns], i = null !== (r = null == e ? void 0 : e.$user_state) && void 0 !== r ? r : $0fb0e9cf977607be$var$Fn, l = n[$0fb0e9cf977607be$var$ns], a = null !== (o = n.$user_state) && void 0 !== o ? o : $0fb0e9cf977607be$var$Fn;
            if (l !== t || a !== i) {
                this.Yo = !0, this.hi || $0fb0e9cf977607be$var$Pr.$t($0fb0e9cf977607be$var$tl(this.ua), !0);
                const e = $0fb0e9cf977607be$var$Wn({}, this.props);
                $0fb0e9cf977607be$var$pr.forEach((t)=>delete e[t]), "anonymous" !== a || "identified" !== i && "anonymous" !== s.$user_state && ($0fb0e9cf977607be$var$R(t) || l === t) || ($0fb0e9cf977607be$var$ul(e, s), delete e[$0fb0e9cf977607be$var$Ks]), this.props = e;
                const n = new Set;
                $0fb0e9cf977607be$var$pr.forEach((t)=>{
                    var i;
                    const e = null === (i = $0fb0e9cf977607be$var$Co(t)) || void 0 === i ? void 0 : i.storageGroup;
                    e && n.add(e);
                }), n.forEach((t)=>{
                    if (this.hi) return;
                    const i = {};
                    $0fb0e9cf977607be$var$Vn(this.props, (e, s)=>{
                        var n;
                        (null === (n = $0fb0e9cf977607be$var$Co(s)) || void 0 === n ? void 0 : n.storageGroup) === t && (i[s] = e);
                    }), $0fb0e9cf977607be$var$O(i) ? ($0fb0e9cf977607be$var$fr.Pt(this.fa(t)), this.Jo[t] = {}) : $0fb0e9cf977607be$var$fr.$t(this.fa(t), i) && (this.Jo[t] = {
                        persisted: !0,
                        fingerprint: this.ka(i, t)
                    });
                });
            }
        }
        $0fb0e9cf977607be$var$Pr.Ot($0fb0e9cf977607be$var$tl(this.ua)) && (this.Yo = !0);
    }
    ja() {
        for (const t of $0fb0e9cf977607be$var$ko){
            const i = $0fb0e9cf977607be$var$fr.Lt(this.fa(t));
            if (i && !$0fb0e9cf977607be$var$O(i)) {
                const e = this.ma(t);
                e.persisted = !0, this.Ba(t) || (e.fingerprint = this.ka(i, t)), this.Ha(t, i) || $0fb0e9cf977607be$var$Wn(this.props, i);
            }
        }
    }
    Ba(t) {
        return Object.keys(this.props).some((i)=>{
            var e;
            return (null === (e = $0fb0e9cf977607be$var$Co(i)) || void 0 === e ? void 0 : e.storageGroup) === t;
        });
    }
    Ha(t, i) {
        const e = $0fb0e9cf977607be$var$Qo[t];
        if (!e) return !1;
        const s = i[e], n = this.props[e];
        return $0fb0e9cf977607be$var$D(s) && $0fb0e9cf977607be$var$D(n) && n > s;
    }
    refreshKey(t) {
        var i;
        if (this.hi) return;
        if (this.ra.has(t)) return;
        const e = this.Xo ? null === (i = $0fb0e9cf977607be$var$Co(t)) || void 0 === i ? void 0 : i.storageGroup : void 0, s = e ? $0fb0e9cf977607be$var$fr.Lt(this.fa(e)) : this.No.Lt(this.ua);
        if (s && t in s) this.xa(t, s[t], !1);
        else {
            if (e) {
                const i = this.No.Lt(this.ua);
                if (i && t in i) return void this.xa(t, i[t], !1);
            }
            this.$a(t, !1);
        }
    }
    save() {
        if (this.hi) return;
        const t = this.Ea();
        t > 0 ? $0fb0e9cf977607be$var$R(this.La) && (this.La = setTimeout(()=>{
            this.La = void 0, this.Na();
        }, t)) : this.Na();
    }
    flush() {
        $0fb0e9cf977607be$var$R(this.La) || (clearTimeout(this.La), this.La = void 0, this.Na());
    }
    Na(t = !1) {
        if (this.hi || this.ta && !t) return;
        t || (this.syncCookieProperties(), this.Mr.cookieWinsOnConflict && "localstorage+cookie" === this.Mr.persistence.toLowerCase() || $0fb0e9cf977607be$var$rl.forEach((t)=>this.refreshKey(t)));
        const i = !t && !this.ia;
        i || (this.sa = !1);
        const e = !!i && this.Ca();
        if (this.sa) return void (this.Mr.debug && $0fb0e9cf977607be$var$Je.warn("skipping persistence write because storage belongs to a different distinct ID"));
        if (this.Xo) return this.za(), void (e && this.oa.forEach((t)=>t()));
        const s = this.Ua(this.No, this.ua, this.props, $0fb0e9cf977607be$var$el);
        "written" === s && this.Pa(this.props), "failed" !== s && (this.ea.clear(), this.na = !1, this.ra.clear()), e && this.oa.forEach((t)=>t());
    }
    za() {
        const { main: t, groups: i } = this._a(), e = this.Ua(this.No, this.ua, t, $0fb0e9cf977607be$var$el);
        "written" === e && this.Pa(t), "failed" !== e && (this.na = !1, this.ra.clear(), $0fb0e9cf977607be$var$sl.forEach((t)=>{
            var i;
            (null === (i = $0fb0e9cf977607be$var$Co(t)) || void 0 === i ? void 0 : i.storageGroup) || this.ea.delete(t);
        }));
        for (const t of $0fb0e9cf977607be$var$ko){
            var s;
            const e = i[t];
            if ($0fb0e9cf977607be$var$O(e) && !(null === (s = this.Jo[t]) || void 0 === s ? void 0 : s.persisted)) {
                $0fb0e9cf977607be$var$sl.forEach((i)=>{
                    var e;
                    (null === (e = $0fb0e9cf977607be$var$Co(i)) || void 0 === e ? void 0 : e.storageGroup) === t && this.ea.delete(i);
                });
                continue;
            }
            const n = this.Ua($0fb0e9cf977607be$var$fr, this.fa(t), e, t);
            "failed" !== n && $0fb0e9cf977607be$var$sl.forEach((i)=>{
                const e = $0fb0e9cf977607be$var$Co(i);
                (null == e ? void 0 : e.storageGroup) !== t || "written" !== n && e.volatile || this.ea.delete(i);
            });
        }
    }
    _a() {
        const t = {}, i = {
            flags: {},
            surveys: {}
        };
        return $0fb0e9cf977607be$var$Vn(this.props, (e, s)=>{
            var n;
            const r = null === (n = $0fb0e9cf977607be$var$Co(s)) || void 0 === n ? void 0 : n.storageGroup;
            r ? i[r][s] = e : t[s] = e;
        }), {
            main: t,
            groups: i
        };
    }
    ka(t, i) {
        if (i === $0fb0e9cf977607be$var$el) return JSON.stringify(t) + "|" + this.Wa + "|" + this.Va + "|" + this.Ga;
        const e = {};
        return $0fb0e9cf977607be$var$Vn(t, (t, i)=>{
            var s;
            e[i] = (null === (s = $0fb0e9cf977607be$var$Co(i)) || void 0 === s ? void 0 : s.volatile) ? "__volatile__" : t;
        }), JSON.stringify(e);
    }
    Ua(t, i, e, s) {
        const n = this.ma(s);
        if (s !== $0fb0e9cf977607be$var$el && !n.dirty && !$0fb0e9cf977607be$var$R(n.fingerprint)) return "skipped";
        let r;
        try {
            if (r = this.ka(e, s), r === n.fingerprint) return n.dirty = !1, "skipped";
        } catch (t) {
            r = void 0;
        }
        return t.$t(i, e, this.Wa, this.Va, this.Ga, this.Mr.debug) ? (n.dirty = !1, s !== $0fb0e9cf977607be$var$el && (n.persisted = !0), $0fb0e9cf977607be$var$R(r) || (n.fingerprint = r), this.Zo && (n.storageValue = $0fb0e9cf977607be$var$fr.Ot(i)), "written") : (this.Mr.debug && $0fb0e9cf977607be$var$Je.warn(`failed to persist storage entry "${i}"; will retry on next save`), "failed");
    }
    remove({ keepGroupEntries: t = !1 } = {}) {
        if (this.Ia(), $0fb0e9cf977607be$var$R(this.La) || (clearTimeout(this.La), this.La = void 0), this.No.Pt(this.ua, !1), this.No.Pt(this.ua, !0), !t && this.aa) for (const t of $0fb0e9cf977607be$var$ko)$0fb0e9cf977607be$var$fr.Pt(this.fa(t));
        t ? delete this.Jo[$0fb0e9cf977607be$var$el] : this.Jo = {}, this.Ra = void 0, this.Aa = void 0;
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, i, e) {
        if ($0fb0e9cf977607be$var$C(t)) {
            this.syncCookieProperties(), $0fb0e9cf977607be$var$R(i) && (i = "None"), this.Wa = $0fb0e9cf977607be$var$R(e) ? this.Qa : e;
            let s = !1;
            if ($0fb0e9cf977607be$var$Vn(t, (t, e)=>{
                this.props.hasOwnProperty(e) && this.props[e] !== i || (this.xa(e, t), s = !0);
            }), s) return this.save(), !0;
        }
        return !1;
    }
    register(t, i) {
        if ($0fb0e9cf977607be$var$C(t)) {
            this.syncCookieProperties(), this.Wa = $0fb0e9cf977607be$var$R(i) ? this.Qa : i;
            let e = !1;
            if ($0fb0e9cf977607be$var$Vn(t, (i, s)=>{
                t.hasOwnProperty(s) && (this.props[s] !== i || $0fb0e9cf977607be$var$C(i) || $0fb0e9cf977607be$var$T(i)) && (this.xa(s, i), e = !0);
            }), e) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        this.syncCookieProperties();
        const i = "string" == typeof t ? [
            t
        ] : t;
        let e = !1;
        for (const t of i)t in this.props && (this.$a(t), e = !0);
        e && this.save();
    }
    update_campaign_params() {
        const t = null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.URL;
        if (t === this.la) return;
        const i = $0fb0e9cf977607be$var$Uo(this.Mr.custom_campaign_params, this.Mr.mask_personal_data_properties, this.Mr.custom_personal_data_properties), e = !$0fb0e9cf977607be$var$O($0fb0e9cf977607be$var$Jn(i));
        return e && this.register(i), this.la = t, e ? i : void 0;
    }
    update_search_keyword() {
        this.register(function() {
            const t = null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.referrer;
            return t ? $0fb0e9cf977607be$var$Ho(t) : {};
        }());
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $0fb0e9cf977607be$var$Go(),
            $referring_domain: (null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.referrer) && (null === (t = $0fb0e9cf977607be$var$Ro($0fb0e9cf977607be$var$s.referrer)) || void 0 === t ? void 0 : t.host) || $0fb0e9cf977607be$var$Wo
        }, void 0);
    }
    set_initial_person_info() {
        if (this.props.$initial_campaign_params || this.props.$initial_referrer_info) return;
        const t = $0fb0e9cf977607be$var$Ko(this.Mr.mask_personal_data_properties, this.Mr.custom_personal_data_properties, this.Mr.disable_capture_url_hashes);
        this.register_once({
            [$0fb0e9cf977607be$var$mn]: this.Ko ? {
                r: $0fb0e9cf977607be$var$il(t.r),
                u: t.u ? $0fb0e9cf977607be$var$il(t.u) : void 0
            } : t
        }, void 0);
    }
    get_initial_props() {
        const t = {};
        $0fb0e9cf977607be$var$Vn([
            $0fb0e9cf977607be$var$gn,
            $0fb0e9cf977607be$var$_n
        ], (i)=>{
            const e = this.props[i];
            e && $0fb0e9cf977607be$var$Vn(e, function(i, e) {
                t["$initial_" + $0fb0e9cf977607be$var$w(e)] = i;
            });
        });
        const i = this.props[$0fb0e9cf977607be$var$mn];
        if (i) {
            const e = function(t, i = !1) {
                const e = $0fb0e9cf977607be$var$Jo(t, i), s = {};
                return $0fb0e9cf977607be$var$Vn(e, function(t, i) {
                    s[`$initial_${$0fb0e9cf977607be$var$w(i)}`] = t;
                }), s;
            }(i, this.Mr.disable_capture_url_hashes);
            $0fb0e9cf977607be$var$Wn(t, e);
        }
        return t;
    }
    safe_merge(t) {
        return $0fb0e9cf977607be$var$Vn(this.props, function(i, e) {
            e in t || (t[e] = i);
        }), t;
    }
    update_config(t, i, e) {
        const s = t.persistence !== i.persistence, n = !((t, i)=>{
            if (t.length !== i.length) return !1;
            const e = [
                ...t
            ].sort(), s = [
                ...i
            ].sort();
            return e.every((t, i)=>t === s[i]);
        })(t.cookie_persisted_properties || [], i.cookie_persisted_properties || []), r = s || n, o = t.cookieWinsOnConflict !== i.cookieWinsOnConflict, l = t.disable_persistence || !!e, a = !!this.hi && !l;
        l || this.Oa(i, a), this.Mr = t, !l && (s || n || o) && (this.Ra = void 0, this.Aa = void 0, this.Oa($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
            cookie_persisted_properties: i.cookie_persisted_properties
        }), a));
        const u = r || o ? this.ha(t) : this.No;
        this.Ja();
        const h = this.ca(t), d = r || h !== this.Xo, c = !l && (d || t.cross_subdomain_cookie !== this.Va || t.secure_cookie !== this.Ga) && this.Fa(a);
        this.ia = d;
        try {
            if (this.Qa = this.Wa = t.cookie_expiration, this.set_disabled(l), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), d) {
                const t = this.props;
                this.clear(), this.No = u, this.Xo = h, this.props = t, this.save();
            } else o && (this.No = u, l || (delete this.Jo[$0fb0e9cf977607be$var$el], this.Na()));
        } finally{
            this.ia = !1, c && this.qa();
        }
    }
    Ja() {
        const t = this.props[$0fb0e9cf977607be$var$mn];
        if (!this.Ko || !$0fb0e9cf977607be$var$C(t) || "string" != typeof t.r) return;
        const i = $0fb0e9cf977607be$var$il(t.r), e = "string" == typeof t.u ? $0fb0e9cf977607be$var$il(t.u) : t.u;
        i === t.r && e === t.u || this.xa($0fb0e9cf977607be$var$mn, $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
            r: i,
            u: e
        }));
    }
    set_disabled(t) {
        this.hi = t, this.hi ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.Va && (this.Va = t, this.remove({
            keepGroupEntries: !0
        }), this.save());
    }
    set_secure(t) {
        t !== this.Ga && (this.Ga = t, this.remove({
            keepGroupEntries: !0
        }), this.save());
    }
    set_event_timer(t, i) {
        const e = this.props.__timers || {};
        e[t] = i, this.xa($0fb0e9cf977607be$var$vs, e), this.save();
    }
    remove_event_timer(t) {
        const i = this.props.__timers || {}, e = i[t];
        return $0fb0e9cf977607be$var$R(e) || (delete i[t], this.xa($0fb0e9cf977607be$var$vs, i), this.save()), e;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, i) {
        this.xa(t, i), this.save();
    }
    xa(t, i, e = !0) {
        var s;
        const n = this.props[t];
        this.props[t] = i, e && ("distinct_id" !== t && "$user_state" !== t || n === i || (this.na = !0), $0fb0e9cf977607be$var$ol(t) && !$0fb0e9cf977607be$var$ll(n, i) && this.ra.add(t), this.Ma(t, n, i), (null === (s = $0fb0e9cf977607be$var$Co(t)) || void 0 === s ? void 0 : s.volatile) || this.Ta(t));
    }
    $a(t, i = !0) {
        delete this.props[t], i && ($0fb0e9cf977607be$var$nl(t) && this.ga(t, !0), $0fb0e9cf977607be$var$ol(t) && this.ra.add(t), this.Ta(t));
    }
    Ta(t) {
        var i;
        const e = null === (i = $0fb0e9cf977607be$var$Co(t)) || void 0 === i ? void 0 : i.storageGroup;
        e && (this.ma(e).dirty = !0);
    }
    ma(t) {
        return this.Jo[t] || (this.Jo[t] = {});
    }
};
const $0fb0e9cf977607be$export$6a00d17b5aff0af = {
    GZipJS: "gzip-js",
    Base64: "base64"
}, $0fb0e9cf977607be$export$352273f853caad57 = {
    Activation: "events",
    Cancellation: "cancelEvents"
}, $0fb0e9cf977607be$export$87f1e68f1b904cbb = {
    Button: "button",
    Tab: "tab",
    Selector: "selector"
}, $0fb0e9cf977607be$export$8c0ce98316e43193 = {
    TopLeft: "top_left",
    TopRight: "top_right",
    TopCenter: "top_center",
    MiddleLeft: "middle_left",
    MiddleRight: "middle_right",
    MiddleCenter: "middle_center",
    Left: "left",
    Center: "center",
    Right: "right",
    NextToTrigger: "next_to_trigger"
}, $0fb0e9cf977607be$export$3693bed37a847924 = {
    Top: "top",
    Left: "left",
    Right: "right",
    Bottom: "bottom"
}, $0fb0e9cf977607be$export$22779822dd24228f = {
    Popover: "popover",
    API: "api",
    Widget: "widget",
    ExternalSurvey: "external_survey"
}, $0fb0e9cf977607be$export$9c2ac61661d417f8 = {
    Open: "open",
    MultipleChoice: "multiple_choice",
    SingleChoice: "single_choice",
    Rating: "rating",
    Link: "link"
}, $0fb0e9cf977607be$export$bbed2da3bd3bb001 = {
    NextQuestion: "next_question",
    End: "end",
    ResponseBased: "response_based",
    SpecificQuestion: "specific_question"
}, $0fb0e9cf977607be$export$407ee791fe918359 = {
    Once: "once",
    Recurring: "recurring",
    Always: "always"
}, $0fb0e9cf977607be$export$9d7ec1793ca1658e = {
    SHOWN: "survey shown",
    DISMISSED: "survey dismissed",
    SENT: "survey sent",
    ABANDONED: "survey abandoned"
}, $0fb0e9cf977607be$export$fe4c9af525341543 = {
    SURVEY_ID: "$survey_id",
    SURVEY_NAME: "$survey_name",
    SURVEY_RESPONSE: "$survey_response",
    SURVEY_ITERATION: "$survey_iteration",
    SURVEY_ITERATION_START_DATE: "$survey_iteration_start_date",
    SURVEY_PARTIALLY_COMPLETED: "$survey_partially_completed",
    SURVEY_SUBMISSION_ID: "$survey_submission_id",
    SURVEY_QUESTIONS: "$survey_questions",
    SURVEY_COMPLETED: "$survey_completed",
    PRODUCT_TOUR_ID: "$product_tour_id",
    SURVEY_LAST_SEEN_DATE: "$survey_last_seen_date",
    SURVEY_LANGUAGE: "$survey_language"
}, $0fb0e9cf977607be$export$a8a66d9d1b857494 = {
    Popover: "popover",
    Inline: "inline"
};
function $0fb0e9cf977607be$var$Sl(t) {
    let i = !0;
    return {
        dispose () {
            if (i) {
                i = !1;
                const e = t();
                e && $0fb0e9cf977607be$var$P(e.then) && e.then(void 0, ()=>{});
            }
        }
    };
}
const $0fb0e9cf977607be$export$8f14e1a0dc415d5d = {
    backgroundColor: "#ffffff",
    textColor: "#1d1f27",
    buttonColor: "#1d1f27",
    borderRadius: 8,
    buttonBorderRadius: 6,
    borderColor: "#e5e7eb",
    fontFamily: "system-ui",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    showOverlay: !0,
    whiteLabel: !1,
    dismissOnClickOutside: !0,
    zIndex: 2147483646
}, $0fb0e9cf977607be$export$e5d0052c1e47bfda = {
    SHOWN: "product tour shown",
    DISMISSED: "product tour dismissed",
    COMPLETED: "product tour completed",
    STEP_SHOWN: "product tour step shown",
    STEP_COMPLETED: "product tour step completed",
    BUTTON_CLICKED: "product tour button clicked",
    STEP_SELECTOR_FAILED: "product tour step selector failed",
    BANNER_CONTAINER_SELECTOR_FAILED: "product tour banner container selector failed",
    BANNER_ACTION_CLICKED: "product tour banner action clicked"
}, $0fb0e9cf977607be$export$eedf6d13bc23d767 = {
    TOUR_ID: "$product_tour_id",
    TOUR_NAME: "$product_tour_name",
    TOUR_ITERATION: "$product_tour_iteration",
    TOUR_RENDER_REASON: "$product_tour_render_reason",
    TOUR_STEP_ID: "$product_tour_step_id",
    TOUR_STEP_ORDER: "$product_tour_step_order",
    TOUR_STEP_TYPE: "$product_tour_step_type",
    TOUR_DISMISS_REASON: "$product_tour_dismiss_reason",
    TOUR_BUTTON_TEXT: "$product_tour_button_text",
    TOUR_BUTTON_ACTION: "$product_tour_button_action",
    TOUR_BUTTON_LINK: "$product_tour_button_link",
    TOUR_BUTTON_TOUR_ID: "$product_tour_button_tour_id",
    TOUR_STEPS_COUNT: "$product_tour_steps_count",
    TOUR_STEP_SELECTOR: "$product_tour_step_selector",
    TOUR_STEP_SELECTOR_FOUND: "$product_tour_step_selector_found",
    TOUR_STEP_ELEMENT_TAG: "$product_tour_step_element_tag",
    TOUR_STEP_ELEMENT_ID: "$product_tour_step_element_id",
    TOUR_STEP_ELEMENT_CLASSES: "$product_tour_step_element_classes",
    TOUR_STEP_ELEMENT_TEXT: "$product_tour_step_element_text",
    TOUR_ERROR: "$product_tour_error",
    TOUR_MATCHES_COUNT: "$product_tour_matches_count",
    TOUR_FAILURE_PHASE: "$product_tour_failure_phase",
    TOUR_WAITED_FOR_ELEMENT: "$product_tour_waited_for_element",
    TOUR_WAIT_DURATION_MS: "$product_tour_wait_duration_ms",
    TOUR_BANNER_SELECTOR: "$product_tour_banner_selector",
    TOUR_LINKED_SURVEY_ID: "$product_tour_linked_survey_id",
    USE_MANUAL_SELECTOR: "$use_manual_selector",
    INFERENCE_DATA_PRESENT: "$inference_data_present",
    TOUR_LAST_SEEN_DATE: "$product_tour_last_seen_date",
    TOUR_TYPE: "$product_tour_type"
}, $0fb0e9cf977607be$var$Tl = $0fb0e9cf977607be$var$Ye("[RateLimiter]");
var $0fb0e9cf977607be$var$Pl = class {
    constructor(t){
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            const i = t.text;
            if (i && i.length) try {
                (JSON.parse(i).quota_limited || []).forEach((t)=>{
                    $0fb0e9cf977607be$var$Tl.info(`${t || "events"} is quota limited.`), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $0fb0e9cf977607be$var$Tl.warn(`could not rate limit - continuing. Error: "${null == t ? void 0 : t.message}"`, {
                    text: i
                });
            }
        }, this.instance = t, this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    get captureEventsPerSecond() {
        var t;
        return (null === (t = this.instance.config.rate_limiting) || void 0 === t ? void 0 : t.events_per_second) || 10;
    }
    get captureEventsBurstLimit() {
        var t;
        return Math.max((null === (t = this.instance.config.rate_limiting) || void 0 === t ? void 0 : t.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond);
    }
    clientRateLimitContext(t = !1) {
        var i, e, s;
        const { captureEventsBurstLimit: n, captureEventsPerSecond: r } = this, o = (new Date).getTime(), l = null !== (i = null === (e = this.instance.persistence) || void 0 === e ? void 0 : e.get_property("$capture_rate_limit")) && void 0 !== i ? i : {
            tokens: n,
            last: o
        };
        l.tokens += (o - l.last) / 1e3 * r, l.last = o, l.tokens > n && (l.tokens = n);
        const a = 1 > l.tokens;
        if (a || t || (l.tokens = Math.max(0, l.tokens - 1)), a && !t) {
            const t = ($0fb0e9cf977607be$var$D(l.dropped) ? l.dropped : 0) + 1;
            l.dropped = t, !this.lastEventRateLimited && this.Za(t) && (l.dropped = 0);
        }
        return this.lastEventRateLimited = a, null === (s = this.instance.persistence) || void 0 === s || s.set_property("$capture_rate_limit", l), {
            isRateLimited: a,
            remainingTokens: l.tokens
        };
    }
    Ka(t) {
        const i = this.instance.config.property_denylist;
        return !$0fb0e9cf977607be$var$T(i) || !i.includes(t);
    }
    Xa() {
        var t;
        if (this.Ka("$current_url") && this.Ka("$pathname") && (null == $0fb0e9cf977607be$var$n ? void 0 : $0fb0e9cf977607be$var$n.pathname)) return `${null !== (t = $0fb0e9cf977607be$var$n.origin) && void 0 !== t ? t : ""}${$0fb0e9cf977607be$var$n.pathname}`;
    }
    Za(t) {
        var i, e;
        const { captureEventsBurstLimit: s, captureEventsPerSecond: n } = this, r = this.Xa(), o = this.Ka("$session_id") ? null === (i = (e = this.instance).get_session_id) || void 0 === i ? void 0 : i.call(e) : void 0, l = [
            `${t} event(s) dropped since the last warning`,
            r ? `triggered on ${r}` : void 0,
            o ? `session ${o}` : void 0
        ].filter(Boolean).join(", ");
        return !!this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: `posthog-js client rate limited: ${l}. Config is set to ${n} events per second and ${s} events burst limit.`
        }, {
            skip_client_rate_limiting: !0
        });
    }
    isServerRateLimited(t) {
        const i = this.serverLimits[t || "events"] || !1;
        return !1 !== i && (new Date).getTime() < i;
    }
};
const $0fb0e9cf977607be$var$Cl = $0fb0e9cf977607be$var$Ye("[RemoteConfig]");
var $0fb0e9cf977607be$var$Ol = class {
    constructor(t){
        this._instance = t;
    }
    get remoteConfig() {
        var t;
        return null === (t = $0fb0e9cf977607be$var$c._POSTHOG_REMOTE_CONFIG) || void 0 === t || null === (t = t[this._instance.config.token]) || void 0 === t ? void 0 : t.config;
    }
    Ya(t) {
        var i, e, s;
        (null === (i = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.loadExternalDependency) ? null === (e = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === e || null === (s = e.loadExternalDependency) || void 0 === s || s.call(e, this._instance, "remote-config", ()=>t(this.remoteConfig)) : t();
    }
    tl(t) {
        this._instance._send_request({
            method: "GET",
            url: this._instance.requestRouter.endpointFor("assets", `/array/${this._instance.config.token}/config`),
            callback: t
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $0fb0e9cf977607be$var$Cl.info("Using preloaded remote config", this.remoteConfig), void this.el(this.remoteConfig);
            if (this._instance.il()) return void $0fb0e9cf977607be$var$Cl.warn("Remote config is disabled. Falling back to local config.");
            this.Ya((t)=>{
                if (!t) return $0fb0e9cf977607be$var$Cl.info("No config found after loading remote JS config. Falling back to JSON."), void this.tl((t)=>{
                    this.el(t.json, t);
                });
                this.el(t);
            });
        } catch (t) {
            $0fb0e9cf977607be$var$Cl.error("Error loading remote config", t), this.el();
        }
    }
    el(t, i) {
        !t && i && (0 === i.statusCode ? i.error || $0fb0e9cf977607be$var$Cl.warn("Failed to fetch remote config from PostHog.") : $0fb0e9cf977607be$var$Cl.error("Failed to fetch remote config from PostHog."));
        try {
            this._instance.el(t ? {
                ok: !0,
                config: t
            } : {
                ok: !1
            });
        } catch (t) {
            $0fb0e9cf977607be$var$Cl.error("Error applying remote config", t);
        }
        if (!1 !== (null == t ? void 0 : t.hasFeatureFlags) && !this._instance.config.advanced_disable_feature_flags_on_first_load) try {
            var e;
            null === (e = this._instance.featureFlags) || void 0 === e || e.ensureFlagsLoaded();
        } catch (t) {
            $0fb0e9cf977607be$var$Cl.error("Error loading feature flags", t);
        }
    }
};
const $0fb0e9cf977607be$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
var $0fb0e9cf977607be$var$Il = Uint8Array, $0fb0e9cf977607be$var$Ml = Uint16Array, $0fb0e9cf977607be$var$Al = Uint32Array, $0fb0e9cf977607be$var$Fl = new $0fb0e9cf977607be$var$Il([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $0fb0e9cf977607be$var$Dl = new $0fb0e9cf977607be$var$Il([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $0fb0e9cf977607be$var$Nl = new $0fb0e9cf977607be$var$Il([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $0fb0e9cf977607be$var$jl = function(t, i) {
    for(var e = new $0fb0e9cf977607be$var$Ml(31), s = 0; 31 > s; ++s)e[s] = i += 1 << t[s - 1];
    var n = new $0fb0e9cf977607be$var$Al(e[30]);
    for(s = 1; 30 > s; ++s)for(var r = e[s]; e[s + 1] > r; ++r)n[r] = r - e[s] << 5 | s;
    return [
        e,
        n
    ];
}, $0fb0e9cf977607be$var$Ll = $0fb0e9cf977607be$var$jl($0fb0e9cf977607be$var$Fl, 2), $0fb0e9cf977607be$var$Bl = $0fb0e9cf977607be$var$Ll[1];
$0fb0e9cf977607be$var$Ll[0][28] = 258, $0fb0e9cf977607be$var$Bl[258] = 28;
for(var $0fb0e9cf977607be$var$Ul = $0fb0e9cf977607be$var$jl($0fb0e9cf977607be$var$Dl, 0)[1], $0fb0e9cf977607be$var$zl = new $0fb0e9cf977607be$var$Ml(32768), $0fb0e9cf977607be$var$Hl = 0; 32768 > $0fb0e9cf977607be$var$Hl; ++$0fb0e9cf977607be$var$Hl){
    var $0fb0e9cf977607be$var$ql = (43690 & $0fb0e9cf977607be$var$Hl) >>> 1 | (21845 & $0fb0e9cf977607be$var$Hl) << 1;
    $0fb0e9cf977607be$var$zl[$0fb0e9cf977607be$var$Hl] = ((65280 & ($0fb0e9cf977607be$var$ql = (61680 & ($0fb0e9cf977607be$var$ql = (52428 & $0fb0e9cf977607be$var$ql) >>> 2 | (13107 & $0fb0e9cf977607be$var$ql) << 2)) >>> 4 | (3855 & $0fb0e9cf977607be$var$ql) << 4)) >>> 8 | (255 & $0fb0e9cf977607be$var$ql) << 8) >>> 1;
}
var $0fb0e9cf977607be$var$Vl = function(t, i, e) {
    for(var s = t.length, n = 0, r = new $0fb0e9cf977607be$var$Ml(i); s > n; ++n)++r[t[n] - 1];
    var o, l = new $0fb0e9cf977607be$var$Ml(i);
    for(n = 0; i > n; ++n)l[n] = l[n - 1] + r[n - 1] << 1;
    if (e) {
        o = new $0fb0e9cf977607be$var$Ml(1 << i);
        var a = 15 - i;
        for(n = 0; s > n; ++n)if (t[n]) for(var u = n << 4 | t[n], h = i - t[n], d = l[t[n] - 1]++ << h, c = d | (1 << h) - 1; c >= d; ++d)o[$0fb0e9cf977607be$var$zl[d] >>> a] = u;
    } else for(o = new $0fb0e9cf977607be$var$Ml(s), n = 0; s > n; ++n)o[n] = $0fb0e9cf977607be$var$zl[l[t[n] - 1]++] >>> 15 - t[n];
    return o;
}, $0fb0e9cf977607be$var$Wl = new $0fb0e9cf977607be$var$Il(288);
for($0fb0e9cf977607be$var$Hl = 0; 144 > $0fb0e9cf977607be$var$Hl; ++$0fb0e9cf977607be$var$Hl)$0fb0e9cf977607be$var$Wl[$0fb0e9cf977607be$var$Hl] = 8;
for($0fb0e9cf977607be$var$Hl = 144; 256 > $0fb0e9cf977607be$var$Hl; ++$0fb0e9cf977607be$var$Hl)$0fb0e9cf977607be$var$Wl[$0fb0e9cf977607be$var$Hl] = 9;
for($0fb0e9cf977607be$var$Hl = 256; 280 > $0fb0e9cf977607be$var$Hl; ++$0fb0e9cf977607be$var$Hl)$0fb0e9cf977607be$var$Wl[$0fb0e9cf977607be$var$Hl] = 7;
for($0fb0e9cf977607be$var$Hl = 280; 288 > $0fb0e9cf977607be$var$Hl; ++$0fb0e9cf977607be$var$Hl)$0fb0e9cf977607be$var$Wl[$0fb0e9cf977607be$var$Hl] = 8;
var $0fb0e9cf977607be$var$Gl = new $0fb0e9cf977607be$var$Il(32);
for($0fb0e9cf977607be$var$Hl = 0; 32 > $0fb0e9cf977607be$var$Hl; ++$0fb0e9cf977607be$var$Hl)$0fb0e9cf977607be$var$Gl[$0fb0e9cf977607be$var$Hl] = 5;
var $0fb0e9cf977607be$var$Kl = $0fb0e9cf977607be$var$Vl($0fb0e9cf977607be$var$Wl, 9, 0), $0fb0e9cf977607be$var$Jl = $0fb0e9cf977607be$var$Vl($0fb0e9cf977607be$var$Gl, 5, 0), $0fb0e9cf977607be$var$Yl = function(t) {
    return (t / 8 | 0) + (7 & t && 1);
}, $0fb0e9cf977607be$var$Xl = function(t, i, e) {
    (null == i || 0 > i) && (i = 0), (null == e || e > t.length) && (e = t.length);
    var s = new (t instanceof $0fb0e9cf977607be$var$Ml ? $0fb0e9cf977607be$var$Ml : t instanceof $0fb0e9cf977607be$var$Al ? $0fb0e9cf977607be$var$Al : $0fb0e9cf977607be$var$Il)(e - i);
    return s.set(t.subarray(i, e)), s;
}, $0fb0e9cf977607be$var$Ql = function(t, i, e) {
    var s = i / 8 | 0;
    t[s] |= e <<= 7 & i, t[s + 1] |= e >>> 8;
}, $0fb0e9cf977607be$var$Zl = function(t, i, e) {
    var s = i / 8 | 0;
    t[s] |= e <<= 7 & i, t[s + 1] |= e >>> 8, t[s + 2] |= e >>> 16;
}, $0fb0e9cf977607be$var$ta = function(t, i) {
    for(var e = [], s = 0; t.length > s; ++s)t[s] && e.push({
        s: s,
        f: t[s]
    });
    var n = e.length, r = e.slice();
    if (!n) return [
        new $0fb0e9cf977607be$var$Il(0),
        0
    ];
    if (1 == n) {
        var o = new $0fb0e9cf977607be$var$Il(e[0].s + 1);
        return o[e[0].s] = 1, [
            o,
            1
        ];
    }
    e.sort(function(t, i) {
        return t.f - i.f;
    }), e.push({
        s: -1,
        f: 25001
    });
    var l = e[0], a = e[1], u = 0, h = 1, d = 2;
    for(e[0] = {
        s: -1,
        f: l.f + a.f,
        l: l,
        r: a
    }; h != n - 1;)l = e[e[d].f > e[u].f ? u++ : d++], a = e[u != h && e[d].f > e[u].f ? u++ : d++], e[h++] = {
        s: -1,
        f: l.f + a.f,
        l: l,
        r: a
    };
    var c = r[0].s;
    for(s = 1; n > s; ++s)r[s].s > c && (c = r[s].s);
    var v = new $0fb0e9cf977607be$var$Ml(c + 1), f = $0fb0e9cf977607be$var$ia(e[h - 1], v, 0);
    if (f > i) {
        s = 0;
        var p = 0, _ = f - i, g = 1 << _;
        for(r.sort(function(t, i) {
            return v[i.s] - v[t.s] || t.f - i.f;
        }); n > s; ++s){
            var m = r[s].s;
            if (i >= v[m]) break;
            p += g - (1 << f - v[m]), v[m] = i;
        }
        for(p >>>= _; p > 0;){
            var b = r[s].s;
            i > v[b] ? p -= 1 << i - v[b]++ - 1 : ++s;
        }
        for(; s >= 0 && p; --s){
            var y = r[s].s;
            v[y] == i && (--v[y], ++p);
        }
        f = i;
    }
    return [
        new $0fb0e9cf977607be$var$Il(v),
        f
    ];
}, $0fb0e9cf977607be$var$ia = function(t, i, e) {
    return -1 == t.s ? Math.max($0fb0e9cf977607be$var$ia(t.l, i, e + 1), $0fb0e9cf977607be$var$ia(t.r, i, e + 1)) : i[t.s] = e;
}, $0fb0e9cf977607be$var$ea = function(t) {
    for(var i = t.length; i && !t[--i];);
    for(var e = new $0fb0e9cf977607be$var$Ml(++i), s = 0, n = t[0], r = 1, o = function(t) {
        e[s++] = t;
    }, l = 1; i >= l; ++l)if (t[l] == n && l != i) ++r;
    else {
        if (!n && r > 2) {
            for(; r > 138; r -= 138)o(32754);
            r > 2 && (o(r > 10 ? r - 11 << 5 | 28690 : r - 3 << 5 | 12305), r = 0);
        } else if (r > 3) {
            for(o(n), --r; r > 6; r -= 6)o(8304);
            r > 2 && (o(r - 3 << 5 | 8208), r = 0);
        }
        for(; r--;)o(n);
        r = 1, n = t[l];
    }
    return [
        e.subarray(0, s),
        i
    ];
}, $0fb0e9cf977607be$var$sa = function(t, i) {
    for(var e = 0, s = 0; i.length > s; ++s)e += t[s] * i[s];
    return e;
}, $0fb0e9cf977607be$var$na = function(t, i, e) {
    var s = e.length, n = $0fb0e9cf977607be$var$Yl(i + 2);
    t[n] = 255 & s, t[n + 1] = s >>> 8, t[n + 2] = 255 ^ t[n], t[n + 3] = 255 ^ t[n + 1];
    for(var r = 0; s > r; ++r)t[n + r + 4] = e[r];
    return 8 * (n + 4 + s);
}, $0fb0e9cf977607be$var$ra = function(t, i, e, s, n, r, o, l, a, u, h) {
    $0fb0e9cf977607be$var$Ql(i, h++, e), ++n[256];
    for(var d = $0fb0e9cf977607be$var$ta(n, 15), c = d[0], v = d[1], f = $0fb0e9cf977607be$var$ta(r, 15), p = f[0], _ = f[1], g = $0fb0e9cf977607be$var$ea(c), m = g[0], b = g[1], y = $0fb0e9cf977607be$var$ea(p), w = y[0], S = y[1], x = new $0fb0e9cf977607be$var$Ml(19), E = 0; m.length > E; ++E)x[31 & m[E]]++;
    for(E = 0; w.length > E; ++E)x[31 & w[E]]++;
    for(var k = $0fb0e9cf977607be$var$ta(x, 7), T = k[0], P = k[1], C = 19; C > 4 && !T[$0fb0e9cf977607be$var$Nl[C - 1]]; --C);
    var O, R, I, M, A = u + 5 << 3, F = $0fb0e9cf977607be$var$sa(n, $0fb0e9cf977607be$var$Wl) + $0fb0e9cf977607be$var$sa(r, $0fb0e9cf977607be$var$Gl) + o, D = $0fb0e9cf977607be$var$sa(n, c) + $0fb0e9cf977607be$var$sa(r, p) + o + 14 + 3 * C + $0fb0e9cf977607be$var$sa(x, T) + (2 * x[16] + 3 * x[17] + 7 * x[18]);
    if (F >= A && D >= A) return $0fb0e9cf977607be$var$na(i, h, t.subarray(a, a + u));
    if ($0fb0e9cf977607be$var$Ql(i, h, 1 + (F > D)), h += 2, F > D) {
        O = $0fb0e9cf977607be$var$Vl(c, v, 0), R = c, I = $0fb0e9cf977607be$var$Vl(p, _, 0), M = p;
        var N = $0fb0e9cf977607be$var$Vl(T, P, 0);
        for($0fb0e9cf977607be$var$Ql(i, h, b - 257), $0fb0e9cf977607be$var$Ql(i, h + 5, S - 1), $0fb0e9cf977607be$var$Ql(i, h + 10, C - 4), h += 14, E = 0; C > E; ++E)$0fb0e9cf977607be$var$Ql(i, h + 3 * E, T[$0fb0e9cf977607be$var$Nl[E]]);
        h += 3 * C;
        for(var j = [
            m,
            w
        ], L = 0; 2 > L; ++L){
            var B = j[L];
            for(E = 0; B.length > E; ++E)$0fb0e9cf977607be$var$Ql(i, h, N[U = 31 & B[E]]), h += T[U], U > 15 && ($0fb0e9cf977607be$var$Ql(i, h, B[E] >>> 5 & 127), h += B[E] >>> 12);
        }
    } else O = $0fb0e9cf977607be$var$Kl, R = $0fb0e9cf977607be$var$Wl, I = $0fb0e9cf977607be$var$Jl, M = $0fb0e9cf977607be$var$Gl;
    for(E = 0; l > E; ++E)if (s[E] > 255) {
        var U;
        $0fb0e9cf977607be$var$Zl(i, h, O[257 + (U = s[E] >>> 18 & 31)]), h += R[U + 257], U > 7 && ($0fb0e9cf977607be$var$Ql(i, h, s[E] >>> 23 & 31), h += $0fb0e9cf977607be$var$Fl[U]);
        var z = 31 & s[E];
        $0fb0e9cf977607be$var$Zl(i, h, I[z]), h += M[z], z > 3 && ($0fb0e9cf977607be$var$Zl(i, h, s[E] >>> 5 & 8191), h += $0fb0e9cf977607be$var$Dl[z]);
    } else $0fb0e9cf977607be$var$Zl(i, h, O[s[E]]), h += R[s[E]];
    return $0fb0e9cf977607be$var$Zl(i, h, O[256]), h + R[256];
}, $0fb0e9cf977607be$var$oa = new $0fb0e9cf977607be$var$Al([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $0fb0e9cf977607be$var$la = new $0fb0e9cf977607be$var$Il(0), $0fb0e9cf977607be$var$aa = function() {
    for(var t = new $0fb0e9cf977607be$var$Al(256), i = 0; 256 > i; ++i){
        for(var e = i, s = 9; --s;)e = (1 & e && 3988292384) ^ e >>> 1;
        t[i] = e;
    }
    return t;
}(), $0fb0e9cf977607be$var$ua = function(t, i, e) {
    for(; e; ++i)t[i] = e, e >>>= 8;
};
function $0fb0e9cf977607be$var$ha(t, i) {
    void 0 === i && (i = {});
    var e = function() {
        var t = 4294967295;
        return {
            p (i) {
                for(var e = t, s = 0; i.length > s; ++s)e = $0fb0e9cf977607be$var$aa[255 & e ^ i[s]] ^ e >>> 8;
                t = e;
            },
            d () {
                return 4294967295 ^ t;
            }
        };
    }(), s = t.length;
    e.p(t);
    var n, r, o, l, a, u, h = (l = 10 + ((n = i).filename && n.filename.length + 1 || 0), a = 8, function(t, i, e, s, n, r) {
        var o = t.length, l = new $0fb0e9cf977607be$var$Il(s + o + 5 * (1 + Math.floor(o / 7e3)) + n), a = l.subarray(s, l.length - n), u = 0;
        if (!i || 8 > o) for(var h = 0; o >= h; h += 65535){
            var d = h + 65535;
            o > d ? u = $0fb0e9cf977607be$var$na(a, u, t.subarray(h, d)) : (a[h] = r, u = $0fb0e9cf977607be$var$na(a, u, t.subarray(h, o)));
        }
        else {
            for(var c = $0fb0e9cf977607be$var$oa[i - 1], v = c >>> 13, f = 8191 & c, p = (1 << e) - 1, _ = new $0fb0e9cf977607be$var$Ml(32768), g = new $0fb0e9cf977607be$var$Ml(p + 1), m = Math.ceil(e / 3), b = 2 * m, y = function(i) {
                return (t[i] ^ t[i + 1] << m ^ t[i + 2] << b) & p;
            }, w = new $0fb0e9cf977607be$var$Al(25e3), S = new $0fb0e9cf977607be$var$Ml(288), x = new $0fb0e9cf977607be$var$Ml(32), E = 0, k = 0, T = (h = 0, 0), P = 0, C = 0; o > h; ++h){
                var O = y(h), R = 32767 & h, I = g[O];
                if (_[R] = I, g[O] = R, h >= P) {
                    var M = o - h;
                    if ((E > 7e3 || T > 24576) && M > 423) {
                        u = $0fb0e9cf977607be$var$ra(t, a, 0, w, S, x, k, T, C, h - C, u), T = E = k = 0, C = h;
                        for(var A = 0; 286 > A; ++A)S[A] = 0;
                        for(A = 0; 30 > A; ++A)x[A] = 0;
                    }
                    var F = 2, D = 0, N = f, j = R - I & 32767;
                    if (M > 2 && O == y(h - j)) for(var L = Math.min(v, M) - 1, B = Math.min(32767, h), U = Math.min(258, M); B >= j && --N && R != I;){
                        if (t[h + F] == t[h + F - j]) {
                            for(var z = 0; U > z && t[h + z] == t[h + z - j]; ++z);
                            if (z > F) {
                                if (F = z, D = j, z > L) break;
                                var H = Math.min(j, z - 2), q = 0;
                                for(A = 0; H > A; ++A){
                                    var V = h - j + A + 32768 & 32767, W = V - _[V] + 32768 & 32767;
                                    W > q && (q = W, I = V);
                                }
                            }
                        }
                        j += (R = I) - (I = _[R]) + 32768 & 32767;
                    }
                    if (D) {
                        w[T++] = 268435456 | $0fb0e9cf977607be$var$Bl[F] << 18 | $0fb0e9cf977607be$var$Ul[D];
                        var G = 31 & $0fb0e9cf977607be$var$Bl[F], K = 31 & $0fb0e9cf977607be$var$Ul[D];
                        k += $0fb0e9cf977607be$var$Fl[G] + $0fb0e9cf977607be$var$Dl[K], ++S[257 + G], ++x[K], P = h + F, ++E;
                    } else w[T++] = t[h], ++S[t[h]];
                }
            }
            u = $0fb0e9cf977607be$var$ra(t, a, r, w, S, x, k, T, C, h - C, u), r || (u = $0fb0e9cf977607be$var$na(a, u, $0fb0e9cf977607be$var$la));
        }
        return $0fb0e9cf977607be$var$Xl(l, 0, s + $0fb0e9cf977607be$var$Yl(u) + n);
    }(r = t, null == (o = i).level ? 6 : o.level, null == o.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(r.length)))) : 12 + o.mem, l, a, !u)), d = h.length;
    return function(t, i) {
        var e = i.filename;
        if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = 2 > i.level ? 4 : 9 == i.level ? 2 : 0, t[9] = 3, 0 != i.mtime && $0fb0e9cf977607be$var$ua(t, 4, Math.floor(new Date(i.mtime || Date.now()) / 1e3)), e) {
            t[3] = 8;
            for(var s = 0; e.length >= s; ++s)t[s + 10] = e.charCodeAt(s);
        }
    }(h, i), $0fb0e9cf977607be$var$ua(h, d - 8, e.d()), $0fb0e9cf977607be$var$ua(h, d - 4, s), h;
}
const $0fb0e9cf977607be$var$da = !!$0fb0e9cf977607be$var$o || !!$0fb0e9cf977607be$var$r, $0fb0e9cf977607be$var$ca = new WeakMap, $0fb0e9cf977607be$var$va = "text/plain";
let $0fb0e9cf977607be$var$fa = 0, $0fb0e9cf977607be$var$pa = !1;
const $0fb0e9cf977607be$var$_a = (t, i)=>{
    const [e, s] = t.split("#"), [n, r] = e.split("?");
    if (!r) return t;
    const o = r.split("&").filter((t)=>t.split("=")[0] !== i).join("&");
    return `${n}${o ? `?${o}` : ""}${s ? `#${s}` : ""}`;
}, $0fb0e9cf977607be$var$ga = (t, i, e = !0)=>{
    var s;
    const [n, r] = t.split("?"), o = $0fb0e9cf977607be$var$Ei({}, i), l = null !== (s = null == r ? void 0 : r.split("&").map((t)=>{
        var i;
        const [s, n] = t.split("="), r = e && null !== (i = o[s]) && void 0 !== i ? i : n;
        return delete o[s], `${s}=${r}`;
    })) && void 0 !== s ? s : [], a = function(t, i = "&") {
        let e, s;
        const n = [];
        return $0fb0e9cf977607be$var$Vn(t, function(t, i) {
            $0fb0e9cf977607be$var$R(t) || $0fb0e9cf977607be$var$R(i) || "undefined" === i || (e = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), s = encodeURIComponent(i), n[n.length] = s + "=" + e);
        }), n.join(i);
    }(o);
    return a && l.push(a), l.length > 0 ? `${n}?${l.join("&")}` : n;
}, $0fb0e9cf977607be$var$ma = (t)=>{
    if (t.nl) return t.nl;
    const { data: i, compression: e } = t;
    if (!i) return;
    if (e === $0fb0e9cf977607be$export$6a00d17b5aff0af.GZipJS) {
        const t = $0fb0e9cf977607be$var$ha(function(t) {
            var i = t.length;
            if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
            for(var e = new $0fb0e9cf977607be$var$Il(t.length + (t.length >>> 1)), s = 0, n = function(t) {
                e[s++] = t;
            }, r = 0; i > r; ++r){
                if (s + 5 > e.length) {
                    var o = new $0fb0e9cf977607be$var$Il(s + 8 + (i - r << 1));
                    o.set(e), e = o;
                }
                var l = t.charCodeAt(r);
                128 > l ? n(l) : 2048 > l ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && 57344 > l ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++r)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
            }
            return $0fb0e9cf977607be$var$Xl(e, 0, s);
        }($0fb0e9cf977607be$var$Oo(i)), {
            mtime: 0
        });
        return {
            contentType: $0fb0e9cf977607be$var$va,
            body: t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength),
            estimatedSize: t.byteLength
        };
    }
    if (e === $0fb0e9cf977607be$export$6a00d17b5aff0af.Base64) {
        const t = function(t) {
            return t ? btoa(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g, (t, i)=>String.fromCharCode(parseInt(i, 16)))) : t;
        }($0fb0e9cf977607be$var$Oo(i)), e = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $0fb0e9cf977607be$var$Oo(t)))(t);
        return {
            contentType: "application/x-www-form-urlencoded",
            body: e,
            estimatedSize: new Blob([
                e
            ]).size
        };
    }
    const s = $0fb0e9cf977607be$var$Oo(i);
    return {
        contentType: "application/json",
        body: s,
        estimatedSize: new Blob([
            s
        ]).size
    };
}, $0fb0e9cf977607be$var$ba = (t)=>{
    const i = ()=>"sendBeacon" === t.transport ? {
            url: $0fb0e9cf977607be$var$ga(t.url, {
                compression: $0fb0e9cf977607be$export$6a00d17b5aff0af.Base64
            }),
            encodedBody: $0fb0e9cf977607be$var$ma($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                compression: $0fb0e9cf977607be$export$6a00d17b5aff0af.Base64,
                nl: void 0
            }))
        } : {
            url: $0fb0e9cf977607be$var$_a(t.url, "compression"),
            encodedBody: $0fb0e9cf977607be$var$ma($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                compression: void 0,
                nl: void 0
            }))
        };
    let e;
    try {
        e = $0fb0e9cf977607be$var$ma(t);
    } catch (e) {
        if ($0fb0e9cf977607be$var$ge(t.compression, $0fb0e9cf977607be$var$Io(t.url, "compression"))) return $0fb0e9cf977607be$var$Je.error("Failed to gzip request body, sending uncompressed payload", e), i();
        throw e;
    }
    var s;
    return e && $0fb0e9cf977607be$var$ge(t.compression, $0fb0e9cf977607be$var$Io(t.url, "compression")) && !((s = e.body) instanceof ArrayBuffer ? $0fb0e9cf977607be$var$_e(new Uint8Array(s)) : ArrayBuffer.isView(s) && $0fb0e9cf977607be$var$_e(new Uint8Array(s.buffer, s.byteOffset, s.byteLength))) ? ($0fb0e9cf977607be$var$pa = !0, i()) : {
        url: t.url,
        encodedBody: e
    };
}, $0fb0e9cf977607be$var$ya = (t)=>{
    try {
        return $0fb0e9cf977607be$var$ba(t);
    } catch (e) {
        var i;
        return $0fb0e9cf977607be$var$Je.error(e), void (null === (i = t.callback) || void 0 === i || i.call(t, {
            statusCode: 0,
            error: e
        }));
    }
}, $0fb0e9cf977607be$var$wa = function() {
    var t = $0fb0e9cf977607be$var$Y(function*(t) {
        const i = yield function(t) {
            return $0fb0e9cf977607be$var$Se.apply(this, arguments);
        }($0fb0e9cf977607be$var$Oo(t.data), $0fb0e9cf977607be$var$es.DEBUG, {
            rethrow: !0
        });
        if (!i) return t;
        const e = yield i.arrayBuffer();
        return $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
            nl: {
                contentType: $0fb0e9cf977607be$var$va,
                body: e,
                estimatedSize: e.byteLength
            }
        });
    });
    return function(i) {
        return t.apply(this, arguments);
    };
}(), $0fb0e9cf977607be$var$$a = /Failed to fetch|NetworkError|Load failed/i, $0fb0e9cf977607be$var$Sa = (t)=>"TypeError" === (null == t ? void 0 : t.name) && $0fb0e9cf977607be$var$$a.test((null == t ? void 0 : t.message) || ""), $0fb0e9cf977607be$var$xa = (t)=>{
    try {
        const i = function(t, i = Date.now()) {
            if ("string" != typeof t || !t) return;
            const e = t.trim(), s = /^\d+\s*,/.test(e) ? e.slice(0, e.indexOf(",")).trim() : e;
            if (/^\d+$/.test(s)) {
                const t = 1e3 * Math.min(Number(s), 300);
                return t > 0 ? t : void 0;
            }
            if (!/^(Mon|Tue|Wed|Thu|Fri|Sat|Sun)[a-z]*[ ,]/.test(s)) return;
            const n = /^\w{3} \w{3} /.test(s) ? s + " GMT" : s, r = Date.parse(n) - i;
            return Number.isFinite(r) && r > 0 ? Math.min(r, $0fb0e9cf977607be$var$ai) : void 0;
        }(t());
        return $0fb0e9cf977607be$var$R(i) ? void 0 : Math.min(i, 3e4);
    } catch (t) {
        return;
    }
}, $0fb0e9cf977607be$var$Ea = (t)=>{
    const i = $0fb0e9cf977607be$var$ya(t);
    if (!i) return;
    const e = new $0fb0e9cf977607be$var$o;
    $0fb0e9cf977607be$var$ca.set(e, !0);
    const { url: s, encodedBody: n } = i;
    e.open(t.method || "GET", s, !0);
    const { contentType: r, body: l } = null != n ? n : {};
    $0fb0e9cf977607be$var$Vn(t.headers, function(t, i) {
        e.setRequestHeader(i, t);
    }), r && e.setRequestHeader("Content-Type", r), t.timeout && (e.timeout = t.timeout), e.onreadystatechange = ()=>{
        if (4 === e.readyState) {
            var i;
            const s = {
                statusCode: e.status,
                text: e.responseText
            };
            if (200 === e.status) try {
                s.json = JSON.parse(e.responseText);
            } catch (t) {}
            null === (i = t.callback) || void 0 === i || i.call(t, s, $0fb0e9cf977607be$var$xa(()=>e.getResponseHeader("Retry-After")));
        }
    }, e.send(l);
}, $0fb0e9cf977607be$var$ka = (t)=>{
    const i = $0fb0e9cf977607be$var$ya(t);
    if (!i) return;
    const { url: e, encodedBody: s } = i, { contentType: n, body: o, estimatedSize: a } = null != s ? s : {}, u = new Headers;
    $0fb0e9cf977607be$var$Vn(t.headers, function(t, i) {
        u.append(i, t);
    }), n && u.append("Content-Type", n);
    let h = null, d = !1;
    if ($0fb0e9cf977607be$var$l) {
        const i = new $0fb0e9cf977607be$var$l;
        h = {
            signal: i.signal,
            timeout: setTimeout(()=>{
                d = !0;
                try {
                    i.abort($0fb0e9cf977607be$var$ci("AbortError", "PostHog request timed out" + ((e = t.timeout) ? ` after ${e}ms` : "")));
                } catch (t) {
                    v(t);
                }
                var e;
            }, t.timeout)
        };
    }
    let c = !1;
    const v = (i)=>{
        var e;
        c || (c = !0, d && "AbortError" === (null == i ? void 0 : i.name) || $0fb0e9cf977607be$var$Sa(i) ? $0fb0e9cf977607be$var$Je.warn(i) : $0fb0e9cf977607be$var$Je.error(i), null === (e = t.callback) || void 0 === e || e.call(t, {
            statusCode: 0,
            error: i
        }));
    };
    let f = 0;
    const p = ()=>{
        $0fb0e9cf977607be$var$fa -= f, f = 0, h && clearTimeout(h.timeout);
    };
    try {
        const i = $0fb0e9cf977607be$var$Ei({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: u,
            referrerPolicy: "strict-origin",
            body: o,
            signal: null == h ? void 0 : h.signal
        }, t.fetchOptions), s = null != a ? a : $0fb0e9cf977607be$var$R(o) ? 0 : void 0;
        i.keepalive = "POST" === i.method && !t.sl && !1 !== i.keepalive && i.body === o && !$0fb0e9cf977607be$var$R(s) && s >= 0 && 52428.8 > $0fb0e9cf977607be$var$fa + s, i.keepalive && (f = s, $0fb0e9cf977607be$var$fa += f), $0fb0e9cf977607be$var$r(e, i).then((i)=>i.text().then((e)=>{
                var s;
                if (c) return;
                const n = {
                    statusCode: i.status,
                    text: e
                };
                if (200 === i.status) try {
                    n.json = JSON.parse(e);
                } catch (t) {
                    $0fb0e9cf977607be$var$Je.error(t);
                }
                c = !0, p(), null === (s = t.callback) || void 0 === s || s.call(t, n, $0fb0e9cf977607be$var$xa(()=>i.headers.get("Retry-After")));
            })).catch((t)=>{
            p(), v(t);
        }).finally(p);
    } catch (t) {
        p(), v(t);
    }
}, $0fb0e9cf977607be$var$Ta = (t)=>{
    try {
        var i;
        const { url: s, encodedBody: n } = $0fb0e9cf977607be$var$ba(t), { contentType: o, body: l, estimatedSize: a } = null != n ? n : {};
        if (!l) return;
        const u = l instanceof Blob ? l : new Blob([
            l
        ], {
            type: o
        });
        if ($0fb0e9cf977607be$var$e.sendBeacon(s, u)) return;
        const h = $0fb0e9cf977607be$var$T(t.data) ? t.data : null === (i = t.data) || void 0 === i ? void 0 : i.batch;
        if ($0fb0e9cf977607be$var$T(h) && h.length > 1 && (null != a ? a : 0) > 16384) {
            const i = Math.ceil(h.length / 2), e = (i)=>$0fb0e9cf977607be$var$T(t.data) ? i : $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t.data), {}, {
                    batch: i
                });
            return $0fb0e9cf977607be$var$Ta($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                data: e(h.slice(0, i))
            })), void $0fb0e9cf977607be$var$Ta($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                data: e(h.slice(i))
            }));
        }
        $0fb0e9cf977607be$var$Je.warn(`Beacon of ~${null != a ? a : 0} bytes was rejected by the browser, falling back to ${$0fb0e9cf977607be$var$r ? "fetch" : "XHR"}`), $0fb0e9cf977607be$var$r ? $0fb0e9cf977607be$var$ka($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
            sl: !0
        })) : $0fb0e9cf977607be$var$Ea(t);
    } catch (t) {
        $0fb0e9cf977607be$var$Je.warn("Beacon send failed", t);
    }
}, $0fb0e9cf977607be$var$Pa = (t, i, e, s)=>{
    const n = "query" === s ? "POST" === i ? "sent_at" : "_" : void 0;
    return $0fb0e9cf977607be$var$ga(e === $0fb0e9cf977607be$export$6a00d17b5aff0af.GZipJS ? $0fb0e9cf977607be$var$_a(t, "compression") : t, $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, n ? {
        [n]: Date.now().toString()
    } : {}), e === $0fb0e9cf977607be$export$6a00d17b5aff0af.GZipJS ? {} : {
        compression: e
    }));
}, $0fb0e9cf977607be$var$Ca = (()=>{
    const t = [];
    return $0fb0e9cf977607be$var$r && t.push({
        transport: "fetch",
        method: $0fb0e9cf977607be$var$ka
    }), $0fb0e9cf977607be$var$o && t.push({
        transport: "XHR",
        method: $0fb0e9cf977607be$var$Ea
    }), (null == $0fb0e9cf977607be$var$e ? void 0 : $0fb0e9cf977607be$var$e.sendBeacon) && t.push({
        transport: "sendBeacon",
        method: $0fb0e9cf977607be$var$Ta
    }), t;
})();
let $0fb0e9cf977607be$var$Oa = !$0fb0e9cf977607be$var$da && -1 === (null == $0fb0e9cf977607be$var$u ? void 0 : $0fb0e9cf977607be$var$u.indexOf("MSIE")) && -1 === (null == $0fb0e9cf977607be$var$u ? void 0 : $0fb0e9cf977607be$var$u.indexOf("Mozilla"));
function $0fb0e9cf977607be$var$Ra(t, i, e) {
    var s, n, r;
    e && (i = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i), {}, {
        callback: (t)=>e(t)
    })), t.__loaded ? $0fb0e9cf977607be$var$Oa ? t.__request_queue.push(i) : t.rateLimiter.isServerRateLimited(i.batchKey) ? i.fireCallbackOnDrop && (null === (n = i.callback) || void 0 === n || n.call(i, {
        statusCode: 429
    })) : (i.transport = i.transport || t.config.api_transport, i.headers = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t.config.request_headers), i.headers), i.compression = "best-available" === i.compression ? null !== (s = t.compression) && void 0 !== s ? s : i.compressionFallback : i.compression, ($0fb0e9cf977607be$var$R(t.config.disable_beacon) ? t.config.__preview_disable_beacon : t.config.disable_beacon) && (i.disableTransport = [
        "sendBeacon"
    ]), i.fetchOptions = i.fetchOptions || t.config.fetch_options, ((t, i)=>{
        var e, s, n;
        const r = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
            callback: null != i ? i : (i)=>{
                var e;
                return null === (e = t.callback) || void 0 === e ? void 0 : e.call(t, i);
            }
        });
        r.timeout = r.timeout || 6e4;
        const o = null !== (e = r.transport) && void 0 !== e ? e : "fetch";
        "sendBeacon" === o && $0fb0e9cf977607be$var$R(r.compression) && r.data && (r.compression = $0fb0e9cf977607be$export$6a00d17b5aff0af.Base64), "POST" === r.method && r.data && ("capture-body" === r.timestampMode ? r.data = ((t)=>{
            var i, e;
            const s = ($0fb0e9cf977607be$var$T(t) ? t : [
                t
            ]).map((t)=>$0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), t.timestamp instanceof Date && !isNaN(t.timestamp.getTime()) ? {
                    timestamp: t.timestamp.toISOString()
                } : {})), n = s[0];
            return {
                api_key: null !== (i = null == n || null === (e = n.properties) || void 0 === e ? void 0 : e.token) && void 0 !== i ? i : null == n ? void 0 : n.token,
                batch: s,
                sent_at: (new Date).toISOString()
            };
        })(r.data) : "body" === r.timestampMode && (r.data = ((t, i = (new Date).toISOString())=>$0fb0e9cf977607be$var$T(t) ? t.map((t)=>$0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                    sent_at: i
                })) : $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                sent_at: i
            }))(r.data))), r.url = $0fb0e9cf977607be$var$Pa(r.url, r.method, r.compression, r.timestampMode);
        const l = $0fb0e9cf977607be$var$Ca.filter((t)=>!r.disableTransport || !t.transport || !r.disableTransport.includes(t.transport)), u = null !== (s = null === (n = function(t, i) {
            for(let e = 0; t.length > e; e++)if (i(t[e])) return t[e];
        }(l, (t)=>t.transport === o)) || void 0 === n ? void 0 : n.method) && void 0 !== s ? s : l[0].method;
        if (!u) throw new Error("No available transport method");
        const h = (t)=>{
            try {
                u(t);
            } catch (t) {
                var i;
                $0fb0e9cf977607be$var$Sa(t) ? $0fb0e9cf977607be$var$Je.warn(t) : $0fb0e9cf977607be$var$Je.error(t), null === (i = r.callback) || void 0 === i || i.call(r, {
                    statusCode: 0,
                    error: t
                });
            }
        };
        "sendBeacon" !== o && !r.preferSyncCompression && r.data && r.compression === $0fb0e9cf977607be$export$6a00d17b5aff0af.GZipJS && $0fb0e9cf977607be$var$a && "undefined" != typeof Promise && !$0fb0e9cf977607be$var$pa ? $0fb0e9cf977607be$var$wa(r).then((t)=>{
            h(t);
        }).catch((i)=>{
            if ($0fb0e9cf977607be$var$me(i)) return $0fb0e9cf977607be$var$pa = !0, void h($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, r), {}, {
                compression: void 0,
                url: $0fb0e9cf977607be$var$Pa(t.url, t.method, void 0, t.timestampMode)
            }));
            ((t)=>{
                if (!t || "object" != typeof t) return !1;
                const i = "name" in t ? String(t.name) : "";
                return $0fb0e9cf977607be$var$me(t) || i === $0fb0e9cf977607be$var$pe;
            })(i) && ($0fb0e9cf977607be$var$pa = !0), h(r);
        }) : h(r);
    })(i, (s, n)=>{
        var r, o, l;
        t.rateLimiter.checkForLimiting(s), 400 > s.statusCode || null === (r = (o = t.config).on_request_error) || void 0 === r || r.call(o, s), e ? e(s, n) : null === (l = i.callback) || void 0 === l || l.call(i, s);
    })) : i.fireCallbackOnDrop && (null === (r = i.callback) || void 0 === r || r.call(i, {
        statusCode: 0
    }));
}
var $0fb0e9cf977607be$var$Ia = class {
    constructor(t, i){
        this.rl = !0, this.ol = [], this.al = $0fb0e9cf977607be$var$Z((null == i ? void 0 : i.flush_interval_ms) || 3e3, 250, 5e3, $0fb0e9cf977607be$var$Je.createLogger("flush interval"), 3e3), this.ll = t;
    }
    enqueue(t) {
        this.ol.push(t), this.ul || this.hl();
    }
    unload() {
        this.cl();
        const t = this.ol.length > 0 ? this.dl() : {}, i = Object.values(t);
        [
            ...i.filter((t)=>0 === t.url.indexOf("/e")),
            ...i.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.vl(t, "sendBeacon");
        });
    }
    enable() {
        this.rl = !1, this.hl();
    }
    hl() {
        this.rl || (this.ul = setTimeout(()=>{
            if (this.cl(), this.ol.length > 0) {
                const t = this.dl();
                for(const i in t)this.vl(t[i]);
            }
        }, this.al));
    }
    vl(t, i) {
        try {
            this.ll(t, i);
        } catch (t) {
            $0fb0e9cf977607be$var$Je.error(t);
        }
    }
    cl() {
        clearTimeout(this.ul), this.ul = void 0;
    }
    dl() {
        const t = {};
        return $0fb0e9cf977607be$var$Vn(this.ol, (i)=>{
            var e;
            const s = i, n = ((s ? s.batchKey : null) || s.url) + (s.batchGroup ? `:${s.batchGroup}` : "");
            $0fb0e9cf977607be$var$R(t[n]) && (t[n] = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, s), {}, {
                data: []
            })), null === (e = t[n].data) || void 0 === e || e.push(s.data);
        }), this.ol = [], t;
    }
};
const $0fb0e9cf977607be$var$Ma = [
    "retriesPerformedSoFar"
];
var $0fb0e9cf977607be$var$Aa = class {
    constructor(t){
        this._instance = t, this.fl = !1, this.pl = 3e3, this.ol = [], this.ol = [], this.gl = !0, this.resume();
    }
    resume() {
        if (!$0fb0e9cf977607be$var$R($0fb0e9cf977607be$var$t) && "onLine" in $0fb0e9cf977607be$var$t.navigator) {
            if (this.gl = $0fb0e9cf977607be$var$t.navigator.onLine, this.ml) return;
            this.ml = ()=>{
                this.gl = !0, this.yl();
            }, this.bl = ()=>{
                this.gl = !1;
            }, $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "online", this.ml), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "offline", this.bl);
        }
    }
    get length() {
        return this.ol.length;
    }
    retriableRequest(t, i) {
        let { retriesPerformedSoFar: e } = t, s = $0fb0e9cf977607be$var$xe(t, $0fb0e9cf977607be$var$Ma);
        $0fb0e9cf977607be$var$N(e) && (s.url = $0fb0e9cf977607be$var$ga(s.url, {
            retry_count: e
        })), $0fb0e9cf977607be$var$Ra(this._instance, i ? $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, s), {}, {
            transport: i
        }) : s, (t, i)=>{
            var n;
            if (200 !== t.statusCode && (400 > t.statusCode || t.statusCode >= 500)) {
                if ((0 === t.statusCode ? 3 : 10) > (null != e ? e : 0)) return void this.Ls($0fb0e9cf977607be$var$Ei({
                    retriesPerformedSoFar: e
                }, s), i);
                0 === t.statusCode && $0fb0e9cf977607be$var$Je.warn(`Request failed before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped retrying after ${null != e ? e : 0} retries.`);
            }
            null === (n = s.callback) || void 0 === n || n.call(s, t);
        });
    }
    Ls(t, i) {
        const e = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = e + 1;
        const s = Math.max(function(t) {
            const i = 3e3 * Math.pow(2, t), e = i / 2, s = Math.min(18e5, i), n = (Math.random() - .5) * (s - e);
            return Math.ceil(s + n);
        }(e), null != i ? i : 0), n = Date.now() + s;
        this.ol.push({
            retryAt: n,
            requestOptions: t
        });
        let r = `Enqueued failed request for retry in ${s}`;
        navigator.onLine || (r += " (Browser is offline)"), $0fb0e9cf977607be$var$Je.warn(r), this.fl || (this.fl = !0, this._l());
    }
    _l() {
        if (this.wl && clearTimeout(this.wl), 0 === this.ol.length) return this.fl = !1, void (this.wl = void 0);
        this.wl = setTimeout(()=>{
            this.gl && this.ol.length > 0 && this.yl(), this._l();
        }, this.pl);
    }
    yl() {
        const t = Date.now(), i = [], e = this.ol.filter((e)=>t > e.retryAt || (i.push(e), !1));
        if (this.ol = i, e.length > 0) for (const { requestOptions: t } of e)this.retriableRequest(t);
    }
    unload() {
        this.wl && (clearTimeout(this.wl), this.wl = void 0), this.fl = !1, $0fb0e9cf977607be$var$R($0fb0e9cf977607be$var$t) || (this.ml && ($0fb0e9cf977607be$var$t.removeEventListener("online", this.ml), this.ml = void 0), this.bl && ($0fb0e9cf977607be$var$t.removeEventListener("offline", this.bl), this.bl = void 0));
        for (const { requestOptions: t } of this.ol)try {
            this._instance._send_request($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $0fb0e9cf977607be$var$Je.error(t);
        }
        this.ol = [];
    }
}, $0fb0e9cf977607be$var$Fa = class {
    constructor(t){
        this._instance = t, this.kl = ()=>{
            var t, i, e, s;
            this.Sl || (this.Sl = {});
            const n = this.scrollElement(), r = this.scrollY(), o = n ? Math.max(0, n.scrollHeight - n.clientHeight) : 0, l = r + ((null == n ? void 0 : n.clientHeight) || 0), a = (null == n ? void 0 : n.scrollHeight) || 0;
            this.Sl.lastScrollY = Math.ceil(r), this.Sl.maxScrollY = Math.max(r, null !== (t = this.Sl.maxScrollY) && void 0 !== t ? t : 0), this.Sl.maxScrollHeight = Math.max(o, null !== (i = this.Sl.maxScrollHeight) && void 0 !== i ? i : 0), this.Sl.lastContentY = l, this.Sl.maxContentY = Math.max(l, null !== (e = this.Sl.maxContentY) && void 0 !== e ? e : 0), this.Sl.maxContentHeight = Math.max(a, null !== (s = this.Sl.maxContentHeight) && void 0 !== s ? s : 0);
        };
    }
    get xl() {
        return this._instance.config.scroll_root_selector;
    }
    getContext() {
        return this.Sl;
    }
    resetContext() {
        const t = this.Sl;
        return this.Sl = void 0, setTimeout(this.kl, 0), t;
    }
    startMeasuringScrollPosition() {
        $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "scroll", this.kl, {
            capture: !0
        }), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "scrollend", this.kl, {
            capture: !0
        }), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "resize", this.kl);
    }
    scrollElement() {
        if (this.xl) {
            const e = $0fb0e9cf977607be$var$T(this.xl) ? this.xl : [
                this.xl
            ];
            for (const s of e){
                var i;
                const e = null == $0fb0e9cf977607be$var$t || null === (i = $0fb0e9cf977607be$var$t.document) || void 0 === i ? void 0 : i.querySelector(s);
                if (e) return e;
            }
            return;
        }
        var e;
        return null == $0fb0e9cf977607be$var$t || null === (e = $0fb0e9cf977607be$var$t.document) || void 0 === e ? void 0 : e.documentElement;
    }
    $l(i) {
        var e, s;
        const n = "y" === i ? "scrollTop" : "scrollLeft";
        if (this.xl) {
            const t = this.scrollElement();
            return t && t[n] || 0;
        }
        return $0fb0e9cf977607be$var$t ? "y" === i ? $0fb0e9cf977607be$var$t.scrollY || $0fb0e9cf977607be$var$t.pageYOffset || (null === (e = $0fb0e9cf977607be$var$t.document) || void 0 === e || null === (e = e.documentElement) || void 0 === e ? void 0 : e.scrollTop) || 0 : $0fb0e9cf977607be$var$t.scrollX || $0fb0e9cf977607be$var$t.pageXOffset || (null === (s = $0fb0e9cf977607be$var$t.document) || void 0 === s || null === (s = s.documentElement) || void 0 === s ? void 0 : s.scrollLeft) || 0 : 0;
    }
    scrollY() {
        return this.$l("y");
    }
    scrollX() {
        return this.$l("x");
    }
};
const $0fb0e9cf977607be$var$Da = (t)=>$0fb0e9cf977607be$var$Ko(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties, null == t ? void 0 : t.config.disable_capture_url_hashes);
var $0fb0e9cf977607be$var$Na = class {
    constructor(t, i, e, s){
        this.qe = (t)=>{
            const i = this.Cl();
            if (i && i.sessionId === t) return;
            const e = {
                sessionId: t,
                props: this.Tl(this._instance)
            };
            this.Il.register({
                [$0fb0e9cf977607be$var$fn]: e
            });
        }, this._instance = t, this.Ml = i, this.Il = e, this.Tl = s || $0fb0e9cf977607be$var$Da, this.Ml.onSessionId(this.qe);
    }
    Cl() {
        return this.Il.props[$0fb0e9cf977607be$var$fn];
    }
    getSetOnceProps() {
        var t;
        const i = null === (t = this.Cl()) || void 0 === t ? void 0 : t.props;
        return i ? "r" in i ? $0fb0e9cf977607be$var$Jo(i, this._instance.config.disable_capture_url_hashes) : {
            $referring_domain: i.referringDomain,
            $pathname: i.initialPathName,
            utm_source: i.utm_source,
            utm_campaign: i.utm_campaign,
            utm_medium: i.utm_medium,
            utm_content: i.utm_content,
            utm_term: i.utm_term
        } : {};
    }
    getSessionProps() {
        const t = {};
        return $0fb0e9cf977607be$var$Vn($0fb0e9cf977607be$var$Jn(this.getSetOnceProps()), (i, e)=>{
            "$current_url" === e && (e = "url"), t[`$session_entry_${$0fb0e9cf977607be$var$w(e)}`] = i;
        }), t;
    }
}, $0fb0e9cf977607be$var$ja = class {
    on(t, i) {
        return this.El[t] || (this.El[t] = []), this.El[t].push(i), ()=>{
            this.El[t] = this.El[t].filter((t)=>t !== i);
        };
    }
    emit(t, i) {
        for (const e of this.El[t] || [])e(i);
        for (const e of this.El["*"] || [])e(t, i);
    }
    constructor(){
        this.El = {};
    }
};
const $0fb0e9cf977607be$var$La = $0fb0e9cf977607be$var$Ye("[SessionId]"), $0fb0e9cf977607be$var$Ba = 864e5;
var $0fb0e9cf977607be$var$Ua = class {
    on(t, i) {
        return this.Pl.on(t, i);
    }
    constructor(t, i, e){
        var s;
        if (this.Rl = null, this.Al = null, this.Ol = [], this.Fl = void 0, this.Dl = !1, this.Pl = new $0fb0e9cf977607be$var$ja, this.Ll = (t, i)=>!(!$0fb0e9cf977607be$var$N(t) || !$0fb0e9cf977607be$var$N(i)) && Math.abs(t - i) > this.sessionTimeoutMs, !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if ("always" === t.config.cookieless_mode) throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
        this.Mr = t.config, this.Il = t.persistence, this.je = void 0, this.Xt = void 0, this._sessionStartTimestamp = null, this.Nl = void 0, this._sessionActivityTimestamp = null, this.ql = i || $0fb0e9cf977607be$var$lr, this.jl = e || $0fb0e9cf977607be$var$lr;
        const n = this.Mr.persistence_name || this.Mr.token;
        if (this._sessionTimeoutMs = 1e3 * $0fb0e9cf977607be$var$Z(this.Mr.session_idle_timeout_seconds || 1800, 60, 36e3, $0fb0e9cf977607be$var$La.createLogger("session_idle_timeout_seconds"), 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.Bl(), this.Hl = "ph_" + n + "_window_id", this.zl = "ph_" + n + "_primary_window_exists", this.Ul()) {
            const t = $0fb0e9cf977607be$var$Pr.Lt(this.Hl), i = $0fb0e9cf977607be$var$Pr.Lt(this.zl);
            t && !i ? this.je = t : $0fb0e9cf977607be$var$Pr.Pt(this.Hl), $0fb0e9cf977607be$var$Pr.$t(this.zl, !0);
        }
        (null === (s = this.Mr.bootstrap) || void 0 === s ? void 0 : s.sessionID) && this.setBootstrapSessionId(this.Mr.bootstrap.sessionID), this.Wl();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $0fb0e9cf977607be$var$R(this.Ol) && (this.Ol = []), this.Ol.push(t), this.Xt && t(this.Xt, this.je), ()=>{
            this.Ol = this.Ol.filter((i)=>i !== t);
        };
    }
    Ul() {
        return "memory" !== this.Mr.persistence && !this.Il.hi && $0fb0e9cf977607be$var$Pr.Et();
    }
    Vl(t) {
        t !== this.je && (this.je = t, this.Ul() && $0fb0e9cf977607be$var$Pr.$t(this.Hl, t));
    }
    Gl() {
        return this.je ? this.je : this.Ul() ? $0fb0e9cf977607be$var$Pr.Lt(this.Hl) : null;
    }
    Ql(t) {
        const i = this.Rl;
        return !$0fb0e9cf977607be$var$A(i) && !$0fb0e9cf977607be$var$A(t) && 5e3 > Math.abs(t - i);
    }
    Jl(t, i, e) {
        const s = i !== this._sessionActivityTimestamp, n = !(t !== this.Xt || e !== this._sessionStartTimestamp);
        this._sessionStartTimestamp = e, this._sessionActivityTimestamp = i, this.Xt = t, n && !s || n && this.Ql(i) || (this.Rl = i, this.Il.register({
            [$0fb0e9cf977607be$var$Rs]: [
                i,
                t,
                e
            ]
        }));
    }
    Zl() {
        var t;
        const i = null === (t = this.Mr) || void 0 === t ? void 0 : t.persistence_save_debounce_ms;
        return $0fb0e9cf977607be$var$N(i) && i > 0;
    }
    Kl() {
        this.Zl() ? this.Il.refreshKey($0fb0e9cf977607be$var$Rs) : (this.Il.flush(), this.Il.load());
    }
    Xl() {
        var t;
        if ($0fb0e9cf977607be$var$A(this._sessionActivityTimestamp) || this._sessionActivityTimestamp === this.Rl) return;
        this.Kl();
        const [, i, e] = this.Yl();
        i === this.Xt && e === this._sessionStartTimestamp && (this.Rl = this._sessionActivityTimestamp, this.Il.register({
            [$0fb0e9cf977607be$var$Rs]: [
                this._sessionActivityTimestamp,
                null !== (t = this.Xt) && void 0 !== t ? t : null,
                this._sessionStartTimestamp
            ]
        }), this.Il.flush());
    }
    tu() {
        const [t] = this.Yl(), i = $0fb0e9cf977607be$var$N(t) ? t : 0, e = $0fb0e9cf977607be$var$N(this._sessionActivityTimestamp) ? this._sessionActivityTimestamp : 0;
        return Math.max(i, e);
    }
    eu(t) {
        return this.Kl(), this.Ll(t, this.tu());
    }
    Yl() {
        const t = this.Il.props[$0fb0e9cf977607be$var$Rs];
        return $0fb0e9cf977607be$var$T(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.Rl = null, this.Nl = void 0, clearTimeout(this.iu), this.iu = void 0, this.Jl(null, null, null);
    }
    setBootstrapSessionId(t, i = !1) {
        const e = ((t, i = (new Date).getTime())=>{
            try {
                const e = ((t)=>{
                    const i = t.replace(/-/g, "");
                    if (32 !== i.length) throw new Error("Not a valid UUID");
                    if ("7" !== i[12]) throw new Error("Not a UUIDv7");
                    return parseInt(i.substring(0, 12), 16);
                })(t);
                return e > i + 6e4 ? void $0fb0e9cf977607be$var$La.error("Bootstrap sessionID cannot be in the future") : e;
            } catch (t) {
                return void $0fb0e9cf977607be$var$La.error("Invalid sessionID in bootstrap", t);
            }
        })(t);
        return !$0fb0e9cf977607be$var$R(e) && (i ? this.Nl = {
            sessionId: t,
            sessionStartTimestamp: e
        } : this.Jl(t, (new Date).getTime(), e), !0);
    }
    destroy() {
        this.Dl = !0, this.Xl(), clearTimeout(this.iu), this.iu = void 0, this.Fl && $0fb0e9cf977607be$var$t && ($0fb0e9cf977607be$var$t.removeEventListener($0fb0e9cf977607be$var$Ln, this.Fl, {
            capture: !1
        }), this.Fl = void 0), this.Ol = [];
    }
    Wl() {
        this.Fl = ()=>{
            this.Xl(), this.Ul() && $0fb0e9cf977607be$var$Pr.Pt(this.zl);
        }, $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, $0fb0e9cf977607be$var$Ln, this.Fl, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t = !1, i = null, e = !1) {
        if ("always" === this.Mr.cookieless_mode) throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
        const s = i || (new Date).getTime(), n = this.Xt;
        if (e) this.Al = s;
        else if ($0fb0e9cf977607be$var$A(this.Al) || this.Al > s || s - this.Al >= 1e3) {
            var r, o;
            null === (r = (o = this.Il).syncCookieProperties) || void 0 === r || r.call(o), this.Al = s;
        }
        let [, l, a] = this.Yl();
        const u = !$0fb0e9cf977607be$var$R(n) && l !== n, h = this.tu();
        let d = this.Gl();
        const c = this.Nl, v = !!c && (c.sessionStartTimestamp > s + 6e4 || s - c.sessionStartTimestamp > $0fb0e9cf977607be$var$Ba), f = c ? v : $0fb0e9cf977607be$var$N(a) && Math.abs(s - a) > $0fb0e9cf977607be$var$Ba;
        let p = !1, _ = u, g = !l || !!c;
        const m = l;
        let b = !g && !t && this.Ll(s, h);
        if (b && (b = this.eu(s), b || $0fb0e9cf977607be$var$La.info("cross-tab refresh kept the session alive", {
            sessionId: l
        }), [, l, a] = this.Yl(), b || (g = !l || !!c)), g || b || f) {
            _ = !1;
            const t = c && !v;
            l = t ? c.sessionId : this.ql(), d = this.jl(), $0fb0e9cf977607be$var$La.info("new session ID assigned", {
                sessionId: l,
                windowId: d,
                bootstrapped: !!t,
                changeReason: {
                    noSessionId: g,
                    activityTimeout: b,
                    sessionPastMaximumLength: f
                }
            }), a = t ? c.sessionStartTimestamp : s, this.Nl = void 0, p = !0;
        } else d || (d = this.jl(), p = !0), _ = _ || l !== m, _ && ($0fb0e9cf977607be$var$La.info("adopted cross-tab session id", {
            sessionId: l,
            windowId: d
        }), p = !0);
        const y = $0fb0e9cf977607be$var$N(h) && t && !f ? h : s, w = $0fb0e9cf977607be$var$N(a) ? a : (new Date).getTime();
        this.Vl(d), this.Jl(l, y, w), t || this.Bl();
        const S = {
            noSessionId: g,
            activityTimeout: b,
            sessionPastMaximumLength: f,
            crossTabAdoption: _
        };
        return p && this.Ol.forEach((t)=>t(l, d, S)), {
            sessionId: l,
            windowId: d,
            sessionStartTimestamp: w,
            changeReason: p ? S : void 0,
            lastActivityTimestamp: h
        };
    }
    Bl() {
        this.Dl || (clearTimeout(this.iu), this.iu = setTimeout(()=>{
            if (!this.Dl) {
                if (this.eu((new Date).getTime())) {
                    const t = this.Xt;
                    this.resetSessionId(), this.Pl.emit("forcedIdleReset", {
                        idleSessionId: t
                    });
                } else this.Bl();
            }
        }, 1.1 * this.sessionTimeoutMs));
    }
};
const $0fb0e9cf977607be$var$za = function(t, i) {
    if (!t) return !1;
    const e = t.userAgent;
    if (e && $0fb0e9cf977607be$var$Q(e, i)) return !0;
    try {
        const e = null == t ? void 0 : t.userAgentData;
        if ((null == e ? void 0 : e.brands) && e.brands.some((t)=>$0fb0e9cf977607be$var$Q(null == t ? void 0 : t.brand, i))) return !0;
    } catch (t) {}
    return !!t.webdriver;
};
function $0fb0e9cf977607be$var$Ha() {
    return ($0fb0e9cf977607be$var$Ha = $0fb0e9cf977607be$var$Y(function*() {
        const t = null == $0fb0e9cf977607be$var$e ? void 0 : $0fb0e9cf977607be$var$e.userAgentData;
        if (null == t ? void 0 : t.getHighEntropyValues) try {
            const i = yield t.getHighEntropyValues([
                "model"
            ]), e = null == i ? void 0 : i.model;
            return $0fb0e9cf977607be$var$I(e) && e.length > 0 ? e : void 0;
        } catch (t) {
            return void $0fb0e9cf977607be$var$Je.info("Unable to resolve $device_model from userAgentData.getHighEntropyValues", t);
        }
    })).apply(this, arguments);
}
function $0fb0e9cf977607be$var$qa(t, i) {
    let e = `$survey_${i}/${t.id}`;
    return t.current_iteration && t.current_iteration > 0 && (e = `$survey_${i}/${t.id}/${t.current_iteration}`), e;
}
function $0fb0e9cf977607be$var$Va(t) {
    var i;
    return !!(null === (i = t.conditions) || void 0 === i || null === (i = i.events) || void 0 === i || null === (i = i.values) || void 0 === i ? void 0 : i.length);
}
const $0fb0e9cf977607be$var$Wa = (t, i)=>{
    if (!((t)=>{
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    })(i)) return !1;
    try {
        return new RegExp(i).test(t);
    } catch (t) {
        return !1;
    }
}, $0fb0e9cf977607be$var$Ga = (t)=>t.toLowerCase(), $0fb0e9cf977607be$var$Ka = {
    exact: (t, i)=>i.some((i)=>t.some((t)=>i === t)),
    is_not: (t, i)=>i.every((i)=>t.every((t)=>i !== t)),
    regex: (t, i)=>i.some((i)=>t.some((t)=>$0fb0e9cf977607be$var$Wa(i, t))),
    not_regex: (t, i)=>i.every((i)=>t.every((t)=>!$0fb0e9cf977607be$var$Wa(i, t))),
    icontains: (t, i)=>i.map($0fb0e9cf977607be$var$Ga).some((i)=>t.map($0fb0e9cf977607be$var$Ga).some((t)=>i.includes(t))),
    not_icontains: (t, i)=>i.map($0fb0e9cf977607be$var$Ga).every((i)=>t.map($0fb0e9cf977607be$var$Ga).every((t)=>!i.includes(t))),
    gt: (t, i)=>i.some((i)=>{
            const e = parseFloat(i);
            return !isNaN(e) && t.some((t)=>e > parseFloat(t));
        }),
    lt: (t, i)=>i.some((i)=>{
            const e = parseFloat(i);
            return !isNaN(e) && t.some((t)=>e < parseFloat(t));
        })
};
function $0fb0e9cf977607be$var$Ja(t, i) {
    return !t || Object.entries(t).every(([t, e])=>{
        const s = null == i ? void 0 : i[t];
        if (null == s) return !1;
        const n = $0fb0e9cf977607be$var$Ka[e.operator];
        return !!n && n(e.values.map(String), [
            String(s)
        ]);
    });
}
function $0fb0e9cf977607be$var$Ya(t, i, e) {
    return $0fb0e9cf977607be$var$Oo({
        distinct_id: t,
        userPropertiesToSet: i,
        userPropertiesToSetOnce: e
    });
}
const $0fb0e9cf977607be$var$Xa = "custom", $0fb0e9cf977607be$var$Qa = "i.posthog.com", $0fb0e9cf977607be$var$Za = /^\/static\//, $0fb0e9cf977607be$var$tu = [
    "/s/",
    "/e/",
    "/i/"
];
var $0fb0e9cf977607be$var$iu = class {
    constructor(t){
        this.nu = {}, this.instance = t;
    }
    get apiHost() {
        const t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get flagsApiHost() {
        const t = this.instance.config.flags_api_host;
        return t ? t.trim().replace(/\/$/, "") : this.apiHost;
    }
    get uiHost() {
        var t;
        let i = null === (t = this.instance.config.ui_host) || void 0 === t ? void 0 : t.replace(/\/$/, "");
        return i || (i = this.apiHost.replace(`.${$0fb0e9cf977607be$var$Qa}`, ".posthog.com")), "https://app.posthog.com" === i ? "https://us.posthog.com" : i;
    }
    get region() {
        return this.nu[this.apiHost] || (this.nu[this.apiHost] = /https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "us" : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "eu" : $0fb0e9cf977607be$var$Xa), this.nu[this.apiHost];
    }
    su(t) {
        if (!$0fb0e9cf977607be$var$Za.test(t)) return;
        const i = this.instance.config.asset_host;
        return "string" == typeof i && i.trim().replace(/\/$/, "") || void 0;
    }
    ru(t) {
        const i = $0fb0e9cf977607be$var$Ro(t);
        return i ? i.protocol + "//" + i.host + i.pathname : void 0;
    }
    ou(t, i, e) {
        if ("ui" === t) return e;
        let s = e;
        const n = this.instance.config.rewriteRequestPath;
        if (n) {
            var r;
            const t = (null === (r = $0fb0e9cf977607be$var$Ro(e)) || void 0 === r ? void 0 : r.href) || e;
            s = n(new URL(t)).toString();
        }
        if (n && "api" === t && $0fb0e9cf977607be$var$tu.some((t)=>0 === i.indexOf(t))) {
            const t = this.ru(s);
            if (t) {
                const i = this.apiHost;
                let e = this.au;
                (null == e ? void 0 : e.apiHost) === i && e.rewriteRequestPath === n || (e = {
                    apiHost: i,
                    rewriteRequestPath: n,
                    urls: new Set
                }, this.au = e), e.urls.add(t);
            }
        }
        return s;
    }
    isIngestionEndpoint(t) {
        const i = this.au, e = this.ru(t);
        return (null == i ? void 0 : i.apiHost) === this.apiHost && i.rewriteRequestPath === this.instance.config.rewriteRequestPath && !!e && i.urls.has(e);
    }
    endpointFor(t, i = "") {
        if (i && (i = "/" === i[0] ? i : `/${i}`), "ui" === t) return this.ou(t, i, this.uiHost + i);
        if ("flags" === t) return this.ou(t, i, this.flagsApiHost + i);
        if ("assets" === t) {
            const e = this.su(i);
            if (e) return this.ou(t, i, `${e}${i}`);
        }
        if (this.region === $0fb0e9cf977607be$var$Xa) return this.ou(t, i, this.apiHost + i);
        const e = $0fb0e9cf977607be$var$Qa + i;
        switch(t){
            case "assets":
                return this.ou(t, i, `https://${this.region}-assets.${e}`);
            case "api":
                return this.ou(t, i, `https://${this.region}.${e}`);
        }
    }
};
const $0fb0e9cf977607be$var$eu = $0fb0e9cf977607be$var$Ye("[Surveys]"), $0fb0e9cf977607be$var$su = (t)=>{
    try {
        const i = ((t)=>((t, i)=>`seenSurvey_${function(t) {
                    return t.current_iteration && t.current_iteration > 0 ? `${t.id}_${t.current_iteration}` : t.id;
                }(i)}`)(0, t))(t);
        if (localStorage.getItem(i)) return;
        localStorage.setItem(i, "true");
    } catch (t) {
        $0fb0e9cf977607be$var$eu.error("Failed to persist survey seen state", t);
    }
}, $0fb0e9cf977607be$var$nu = [
    $0fb0e9cf977607be$export$22779822dd24228f.Popover,
    $0fb0e9cf977607be$export$22779822dd24228f.Widget,
    $0fb0e9cf977607be$export$22779822dd24228f.API
], $0fb0e9cf977607be$var$ru = {
    ignoreConditions: !1,
    ignoreDelay: !1,
    displayType: $0fb0e9cf977607be$export$a8a66d9d1b857494.Popover
}, $0fb0e9cf977607be$var$ou = $0fb0e9cf977607be$var$Ye("[PostHog ExternalIntegrations]"), $0fb0e9cf977607be$var$lu = {
    intercom: "intercom-integration",
    crispChat: "crisp-chat-integration"
};
var $0fb0e9cf977607be$var$au = class {
    constructor(t){
        this._instance = t;
    }
    Ho(t, i) {
        var e, s;
        null === (e = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === e || null === (s = e.loadExternalDependency) || void 0 === s || s.call(e, this._instance, t, (t)=>{
            if (t) return $0fb0e9cf977607be$var$ou.error("failed to load script", t);
            i();
        });
    }
    startIfEnabledOrStop() {
        var t;
        for (const [n, r] of Object.entries(null !== (t = this._instance.config.integrations) && void 0 !== t ? t : {})){
            var i, e, s;
            r && !(null === (i = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === i || null === (i = i.integrations) || void 0 === i ? void 0 : i[n]) && this.Ho($0fb0e9cf977607be$var$lu[n], ()=>{
                var t;
                null === (t = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === t || null === (t = t.integrations) || void 0 === t || null === (t = t[n]) || void 0 === t || t.start(this._instance);
            }), !r && (null === (e = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === e || null === (e = e.integrations) || void 0 === e ? void 0 : e[n]) && (null === (s = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === s || null === (s = s.integrations) || void 0 === s || null === (s = s[n]) || void 0 === s || s.stop());
        }
    }
}, $0fb0e9cf977607be$var$uu = class {
    constructor(t, i){
        this.A = t, this.bo = i, this.lu = new Map, this.To = !1;
    }
    add(t) {
        var i = this;
        return $0fb0e9cf977607be$var$Y(function*() {
            if (i.To) throw new Error("Cannot add an extension to a disposed ExtensionRuntime");
            if (i.lu.has(t.name)) throw new Error(`Browser extension "${t.name}" is already registered`);
            i.lu.set(t.name, t);
            try {
                const e = t.setup(i.bo);
                e && (yield e);
            } catch (e) {
                const s = i.lu.get(t.name) === t;
                s && i.lu.delete(t.name), i.A.error(`Failed to set up browser extension "${t.name}"`, e), s && i.uu(t);
            }
        })();
    }
    getExtension(t) {
        return this.lu.get(t);
    }
    dispose() {
        if (this.To) return;
        this.To = !0;
        const t = Array.from(this.lu.values()).reverse();
        this.lu.clear();
        for (const i of t)this.uu(i);
    }
    uu(t) {
        try {
            var i;
            const e = null === (i = t.dispose) || void 0 === i ? void 0 : i.call(t);
            e && $0fb0e9cf977607be$var$P(e.then) && e.then(void 0, (i)=>{
                this.A.error(`Failed to dispose browser extension "${t.name}"`, i);
            });
        } catch (i) {
            this.A.error(`Failed to dispose browser extension "${t.name}"`, i);
        }
    }
}, $0fb0e9cf977607be$var$hu = class {
    constructor(t){
        this._instance = t;
    }
    initialize() {}
    get(t) {
        const i = this._instance.persistence;
        if ("string" == typeof t) return null == i ? void 0 : i.get_property(t);
        const e = {};
        for (const s of t){
            const t = null == i ? void 0 : i.get_property(s);
            $0fb0e9cf977607be$var$R(t) || (e[s] = t);
        }
        return e;
    }
    set(t, i) {
        var e;
        null === (e = this._instance.persistence) || void 0 === e || e.register("string" == typeof t ? {
            [t]: i
        } : t);
    }
    remove(t) {
        var i;
        null === (i = this._instance.persistence) || void 0 === i || i.unregister(t);
    }
};
const $0fb0e9cf977607be$var$du = "extensionsRemoteConfig";
var $0fb0e9cf977607be$var$cu = class {
    constructor(t){
        this.instance = t, this.To = !1, this.A = $0fb0e9cf977607be$var$Je, this.hu = t.cu, this.kv = new $0fb0e9cf977607be$var$hu(t), this.onEvent = (t)=>$0fb0e9cf977607be$var$Sl(this.instance.on("eventCaptured", (i)=>{
                try {
                    t({
                        event: i.event,
                        properties: i.properties
                    });
                } catch (t) {
                    this.A.error("Browser extension event listener failed", t);
                }
            })), this.onRemoteConfig = (t)=>{
            if (this.To) return $0fb0e9cf977607be$var$Sl(()=>{});
            const i = (i)=>{
                try {
                    t(i);
                } catch (t) {
                    this.A.error("Browser extension remote config listener failed", t);
                }
            }, e = this.instance.du.on($0fb0e9cf977607be$var$du, i);
            return this.hu && i(this.hu), $0fb0e9cf977607be$var$Sl(e);
        }, this.vu = new $0fb0e9cf977607be$var$uu($0fb0e9cf977607be$var$Je.createLogger("[BrowserExtensions]"), this);
    }
    get logger() {
        return this.A;
    }
    get distinctId() {
        return this.instance.get_distinct_id();
    }
    get anonymousId() {
        var t;
        return null !== (t = this.instance.get_property("$device_id")) && void 0 !== t ? t : this.distinctId;
    }
    get deviceId() {
        const t = this.instance.get_property($0fb0e9cf977607be$var$rs);
        return "string" == typeof t ? t : void 0;
    }
    get library() {
        return {
            name: $0fb0e9cf977607be$var$es.LIB_NAME,
            version: $0fb0e9cf977607be$var$es.LIB_VERSION
        };
    }
    get initialPersonProperties() {
        var t, i;
        return null !== (t = null === (i = this.instance.persistence) || void 0 === i ? void 0 : i.get_initial_props()) && void 0 !== t ? t : {};
    }
    get groups() {
        return this.instance.getGroups();
    }
    get session() {
        try {
            var t, i, e, s;
            const n = null === (t = this.instance.sessionManager) || void 0 === t ? void 0 : t.checkAndGetSessionAndWindowId(!0);
            return {
                sessionId: null !== (i = null == n ? void 0 : n.sessionId) && void 0 !== i ? i : "",
                windowId: null !== (e = null == n ? void 0 : n.windowId) && void 0 !== e ? e : "",
                sessionStartTimestamp: null !== (s = null == n ? void 0 : n.sessionStartTimestamp) && void 0 !== s ? s : 0
            };
        } catch (t) {
            return {
                sessionId: "",
                windowId: "",
                sessionStartTimestamp: 0
            };
        }
    }
    get canCapture() {
        return this.instance.is_capturing();
    }
    get projectToken() {
        return this.instance.config.token;
    }
    add(t) {
        return this.vu.add(t);
    }
    getExtension(t) {
        return this.vu.getExtension(t);
    }
    capture(t, i, e) {
        e ? this.instance.capture(t, i, {
            timestamp: e.timestamp,
            uuid: e.uuid,
            $set: e.set,
            $set_once: e.setOnce
        }) : this.instance.capture(t, i);
    }
    registerDynamicEventProperties(t) {
        return $0fb0e9cf977607be$var$Sl(this.instance.fu(t));
    }
    handleRemoteConfig(t) {
        this.To || (this.hu = t, this.instance.du.emit($0fb0e9cf977607be$var$du, t));
    }
    sendRequest(t) {
        var i = this;
        return $0fb0e9cf977607be$var$Y(function*(t, e = {}) {
            var s;
            const n = i.instance.requestRouter.endpointFor(null !== (s = e.target) && void 0 !== s ? s : "api", t), r = {
                method: e.method,
                url: e.query ? $0fb0e9cf977607be$var$ga(n, e.query) : n,
                data: e.body,
                headers: e.headers,
                timeout: e.timeoutMs,
                fireCallbackOnDrop: !0,
                transport: e.transport,
                compression: e.compression,
                compressionFallback: "flags" === e.target && "best-available" === e.compression ? $0fb0e9cf977607be$var$_.Base64 : void 0,
                timestampMode: e.sentAt
            };
            return "sendBeacon" === e.transport ? (i.instance._send_request(r), {
                statusCode: 202
            }) : new Promise((t)=>{
                r.callback = t, i.instance._send_request(r);
            });
        }).apply(this, arguments);
    }
    dispose() {
        this.To || (this.To = !0, this.vu.dispose());
    }
};
const $0fb0e9cf977607be$var$vu = {};
let $0fb0e9cf977607be$var$fu = 0;
const $0fb0e9cf977607be$var$pu = ()=>{}, $0fb0e9cf977607be$var$_u = 'Consent opt in/out is not valid with cookieless_mode="always" and will be ignored', $0fb0e9cf977607be$var$gu = "Surveys module not available", $0fb0e9cf977607be$var$mu = "sanitize_properties is deprecated. Use before_send instead", $0fb0e9cf977607be$var$bu = "Invalid value for property_denylist config: ", $0fb0e9cf977607be$var$yu = [
    "$recording_status",
    "$sdk_debug_recording_script_not_loaded",
    "$sdk_debug_replay_url_trigger_status",
    "$sdk_debug_replay_event_trigger_status",
    "$sdk_debug_replay_linked_flag_trigger_status",
    "$sdk_debug_replay_rrweb_error",
    "$sdk_debug_replay_internal_buffer_length",
    "$sdk_debug_replay_flushed_size"
], $0fb0e9cf977607be$var$wu = [
    "$feature_flag_called",
    "$$heatmap",
    "$snapshot"
], $0fb0e9cf977607be$var$$u = (t)=>"$" === t.charAt(0) && !$0fb0e9cf977607be$var$b($0fb0e9cf977607be$var$wu, t), $0fb0e9cf977607be$var$Su = /^[A-Za-z0-9_-]{1,400}$/, $0fb0e9cf977607be$var$xu = /^fb\.[0-9]+\.[0-9]+\.[A-Za-z0-9_-]+(?:\.[A-Za-z0-9_-]+)?$/, $0fb0e9cf977607be$var$Eu = /^fb\.[0-9]+\.[0-9]+\.[0-9]+$/, $0fb0e9cf977607be$var$ku = [
    "token",
    "distinct_id",
    $0fb0e9cf977607be$var$wn
], $0fb0e9cf977607be$var$Tu = "posthog", $0fb0e9cf977607be$var$Pu = (t)=>{
    const i = {};
    return t && "unset" !== t ? ("2025-11-30" > t || (i.strictMinimumDuration = !0), "2026-05-30" > t || (i.canvasCapture = {
        resolutionScale: .6
    }), "2026-06-25" > t || (i.streamNetworkBody = !0), "2026-08-30" > t || (i.captureJsonLd = !0), i) : i;
}, $0fb0e9cf977607be$var$Cu = (i)=>{
    var e;
    return $0fb0e9cf977607be$var$Ei({
        api_host: "https://us.i.posthog.com",
        flags_api_host: null,
        ui_host: null,
        asset_host: null,
        token: "",
        autocapture: !0,
        cross_subdomain_cookie: $0fb0e9cf977607be$var$Qn(null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        cookie_persisted_properties: [],
        loaded: $0fb0e9cf977607be$var$pu,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageleave: "if_capture_pageview",
        defaults: null != i ? i : "unset",
        __preview_deferred_init_extensions: !1,
        __preview_external_dependency_versioned_paths: !1,
        __preview_cookie_wins_on_conflict: !1,
        debug: $0fb0e9cf977607be$var$n && $0fb0e9cf977607be$var$I(null == $0fb0e9cf977607be$var$n ? void 0 : $0fb0e9cf977607be$var$n.search) && -1 !== $0fb0e9cf977607be$var$n.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_surveys_automatic_display: !1,
        disable_conversations: !1,
        disable_product_tours: !1,
        disableDeviceModel: !1,
        reuseAnonymousId: !1,
        disable_external_dependency_loading: !1,
        strict_script_versioning: "fallback",
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $0fb0e9cf977607be$var$t || null === (e = $0fb0e9cf977607be$var$t.location) || void 0 === e ? void 0 : e.protocol),
        ip: !1,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        consent_persistence_name: null,
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_flags: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_only_evaluate_survey_feature_flags: !1,
        advanced_feature_flags_dedup_per_session: !1,
        advanced_enable_surveys: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        feature_flag_request_max_retries: 1,
        surveys_request_timeout_ms: 1e4,
        on_request_error (t) {
            $0fb0e9cf977607be$var$Je.error("Bad HTTP status: " + t.statusCode + " " + t.text);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: $0fb0e9cf977607be$var$Nn,
        before_send: void 0,
        get_current_url: void 0,
        request_queue_config: {
            flush_interval_ms: 3e3
        },
        error_tracking: {},
        _onCapture: $0fb0e9cf977607be$var$pu
    }, ((t)=>({
            rageclick: t && t >= "2026-05-30" ? {
                content_ignorelist: $0fb0e9cf977607be$var$Kr,
                ignore_text_selection: !0
            } : !t || "2025-11-30" > t || {
                content_ignorelist: !0
            },
            capture_pageview: !t || "2025-05-24" > t || "history_change",
            session_recording: $0fb0e9cf977607be$var$Pu(t),
            external_scripts_inject_target: t && t >= "2026-01-30" ? "head" : "body",
            internal_or_test_user_hostname: t && t >= "2026-01-30" ? /^(localhost|127\.0\.0\.1)$/ : void 0,
            persistence_save_debounce_ms: t && t >= "2026-05-30" ? 250 : 0,
            split_storage: !(!t || "2026-05-30" > t),
            detect_google_search_app: !(!t || "2026-05-30" > t),
            disable_capture_url_hashes: !(!t || "2026-06-25" > t),
            cookieWinsOnConflict: !(!t || "unset" === t || "2026-08-29" > t)
        }))(i));
}, $0fb0e9cf977607be$var$Ou = [
    [
        "process_person",
        "person_profiles"
    ],
    [
        "xhr_headers",
        "request_headers"
    ],
    [
        "cookie_name",
        "persistence_name"
    ],
    [
        "disable_cookie",
        "disable_persistence"
    ],
    [
        "__preview_disable_beacon",
        "disable_beacon"
    ],
    [
        "store_google",
        "save_campaign_params"
    ],
    [
        "verbose",
        "debug"
    ],
    [
        "__preview_cookie_wins_on_conflict",
        "cookieWinsOnConflict"
    ]
], $0fb0e9cf977607be$var$Ru = (t)=>{
    const i = {};
    for (const [e, s] of $0fb0e9cf977607be$var$Ou)$0fb0e9cf977607be$var$R(t[e]) || (i[s] = t[e]);
    const e = $0fb0e9cf977607be$var$Wn({}, i, t), s = t.__preview_external_dependency_versioned_paths;
    return $0fb0e9cf977607be$var$R(s) || ($0fb0e9cf977607be$var$R(t.strict_script_versioning) && (e.strict_script_versioning = !!s), $0fb0e9cf977607be$var$I(s) && $0fb0e9cf977607be$var$R(t.asset_host) && (e.asset_host = s)), $0fb0e9cf977607be$var$T(t.property_blacklist) && ($0fb0e9cf977607be$var$R(t.property_denylist) ? e.property_denylist = t.property_blacklist : $0fb0e9cf977607be$var$T(t.property_denylist) ? e.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $0fb0e9cf977607be$var$Je.error($0fb0e9cf977607be$var$bu + t.property_denylist)), e;
};
var $0fb0e9cf977607be$var$Iu = class {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get pu() {
        return this.__forceAllowLocalhost;
    }
    set pu(t) {
        $0fb0e9cf977607be$var$Je.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}, $0fb0e9cf977607be$export$a9d6b9cbf49b8241 = class i {
    gu(t) {
        if (!t) return;
        const i = this.lu.indexOf(t);
        -1 !== i && this.lu.splice(i, 1);
    }
    mu(t, i) {
        var e;
        return this.gu(t), this.lu.push(i), null === (e = i.initialize) || void 0 === e || e.call(i), i;
    }
    yu() {
        return "always" === this.config.cookieless_mode || "on_reject" === this.config.cookieless_mode && this.consent.isRejected();
    }
    bu() {
        if (this._u) return;
        if (this.config.reuseAnonymousId) return;
        if (this.config.segment) return;
        if (this.yu()) return;
        const t = "memory" === this.config.persistence || "sessionStorage" === this.config.persistence;
        if (!t && !this.config.disable_persistence) return;
        if (this.wu) return;
        let i, e, s;
        t ? (i = `persistence is set to '${this.config.persistence}'`, e = "memory" === this.config.persistence ? "on every page load" : "for every new browser tab or window", s = "Either set persistence to 'localStorage+cookie', keep this persistence and pass a stable ID through bootstrap.distinctID, or enable reuseAnonymousId.") : (i = "persistence is disabled (disable_persistence is true)", e = "on every page load", s = "Either set disable_persistence to false, keep persistence disabled and pass a stable ID through bootstrap.distinctID, or enable reuseAnonymousId."), this._u = !0, console.warn("[PostHog.js]", `${i} but no bootstrap.distinctID was provided. PostHog will mint a new distinct ID ${e}, so calling identify() merges a new ID onto the person each time. A person can then pass the distinct-ID limit and its events stop appearing on person pages and the session tab. ${s}`);
    }
    ku() {
        const t = this.persistence;
        if (!t || this.Su) return;
        if (this.yu()) return void ("on_reject" === this.config.cookieless_mode && "$posthog_cookieless" !== this.get_distinct_id() && (this.xu(), this.$u()));
        if ("$posthog_cookieless" !== this.get_distinct_id()) return;
        this.Cu() || t.load(!0);
        const i = this.get_distinct_id();
        if (!i || "$posthog_cookieless" === i) {
            const i = this.config.get_device_id($0fb0e9cf977607be$var$lr());
            this.register({
                distinct_id: i,
                $device_id: i
            }), t.set_property($0fb0e9cf977607be$var$vn, $0fb0e9cf977607be$var$Fn);
        }
        this.xu();
    }
    get decideEndpointWasHit() {
        var t, i;
        return null !== (t = null === (i = this.featureFlags) || void 0 === i ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    get flagsEndpointWasHit() {
        var t, i;
        return null !== (t = null === (i = this.featureFlags) || void 0 === i ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        var t;
        this.Tu = !1, this.Iu = !1, this.webPerformance = new $0fb0e9cf977607be$var$Iu, this.Mu = !1, this.version = $0fb0e9cf977607be$var$es.LIB_VERSION, this.Eu = new Set, this.Pu = "", this.du = new $0fb0e9cf977607be$var$ja, this.lu = [], this.Ru = [], this.Au = !1, this.wu = !1, this._u = !1, this.Su = !1, this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = $0fb0e9cf977607be$var$Cu(), this.SentryIntegration = $0fb0e9cf977607be$var$xo, this.sentryIntegration = (t)=>(function(t, i) {
                const e = $0fb0e9cf977607be$var$So(t, i);
                return {
                    name: $0fb0e9cf977607be$var$$o,
                    processEvent: (t)=>e(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.Ou = !1, this.Fu = null, this.Du = null, this.Lu = null, this.scrollManager = new $0fb0e9cf977607be$var$Fa(this), this.pageViewManager = new $0fb0e9cf977607be$var$Eo(this), this.rateLimiter = new $0fb0e9cf977607be$var$Pl(this), this.requestRouter = new $0fb0e9cf977607be$var$iu(this), this.consent = new $0fb0e9cf977607be$var$Cr(this), this.externalIntegrations = new $0fb0e9cf977607be$var$au(this);
        const e = null !== (t = i.__defaultExtensionClasses) && void 0 !== t ? t : {};
        this.featureFlags = e.featureFlags && new e.featureFlags(this), this.toolbar = e.toolbar && new e.toolbar(this), this.surveys = e.surveys && new e.surveys(this), this.conversations = e.conversations && new e.conversations(this), this.logs = e.logs && new e.logs(this), this.metrics = e.metrics && new e.metrics(this), this.experiments = e.experiments && new e.experiments(this), this.exceptions = e.exceptions && new e.exceptions(this), this.people = {
            set: (t, i, e)=>{
                const s = $0fb0e9cf977607be$var$I(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(s), null == e || e({});
            },
            set_once: (t, i, e)=>{
                const s = $0fb0e9cf977607be$var$I(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(void 0, s), null == e || e({});
            }
        }, this.on("eventCaptured", (t)=>$0fb0e9cf977607be$var$Je.info(`send "${null == t ? void 0 : t.event}"`, t));
    }
    init(t, e, s) {
        if (s && s !== $0fb0e9cf977607be$var$Tu) {
            var n;
            const r = null !== (n = $0fb0e9cf977607be$var$vu[s]) && void 0 !== n ? n : new i;
            return r._init(t, e, s), $0fb0e9cf977607be$var$vu[s] = r, $0fb0e9cf977607be$var$vu[$0fb0e9cf977607be$var$Tu][s] = r, r;
        }
        return this._init(t, e, s);
    }
    _init(i, e = {}, s) {
        var n, r, o;
        const l = $0fb0e9cf977607be$var$I(i) ? i.trim() : "";
        if (!l) return $0fb0e9cf977607be$var$Je.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        var a;
        if (this.__loaded) return l !== (null === (a = this.config) || void 0 === a ? void 0 : a.token) ? console.warn("[PostHog.js]", `You have already initialized PostHog with a different project token! Re-initializing is a no-op, so events will keep going to the project this instance was initialized with. To capture into a second project, load PostHog once, then initialize a named instance after the SDK has loaded, e.g. posthog.init('${l}', { ... }, 'project2')`) : console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = $0fb0e9cf977607be$var$Cu(e.defaults), e.debug = this.Nu(e.debug), this.qu = e, this.ju = [], e.person_profiles ? this.Du = e.person_profiles : e.process_person && (this.Du = e.process_person);
        const u = $0fb0e9cf977607be$var$Cu(e.defaults), h = $0fb0e9cf977607be$var$Ru(e), d = $0fb0e9cf977607be$var$Wn({}, u, h, {
            name: s,
            token: l
        });
        $0fb0e9cf977607be$var$C(u.rageclick) && $0fb0e9cf977607be$var$C(h.rageclick) && (d.rageclick = $0fb0e9cf977607be$var$Wn({}, u.rageclick, h.rageclick)), $0fb0e9cf977607be$var$C(u.session_recording) && $0fb0e9cf977607be$var$C(h.session_recording) && (d.session_recording = $0fb0e9cf977607be$var$Wn({}, u.session_recording, h.session_recording)), this.set_config(d), this.config.on_xhr_error && $0fb0e9cf977607be$var$Je.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = e.disable_compression ? void 0 : $0fb0e9cf977607be$export$6a00d17b5aff0af.GZipJS;
        const c = this.Cu(), v = !this.yu();
        if (this.persistence = new $0fb0e9cf977607be$var$hl(this.config, c, !0, v), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $0fb0e9cf977607be$var$hl($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, this.config), {}, {
            persistence: "sessionStorage"
        }), c, !1, v), this.Pu = "ph_" + (this.config.persistence_name || this.config.token) + "_session_registered_properties", "memory" !== this.config.persistence && !c && $0fb0e9cf977607be$var$Pr.Et()) {
            const t = $0fb0e9cf977607be$var$Pr.Lt(this.Pu);
            $0fb0e9cf977607be$var$T(t) && t.forEach((t)=>{
                $0fb0e9cf977607be$var$I(t) && this.Eu.add(t);
            });
        } else $0fb0e9cf977607be$var$Pr.Pt(this.Pu);
        const f = $0fb0e9cf977607be$var$Ei({}, this.persistence.props), p = $0fb0e9cf977607be$var$Ei({}, this.sessionPersistence.props);
        this.register({
            $initialization_time: (new Date).toISOString()
        }), this.Bu = new $0fb0e9cf977607be$var$Ia((t, i)=>this.Hu(t, i), this.config.request_queue_config), this.zu = new $0fb0e9cf977607be$var$Aa(this), this.__request_queue = [];
        const _ = this.yu();
        _ || (this.sessionManager = new $0fb0e9cf977607be$var$Ua(this), this.sessionPropsManager = new $0fb0e9cf977607be$var$Na(this, this.sessionManager, this.persistence), this.sessionManager.onSessionId((t, i, e)=>{
            ((null == e ? void 0 : e.activityTimeout) || (null == e ? void 0 : e.sessionPastMaximumLength) || (null == e ? void 0 : e.crossTabAdoption)) && this.Uu();
        })), this.Wu(), this.config.__preview_deferred_init_extensions ? ($0fb0e9cf977607be$var$Je.info("Deferring extension initialization to improve startup performance"), setTimeout(()=>{
            this.Vu(_);
        }, 0)) : ($0fb0e9cf977607be$var$Je.info("Initializing extensions synchronously"), this.Vu(_)), $0fb0e9cf977607be$var$es.DEBUG = $0fb0e9cf977607be$var$es.DEBUG || this.config.debug, $0fb0e9cf977607be$var$es.DEBUG && $0fb0e9cf977607be$var$Je.info("Starting in debug mode", {
            this: this,
            config: e,
            thisC: $0fb0e9cf977607be$var$Ei({}, this.config),
            p: f,
            s: p
        }), this.config.identity_distinct_id && !(null === (n = e.bootstrap) || void 0 === n ? void 0 : n.distinctID) && (e.bootstrap = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, e.bootstrap), {}, {
            distinctID: this.config.identity_distinct_id,
            isIdentifiedID: !0
        }));
        const g = null === (r = e.bootstrap) || void 0 === r ? void 0 : r.distinctID;
        if (this.wu = !!g && !$0fb0e9cf977607be$var$M(g), null === (o = e.bootstrap) || void 0 === o ? void 0 : o.distinctID) {
            const t = e.bootstrap.distinctID, i = this.get_distinct_id(), s = this.persistence.get_property($0fb0e9cf977607be$var$vn);
            if (e.bootstrap.isIdentifiedID && null != i && i !== t && "anonymous" === s) this.identify(t);
            else if (e.bootstrap.isIdentifiedID && null != i && i !== t && "identified" === s) $0fb0e9cf977607be$var$Je.warn("Bootstrap distinctID differs from an already-identified user. The existing identity is preserved. Call reset() before reinitializing if you intend to switch users.");
            else {
                const i = this.config.get_device_id($0fb0e9cf977607be$var$lr()), s = e.bootstrap.isIdentifiedID ? i : t;
                this.persistence.set_property($0fb0e9cf977607be$var$vn, e.bootstrap.isIdentifiedID ? $0fb0e9cf977607be$var$Dn : $0fb0e9cf977607be$var$Fn), this.register({
                    distinct_id: t,
                    $device_id: s
                });
            }
        }
        if (_) this.register_once({
            distinct_id: $0fb0e9cf977607be$var$yn,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            const t = this.config.get_device_id($0fb0e9cf977607be$var$lr());
            this.register_once({
                distinct_id: t,
                $device_id: t
            }, ""), this.persistence.set_property($0fb0e9cf977607be$var$vn, $0fb0e9cf977607be$var$Fn);
        }
        return $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "pageshow", ()=>{
            var t;
            this.Tu = !1, this.Iu || null === (t = this.zu) || void 0 === t || t.resume();
        }), e.segment ? $0fb0e9cf977607be$var$wo(this, ()=>this.Gu()) : this.Gu(), $0fb0e9cf977607be$var$P(this.config._onCapture) && this.config._onCapture !== $0fb0e9cf977607be$var$pu && ($0fb0e9cf977607be$var$Je.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this.config.ip && $0fb0e9cf977607be$var$Je.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this.config.disableDeviceModel || (function() {
            return $0fb0e9cf977607be$var$Ha.apply(this, arguments);
        })().then((t)=>{
            t && this.register({
                [$0fb0e9cf977607be$var$os]: t
            });
        }).catch($0fb0e9cf977607be$var$pu), this;
    }
    Qu(t) {
        const i = t;
        return $0fb0e9cf977607be$var$I(i.name) && $0fb0e9cf977607be$var$P(i.setup);
    }
    Ju(t, i) {
        this.Qu(t) ? i.push(()=>{
            this.Zu().add(t).catch(()=>{
                var i;
                return null === (i = t.dispose) || void 0 === i ? void 0 : i.call(t);
            }).catch((i)=>{
                $0fb0e9cf977607be$var$Je.error(`Failed to dispose browser extension "${t.name}"`, i);
            });
        }) : this.lu.push(t);
    }
    Wu() {
        var t, e, s;
        const n = null !== (t = null === (e = this.config.__extensionClasses) || void 0 === e ? void 0 : e.featureFlags) && void 0 !== t ? t : null === (s = i.__defaultExtensionClasses) || void 0 === s ? void 0 : s.featureFlags;
        var r, o, l;
        n && (this.featureFlags && this.featureFlags instanceof n || (null === (r = this.Ku) || void 0 === r || r.call(this), this.Ku = void 0, this.featureFlags = new n(this)), $0fb0e9cf977607be$var$P(this.featureFlags.onReloading) && $0fb0e9cf977607be$var$P(this.featureFlags.setup) ? this.Ku || (this.Ku = this.featureFlags.onReloading(()=>{
            this.du.emit("featureFlagsReloading", !0);
        }), this.Zu().add(this.featureFlags)) : null === (o = (l = this.featureFlags).initialize) || void 0 === o || o.call(l));
    }
    Vu(t) {
        const e = performance.now(), s = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i.__defaultExtensionClasses), this.config.__extensionClasses), n = [];
        var r, o, l, a, u, h, d;
        s.exceptions && this.lu.push(this.exceptions = null !== (r = this.exceptions) && void 0 !== r ? r : new s.exceptions(this)), s.historyAutocapture && this.lu.push(this.historyAutocapture = new s.historyAutocapture(this)), s.tracingHeaders && this.lu.push(this.tracingHeaders = new s.tracingHeaders(this)), s.siteApps && this.lu.push(this.siteApps = new s.siteApps(this)), s.sessionRecording && !t && this.lu.push(this.sessionRecording = new s.sessionRecording(this)), this.config.disable_scroll_properties || n.push(()=>{
            this.scrollManager.startMeasuringScrollPosition();
        }), s.autocapture && this.Ju(this.autocapture = new s.autocapture(this), n), s.surveys && this.Ju(this.surveys = null !== (o = this.surveys) && void 0 !== o ? o : new s.surveys(this), n), s.logs && this.Ju(this.logs = null !== (l = this.logs) && void 0 !== l ? l : new s.logs(this), n), s.metrics && this.lu.push(this.metrics = null !== (a = this.metrics) && void 0 !== a ? a : new s.metrics(this)), s.conversations && this.lu.push(this.conversations = null !== (u = this.conversations) && void 0 !== u ? u : new s.conversations(this)), s.productTours && this.lu.push(this.productTours = new s.productTours(this)), s.heatmaps && this.lu.push(this.heatmaps = new s.heatmaps(this)), s.webVitalsAutocapture && this.lu.push(this.webVitalsAutocapture = new s.webVitalsAutocapture(this)), s.exceptionObserver && this.lu.push(this.exceptionObserver = new s.exceptionObserver(this)), s.deadClicksAutocapture && this.lu.push(this.deadClicksAutocapture = new s.deadClicksAutocapture(this, $0fb0e9cf977607be$var$mo)), s.toolbar && this.lu.push(this.toolbar = null !== (h = this.toolbar) && void 0 !== h ? h : new s.toolbar(this)), s.experiments && this.lu.push(this.experiments = null !== (d = this.experiments) && void 0 !== d ? d : new s.experiments(this)), this.lu.forEach((t)=>{
            t.initialize && n.push(()=>{
                var i;
                null === (i = t.initialize) || void 0 === i || i.call(t);
            });
        }), n.push(()=>{
            if (this.Xu) {
                const t = this.Xu;
                this.Xu = void 0, this.lu.forEach((i)=>{
                    var e;
                    return null === (e = i.onRemoteConfig) || void 0 === e ? void 0 : e.call(i, t);
                });
            }
        }), this.Yu(n, e);
    }
    Yu(t, i) {
        for(; t.length > 0;){
            if (this.config.__preview_deferred_init_extensions && performance.now() - i >= 30 && t.length > 0) return void setTimeout(()=>{
                this.Yu(t, i);
            }, 0);
            const e = t.shift();
            if (e) try {
                e();
            } catch (t) {
                $0fb0e9cf977607be$var$Je.error("Error initializing extension:", t);
            }
        }
        const e = Math.round(performance.now() - i);
        this.register_for_session({
            [$0fb0e9cf977607be$var$$n]: this.config.__preview_deferred_init_extensions ? "deferred" : "synchronous",
            [$0fb0e9cf977607be$var$Sn]: e
        }), this.config.__preview_deferred_init_extensions && $0fb0e9cf977607be$var$Je.info(`PostHog extensions initialized (${e}ms)`);
    }
    el(t) {
        var i;
        if (!$0fb0e9cf977607be$var$s || !$0fb0e9cf977607be$var$s.body) return $0fb0e9cf977607be$var$Je.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.el(t);
        }, 500);
        if (this.config.__preview_deferred_init_extensions && (this.Xu = t), this.cu = t, this.compression = void 0, t.ok) {
            var e;
            const i = t.config;
            i.supportedCompression && !this.config.disable_compression && (this.compression = $0fb0e9cf977607be$var$b(i.supportedCompression, $0fb0e9cf977607be$export$6a00d17b5aff0af.GZipJS) ? $0fb0e9cf977607be$export$6a00d17b5aff0af.GZipJS : $0fb0e9cf977607be$var$b(i.supportedCompression, $0fb0e9cf977607be$export$6a00d17b5aff0af.Base64) ? $0fb0e9cf977607be$export$6a00d17b5aff0af.Base64 : void 0), (null === (e = i.analytics) || void 0 === e ? void 0 : e.endpoint) && (this.analyticsDefaultEndpoint = i.analytics.endpoint);
        }
        this.set_config({
            person_profiles: this.Du ? this.Du : $0fb0e9cf977607be$var$Nn
        }), null === (i = this.th) || void 0 === i || i.handleRemoteConfig(t), this.lu.forEach((i)=>{
            var e;
            return null === (e = i.onRemoteConfig) || void 0 === e ? void 0 : e.call(i, t);
        });
    }
    Gu() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $0fb0e9cf977607be$var$Je.critical("`loaded` function failed", t);
        }
        if (this.eh(), this.config.internal_or_test_user_hostname && (null == $0fb0e9cf977607be$var$n ? void 0 : $0fb0e9cf977607be$var$n.hostname)) {
            const t = $0fb0e9cf977607be$var$n.hostname, i = this.config.internal_or_test_user_hostname;
            ("string" == typeof i ? t === i : i.test(t)) && this.setInternalOrTestUser();
        }
        this.config.capture_pageview && setTimeout(()=>{
            (this.consent.isOptedIn() || this.yu()) && this.ih();
        }, 1), this.nh = new $0fb0e9cf977607be$var$Ol(this), this.nh.load();
    }
    eh() {
        var t;
        this.is_capturing() && this.config.request_batching && (null === (t = this.Bu) || void 0 === t || t.enable());
    }
    _dom_loaded() {
        this.is_capturing() && $0fb0e9cf977607be$var$qn(this.__request_queue, (t)=>this.Hu(t)), this.__request_queue = [], this.eh();
    }
    _handle_unload() {
        var t, i, e, s, n, r;
        this.Tu = !0, null === (t = this.surveys) || void 0 === t || null === (i = t.handlePageUnload) || void 0 === i || i.call(t), null === (e = this.metrics) || void 0 === e || e.flush("sendBeacon"), this.config.request_batching ? (this.sh() && this.capture($0fb0e9cf977607be$var$Un), null === (s = this.logs) || void 0 === s || s.flushLogs("sendBeacon"), null === (n = this.Bu) || void 0 === n || n.unload(), null === (r = this.zu) || void 0 === r || r.unload()) : this.sh() && this.capture($0fb0e9cf977607be$var$Un, null, {
            transport: "sendBeacon"
        });
    }
    _send_request(t) {
        $0fb0e9cf977607be$var$Ra(this, t);
    }
    Hu(t, i) {
        this.zu ? this.zu.retriableRequest(t, i) : this._send_request(i ? $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
            transport: i
        }) : t);
    }
    _execute_array(t) {
        $0fb0e9cf977607be$var$fu++;
        try {
            let i;
            const e = [], s = [], n = [];
            $0fb0e9cf977607be$var$qn(t, (t)=>{
                if (t) {
                    if (i = t[0], $0fb0e9cf977607be$var$T(i)) n.push(t);
                    else if ($0fb0e9cf977607be$var$P(t)) try {
                        t.call(this);
                    } catch (i) {
                        $0fb0e9cf977607be$var$Je.error("Error executing queued PostHog call", t, i);
                    }
                    else $0fb0e9cf977607be$var$T(t) && "alias" === i ? e.push(t) : $0fb0e9cf977607be$var$T(t) && -1 !== i.indexOf("capture") && $0fb0e9cf977607be$var$P(this[i]) ? n.push(t) : s.push(t);
                }
            });
            const r = function(t, i) {
                $0fb0e9cf977607be$var$qn(t, function(t) {
                    try {
                        if ($0fb0e9cf977607be$var$T(t[0])) {
                            let e = i;
                            $0fb0e9cf977607be$var$Vn(t, function(t) {
                                e = e[t[0]].apply(e, t.slice(1));
                            });
                        } else i[t[0]].apply(i, t.slice(1));
                    } catch (i) {
                        $0fb0e9cf977607be$var$Je.error("Error executing queued PostHog call", t, i);
                    }
                });
            };
            r(e, this), r(s, this), r(n, this);
        } finally{
            $0fb0e9cf977607be$var$fu--;
        }
    }
    push(t) {
        if ($0fb0e9cf977607be$var$fu > 0 && $0fb0e9cf977607be$var$T(t) && $0fb0e9cf977607be$var$I(t[0])) {
            const e = i.prototype[t[0]];
            return void ($0fb0e9cf977607be$var$P(e) && e.apply(this, t.slice(1)));
        }
        this._execute_array([
            t
        ]);
    }
    get rh() {
        return {
            property: $0fb0e9cf977607be$var$us,
            persistenceKey: $0fb0e9cf977607be$var$hs,
            cookieName: "_fbc",
            pattern: $0fb0e9cf977607be$var$xu,
            register: (t, i)=>{
                var e;
                return null === (e = this.persistence) || void 0 === e ? void 0 : e.register({
                    [$0fb0e9cf977607be$var$hs]: {
                        value: t,
                        delivered: i
                    }
                });
            },
            unregister: ()=>{
                var t;
                return null === (t = this.persistence) || void 0 === t ? void 0 : t.unregister($0fb0e9cf977607be$var$hs);
            }
        };
    }
    get oh() {
        return {
            property: $0fb0e9cf977607be$var$ds,
            persistenceKey: $0fb0e9cf977607be$var$cs,
            cookieName: "_fbp",
            pattern: $0fb0e9cf977607be$var$Eu,
            register: (t, i)=>{
                var e;
                return null === (e = this.persistence) || void 0 === e ? void 0 : e.register({
                    [$0fb0e9cf977607be$var$cs]: {
                        value: t,
                        delivered: i
                    }
                });
            },
            unregister: ()=>{
                var t;
                return null === (t = this.persistence) || void 0 === t ? void 0 : t.unregister($0fb0e9cf977607be$var$cs);
            }
        };
    }
    ah(t) {
        var i;
        const e = null === (i = this.persistence) || void 0 === i ? void 0 : i.get_property(t.persistenceKey);
        return $0fb0e9cf977607be$var$I(e) && t.pattern.test(e) ? {
            value: e,
            delivered: !1
        } : $0fb0e9cf977607be$var$C(e) && $0fb0e9cf977607be$var$I(e.value) && t.pattern.test(e.value) ? {
            value: e.value,
            delivered: !0 === e.delivered
        } : void 0;
    }
    uh(t, i, e) {
        return i === (null == e ? void 0 : e.value) ? {
            value: i,
            pending: !e.delivered
        } : (t.register(i, !1), {
            value: i,
            pending: !0
        });
    }
    hh(t) {
        if (!this.config.save_campaign_params || this.yu()) return;
        const i = $0fb0e9cf977607be$var$ir(t.cookieName);
        return $0fb0e9cf977607be$var$I(i) && t.pattern.test(i) ? i : void 0;
    }
    dh(t, i, e, s) {
        if (!this.persistence) return;
        const n = this.rh;
        this.persistence.refreshKey(n.persistenceKey);
        const r = this.ah(n);
        if (s) return void n.unregister();
        if (e) return $0fb0e9cf977607be$var$I(i) && $0fb0e9cf977607be$var$xu.test(i) ? this.uh(n, i, r) : void n.unregister();
        const o = $0fb0e9cf977607be$var$I(t) && $0fb0e9cf977607be$var$Su.test(t) ? t : void 0, l = this.hh(n);
        return l && ((t, i, e)=>{
            const s = t.split(".");
            if (i) return s[3] === i;
            if (!e) return !0;
            const n = e.value.split(".");
            return s[3] === n[3] || Number(s[2]) > Number(n[2]);
        })(l, o, r) ? this.uh(n, l, r) : o ? (null == r ? void 0 : r.value.split(".")[3]) === o ? {
            value: r.value,
            pending: !r.delivered
        } : this.uh(n, `fb.1.${Date.now()}.${o}`, r) : r ? {
            value: r.value,
            pending: !r.delivered
        } : void 0;
    }
    fh(t, i, e) {
        if (!this.persistence) return;
        const s = this.oh;
        this.persistence.refreshKey(s.persistenceKey);
        const n = this.ah(s);
        if (e) return void s.unregister();
        if (i) return $0fb0e9cf977607be$var$I(t) && $0fb0e9cf977607be$var$Eu.test(t) ? this.uh(s, t, n) : void s.unregister();
        const r = this.hh(s);
        return r ? this.uh(s, r, n) : n ? {
            value: n.value,
            pending: !n.delivered
        } : void 0;
    }
    ph(t, i) {
        if (!this.persistence) return;
        this.persistence.refreshKey(t.persistenceKey);
        const e = this.ah(t);
        (null == e ? void 0 : e.value) !== i || e.delivered || t.register(i, !0);
    }
    capture(t, i, e) {
        var s, n;
        if (!(this.__loaded && this.persistence && this.sessionPersistence && this.Bu)) return void $0fb0e9cf977607be$var$Je.uninitializedWarning("posthog.capture");
        if (!this.is_capturing()) return;
        if ($0fb0e9cf977607be$var$R(t) || !$0fb0e9cf977607be$var$I(t)) return void $0fb0e9cf977607be$var$Je.error("No event name provided to posthog.capture");
        if (this.ku(), "$snapshot" === t && this.yu()) return;
        const r = !this.config.opt_out_useragent_filter && this._is_bot();
        if (r && !this.config.__preview_capture_bot_pageviews) return;
        const o = (null == e ? void 0 : e.skip_client_rate_limiting) ? void 0 : this.rateLimiter.clientRateLimitContext();
        if (null == o ? void 0 : o.isRateLimited) return void $0fb0e9cf977607be$var$Je.critical("This capture call is ignored due to client rate limiting.");
        let l;
        (null == i ? void 0 : i.$current_url) && !$0fb0e9cf977607be$var$I(null == i ? void 0 : i.$current_url) && ($0fb0e9cf977607be$var$Je.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == i || delete i.$current_url), "$exception" !== t || (null == e ? void 0 : e.gh) || $0fb0e9cf977607be$var$Je.warn("Using `posthog.capture('$exception')` is unreliable because it does not attach required metadata. Use `posthog.captureException(error)` instead, which attaches required metadata automatically."), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && (l = this.sessionPersistence.update_campaign_params()), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
        const a = new Date, u = (null == e ? void 0 : e.timestamp) || a, h = $0fb0e9cf977607be$var$di(null == e ? void 0 : e.uuid, $0fb0e9cf977607be$var$lr);
        let d = {
            uuid: h,
            event: t,
            properties: this.calculateEventProperties(t, i || {}, u, h)
        };
        "$pageview" === t && this.config.__preview_capture_bot_pageviews && r && (d.event = "$bot_pageview", d.properties.$browser_type = "bot"), o && (d.properties.$lib_rate_limit_remaining_tokens = o.remainingTokens);
        const c = "$feature_flag_called" === t && !1 === d.properties.$feature_flag_has_experiment && !0 === this.get_property("$minimal_flag_called_events");
        (null == e ? void 0 : e.$set) && !c && (d.$set = null == e ? void 0 : e.$set);
        const v = $0fb0e9cf977607be$var$C(null == i ? void 0 : i.$set) ? i.$set : void 0, f = $0fb0e9cf977607be$var$T(null == i ? void 0 : i.$unset) ? i.$unset : [], p = (null == e ? void 0 : e.$unset) || [], _ = (t)=>{
            var i;
            const s = !!(null == e ? void 0 : e.$set) && t in e.$set;
            return {
                hasProvided: s || !!v && t in v,
                provided: s ? null == e || null === (i = e.$set) || void 0 === i ? void 0 : i[t] : null == v ? void 0 : v[t],
                unset: -1 !== f.indexOf(t) || -1 !== p.indexOf(t)
            };
        }, g = _($0fb0e9cf977607be$var$us), m = _($0fb0e9cf977607be$var$ds), b = [
            {
                channel: this.rh,
                hasProvided: g.hasProvided,
                update: this.dh(null == l ? void 0 : l.fbclid, g.provided, g.hasProvided, g.unset)
            },
            {
                channel: this.oh,
                hasProvided: m.hasProvided,
                update: this.fh(m.provided, m.hasProvided, m.unset)
            }
        ];
        for (const { channel: t, hasProvided: i, update: e } of b)e && !0 === d.properties.$process_person_profile && e.pending && !i && !c && (d.$set = $0fb0e9cf977607be$var$Ei({
            [t.property]: e.value
        }, d.$set));
        const y = null == e ? void 0 : e.$unset;
        y && (d.$unset = y);
        const w = c ? void 0 : this.mh(null == e ? void 0 : e.$set_once, t !== $0fb0e9cf977607be$var$Hn, t === $0fb0e9cf977607be$var$zn);
        if (w && (d.$set_once = w), (null == e ? void 0 : e._noTruncate) || (S = this.config.properties_string_max_length, d = function(t, i) {
            const e = new Set;
            return function t(s, n) {
                if (s !== Object(s)) return i ? i(s) : s;
                if (e.has(s)) return;
                let r;
                if (e.add(s), $0fb0e9cf977607be$var$T(s)) r = [], $0fb0e9cf977607be$var$qn(s, (i)=>{
                    r.push(t(i));
                });
                else {
                    const i = {};
                    $0fb0e9cf977607be$var$Vn($0fb0e9cf977607be$var$H(s) ? $0fb0e9cf977607be$var$Yn(s) : s, (s, n)=>{
                        e.has(s) || (i[n] = t(s, n));
                    }), r = i;
                }
                return r;
            }(t);
        }(d, (t)=>$0fb0e9cf977607be$var$I(t) ? t.slice(0, S) : t)), d.timestamp = u, $0fb0e9cf977607be$var$R(null == e ? void 0 : e.timestamp) || (d.properties.$event_time_override_provided = !0, d.properties.$event_time_override_system_time = a), c && (d.properties = ((t, i = [])=>{
            const e = {}, s = (i)=>{
                void 0 !== t[i] && (e[i] = t[i]);
            };
            return $0fb0e9cf977607be$var$fe.forEach(s), i.forEach(s), e;
        })(d.properties, $0fb0e9cf977607be$var$ku)), t === $0fb0e9cf977607be$export$9d7ec1793ca1658e.DISMISSED || t === $0fb0e9cf977607be$export$9d7ec1793ca1658e.SENT) {
            const e = null == i ? void 0 : i[$0fb0e9cf977607be$export$fe4c9af525341543.SURVEY_ID], s = null == i ? void 0 : i[$0fb0e9cf977607be$export$fe4c9af525341543.SURVEY_ITERATION];
            $0fb0e9cf977607be$var$su({
                id: e,
                current_iteration: s
            }), d.$set = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, d.$set), {}, {
                [$0fb0e9cf977607be$var$qa({
                    id: e,
                    current_iteration: s
                }, t === $0fb0e9cf977607be$export$9d7ec1793ca1658e.SENT ? "responded" : "dismissed")]: !0
            });
        } else t === $0fb0e9cf977607be$export$9d7ec1793ca1658e.SHOWN && (d.$set = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, d.$set), {}, {
            [$0fb0e9cf977607be$export$fe4c9af525341543.SURVEY_LAST_SEEN_DATE]: (new Date).toISOString()
        }));
        var S;
        if (t === $0fb0e9cf977607be$export$e5d0052c1e47bfda.SHOWN) {
            const t = null == i ? void 0 : i[$0fb0e9cf977607be$export$eedf6d13bc23d767.TOUR_TYPE];
            t && (d.$set = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, d.$set), {}, {
                [`${$0fb0e9cf977607be$export$eedf6d13bc23d767.TOUR_LAST_SEEN_DATE}/${t}`]: (new Date).toISOString()
            }));
        }
        const x = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, d.properties.$set), d.$set);
        if ($0fb0e9cf977607be$var$O(x) || this.setPersonPropertiesForFlags(x), !$0fb0e9cf977607be$var$F(this.config.before_send)) {
            const t = this.Fs(d);
            if (!t) return;
            d = t, d.uuid = $0fb0e9cf977607be$var$di(d.uuid, $0fb0e9cf977607be$var$lr);
        }
        this.sessionRecording && !this.Au && $0fb0e9cf977607be$var$$u(t) && (this.Au = !0, setTimeout(()=>this.Au = !1, 3e4));
        const E = b.filter(({ channel: t, update: i })=>{
            var e, s, n;
            const r = null !== (e = null === (s = d.$set) || void 0 === s ? void 0 : s[t.property]) && void 0 !== e ? e : $0fb0e9cf977607be$var$C(null === (n = d.properties) || void 0 === n ? void 0 : n.$set) ? d.properties.$set[t.property] : void 0;
            return (null == i ? void 0 : i.pending) && r === i.value;
        });
        this.du.emit("eventCaptured", d);
        const k = null !== (s = null == e ? void 0 : e._url) && void 0 !== s ? s : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint), P = "recordings" === (null == e ? void 0 : e._batchKey) || /\/s\/(?:\?|$)/.test(k), M = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({
            method: "POST",
            url: k,
            data: d,
            compression: "best-available",
            preferSyncCompression: null == e ? void 0 : e.send_instantly,
            timestampMode: P ? "body" : "capture-body",
            batchKey: null == e ? void 0 : e._batchKey
        }, P && (null === (n = d.properties) || void 0 === n ? void 0 : n.$session_id) ? {
            batchGroup: d.properties.$session_id + (d.properties.$window_id ? `-${d.properties.$window_id}` : "")
        } : {}), (null == e ? void 0 : e.transport) ? {
            transport: e.transport
        } : {}), E.length ? {
            fireCallbackOnDrop: !0,
            callback: (t)=>{
                if (t.statusCode >= 200 && 300 > t.statusCode) for (const { channel: t, update: i } of E)this.ph(t, i.value);
            }
        } : {});
        if (!this.config.request_batching || e && !(null == e ? void 0 : e._batchKey) || (null == e ? void 0 : e.send_instantly) || E.length) {
            var A;
            let t;
            !M.transport && !M.callback && $0fb0e9cf977607be$var$O(null !== (A = this.config.request_headers) && void 0 !== A ? A : {}) && this.Tu && (t = "sendBeacon"), this.Hu(M, t);
        } else this.Bu.enqueue(M);
        return d;
    }
    _addCaptureHook(t) {
        return this.on("eventCaptured", (i)=>t(i.event, i));
    }
    getExtension(t) {
        var i;
        return null === (i = this.th) || void 0 === i ? void 0 : i.getExtension(t);
    }
    Zu() {
        var t;
        return null !== (t = this.th) && void 0 !== t ? t : this.th = new $0fb0e9cf977607be$var$cu(this);
    }
    fu(t) {
        this.Ru.push(t);
        let i = !0;
        return ()=>{
            if (!i) return;
            i = !1;
            const e = this.Ru.indexOf(t);
            -1 !== e && this.Ru.splice(e, 1);
        };
    }
    yh(t = !0) {
        var i, e, s;
        return !!(null === (i = this.persistence) || void 0 === i ? void 0 : i.consumeCookieIdentityChange()) && (this.Lu = null, "anonymous" === this.persistence.get_property("$user_state") && (null === (s = this.sessionPersistence) || void 0 === s || s.clear(), this.Eu.clear(), this.bh()), null === (e = this.featureFlags) || void 0 === e || e.reset(), t && this.reloadFeatureFlags(), !0);
    }
    calculateEventProperties(i, e, r, o, l) {
        if (r = r || new Date, !this.persistence || !this.sessionPersistence) return e;
        this.ku(), this.persistence.syncCookieProperties(), this.yh();
        const a = l ? void 0 : this.persistence.remove_event_timer(i);
        let h = $0fb0e9cf977607be$var$Ei({}, e);
        if (h.token = this.config.token, h.$config_defaults = this.config.defaults, this.yu() && (h[$0fb0e9cf977607be$var$wn] = !0), "$snapshot" === i) {
            const t = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, this.persistence.properties()), this.sessionPersistence.properties());
            return h.distinct_id = t.distinct_id, (!$0fb0e9cf977607be$var$I(h.distinct_id) && !$0fb0e9cf977607be$var$D(h.distinct_id) || $0fb0e9cf977607be$var$M(h.distinct_id)) && $0fb0e9cf977607be$var$Je.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), h;
        }
        const d = function(i, e, s, r = !1) {
            var o, l, a, h;
            if (!$0fb0e9cf977607be$var$u) return {};
            const d = i ? [
                ...$0fb0e9cf977607be$var$No,
                ...e || []
            ] : [], [c, v] = $0fb0e9cf977607be$var$Zt($0fb0e9cf977607be$var$u), [p, _] = function(t) {
                for(let i = 0; $0fb0e9cf977607be$var$si.length > i; i++){
                    const [e, s, n] = $0fb0e9cf977607be$var$si[i], r = t.match(e);
                    if (r) {
                        const i = n && t.match(n) || r;
                        return [
                            s,
                            (null == i ? void 0 : i[1]) || ""
                        ];
                    }
                }
                return [
                    "",
                    ""
                ];
            }($0fb0e9cf977607be$var$u), g = function() {
                const t = "u" > typeof navigator ? navigator : void 0;
                return (null == t ? void 0 : t.brave) ? {
                    brave: !0
                } : {};
            }(), m = {};
            $0fb0e9cf977607be$var$R(s) || (m.detectGoogleSearchApp = s);
            const b = {}, y = null === (o = navigator) || void 0 === o || null === (o = o.userAgentData) || void 0 === o ? void 0 : o.platform, w = null === (l = navigator) || void 0 === l ? void 0 : l.maxTouchPoints, S = null == $0fb0e9cf977607be$var$t || null === (a = $0fb0e9cf977607be$var$t.screen) || void 0 === a ? void 0 : a.width, x = null == $0fb0e9cf977607be$var$t || null === (h = $0fb0e9cf977607be$var$t.screen) || void 0 === h ? void 0 : h.height, E = null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.devicePixelRatio;
            $0fb0e9cf977607be$var$R(y) || (b.userAgentDataPlatform = y), $0fb0e9cf977607be$var$R(w) || (b.maxTouchPoints = w), $0fb0e9cf977607be$var$R(S) || (b.screenWidth = S), $0fb0e9cf977607be$var$R(x) || (b.screenHeight = x), $0fb0e9cf977607be$var$R(E) || (b.devicePixelRatio = E);
            const k = $0fb0e9cf977607be$var$Wn($0fb0e9cf977607be$var$Jn({
                $os: c,
                $os_version: v,
                $browser: $0fb0e9cf977607be$var$Jt($0fb0e9cf977607be$var$u, navigator.vendor, g, m),
                $webview_app: p,
                $webview_app_version: _,
                $device: $0fb0e9cf977607be$var$ti($0fb0e9cf977607be$var$u),
                $device_type: $0fb0e9cf977607be$var$ii($0fb0e9cf977607be$var$u, b),
                $timezone: $0fb0e9cf977607be$var$Yo(),
                $timezone_offset: $0fb0e9cf977607be$var$Xo()
            }), {
                $current_url: $0fb0e9cf977607be$var$Mo(r ? $0fb0e9cf977607be$var$vi(null == $0fb0e9cf977607be$var$n ? void 0 : $0fb0e9cf977607be$var$n.href) : null == $0fb0e9cf977607be$var$n ? void 0 : $0fb0e9cf977607be$var$n.href, d, $0fb0e9cf977607be$var$Lo),
                $host: null == $0fb0e9cf977607be$var$n ? void 0 : $0fb0e9cf977607be$var$n.host,
                $pathname: null == $0fb0e9cf977607be$var$n ? void 0 : $0fb0e9cf977607be$var$n.pathname,
                $raw_user_agent: $0fb0e9cf977607be$var$u.length > 1e3 ? $0fb0e9cf977607be$var$u.substring(0, 997) + "..." : $0fb0e9cf977607be$var$u,
                $browser_version: $0fb0e9cf977607be$var$Xt($0fb0e9cf977607be$var$u, navigator.vendor, g, m),
                $browser_language: $0fb0e9cf977607be$var$qo(),
                $browser_language_prefix: $0fb0e9cf977607be$var$Vo(),
                $screen_height: null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.screen.height,
                $screen_width: null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.screen.width,
                $viewport_height: null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.innerHeight,
                $viewport_width: null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.innerWidth,
                $lib: $0fb0e9cf977607be$var$f.LIB_NAME,
                $lib_version: $0fb0e9cf977607be$var$f.LIB_VERSION,
                $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
                $time: Date.now() / 1e3
            });
            return $0fb0e9cf977607be$var$f.SDK_DIST_CHANNEL && (k.$sdk_dist_channel = $0fb0e9cf977607be$var$f.SDK_DIST_CHANNEL), k;
        }(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties, this.config.detect_google_search_app, this.config.disable_capture_url_hashes);
        if (this.sessionManager) {
            const { sessionId: t, windowId: i } = this.sessionManager.checkAndGetSessionAndWindowId(l, r.getTime(), !0);
            h.$session_id = t, h.$window_id = i;
        }
        this.sessionPropsManager && $0fb0e9cf977607be$var$Wn(h, this.sessionPropsManager.getSessionProps());
        try {
            var c;
            if (this.sessionRecording) {
                const t = this.sessionRecording.sdkDebugProperties, e = !this.Au && $0fb0e9cf977607be$var$$u(i);
                for(const i in t)(e || $0fb0e9cf977607be$var$b($0fb0e9cf977607be$var$yu, i)) && (h[i] = t[i]);
            }
            h.$sdk_debug_retry_queue_size = null === (c = this.zu) || void 0 === c ? void 0 : c.length;
        } catch (t) {
            h.$sdk_debug_error_capturing_properties = String(t);
        }
        let v;
        if (this.requestRouter.region === $0fb0e9cf977607be$var$Xa && (h.$lib_custom_api_host = this.config.api_host), v = "$pageview" !== i || l ? "$pageleave" !== i || l ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(r) : this.pageViewManager.doPageView(r, o), h = $0fb0e9cf977607be$var$Wn(h, v), "$pageview" === i && $0fb0e9cf977607be$var$s && (h.title = $0fb0e9cf977607be$var$s.title), !$0fb0e9cf977607be$var$R(a)) {
            const t = r.getTime() - a;
            h.$duration = parseFloat((t / 1e3).toFixed(3));
        }
        $0fb0e9cf977607be$var$u && this.config.opt_out_useragent_filter && (h.$browser_type = this._is_bot() ? "bot" : "browser");
        const p = this.persistence.properties(), _ = this.sessionPersistence.properties(), g = h.$groups, m = p.$groups;
        $0fb0e9cf977607be$var$C(g) && !$0fb0e9cf977607be$var$O(g) && (h.$groups = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, $0fb0e9cf977607be$var$C(m) ? m : {}), g)), $0fb0e9cf977607be$var$Vn([
            "$referrer",
            "$referring_domain"
        ], (t)=>{
            t in p && delete _[t];
        });
        const y = {};
        if (this.Ru.length > 0) for (const t of this.Ru.slice())try {
            $0fb0e9cf977607be$var$Wn(y, t());
        } catch (t) {
            $0fb0e9cf977607be$var$Je.error("Failed to produce browser extension event properties", t);
        }
        h = $0fb0e9cf977607be$var$Wn({}, d, p, _, $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, y), h)), h.$is_identified = this._isIdentified(), $0fb0e9cf977607be$var$T(this.config.property_denylist) ? $0fb0e9cf977607be$var$Vn(this.config.property_denylist, function(t) {
            delete h[t];
        }) : $0fb0e9cf977607be$var$Je.error($0fb0e9cf977607be$var$bu + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        const w = this.config.sanitize_properties;
        w && ($0fb0e9cf977607be$var$Je.error($0fb0e9cf977607be$var$mu), h = w(h, i));
        const S = this._h();
        return h.$process_person_profile = S, S && !l && this.wh("_calculate_event_properties"), h;
    }
    mh(t, i = !0, e = !1) {
        var s;
        if (!this.persistence || !this._h()) return t;
        if (this.Mu && !e) return t;
        const n = this.persistence.get_initial_props(), r = null === (s = this.sessionPropsManager) || void 0 === s ? void 0 : s.getSetOnceProps();
        let o = $0fb0e9cf977607be$var$Wn({}, n, r || {}, t || {});
        const l = this.config.sanitize_properties;
        return l && ($0fb0e9cf977607be$var$Je.error($0fb0e9cf977607be$var$mu), o = l(o, "$set_once")), i && (this.Mu = !0), $0fb0e9cf977607be$var$O(o) ? void 0 : o;
    }
    register(t, i) {
        var e;
        null === (e = this.persistence) || void 0 === e || e.register(t, i);
    }
    register_once(t, i, e) {
        var s;
        null === (s = this.persistence) || void 0 === s || s.register_once(t, i, e);
    }
    register_for_session(t) {
        var i, e;
        null === (i = this.persistence) || void 0 === i || i.syncCookieProperties(), this.yh(), null === (e = this.sessionPersistence) || void 0 === e || e.register(t), Object.keys(t).forEach((t)=>this.Eu.add(t)), this.bh();
    }
    unregister(t) {
        var i;
        null === (i = this.persistence) || void 0 === i || i.unregister(t);
    }
    unregister_for_session(t) {
        var i;
        null === (i = this.sessionPersistence) || void 0 === i || i.unregister(t), this.Eu.delete(t), this.bh();
    }
    kh(t, i) {
        this.register({
            [t]: i
        });
    }
    Uu() {
        this.Eu.forEach((t)=>{
            var i;
            null === (i = this.sessionPersistence) || void 0 === i || i.unregister(t);
        }), this.Eu.clear(), this.bh();
    }
    bh() {
        var t;
        if (!this.Pu) return;
        if ("memory" === this.config.persistence || (null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.hi) || !$0fb0e9cf977607be$var$Pr.Et()) return void $0fb0e9cf977607be$var$Pr.Pt(this.Pu);
        const i = [];
        this.Eu.forEach((t)=>i.push(t)), i.length > 0 ? $0fb0e9cf977607be$var$Pr.$t(this.Pu, i) : $0fb0e9cf977607be$var$Pr.Pt(this.Pu);
    }
    getFeatureFlag(t, i) {
        var e;
        return null === (e = this.featureFlags) || void 0 === e ? void 0 : e.getFeatureFlag(t, i);
    }
    getFeatureFlagPayload(t) {
        var i;
        return null === (i = this.featureFlags) || void 0 === i ? void 0 : i.getFeatureFlagPayload(t);
    }
    getFeatureFlagResult(t, i) {
        var e;
        return null === (e = this.featureFlags) || void 0 === e ? void 0 : e.getFeatureFlagResult(t, i);
    }
    getAllFeatureFlags() {
        var t, i;
        return null !== (t = null === (i = this.featureFlags) || void 0 === i ? void 0 : i.getAllFeatureFlags()) && void 0 !== t ? t : [];
    }
    isFeatureEnabled(t, i) {
        var e, s;
        return null !== (e = null === (s = this.featureFlags) || void 0 === s ? void 0 : s.isFeatureEnabled(t, i)) && void 0 !== e ? e : null == i ? void 0 : i.defaultValue;
    }
    reloadFeatureFlags() {
        var t;
        null === (t = this.featureFlags) || void 0 === t || t.reloadFeatureFlags();
    }
    updateFlags(t, i, e) {
        var s;
        null === (s = this.featureFlags) || void 0 === s || s.updateFlags(t, i, e);
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        var s;
        null === (s = this.featureFlags) || void 0 === s || s.updateEarlyAccessFeatureEnrollment(t, i, e);
    }
    getEarlyAccessFeatures(t, i = !1, e) {
        var s;
        return null === (s = this.featureFlags) || void 0 === s ? void 0 : s.getEarlyAccessFeatures(t, i, e);
    }
    on(t, i) {
        return this.du.on(t, i);
    }
    onFeatureFlags(t) {
        return this.featureFlags ? this.featureFlags.onFeatureFlags(t) : (t([], {}, {
            errorsLoading: !0
        }), ()=>{});
    }
    onSurveysLoaded(t) {
        return this.surveys ? this.surveys.onSurveysLoaded(t) : (t([], {
            isLoaded: !1,
            error: $0fb0e9cf977607be$var$gu
        }), ()=>{});
    }
    onSessionId(t) {
        var i, e;
        return null !== (i = null === (e = this.sessionManager) || void 0 === e ? void 0 : e.onSessionId(t)) && void 0 !== i ? i : ()=>{};
    }
    getSurveys(t, i = !1) {
        this.surveys ? this.surveys.getSurveys(t, i) : t([], {
            isLoaded: !1,
            error: $0fb0e9cf977607be$var$gu
        });
    }
    getActiveMatchingSurveys(t, i = !1) {
        this.surveys ? this.surveys.getActiveMatchingSurveys(t, i) : t([], {
            isLoaded: !1,
            error: $0fb0e9cf977607be$var$gu
        });
    }
    onActiveMatchingSurveysChanged(t) {
        return this.surveys ? this.surveys.onActiveMatchingSurveysChanged(t) : (t([], {
            isLoaded: !1,
            error: $0fb0e9cf977607be$var$gu
        }), ()=>{});
    }
    renderSurvey(t, i) {
        var e;
        null === (e = this.surveys) || void 0 === e || e.renderSurvey(t, i);
    }
    displaySurvey(t, i = $0fb0e9cf977607be$var$ru) {
        var e;
        null === (e = this.surveys) || void 0 === e || e.displaySurvey(t, i);
    }
    cancelPendingSurvey(t) {
        var i;
        null === (i = this.surveys) || void 0 === i || i.cancelPendingSurvey(t);
    }
    canRenderSurvey(t) {
        var i, e;
        return null !== (i = null === (e = this.surveys) || void 0 === e ? void 0 : e.canRenderSurvey(t)) && void 0 !== i ? i : {
            visible: !1,
            disabledReason: $0fb0e9cf977607be$var$gu
        };
    }
    canRenderSurveyAsync(t, i = !1) {
        var e, s;
        return null !== (e = null === (s = this.surveys) || void 0 === s ? void 0 : s.canRenderSurveyAsync(t, i)) && void 0 !== e ? e : Promise.resolve({
            visible: !1,
            disabledReason: $0fb0e9cf977607be$var$gu
        });
    }
    Sh(t) {
        return !t || $0fb0e9cf977607be$var$M(t) ? ($0fb0e9cf977607be$var$Je.critical("Unique user id has not been set in posthog.identify"), !1) : "$posthog_cookieless" === t ? ($0fb0e9cf977607be$var$Je.critical(`The string "${t}" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.`), !1) : ![
            "distinct_id",
            "distinctid"
        ].includes(t.toLowerCase()) && ![
            "undefined",
            "null"
        ].includes(t.toLowerCase()) || ($0fb0e9cf977607be$var$Je.critical(`The string "${t}" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.`), !1);
    }
    identify(t, i, e) {
        if (!this.__loaded || !this.persistence) return $0fb0e9cf977607be$var$Je.uninitializedWarning("posthog.identify");
        if ($0fb0e9cf977607be$var$D(t) && (t = t.toString(), $0fb0e9cf977607be$var$Je.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), !this.Sh(t)) return;
        if (!this.wh("posthog.identify")) return;
        this.ku();
        const s = this.get_distinct_id(), n = this.persistence.syncCookieProperties() && this.get_distinct_id() !== s, r = this.yh(!1), o = this.persistence.Fa();
        let l = !1;
        try {
            const s = this.get_distinct_id();
            this.register({
                $user_id: t
            }), this.get_property("$device_id") || this.register_once({
                $had_persisted_distinct_id: !0,
                $device_id: s
            }, ""), t !== s && t !== this.get_property("__alias") && (this.unregister($0fb0e9cf977607be$var$ls), this.register({
                distinct_id: t
            }));
            const o = (this.persistence.get_property("$user_state") || "anonymous") === $0fb0e9cf977607be$var$Fn, u = t !== s, h = !u && o;
            if (u && o) {
                var a;
                const n = this.config.reuseAnonymousId ? {
                    distinct_id: t
                } : {
                    distinct_id: t,
                    $anon_distinct_id: s
                };
                this.persistence.set_property($0fb0e9cf977607be$var$vn, $0fb0e9cf977607be$var$Dn), this.setPersonPropertiesForFlags({
                    $set: i || {},
                    $set_once: e || {}
                }, !1), this.config.cookieWinsOnConflict && this.persistence.Da(), this.capture("$identify", n, {
                    $set: i || {},
                    $set_once: e || {}
                }) && (this.Lu = $0fb0e9cf977607be$var$Ya(t, i, e)), null === (a = this.featureFlags) || void 0 === a || a.setAnonymousDistinctId(this.config.reuseAnonymousId ? void 0 : s);
            } else if (h) {
                this.persistence.set_property($0fb0e9cf977607be$var$vn, $0fb0e9cf977607be$var$Dn);
                const s = i || {}, n = e || {};
                this.setPersonPropertiesForFlags({
                    $set: s,
                    $set_once: n
                }, !1), this.config.cookieWinsOnConflict && this.persistence.Da(), this.capture("$set", {
                    $set: s,
                    $set_once: n
                }) && (this.Lu = $0fb0e9cf977607be$var$Ya(t, i, e));
            } else (i || e) && this.setPersonProperties(i, e);
            u || n || r ? (this.reloadFeatureFlags(), this.featureFlags ? this.featureFlags.resetFlagCallReported() : this.unregister($0fb0e9cf977607be$var$un)) : h && (i || e) && this.reloadFeatureFlags(), l = !0;
        } finally{
            o && this.persistence.qa(l);
        }
    }
    setPersonProperties(t, i) {
        if (!t && !i) return;
        if (!this.wh("posthog.setPersonProperties")) return;
        const e = $0fb0e9cf977607be$var$Ya(this.get_distinct_id(), t, i);
        this.Lu !== e ? (this.setPersonPropertiesForFlags({
            $set: t || {},
            $set_once: i || {}
        }, !0), this.capture("$set", {
            $set: t || {},
            $set_once: i || {}
        }) && (this.Lu = e)) : $0fb0e9cf977607be$var$Je.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
    }
    unsetPersonProperties(t) {
        var i;
        const e = ($0fb0e9cf977607be$var$T(t) ? t : [
            t
        ]).filter((t)=>$0fb0e9cf977607be$var$I(t) && t.length > 0);
        0 !== e.length && this.wh("posthog.unsetPersonProperties") && (null === (i = this.featureFlags) || void 0 === i || i.unsetPersonPropertiesForFlags(e, !0), this.capture("$set", {
            $unset: e
        }), this.Lu = null);
    }
    group(t, i, e) {
        var s;
        if (!t || !i) return void $0fb0e9cf977607be$var$Je.error("posthog.group requires a group type and group key");
        null === (s = this.persistence) || void 0 === s || s.syncCookieProperties(), this.yh();
        const n = this.getGroups(), r = n[t] !== i;
        if (r && this.resetGroupPropertiesForFlags(t), this.register({
            $groups: $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, n), {}, {
                [t]: i
            })
        }), (r || e) && this._h()) {
            const s = {
                $group_type: t,
                $group_key: i
            };
            e && (s.$group_set = e), this.capture($0fb0e9cf977607be$var$Hn, s);
        }
        e && this.setGroupPropertiesForFlags({
            [t]: e
        }), r && !e && this.reloadFeatureFlags();
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, i = !0) {
        var e;
        null === (e = this.featureFlags) || void 0 === e || e.setPersonPropertiesForFlags(t, i);
    }
    resetPersonPropertiesForFlags(t = !0) {
        var i;
        null === (i = this.featureFlags) || void 0 === i || i.resetPersonPropertiesForFlags(t);
    }
    setGroupPropertiesForFlags(t, i = !0) {
        var e;
        this.wh("posthog.setGroupPropertiesForFlags") && (null === (e = this.featureFlags) || void 0 === e || e.setGroupPropertiesForFlags(t, i));
    }
    resetGroupPropertiesForFlags(t) {
        var i;
        null === (i = this.featureFlags) || void 0 === i || i.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        const i = $0fb0e9cf977607be$var$j(t) ? t : null == t ? void 0 : t.resetDeviceID, e = $0fb0e9cf977607be$var$j(t) || null == t ? void 0 : t.bootstrap;
        this.xh(i, !1, e);
    }
    xh(t, i = !1, e) {
        var s, n, r, o, l, a;
        if ($0fb0e9cf977607be$var$Je.info("reset"), !this.__loaded) return $0fb0e9cf977607be$var$Je.uninitializedWarning("posthog.reset");
        const u = null == e ? void 0 : e.sessionID;
        this.config.bootstrap = e || (null === (s = this.qu) || void 0 === s ? void 0 : s.bootstrap) || {}, null === (n = this.featureFlags) || void 0 === n || null === (r = n.updateConfig) || void 0 === r || r.call(n, this.config, this.il());
        const h = this.get_property($0fb0e9cf977607be$var$rs), d = this.get_property($0fb0e9cf977607be$var$os), c = this.get_property($0fb0e9cf977607be$var$xs);
        null === (o = this.sessionRecording) || void 0 === o || o.flushBeforeIdentityReset();
        const v = this.is_capturing();
        i || this.consent.reset(), i || !v || this.is_capturing() || console.warn("[PostHog.js]", "reset() cleared the stored consent, and capturing is now off because of `opt_out_capturing_by_default`. Call opt_in_capturing() again, and prefer calling reset() before opting in rather than after.");
        const f = null === (l = this.persistence) || void 0 === l || null === (a = l.Fa) || void 0 === a ? void 0 : a.call(l), p = this.Su;
        this.Su = p || i;
        let _ = !1;
        try {
            var g, m, b, y, w, S, x, E, k, T, P, C, O;
            if (null === (g = this.persistence) || void 0 === g || g.clear(), null === (m = this.sessionPersistence) || void 0 === m || m.clear(), this.Eu.clear(), this.bh(), $0fb0e9cf977607be$var$R(c) || null === (T = this.persistence) || void 0 === T || T.register({
                $session_recording_remote_config: c
            }), null === (b = this.surveys) || void 0 === b || b.reset(), null === (y = this.featureFlags) || void 0 === y || y.reset(), null === (w = this.conversations) || void 0 === w || w.reset(), null === (S = this.logs) || void 0 === S || S.reset(), null === (x = this.metrics) || void 0 === x || x.reset(), null === (E = this.persistence) || void 0 === E || E.set_property("$user_state", "anonymous"), null === (k = this.sessionManager) || void 0 === k || k.resetSessionId(), this.Lu = null, "always" === this.config.cookieless_mode) this.register_once({
                distinct_id: $0fb0e9cf977607be$var$yn,
                $device_id: null
            }, "");
            else {
                const i = this.config.get_device_id($0fb0e9cf977607be$var$lr());
                this.register_once({
                    distinct_id: i,
                    $device_id: t ? i : h
                }, ""), t || $0fb0e9cf977607be$var$R(d) || this.register({
                    [$0fb0e9cf977607be$var$os]: d
                });
            }
            if (this.register({
                $last_posthog_reset: (new Date).toISOString()
            }, 1), e) {
                if (e.distinctID && !this.yu() && (null === (O = this.persistence) || void 0 === O || O.set_property("$user_state", e.isIdentifiedID ? "identified" : "anonymous"), this.register({
                    distinct_id: e.distinctID
                })), null === (P = this.featureFlags) || void 0 === P || P.initialize(), !$0fb0e9cf977607be$var$F(u) && !(null === (C = this.sessionManager) || void 0 === C ? void 0 : C.setBootstrapSessionId(u, !0))) {
                    const t = $0fb0e9cf977607be$var$Ei({}, e);
                    delete t.sessionID, this.config.bootstrap = t;
                }
            }
            delete this.config.identity_distinct_id, delete this.config.identity_hash, delete this.config.identity_claims, _ = !0;
        } finally{
            var I, M;
            this.Su = p, f && (null === (I = this.persistence) || void 0 === I || null === (M = I.qa) || void 0 === M || M.call(I, _));
        }
        this.reloadFeatureFlags();
    }
    shutdown(t) {
        var i = this;
        return $0fb0e9cf977607be$var$Y(function*() {
            var t, e, s, n, r, o, l, a;
            if (i.__loaded) {
                i.Iu = !0, i.Zu().dispose(), null === (t = i.sessionRecording) || void 0 === t || t.dispose(), null === (e = i.logs) || void 0 === e || e.flushLogs("sendBeacon"), null === (s = i.metrics) || void 0 === s || s.flush("sendBeacon"), null === (n = i.metrics) || void 0 === n || n.dispose(), null === (r = i.Bu) || void 0 === r || r.unload(), null === (o = i.zu) || void 0 === o || o.unload();
                try {
                    var u;
                    null === (u = i.featureFlags) || void 0 === u || u.destroy();
                } catch (t) {
                    $0fb0e9cf977607be$var$Je.error("Error while destroying feature flags", t);
                }
                null === (l = i.persistence) || void 0 === l || l.destroy(), null === (a = i.sessionPersistence) || void 0 === a || a.destroy();
            } else $0fb0e9cf977607be$var$Je.uninitializedWarning("posthog.shutdown");
        })();
    }
    setIdentity(t, i) {
        var e;
        delete this.config.identity_claims, this.config.identity_distinct_id = t, this.config.identity_hash = i, this.alias(t), null === (e = this.conversations) || void 0 === e || e.$h();
    }
    clearIdentity() {
        var t;
        delete this.config.identity_distinct_id, delete this.config.identity_hash, delete this.config.identity_claims, null === (t = this.conversations) || void 0 === t || t.Ch();
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, i;
        return null !== (t = null === (i = this.sessionManager) || void 0 === i ? void 0 : i.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        const { sessionId: i, sessionStartTimestamp: e } = this.sessionManager.checkAndGetSessionAndWindowId(!0);
        let s = this.requestRouter.endpointFor("ui", `/project/${this.config.token}/replay/${i}`);
        if ((null == t ? void 0 : t.withTimestamp) && e) {
            var n;
            const i = null !== (n = t.timestampLookBack) && void 0 !== n ? n : 10;
            if (!e) return s;
            s += `?t=${Math.max(Math.floor(((new Date).getTime() - e) / 1e3) - i, 0)}`;
        }
        return s;
    }
    alias(t, i) {
        return t === this.get_property("$people_distinct_id") ? ($0fb0e9cf977607be$var$Je.critical("Attempting to create alias for existing People user - aborting."), -2) : this.wh("posthog.alias") ? ($0fb0e9cf977607be$var$R(i) && (i = this.get_distinct_id()), t !== i ? (this.kh($0fb0e9cf977607be$var$ls, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: i
        })) : ($0fb0e9cf977607be$var$Je.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        const i = $0fb0e9cf977607be$var$Ei({}, this.config);
        if ($0fb0e9cf977607be$var$C(t)) {
            var e, s, n, r, o, l, a, u, h, d, c, v, f;
            $0fb0e9cf977607be$var$Wn(this.config, $0fb0e9cf977607be$var$Ru(t));
            const b = this.Cu();
            if (this.persistence) {
                const t = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence;
                var p, _;
                if (t && this.sessionPersistence !== this.persistence && (null === (p = this.sessionPersistence) || void 0 === p || p.remove(), null === (_ = this.sessionPersistence) || void 0 === _ || _.destroy()), this.persistence.update_config(this.config, i, b), t) this.sessionPersistence = this.persistence;
                else if (this.sessionPersistence === this.persistence) this.sessionPersistence = new $0fb0e9cf977607be$var$hl($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, this.config), {}, {
                    persistence: "sessionStorage"
                }), b, !1);
                else {
                    var g;
                    null === (g = this.sessionPersistence) || void 0 === g || g.update_config($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, this.config), {}, {
                        persistence: "sessionStorage"
                    }), $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i), {}, {
                        persistence: "sessionStorage"
                    }), b);
                }
            }
            const y = this.Nu(this.config.debug);
            var m;
            $0fb0e9cf977607be$var$j(y) && (this.config.debug = y), $0fb0e9cf977607be$var$j(this.config.debug) && (this.config.debug ? ($0fb0e9cf977607be$var$es.DEBUG = !0, $0fb0e9cf977607be$var$fr.Et() && $0fb0e9cf977607be$var$fr.$t("ph_debug", !0), $0fb0e9cf977607be$var$Je.info("set_config", {
                config: t,
                oldConfig: i,
                newConfig: $0fb0e9cf977607be$var$Ei({}, this.config)
            })) : ($0fb0e9cf977607be$var$es.DEBUG = !1, $0fb0e9cf977607be$var$fr.Et() && $0fb0e9cf977607be$var$fr.Pt("ph_debug"))), null === (e = this.featureFlags) || void 0 === e || null === (s = e.updateConfig) || void 0 === s || s.call(e, this.config, this.il()), null === (n = this.exceptionObserver) || void 0 === n || n.onConfigChange(), null === (r = this.exceptions) || void 0 === r || r.onConfigChange(), null === (o = this.metrics) || void 0 === o || o.onConfigChange(), null === (l = this.sessionRecording) || void 0 === l || l.startIfEnabledOrStop(), null === (a = this.tracingHeaders) || void 0 === a || a.startIfEnabledOrStop(), null === (u = this.autocapture) || void 0 === u || u.startIfEnabled(), null === (h = this.heatmaps) || void 0 === h || h.startIfEnabled(), ("capture_pageview" in t || "disable_capture_url_hashes" in t) && (null === (m = this.historyAutocapture) || void 0 === m || m.startIfEnabledOrStop()), null === (d = this.exceptionObserver) || void 0 === d || d.startIfEnabledOrStop(), null === (c = this.deadClicksAutocapture) || void 0 === c || c.startIfEnabledOrStop(), null === (v = this.surveys) || void 0 === v || v.loadIfEnabled(), this.xu(), null === (f = this.externalIntegrations) || void 0 === f || f.startIfEnabledOrStop(), !i.segment && this.config.segment && this.persistence && $0fb0e9cf977607be$var$wo(this, $0fb0e9cf977607be$var$pu, !1);
        }
    }
    _overrideSDKInfo(t, i) {
        $0fb0e9cf977607be$var$es.LIB_NAME = t, $0fb0e9cf977607be$var$es.LIB_VERSION = i;
    }
    startSessionRecording(t) {
        const i = !0 === t, e = {
            sampling: i || !!(null == t ? void 0 : t.sampling),
            linked_flag: i || !!(null == t ? void 0 : t.linked_flag),
            url_trigger: i || !!(null == t ? void 0 : t.url_trigger),
            event_trigger: i || !!(null == t ? void 0 : t.event_trigger)
        };
        var s, n, r, o, l;
        Object.values(e).some(Boolean) && (null === (s = this.sessionManager) || void 0 === s || s.checkAndGetSessionAndWindowId(), e.sampling && (null === (n = this.sessionRecording) || void 0 === n || n.overrideSampling()), e.linked_flag && (null === (r = this.sessionRecording) || void 0 === r || r.overrideLinkedFlag()), e.url_trigger && (null === (o = this.sessionRecording) || void 0 === o || o.overrideTrigger("url")), e.event_trigger && (null === (l = this.sessionRecording) || void 0 === l || l.overrideTrigger("event")));
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !!(null === (t = this.sessionRecording) || void 0 === t ? void 0 : t.started);
    }
    captureException(t, i) {
        try {
            if (!this.exceptions) return;
            const e = this.exceptions.buildProperties(t, {
                handled: !0,
                syntheticException: new Error("PostHog syntheticException")
            });
            return this.exceptions.sendExceptionEvent($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, e), i));
        } catch (t) {
            return;
        }
    }
    addExceptionStep(t, i) {
        var e;
        null === (e = this.exceptions) || void 0 === e || e.addExceptionStep(t, i);
    }
    captureLog(t) {
        var i;
        null === (i = this.logs) || void 0 === i || i.captureLog(t);
    }
    get logger() {
        var t, e;
        return null !== (t = null === (e = this.logs) || void 0 === e ? void 0 : e.logger) && void 0 !== t ? t : i.Th;
    }
    startExceptionAutocapture(t) {
        this.set_config({
            capture_exceptions: null == t || t
        });
    }
    stopExceptionAutocapture() {
        this.set_config({
            capture_exceptions: !1
        });
    }
    loadToolbar(t) {
        var i, e;
        return null !== (i = null === (e = this.toolbar) || void 0 === e ? void 0 : e.loadToolbar(t)) && void 0 !== i && i;
    }
    get_property(t) {
        var i;
        return null === (i = this.persistence) || void 0 === i ? void 0 : i.props[t];
    }
    getSessionProperty(t) {
        var i;
        return null === (i = this.sessionPersistence) || void 0 === i ? void 0 : i.props[t];
    }
    toString() {
        var t;
        let i = null !== (t = this.config.name) && void 0 !== t ? t : $0fb0e9cf977607be$var$Tu;
        return i !== $0fb0e9cf977607be$var$Tu && (i = "posthog." + i), i;
    }
    _isIdentified() {
        var t, i;
        return "identified" === (null === (t = this.persistence) || void 0 === t ? void 0 : t.get_property("$user_state")) || "identified" === (null === (i = this.sessionPersistence) || void 0 === i ? void 0 : i.get_property("$user_state"));
    }
    _h() {
        var t, i;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $0fb0e9cf977607be$var$O(this.getGroups()) && !(null === (t = this.persistence) || void 0 === t || null === (t = t.props) || void 0 === t ? void 0 : t.__alias) && !(null === (i = this.persistence) || void 0 === i || null === (i = i.props) || void 0 === i ? void 0 : i.$epp));
    }
    sh() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && !!this.config.capture_pageview;
    }
    createPersonProfile() {
        this._h() || this.wh("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    setInternalOrTestUser() {
        this.wh("posthog.setInternalOrTestUser") && this.setPersonProperties({
            $internal_or_test_user: !0
        });
    }
    wh(t) {
        return "never" === this.config.person_profiles ? ($0fb0e9cf977607be$var$Je.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.bu(), this.kh($0fb0e9cf977607be$var$bn, !0), !0);
    }
    Cu() {
        if ("always" === this.config.cookieless_mode) return !0;
        const t = this.consent.isOptedOut();
        return this.config.disable_persistence || t && !(!this.config.opt_out_persistence_by_default && "on_reject" !== this.config.cookieless_mode);
    }
    xu() {
        var t, i;
        const e = this.Cu();
        var s, n, r;
        return this.is_capturing() || null === (s = this.logs) || void 0 === s || s.Ih(), (null === (t = this.persistence) || void 0 === t ? void 0 : t.hi) !== e && (null === (n = this.persistence) || void 0 === n || n.set_disabled(e)), (null === (i = this.sessionPersistence) || void 0 === i ? void 0 : i.hi) !== e && (null === (r = this.sessionPersistence) || void 0 === r || r.set_disabled(e)), this.bh(), e;
    }
    opt_in_capturing(t) {
        var e;
        if ("always" !== this.config.cookieless_mode) {
            if (this.yu()) {
                var s, n, r, o, l, a;
                null === (s = this.sessionRecording) || void 0 === s || s.dispose({
                    discardBufferedEvents: !0
                }), this.xh(!0, !0), null === (n = this.sessionManager) || void 0 === n || n.destroy(), null === (r = this.pageViewManager) || void 0 === r || r.destroy(), this.sessionManager = new $0fb0e9cf977607be$var$Ua(this), this.pageViewManager = new $0fb0e9cf977607be$var$Eo(this), this.persistence && (this.sessionPropsManager = new $0fb0e9cf977607be$var$Na(this, this.sessionManager, this.persistence));
                const t = null !== (o = null === (l = this.config.__extensionClasses) || void 0 === l ? void 0 : l.sessionRecording) && void 0 !== o ? o : null === (a = i.__defaultExtensionClasses) || void 0 === a ? void 0 : a.sessionRecording;
                var u, h;
                t && (this.sessionRecording = this.mu(this.sessionRecording, new t(this)), this.cu && (null === (u = this.sessionRecording) || void 0 === u || null === (h = u.onRemoteConfig) || void 0 === h || h.call(u, this.cu)));
            }
            var d, c;
            this.consent.optInOut(!0), this.xu(), this.eh(), null === (e = this.sessionRecording) || void 0 === e || e.startIfEnabledOrStop(), "on_reject" == this.config.cookieless_mode && (null === (d = this.surveys) || void 0 === d || d.loadIfEnabled()), ($0fb0e9cf977607be$var$R(null == t ? void 0 : t.captureEventName) || (null == t ? void 0 : t.captureEventName)) && this.capture(null !== (c = null == t ? void 0 : t.captureEventName) && void 0 !== c ? c : "$opt_in", null == t ? void 0 : t.captureProperties, {
                send_instantly: !0
            }), this.config.capture_pageview && this.ih();
        } else $0fb0e9cf977607be$var$Je.warn($0fb0e9cf977607be$var$_u);
    }
    opt_out_capturing() {
        "always" !== this.config.cookieless_mode ? (this.consent.optInOut(!1), this.xu(), "on_reject" === this.config.cookieless_mode && this.$u()) : $0fb0e9cf977607be$var$Je.warn($0fb0e9cf977607be$var$_u);
    }
    $u() {
        var t, i;
        const e = this.sessionRecording;
        null == e || e.dispose({
            discardBufferedEvents: !0
        }), "$posthog_cookieless" !== this.get_distinct_id() && this.xh(!0, !0), this.register({
            distinct_id: $0fb0e9cf977607be$var$yn,
            $device_id: null
        }), this.gu(e), this.sessionRecording = void 0, null === (t = this.sessionManager) || void 0 === t || t.destroy(), null === (i = this.pageViewManager) || void 0 === i || i.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, this.config.capture_pageview && this.ih(), this.eh();
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    get_explicit_consent_status() {
        const t = this.consent.consent;
        return 1 === t ? "granted" : 0 === t ? "denied" : "pending";
    }
    is_capturing() {
        return !this.Su && ("always" === this.config.cookieless_mode || ("on_reject" === this.config.cookieless_mode ? this.consent.isRejected() || this.consent.isOptedIn() : !this.has_opted_out_capturing()));
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.xu();
    }
    _is_bot() {
        return $0fb0e9cf977607be$var$e ? $0fb0e9cf977607be$var$za($0fb0e9cf977607be$var$e, this.config.custom_blocked_useragents) : void 0;
    }
    ih() {
        $0fb0e9cf977607be$var$s && ("visible" === $0fb0e9cf977607be$var$s.visibilityState ? this.Ou || (this.Ou = !0, this.capture($0fb0e9cf977607be$var$Bn, {
            title: $0fb0e9cf977607be$var$s.title
        }, {
            send_instantly: !0
        }), this.Fu && ($0fb0e9cf977607be$var$s.removeEventListener($0fb0e9cf977607be$var$jn, this.Fu), this.Fu = null)) : this.Fu || (this.Fu = this.ih.bind(this), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, $0fb0e9cf977607be$var$jn, this.Fu)));
    }
    debug(i) {
        !1 === i ? (null == $0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$t.console.log("You've disabled debug mode."), this.set_config({
            debug: !1
        })) : (null == $0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({
            debug: !0
        }));
    }
    il() {
        const t = this.qu || {};
        return "advanced_disable_flags" in t ? !!t.advanced_disable_flags : !1 !== this.config.advanced_disable_flags ? !!this.config.advanced_disable_flags : !0 === this.config.advanced_disable_decide ? ($0fb0e9cf977607be$var$Je.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : function(t, i, e, s, n) {
            const r = i in t && !$0fb0e9cf977607be$var$F(t[i]), o = e in t && !$0fb0e9cf977607be$var$F(t[e]);
            return r ? t[i] : !!o && (n && n.warn(`Config field '${e}' is deprecated. Please use '${i}' instead. The old field will be removed in a future major version.`), t[e]);
        }(t, "advanced_disable_flags", "advanced_disable_decide", 0, $0fb0e9cf977607be$var$Je);
    }
    Fs(t) {
        var i;
        if ($0fb0e9cf977607be$var$F(this.config.before_send)) return t;
        const e = Object.keys(null !== (i = t.properties) && void 0 !== i ? i : {}).filter($0fb0e9cf977607be$var$B), s = $0fb0e9cf977607be$var$T(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ];
        let n = t;
        for (const i of s)try {
            if (n = i(n), $0fb0e9cf977607be$var$F(n)) {
                const i = `Event '${t.event}' was rejected in beforeSend function`;
                return $0fb0e9cf977607be$var$L(t.event) ? $0fb0e9cf977607be$var$Je.warn(`${i}. This can cause unexpected behavior.`) : $0fb0e9cf977607be$var$Je.info(i), null;
            }
            n.properties && !$0fb0e9cf977607be$var$O(n.properties) || $0fb0e9cf977607be$var$Je.warn(`Event '${t.event}' has no properties after beforeSend function, this is likely an error.`);
        } catch (i) {
            return $0fb0e9cf977607be$var$Je.error(`Error in beforeSend function for event '${t.event}':`, i), null;
        }
        for (const i of e)if (n.properties && $0fb0e9cf977607be$var$F(n.properties[i])) return $0fb0e9cf977607be$var$Je.warn(`Event '${t.event}' had its '${i}' property removed in a beforeSend function. This property is required for ingestion, so the event will be dropped.`), null;
        return n;
    }
    getPageViewId() {
        var t;
        return null === (t = this.pageViewManager.Wo) || void 0 === t ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, i) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: i
        });
    }
    captureTraceMetric(t, i, e) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: i,
            $ai_metric_value: String(e)
        });
    }
    Nu(t) {
        const i = $0fb0e9cf977607be$var$j(t) && !t, e = $0fb0e9cf977607be$var$fr.Et() && "true" === $0fb0e9cf977607be$var$fr.Ot("ph_debug");
        return !i && (!!e || t);
    }
};
$0fb0e9cf977607be$export$a9d6b9cbf49b8241.__defaultExtensionClasses = {}, $0fb0e9cf977607be$export$a9d6b9cbf49b8241.Th = (()=>{
    const t = ()=>{};
    return {
        trace: t,
        debug: t,
        info: t,
        warn: t,
        error: t,
        fatal: t
    };
})(), function(t, i) {
    for(let e = 0; i.length > e; e++)t.prototype[i[e]] = $0fb0e9cf977607be$var$Kn(t.prototype[i[e]]);
}($0fb0e9cf977607be$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $0fb0e9cf977607be$var$Au = class {
    constructor(t){
        this.disabled = !1 === t;
        const i = $0fb0e9cf977607be$var$C(t) ? t : {};
        this.thresholdPx = i.threshold_px || 30, this.timeoutMs = i.timeout_ms || 1e3, this.clickCount = i.click_count || 3, this.clicks = [];
    }
    isRageClick(t, i, e) {
        if (this.disabled) return !1;
        const s = this.clicks[this.clicks.length - 1];
        if (s && Math.abs(t - s.x) + Math.abs(i - s.y) < this.thresholdPx && this.timeoutMs > e - s.timestamp) {
            if (this.clicks.push({
                x: t,
                y: i,
                timestamp: e
            }), this.clicks.length === this.clickCount) return !0;
        } else this.clicks = [
            {
                x: t,
                y: i,
                timestamp: e
            }
        ];
        return !1;
    }
};
const $0fb0e9cf977607be$var$Fu = "$copy_autocapture", $0fb0e9cf977607be$var$Du = $0fb0e9cf977607be$var$Ye("[AutoCapture]");
function $0fb0e9cf977607be$var$Nu(t, i) {
    return i.length > t ? i.slice(0, t) + "..." : i;
}
function $0fb0e9cf977607be$var$ju(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    let i = t;
    do i = i.previousSibling;
    while (i && !$0fb0e9cf977607be$var$Ir(i));
    return i;
}
function $0fb0e9cf977607be$var$Lu(i, { e: e, maskAllElementAttributes: s, maskAllText: n, elementAttributeIgnoreList: r, elementsChainAsString: o, disableCaptureUrlHashes: l }) {
    var a, u;
    if (!$0fb0e9cf977607be$var$Ir(i)) return {
        props: {}
    };
    const h = [
        i
    ], d = new Set([
        i
    ]);
    let c = i;
    for(; c.parentNode && !$0fb0e9cf977607be$var$Mr(c, "body") && 1e3 > h.length;){
        if ($0fb0e9cf977607be$var$Fr(c.parentNode)) {
            const t = c.parentNode.host;
            if (d.has(t)) break;
            d.add(t), h.push(t), c = t;
            continue;
        }
        if (!$0fb0e9cf977607be$var$Ir(c.parentNode)) break;
        if (d.has(c.parentNode)) break;
        d.add(c.parentNode), h.push(c.parentNode), c = c.parentNode;
    }
    const v = "click" === e.type && "http://www.w3.org/2000/svg" === i.namespaceURI ? h.findIndex((t)=>$0fb0e9cf977607be$var$Mr(t, "button") || $0fb0e9cf977607be$var$Mr(t, "a")) : -1;
    v > 0 && (n = n || h.slice(0, v + 1).some((t)=>!$0fb0e9cf977607be$var$io(t) || $0fb0e9cf977607be$var$eo(t)));
    const f = [], p = {};
    let _, g = !1, m = !1;
    if ($0fb0e9cf977607be$var$Vn(h, (t)=>{
        const i = $0fb0e9cf977607be$var$io(t);
        if ($0fb0e9cf977607be$var$Mr(t, "a") && !s && !(null == r ? void 0 : r.includes("href"))) {
            const e = t.getAttribute("href");
            g = !!(i && e && $0fb0e9cf977607be$var$ho(e)) && (l ? $0fb0e9cf977607be$var$vi(e) : e);
        }
        $0fb0e9cf977607be$var$b($0fb0e9cf977607be$var$jr(t), "ph-no-capture") && (m = !0), f.push(function(t, i, e, s, n = !1) {
            const r = t.tagName.toLowerCase(), o = {
                tag_name: r
            };
            $0fb0e9cf977607be$var$zr.indexOf(r) > -1 && !e && (o.$el_text = "a" === r.toLowerCase() || "button" === r.toLowerCase() ? $0fb0e9cf977607be$var$Nu(1024, $0fb0e9cf977607be$var$co(t)) : $0fb0e9cf977607be$var$Nu(1024, $0fb0e9cf977607be$var$Br(t)));
            const l = $0fb0e9cf977607be$var$jr(t);
            i || (null == s ? void 0 : s.includes("class")) || 0 >= l.length || (o.classes = l.filter(function(t) {
                return "" !== t;
            })), $0fb0e9cf977607be$var$Vn(t.attributes, function(e) {
                var r;
                if ((!$0fb0e9cf977607be$var$eo(t) || -1 !== [
                    "name",
                    "id",
                    "class",
                    "aria-label"
                ].indexOf(e.name)) && !(null == s ? void 0 : s.includes(e.name)) && !i && $0fb0e9cf977607be$var$ho(e.value) && (!$0fb0e9cf977607be$var$I(r = e.name) || "_ngcontent" !== r.substring(0, 10) && "_nghost" !== r.substring(0, 7))) {
                    let t = e.value;
                    "class" === e.name && (t = $0fb0e9cf977607be$var$Dr(t).join(" ")), o["attr__" + e.name] = $0fb0e9cf977607be$var$Nu(1024, "href" === e.name && n ? $0fb0e9cf977607be$var$vi(t) : t);
                }
            });
            let a = 1, u = 1, h = t;
            for(; h = $0fb0e9cf977607be$var$ju(h);)a++, h.tagName === t.tagName && u++;
            return o.nth_child = a, o.nth_of_type = u, o;
        }(t, s, n, r, l)), $0fb0e9cf977607be$var$Vn(function(t) {
            if (!$0fb0e9cf977607be$var$io(t)) return {};
            const i = {};
            return $0fb0e9cf977607be$var$Vn(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    const e = t.name.replace("data-ph-capture-attribute-", ""), s = t.value;
                    e && s && $0fb0e9cf977607be$var$ho(s) && (i[e] = s);
                }
            }), i;
        }(t), (t, i)=>{
            ({}).hasOwnProperty.call(p, i) || (p[i] = t);
        });
    }), m) return {
        props: {},
        explicitNoCapture: m
    };
    if (v > 0 && (i = h[v], f.splice(0, v)), n || (f[0].$el_text = $0fb0e9cf977607be$var$Mr(i, "a") || $0fb0e9cf977607be$var$Mr(i, "button") ? $0fb0e9cf977607be$var$co(i) : $0fb0e9cf977607be$var$Br(i)), g) {
        var y, w;
        f[0].attr__href = g;
        const i = null === (y = $0fb0e9cf977607be$var$Ro(g)) || void 0 === y ? void 0 : y.host, e = null == $0fb0e9cf977607be$var$t || null === (w = $0fb0e9cf977607be$var$t.location) || void 0 === w ? void 0 : w.host;
        i && e && i !== e && (_ = g);
    }
    var S, x;
    return {
        props: $0fb0e9cf977607be$var$Wn((x = e.type, {
            $event_type: x,
            $ce_version: 1
        }), o ? {} : {
            $elements: f
        }, {
            $elements_chain: (S = f, $0fb0e9cf977607be$var$T(S) ? function(t) {
                return t.map((t)=>{
                    var i, e;
                    let s = "";
                    if (t.tag_name && (s += t.tag_name), t.attr_class) {
                        t.attr_class.sort();
                        for (const i of t.attr_class)s += `.${i.replace(/"/g, "")}`;
                    }
                    const n = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t.text ? {
                        text: t.text
                    } : {}), {}, {
                        "nth-child": null !== (i = t.nth_child) && void 0 !== i ? i : 0,
                        "nth-of-type": null !== (e = t.nth_of_type) && void 0 !== e ? e : 0
                    }, t.href ? {
                        href: t.href
                    } : {}), t.attr_id ? {
                        attr_id: t.attr_id
                    } : {}), t.attributes), r = {};
                    return $0fb0e9cf977607be$var$Gn(n).sort(([t], [i])=>(function(t, i) {
                            return i > t ? -1 : t > i ? 1 : 0;
                        })(t, i)).forEach(([t, i])=>r[$0fb0e9cf977607be$var$fo(t.toString())] = $0fb0e9cf977607be$var$fo(i.toString())), s += ":", s += $0fb0e9cf977607be$var$Gn(r).map(([t, i])=>`${t}="${i}"`).join(""), s;
                }).join(";");
            }(function(t) {
                return t.map((t)=>{
                    var i, e;
                    const s = {
                        text: null === (i = t.$el_text) || void 0 === i ? void 0 : i.slice(0, 400),
                        tag_name: t.tag_name,
                        href: null === (e = t.attr__href) || void 0 === e ? void 0 : e.slice(0, 2048),
                        attr_class: $0fb0e9cf977607be$var$po(t),
                        attr_id: t.attr__id,
                        nth_child: t.nth_child,
                        nth_of_type: t.nth_of_type,
                        attributes: {}
                    };
                    return $0fb0e9cf977607be$var$Gn(t).filter(([t])=>0 === t.indexOf("attr__")).forEach(([t, i])=>s.attributes[t] = i), s;
                });
            }(S)) : "")
        }, (null === (a = f[0]) || void 0 === a ? void 0 : a.$el_text) ? {
            $el_text: null === (u = f[0]) || void 0 === u ? void 0 : u.$el_text
        } : {}, _ && "click" === e.type ? {
            $external_click_url: _
        } : {}, p),
        target: i
    };
}
var $0fb0e9cf977607be$var$Bu = class {
    do() {
        this.vo = void 0, clearTimeout(this.fo), this.fo = void 0;
    }
    po(t) {
        var i;
        if (!$0fb0e9cf977607be$var$io(t)) return !0;
        const e = null !== (i = this.mo().css_selector_ignorelist) && void 0 !== i ? i : $0fb0e9cf977607be$var$Wr, s = new Set;
        let n = t;
        for(; n;){
            if (s.size >= 1e3 || s.has(n)) return !0;
            s.add(n);
            const t = n, i = $0fb0e9cf977607be$var$jr(t);
            if ($0fb0e9cf977607be$var$b(i, "ph-no-capture") || $0fb0e9cf977607be$var$b(i, "ph-sensitive") || $0fb0e9cf977607be$var$eo(t) || e.some((i)=>$0fb0e9cf977607be$var$Hr(t, i))) return !0;
            const r = n.parentNode;
            n = $0fb0e9cf977607be$var$Fr(r) ? r.host : r && $0fb0e9cf977607be$var$Ir(r) ? r : null;
        }
        return !1;
    }
    yo(t) {
        if (!this.isEnabled || "pointercancel" === t.type) return void this.do();
        if ("pointerdown" === t.type) {
            this.do();
            const e = $0fb0e9cf977607be$var$Ur(t);
            var i;
            return void (t.isPrimary && 0 === t.button && !t.ctrlKey && e && $0fb0e9cf977607be$var$Ir(e) && (this.vo = {
                target: e,
                excluded: this.po(e),
                id: t.pointerId,
                x: t.clientX,
                y: t.clientY,
                released: !1,
                distinctId: null === (i = this.bo) || void 0 === i ? void 0 : i.distinctId
            }));
        }
        const e = this.vo;
        e && (t.pointerId !== e.id || Math.abs(t.clientX - e.x) > 5 || Math.abs(t.clientY - e.y) > 5 ? this.do() : "pointerup" === t.type && (e.released = !0, this.fo = setTimeout(()=>this.do(), 0)));
    }
    _o(t) {
        var i;
        const e = this.vo;
        this.do();
        const n = $0fb0e9cf977607be$var$Ur(t);
        if ((null == e ? void 0 : e.released) && e.target.isConnected && e.distinctId === (null === (i = this.bo) || void 0 === i ? void 0 : i.distinctId) && t.pointerId === e.id && (t.detail > 0 || "touch" === t.pointerType || "pen" === t.pointerType) && 0 === t.button && 5 >= Math.abs(t.clientX - e.x) && 5 >= Math.abs(t.clientY - e.y) && n && ($0fb0e9cf977607be$var$Mr(n, "html") || $0fb0e9cf977607be$var$Mr(n, "body"))) {
            var r;
            if (e.excluded) return null;
            const t = null !== (r = this.mo().css_selector_ignorelist) && void 0 !== r ? r : $0fb0e9cf977607be$var$Wr;
            return [
                n,
                null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.documentElement,
                null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.body
            ].some((i)=>{
                if (!i) return !1;
                const e = $0fb0e9cf977607be$var$jr(i);
                return $0fb0e9cf977607be$var$b(e, "ph-no-capture") || $0fb0e9cf977607be$var$b(e, "ph-sensitive") || !$0fb0e9cf977607be$var$io(i) || $0fb0e9cf977607be$var$eo(i) || t.some((t)=>$0fb0e9cf977607be$var$Hr(i, t));
            }) ? null : e.target;
        }
    }
    constructor(t){
        this.wo = t, this.name = "autocapture", this.ko = !1, this.So = null, this.xo = !1, this.$o = new Map, this.Co = !1, this.Mr = {
            enabled: !1,
            rageclick: !1,
            maskAllElementAttributes: !1,
            maskAllText: !1,
            disableCaptureUrlHashes: !1,
            remoteRequestsDisabled: !1
        }, this.To = !1, this.wo.refresh(this.Mr), this.rageclicks = new $0fb0e9cf977607be$var$Au(this.Mr.rageclick), this.Io = null;
    }
    setup(t) {
        this.Mo(), this.bo = t;
        const i = t.onRemoteConfig(this.onRemoteConfig.bind(this));
        this.To ? i.dispose() : (this.Eo = i, this.startIfEnabled());
    }
    dispose() {
        var t;
        this.To || (this.To = !0, this.bo = void 0, null === (t = this.Eo) || void 0 === t || t.dispose(), this.Eo = void 0, this.$o.clear(), this.Io = null, this.Po());
    }
    mo() {
        return this.wo.refresh(this.Mr), this.Mr;
    }
    Mo() {
        var t, i;
        return this.mo(), this.Mr.url_allowlist = null === (t = this.Mr.url_allowlist) || void 0 === t ? void 0 : t.map((t)=>new RegExp(t)), this.Mr.url_ignorelist = null === (i = this.Mr.url_ignorelist) || void 0 === i ? void 0 : i.map((t)=>new RegExp(t)), this.Mr;
    }
    Ro() {
        if (!this.isBrowserSupported()) return void $0fb0e9cf977607be$var$Du.info("Disabling Automatic Event Collection because this browser is not supported");
        if (!$0fb0e9cf977607be$var$t || !$0fb0e9cf977607be$var$s) return;
        const i = this.Ao = (i)=>{
            i = i || (null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.event);
            try {
                if ("blur" === i.type) return void this.do();
                if (0 === i.type.indexOf("pointer")) return void this.yo(i);
                const t = "click" === i.type ? this._o(i) : void 0;
                if ($0fb0e9cf977607be$var$A(t)) return;
                this.Oo(i, "$autocapture", t);
            } catch (t) {
                $0fb0e9cf977607be$var$Du.error("Failed to capture event", t);
            }
        };
        if ($0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "blur", i), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, "submit", i, {
            capture: !0
        }), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, "change", i, {
            capture: !0
        }), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, "click", i, {
            capture: !0
        }), $0fb0e9cf977607be$var$Vn([
            "pointerdown",
            "pointermove",
            "pointerup",
            "pointercancel"
        ], (t)=>{
            $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, t, i, {
                capture: !0
            });
        }), this.mo().capture_copied_text) {
            const i = this.Fo = (i)=>{
                i = i || (null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.event);
                try {
                    this.Oo(i, $0fb0e9cf977607be$var$Fu);
                } catch (t) {
                    $0fb0e9cf977607be$var$Du.error("Failed to capture clipboard event", t);
                }
            };
            $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, "copy", i, {
                capture: !0
            }), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, "cut", i, {
                capture: !0
            }), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, "paste", i, {
                capture: !0
            });
        }
    }
    Po() {
        this.do(), this.Ao && (null == $0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$t.removeEventListener("blur", this.Ao), $0fb0e9cf977607be$var$Vn([
            "pointerdown",
            "pointermove",
            "pointerup",
            "pointercancel"
        ], (t)=>{
            null == $0fb0e9cf977607be$var$s || $0fb0e9cf977607be$var$s.removeEventListener(t, this.Ao, !0);
        }), null == $0fb0e9cf977607be$var$s || $0fb0e9cf977607be$var$s.removeEventListener("submit", this.Ao, !0), null == $0fb0e9cf977607be$var$s || $0fb0e9cf977607be$var$s.removeEventListener("change", this.Ao, !0), null == $0fb0e9cf977607be$var$s || $0fb0e9cf977607be$var$s.removeEventListener("click", this.Ao, !0), this.Ao = void 0), this.Fo && (null == $0fb0e9cf977607be$var$s || $0fb0e9cf977607be$var$s.removeEventListener("copy", this.Fo, !0), null == $0fb0e9cf977607be$var$s || $0fb0e9cf977607be$var$s.removeEventListener("cut", this.Fo, !0), null == $0fb0e9cf977607be$var$s || $0fb0e9cf977607be$var$s.removeEventListener("paste", this.Fo, !0), this.Fo = void 0), this.ko = !1;
    }
    startIfEnabled() {
        this.isEnabled || this.do(), !this.To && this.bo && this.isEnabled && !this.ko && (this.Ro(), this.ko = !0);
    }
    onRemoteConfig(t) {
        if (this.To) return;
        if (this.xo = !0, !t.ok) return void this.startIfEnabled();
        const i = t.config;
        i.elementsChainAsString && (this.Co = i.elementsChainAsString);
        const e = i.autocapture_opt_out;
        var s;
        $0fb0e9cf977607be$var$j(e) && (null === (s = this.bo) || void 0 === s || s.kv.set("$autocapture_disabled_server_side", e), this.So = e), this.startIfEnabled();
    }
    setElementSelectors(t, i = this) {
        if (this.To) return;
        t.size ? this.$o.set(i, new Set(t)) : this.$o.delete(i);
        const e = new Set;
        this.$o.forEach((t)=>{
            t.forEach((t)=>e.add(t));
        }), this.Io = e;
    }
    getElementSelectors(t, i) {
        var e;
        const n = [];
        return null === (e = this.Io) || void 0 === e || e.forEach((e)=>{
            const r = null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.querySelectorAll(e);
            null == r || r.forEach((s)=>{
                t !== s && i !== s || $0fb0e9cf977607be$var$b(n, e) || n.push(e);
            });
        }), n;
    }
    get isEnabled() {
        var t, i;
        if (this.To) return !1;
        const e = null === (t = this.bo) || void 0 === t ? void 0 : t.kv.get($0fb0e9cf977607be$var$fs), s = this.So, n = this.mo();
        if (!n.remoteRequestsDisabled && !this.xo) return !1;
        const r = n.remoteRequestsDisabled && !this.xo;
        if ($0fb0e9cf977607be$var$A(s) && !$0fb0e9cf977607be$var$j(e) && !r) return !1;
        const o = null !== (i = this.So) && void 0 !== i ? i : !!e;
        return !!n.enabled && !o;
    }
    Oo(i, e = "$autocapture", s) {
        if (!this.isEnabled) return void this.do();
        let n = s || $0fb0e9cf977607be$var$Ur(i);
        $0fb0e9cf977607be$var$Ar(n) && (n = n.parentNode || null);
        const r = this.Mo();
        var o;
        "$autocapture" === e && "click" === i.type && i instanceof MouseEvent && r.rageclick && (null === (o = this.rageclicks) || void 0 === o ? void 0 : o.isRageClick(i.clientX, i.clientY, i.timeStamp || (new Date).getTime())) && $0fb0e9cf977607be$var$Qr(n, r.rageclick) && this.Oo(i, "$rageclick", s);
        const l = e === $0fb0e9cf977607be$var$Fu, a = l ? $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, r), {}, {
            dom_event_allowlist: void 0
        }) : r;
        if (n && function(i, e, s, n, r, o) {
            var l;
            if (!$0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$Zr(i)) return !1;
            if ((null == s ? void 0 : s.url_allowlist) && !$0fb0e9cf977607be$var$Nr(s.url_allowlist, o)) return !1;
            if ((null == s ? void 0 : s.url_ignorelist) && $0fb0e9cf977607be$var$Nr(s.url_ignorelist, o)) return !1;
            if (null == s ? void 0 : s.dom_event_allowlist) {
                const t = s.dom_event_allowlist;
                if (t && !t.some((t)=>e.type === t)) return !1;
            }
            const { parentIsUsefulElement: a, targetElementList: u } = $0fb0e9cf977607be$var$to(i, n);
            if (!function(t, i) {
                const e = null == i ? void 0 : i.element_allowlist;
                if ($0fb0e9cf977607be$var$R(e)) return !0;
                for (const i of t)if (e.some((t)=>i.tagName.toLowerCase() === t)) return !0;
                return !1;
            }(u, s)) return !1;
            if (!$0fb0e9cf977607be$var$qr(u, null == s ? void 0 : s.css_selector_allowlist)) return !1;
            if ($0fb0e9cf977607be$var$qr(u, null !== (l = null == s ? void 0 : s.css_selector_ignorelist) && void 0 !== l ? l : $0fb0e9cf977607be$var$Wr)) return !1;
            try {
                const s = $0fb0e9cf977607be$var$t.getComputedStyle(i);
                if (s && "pointer" === s.getPropertyValue("cursor") && "click" === e.type) return !0;
            } catch (t) {}
            const h = i.tagName.toLowerCase();
            switch(h){
                case "html":
                    return !1;
                case "form":
                    return (r || [
                        "submit"
                    ]).indexOf(e.type) >= 0;
                case "input":
                case "select":
                case "textarea":
                    return (r || [
                        "change",
                        "click"
                    ]).indexOf(e.type) >= 0;
                default:
                    return a ? (r || [
                        "click"
                    ]).indexOf(e.type) >= 0 : (r || [
                        "click"
                    ]).indexOf(e.type) >= 0 && ($0fb0e9cf977607be$var$zr.indexOf(h) > -1 || "true" === i.getAttribute("contenteditable"));
            }
        }(n, i, a, l, l ? [
            "copy",
            "cut",
            "paste"
        ] : void 0, {
            config: {
                get_current_url: r.getCurrentUrl
            }
        })) {
            var u;
            const { props: s, explicitNoCapture: o, target: l } = $0fb0e9cf977607be$var$Lu(n, {
                e: i,
                maskAllElementAttributes: r.maskAllElementAttributes,
                maskAllText: r.maskAllText,
                elementAttributeIgnoreList: r.element_attribute_ignorelist,
                elementsChainAsString: this.Co,
                disableCaptureUrlHashes: r.disableCaptureUrlHashes
            });
            if (o) return !1;
            const a = this.getElementSelectors(n, l);
            if (a && a.length > 0 && (s.$element_selectors = a), e === $0fb0e9cf977607be$var$Fu) {
                const e = i.type || "clipboard";
                if ("paste" !== e) {
                    var h, d;
                    const i = null == $0fb0e9cf977607be$var$t || null === (h = $0fb0e9cf977607be$var$t.getSelection()) || void 0 === h ? void 0 : h.toString(), e = $0fb0e9cf977607be$var$Lr(i);
                    if (!e) return !1;
                    s.$selected_content = e, s.$clipboard_text_length = null !== (d = null == i ? void 0 : i.length) && void 0 !== d ? d : 0;
                }
                s.$copy_type = e;
            }
            return null === (u = this.bo) || void 0 === u || u.capture(e, s), !0;
        }
    }
    isBrowserSupported() {
        return $0fb0e9cf977607be$var$P(null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.querySelectorAll);
    }
}, $0fb0e9cf977607be$var$Uu = class {
    constructor(t){
        this._instance = t;
    }
    refresh(t) {
        const i = this._instance.config, e = $0fb0e9cf977607be$var$C(i.autocapture) ? i.autocapture : void 0;
        t.enabled = !!i.autocapture, t.rageclick = i.rageclick, t.maskAllElementAttributes = i.mask_all_element_attributes, t.maskAllText = i.mask_all_text, t.disableCaptureUrlHashes = i.disable_capture_url_hashes, t.getCurrentUrl = i.get_current_url, t.remoteRequestsDisabled = this._instance.il(), t.url_allowlist = null == e ? void 0 : e.url_allowlist, t.url_ignorelist = null == e ? void 0 : e.url_ignorelist, t.dom_event_allowlist = null == e ? void 0 : e.dom_event_allowlist, t.element_allowlist = null == e ? void 0 : e.element_allowlist, t.css_selector_allowlist = null == e ? void 0 : e.css_selector_allowlist, t.css_selector_ignorelist = null == e ? void 0 : e.css_selector_ignorelist, t.element_attribute_ignorelist = null == e ? void 0 : e.element_attribute_ignorelist, t.capture_copied_text = null == e ? void 0 : e.capture_copied_text;
    }
};
const $0fb0e9cf977607be$var$zu = $0fb0e9cf977607be$var$Ye("[ExceptionAutocapture]"), $0fb0e9cf977607be$var$Hu = ()=>{}, $0fb0e9cf977607be$var$qu = (t)=>{
    var i;
    if ($0fb0e9cf977607be$var$P(t)) return null !== (i = t.__posthog_layer__) && void 0 !== i ? i : t.__rrweb_layer__;
};
function $0fb0e9cf977607be$var$Vu(t, i, e) {
    try {
        if (!(i in t)) return $0fb0e9cf977607be$var$Hu;
        const s = {
            next: t[i]
        }, n = e(function(...t) {
            return s.next.apply(this, t);
        });
        return $0fb0e9cf977607be$var$P(n) && (n.prototype = n.prototype || {}, Object.defineProperties(n, {
            __posthog_wrapped__: {
                enumerable: !1,
                value: !0
            },
            __posthog_layer__: {
                enumerable: !1,
                value: s
            }
        })), t[i] = n, ()=>{
            if (t[i] === n) return void (t[i] = s.next);
            let e = t[i], r = $0fb0e9cf977607be$var$qu(e);
            for(; r;){
                if (r.next === n) return void (r.next = s.next);
                e = r.next, r = $0fb0e9cf977607be$var$qu(e);
            }
        };
    } catch (t) {
        return $0fb0e9cf977607be$var$Hu;
    }
}
const $0fb0e9cf977607be$var$Wu = $0fb0e9cf977607be$var$Ye("[TracingHeaders]"), $0fb0e9cf977607be$var$Gu = $0fb0e9cf977607be$var$Ye("[Web Vitals]"), $0fb0e9cf977607be$var$Ku = 9e5, $0fb0e9cf977607be$var$Ju = [
    "CLS",
    "FCP",
    "INP",
    "LCP"
], $0fb0e9cf977607be$var$Yu = [
    "INP",
    "LCP"
], $0fb0e9cf977607be$var$Xu = [
    "interactionTarget",
    "interactionType",
    "inputDelay",
    "processingDuration",
    "presentationDelay",
    "loadState",
    "target",
    "url",
    "timeToFirstByte",
    "resourceLoadDelay",
    "resourceLoadDuration",
    "elementRenderDelay",
    "largestShiftTarget",
    "largestShiftTime",
    "largestShiftValue",
    "firstByteToFCP"
], $0fb0e9cf977607be$var$Qu = "disabled", $0fb0e9cf977607be$var$Zu = "lazy_loading", $0fb0e9cf977607be$var$th = $0fb0e9cf977607be$var$Ye("[SessionRecording]"), $0fb0e9cf977607be$var$ih = [
    $0fb0e9cf977607be$var$xn,
    $0fb0e9cf977607be$var$En,
    $0fb0e9cf977607be$var$kn,
    $0fb0e9cf977607be$var$Tn,
    $0fb0e9cf977607be$var$Pn,
    $0fb0e9cf977607be$var$Cn,
    $0fb0e9cf977607be$var$On,
    $0fb0e9cf977607be$var$Rn,
    $0fb0e9cf977607be$var$In
], $0fb0e9cf977607be$var$eh = $0fb0e9cf977607be$var$Ye("[Heatmaps]");
function $0fb0e9cf977607be$var$sh(t) {
    return $0fb0e9cf977607be$var$C(t) && "clientX" in t && "clientY" in t && $0fb0e9cf977607be$var$D(t.clientX) && $0fb0e9cf977607be$var$D(t.clientY);
}
const $0fb0e9cf977607be$var$nh = $0fb0e9cf977607be$var$Ye("[Product Tours]"), $0fb0e9cf977607be$var$rh = (t)=>{
    var i;
    return !t.config.disable_product_tours && !!(null === (i = t.persistence) || void 0 === i ? void 0 : i.get_property($0fb0e9cf977607be$var$ws));
}, $0fb0e9cf977607be$var$oh = [
    "$set_once",
    "$set"
], $0fb0e9cf977607be$var$lh = $0fb0e9cf977607be$var$Ye("[SiteApps]"), $0fb0e9cf977607be$var$ah = "Error while initializing PostHog app with config id ", $0fb0e9cf977607be$var$uh = (t, i)=>(null == t ? void 0 : t.then) ? t.then(i) : i(t), $0fb0e9cf977607be$var$hh = "SDK is not enabled or survey functionality is not yet loaded", $0fb0e9cf977607be$var$dh = "Disabled. Not loading surveys.";
var $0fb0e9cf977607be$var$ch = class {
    constructor(t, i){
        this.wo = t, this.Mh = i, this.name = "surveys", this._surveyEventReceiver = null, this._surveyManager = null, this.Eh = !1, this.Ph = !1, this.Rh = [], this.Ah = [], this.Oh = null, this.Fh = null, this.To = !1, this.Dh = new Set, this.onRemoteConfig = (t)=>{
            if (this.To) return;
            if (this.Mr.disableSurveys) return;
            if (!t.ok) return this.Ph = !0, this.Lh({
                isLoaded: !1,
                error: "Remote config unavailable. Not loading surveys."
            }), $0fb0e9cf977607be$var$eu.warn("Remote config unavailable. Not loading surveys.");
            const i = t.config.surveys;
            if ($0fb0e9cf977607be$var$F(i)) return $0fb0e9cf977607be$var$eu.warn("Flags not loaded yet. Not loading surveys.");
            this.Nh = $0fb0e9cf977607be$var$j(i) ? i : i.length > 0, $0fb0e9cf977607be$var$eu.info(`flags response received, isSurveysEnabled: ${this.Nh}`), this.loadIfEnabled();
        }, this.Lh = (t)=>{
            this.Ah.slice().forEach((i)=>this.qh(i, t));
        };
    }
    setup(t) {
        if (!this.To) return this.jh = t, $0fb0e9cf977607be$var$uh(t.kv.initialize(), ()=>{
            if (this.jh !== t || this.To) return;
            this.jh = void 0, this.bo = t;
            const i = t.onRemoteConfig(this.onRemoteConfig);
            this.To ? i.dispose() : (this.Eo = i, this.loadIfEnabled());
        });
    }
    dispose() {
        var t, i, e, s, n;
        this.To || (this.To = !0, this.jh = void 0, this.bo = void 0, null === (t = this.Eo) || void 0 === t || t.dispose(), this.Eo = void 0, null === (i = this._surveyEventReceiver) || void 0 === i || i.dispose(), this._surveyEventReceiver = null, null === (e = this._surveyManager) || void 0 === e || null === (s = e.dispose) || void 0 === s || s.call(e), this._surveyManager = null, this.Rh = [], this.Ah.forEach((t)=>{
            t.active = !1;
        }), this.Ah = [], null === (n = this.Bh) || void 0 === n || n.call(this), this.Bh = void 0, this.Oh = null, this.Dh.forEach((t)=>clearTimeout(t)), this.Dh.clear());
    }
    get Mr() {
        return this.wo.get();
    }
    initialize() {
        this.loadIfEnabled();
    }
    reset() {
        var t, i;
        null === (t = this._surveyManager) || void 0 === t || null === (i = t.clearInMemoryInProgressSurveyState) || void 0 === i || i.call(t);
        try {
            var e;
            null === (e = this._surveyEventReceiver) || void 0 === e || e.reset(), localStorage.removeItem("lastSeenSurveyDate");
            const t = [];
            for(let i = 0; i < localStorage.length; i++){
                const e = localStorage.key(i);
                ((null == e ? void 0 : e.startsWith("seenSurvey_")) || (null == e ? void 0 : e.startsWith("inProgressSurvey_"))) && t.push(e);
            }
            t.forEach((t)=>localStorage.removeItem(t));
        } catch (t) {}
        this.Lh();
    }
    loadIfEnabled() {
        if (this.To || !this.bo) return;
        const t = this.Mr;
        if (this._surveyManager) return;
        if (this.Eh) return void $0fb0e9cf977607be$var$eu.info("Already initializing surveys, skipping...");
        if (t.disableSurveys) return void $0fb0e9cf977607be$var$eu.info($0fb0e9cf977607be$var$dh);
        if (t.cookielessMode && this.wo.isOptedOut()) return void $0fb0e9cf977607be$var$eu.info("Not loading surveys in cookieless mode without consent.");
        const i = this.wo.getExtensions();
        if (!i) return void this.Hh("PostHog Extensions not found.");
        if ($0fb0e9cf977607be$var$R(this.Nh) && !t.advancedEnableSurveys) return;
        const e = this.Nh || t.advancedEnableSurveys;
        this.Eh = !0, this.Ph = !1;
        try {
            const t = i.generateSurveys;
            if (t) return this.zh(t, e), void (this.Eh = !1);
            const s = i.loadExternalDependency;
            if (!s) return this.Hh($0fb0e9cf977607be$var$An), void (this.Eh = !1);
            s((t)=>{
                try {
                    if (this.To) return;
                    const i = this.wo.getExtensions();
                    t || !(null == i ? void 0 : i.generateSurveys) ? this.Hh("Could not load surveys script", t) : this.zh(i.generateSurveys, e);
                } finally{
                    this.Eh = !1;
                }
            });
        } catch (t) {
            throw this.Eh = !1, this.Hh("Error initializing surveys", t), t;
        }
    }
    zh(t, i) {
        var e, s;
        if (this.To) return;
        this._surveyManager = t(i), this._surveyEventReceiver = this.wo.createEventReceiver(this.Lh);
        const n = null === (e = null !== (s = this.bo) && void 0 !== s ? s : this.Mh) || void 0 === e ? void 0 : e.kv.get($0fb0e9cf977607be$var$Ys);
        n && this.Uh(n), $0fb0e9cf977607be$var$eu.info("Surveys loaded successfully"), this.Wh(), this.Lh(), this.Vh({
            isLoaded: !0
        });
    }
    Hh(t, i) {
        this.Ph = !0, $0fb0e9cf977607be$var$eu.error(t, i), this.Lh({
            isLoaded: !1,
            error: t
        }), this.Vh({
            isLoaded: !1,
            error: t
        });
    }
    onSurveysLoaded(t) {
        return this.Rh.push(t), this._surveyManager && this.Vh({
            isLoaded: !0
        }), ()=>{
            this.Rh = this.Rh.filter((i)=>i !== t);
        };
    }
    getSurveys(t, i = !1) {
        var e;
        const s = null !== (e = this.bo) && void 0 !== e ? e : this.Mh;
        if (!s || this.To) return;
        if (this.Mr.disableSurveys) return $0fb0e9cf977607be$var$eu.info($0fb0e9cf977607be$var$dh), t([]);
        const n = s.kv.get($0fb0e9cf977607be$var$Ys);
        if (n && !i) return t(n, {
            isLoaded: !0
        }), void (this.Gh() && this.getSurveys(()=>{}, !0));
        if (this.Oh) return void this.Oh.then(({ surveys: i, context: e })=>{
            this.To || t(i, e);
        }).catch((t)=>$0fb0e9cf977607be$var$eu.error("Error in survey callback", t));
        const r = this.Qh("/api/surveys/", {
            method: "GET",
            query: {
                token: s.projectToken
            },
            sentAt: "query",
            timeoutMs: this.Mr.requestTimeoutMs
        }).then((t)=>{
            try {
                return this.Jh(s, t);
            } catch (t) {
                return $0fb0e9cf977607be$var$eu.error("Error processing surveys response", t), this.Jh(s, {
                    statusCode: 0,
                    error: t
                });
            }
        }, (t)=>this.Jh(s, {
                statusCode: 0,
                error: t
            }));
        this.Oh = r;
        const o = ()=>{
            this.Oh === r && (this.Oh = null);
        };
        r.then((i)=>{
            o(), this.To || (this.Lh(i.context), t(i.surveys, i.context));
        }, o).catch((t)=>$0fb0e9cf977607be$var$eu.error("Error in survey callback", t));
    }
    Qh(t, i) {
        const e = this.bo;
        return e ? e.sendRequest(t, i) : new Promise((t)=>t({
                statusCode: 0,
                error: new Error($0fb0e9cf977607be$var$hh)
            }));
    }
    Jh(t, i) {
        if (this.To) return {
            surveys: [],
            context: {
                isLoaded: !1,
                error: $0fb0e9cf977607be$var$hh
            }
        };
        const e = i.statusCode;
        if (200 !== e || !i.json) {
            const t = `Surveys API could not be loaded, status: ${e}`;
            return 0 !== e ? $0fb0e9cf977607be$var$eu.error(t) : i.error || $0fb0e9cf977607be$var$eu.warn(t), this.Fh = Date.now(), {
                surveys: [],
                context: {
                    isLoaded: !1,
                    error: t
                }
            };
        }
        this.Fh = null;
        const s = i.json.surveys || [];
        return t.kv.set({
            [$0fb0e9cf977607be$var$Ys]: s,
            [$0fb0e9cf977607be$var$Xs]: Date.now()
        }), this.Uh(s), {
            surveys: s,
            context: {
                isLoaded: !0
            }
        };
    }
    Uh(t) {
        var i;
        const e = t.filter((t)=>(function(t) {
                return !(!t.start_date || t.end_date);
            })(t) && ($0fb0e9cf977607be$var$Va(t) || function(t) {
                var i;
                return !!(null === (i = t.conditions) || void 0 === i || null === (i = i.actions) || void 0 === i || null === (i = i.values) || void 0 === i ? void 0 : i.length);
            }(t)));
        null === (i = this._surveyEventReceiver) || void 0 === i || i.replace(e);
    }
    Gh() {
        return this.Zh() && !this.Oh && !this.Kh();
    }
    Zh() {
        var t, i;
        const e = null === (t = null !== (i = this.bo) && void 0 !== i ? i : this.Mh) || void 0 === t ? void 0 : t.kv.get($0fb0e9cf977607be$var$Xs);
        return $0fb0e9cf977607be$var$D(e) && Date.now() - e > 3e5;
    }
    Kh() {
        return $0fb0e9cf977607be$var$D(this.Fh) && 3e5 > Date.now() - this.Fh;
    }
    markSurveyAsSeen(t, i) {
        var e;
        const s = {
            id: t,
            current_iteration: null !== (e = null == i ? void 0 : i.iteration) && void 0 !== e ? e : null
        };
        $0fb0e9cf977607be$var$su(s);
        try {
            localStorage.setItem("lastSeenSurveyDate", (new Date).toISOString());
        } catch (t) {}
        this.Lh();
    }
    Vh(t) {
        for (const i of this.Rh)try {
            if (!t.isLoaded) return i([], t);
            this.getSurveys(i);
        } catch (t) {
            $0fb0e9cf977607be$var$eu.error("Error in survey callback", t);
        }
    }
    getActiveMatchingSurveys(t, i = !1) {
        if (!$0fb0e9cf977607be$var$F(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(t, i);
        $0fb0e9cf977607be$var$eu.warn("init was not called");
    }
    onActiveMatchingSurveysChanged(t) {
        var i, e;
        if (this.To) return ()=>{};
        const s = {
            callback: t,
            active: !0,
            revision: 0
        };
        this.Ah.push(s), this.Wh();
        const n = null === (i = null !== (e = this.bo) && void 0 !== e ? e : this.Mh) || void 0 === i ? void 0 : i.kv.get($0fb0e9cf977607be$var$Ys);
        return this.Mr.disableSurveys || !this._surveyManager && this.Ph && !this.Eh || !n && !$0fb0e9cf977607be$var$F(this.Fh) && !this.Oh ? this.qh(s, {
            isLoaded: !1
        }) : this._surveyManager && this.qh(s), ()=>{
            var t;
            s.active = !1, this.Ah = this.Ah.filter((t)=>t !== s), 0 === this.Ah.length && (null === (t = this.Bh) || void 0 === t || t.call(this), this.Bh = void 0);
        };
    }
    Wh() {
        var t, i, e;
        this._surveyManager && this.Ah.length > 0 && (null !== (t = this.Bh) && void 0 !== t || (this.Bh = null === (i = (e = this.wo).onMatchingConditionsChanged) || void 0 === i ? void 0 : i.call(e, this.Lh)));
    }
    qh(t, i) {
        if (this.To || !t.active) return;
        const e = ++t.revision, s = (s)=>{
            if (!this.To && t.active && e === t.revision) try {
                const e = null != i ? i : {
                    isLoaded: !0
                }, n = JSON.stringify([
                    s,
                    e
                ]);
                if (n === t.lastResult) return;
                t.lastResult = n, t.callback(s, e);
            } catch (t) {
                $0fb0e9cf977607be$var$eu.error("Error in active matching surveys callback", t);
            }
        };
        try {
            i && !i.isLoaded ? s([]) : this.getActiveMatchingSurveys(s);
        } catch (t) {
            $0fb0e9cf977607be$var$eu.error("Error in active matching surveys callback", t);
        }
    }
    Xh(t) {
        let i = null;
        return this.getSurveys((e)=>{
            var s;
            i = null !== (s = e.find((i)=>i.id === t)) && void 0 !== s ? s : null;
        }), i;
    }
    Yh(t) {
        if ($0fb0e9cf977607be$var$F(this._surveyManager)) return {
            eligible: !1,
            reason: $0fb0e9cf977607be$var$hh
        };
        const i = "string" == typeof t ? this.Xh(t) : t;
        return i ? this._surveyManager.checkSurveyEligibility(i) : {
            eligible: !1,
            reason: "Survey not found"
        };
    }
    tc(t) {
        if (!this.wo.isCapturing()) return {
            eligible: !1,
            reason: "PostHog is not capturing, so a survey response cannot be recorded"
        };
        if ($0fb0e9cf977607be$var$F(this._surveyManager)) return {
            eligible: !1,
            reason: $0fb0e9cf977607be$var$hh
        };
        const i = "string" == typeof t ? this.Xh(t) : t;
        return i ? this._surveyManager.checkSurveyRenderability(i) : {
            eligible: !1,
            reason: "Survey not found"
        };
    }
    canRenderSurvey(t) {
        if ($0fb0e9cf977607be$var$F(this._surveyManager)) return $0fb0e9cf977607be$var$eu.warn("init was not called"), {
            visible: !1,
            disabledReason: $0fb0e9cf977607be$var$hh
        };
        const i = this.tc(t);
        return {
            visible: i.eligible,
            disabledReason: i.reason
        };
    }
    canRenderSurveyAsync(t, i) {
        return $0fb0e9cf977607be$var$F(this._surveyManager) ? ($0fb0e9cf977607be$var$eu.warn("init was not called"), Promise.resolve({
            visible: !1,
            disabledReason: $0fb0e9cf977607be$var$hh
        })) : new Promise((e)=>{
            this.getSurveys((i)=>{
                var s;
                const n = null !== (s = i.find((i)=>i.id === t)) && void 0 !== s ? s : null;
                if (n) {
                    const t = this.tc(n);
                    e({
                        visible: t.eligible,
                        disabledReason: t.reason
                    });
                } else e({
                    visible: !1,
                    disabledReason: "Survey not found"
                });
            }, i);
        });
    }
    renderSurvey(t, i, e) {
        var n;
        if (!this.wo.isCapturing()) return;
        if ($0fb0e9cf977607be$var$F(this._surveyManager)) return void $0fb0e9cf977607be$var$eu.warn("init was not called");
        const r = "string" == typeof t ? this.Xh(t) : t;
        if (!(null == r ? void 0 : r.id)) return void $0fb0e9cf977607be$var$eu.warn("Survey not found");
        if (!$0fb0e9cf977607be$var$nu.includes(r.type)) return void $0fb0e9cf977607be$var$eu.warn(`Surveys of type ${r.type} cannot be rendered in the app`);
        const o = null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.querySelector(i);
        if (o) {
            if (null === (n = r.appearance) || void 0 === n ? void 0 : n.surveyPopupDelaySeconds) {
                $0fb0e9cf977607be$var$eu.info(`Rendering survey ${r.id} with delay of ${r.appearance.surveyPopupDelaySeconds} seconds`);
                const t = setTimeout(()=>{
                    var i, s;
                    this.Dh.delete(t), !this.To && this.wo.isCapturing() && ($0fb0e9cf977607be$var$eu.info(`Rendering survey ${r.id} with delay of ${null === (i = r.appearance) || void 0 === i ? void 0 : i.surveyPopupDelaySeconds} seconds`), null === (s = this._surveyManager) || void 0 === s || s.renderSurvey(r, o, e), $0fb0e9cf977607be$var$eu.info(`Survey ${r.id} rendered`));
                }, 1e3 * r.appearance.surveyPopupDelaySeconds);
                return void this.Dh.add(t);
            }
            this._surveyManager.renderSurvey(r, o, e);
        } else $0fb0e9cf977607be$var$eu.warn("Survey element not found");
    }
    displaySurvey(t, i) {
        var e;
        if (!this.wo.isCapturing()) return;
        if ($0fb0e9cf977607be$var$F(this._surveyManager)) return void $0fb0e9cf977607be$var$eu.warn("init was not called");
        const s = this.Xh(t);
        if (!s) return void $0fb0e9cf977607be$var$eu.warn("Survey not found");
        let n = s;
        if ((null === (e = s.appearance) || void 0 === e ? void 0 : e.surveyPopupDelaySeconds) && i.ignoreDelay && (n = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, s), {}, {
            appearance: $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, s.appearance), {}, {
                surveyPopupDelaySeconds: 0
            })
        })), i.displayType !== $0fb0e9cf977607be$export$a8a66d9d1b857494.Popover && i.initialResponses && $0fb0e9cf977607be$var$eu.warn("initialResponses is only supported for popover surveys. prefill will not be applied."), !1 === i.ignoreConditions) {
            const t = this.Yh(s);
            if (!t.eligible) return void $0fb0e9cf977607be$var$eu.warn("Survey is not eligible to be displayed: ", t.reason);
        }
        i.displayType !== $0fb0e9cf977607be$export$a8a66d9d1b857494.Inline ? this._surveyManager.handlePopoverSurvey(n, i) : this.renderSurvey(n, i.selector, i.properties);
    }
    cancelPendingSurvey(t) {
        $0fb0e9cf977607be$var$F(this._surveyManager) ? $0fb0e9cf977607be$var$eu.warn("init was not called") : this._surveyManager.cancelSurvey(t);
    }
    handlePageUnload() {
        var t, i;
        null === (t = this._surveyManager) || void 0 === t || null === (i = t.handlePageUnload) || void 0 === i || i.call(t);
    }
};
function $0fb0e9cf977607be$var$vh(t, i, e) {
    if ($0fb0e9cf977607be$var$F(t)) return !1;
    switch(e){
        case "exact":
            return t === i;
        case "contains":
            {
                const e = i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/_/g, ".").replace(/%/g, ".*");
                return new RegExp(e, "i").test(t);
            }
        case "regex":
            try {
                return new RegExp(i).test(t);
            } catch (t) {
                return !1;
            }
        default:
            return !1;
    }
}
var $0fb0e9cf977607be$var$fh = class {
    constructor(t){
        this._instance = t, this.ec = new Set, this.nc = new Set, this.sc = new $0fb0e9cf977607be$var$ja, this.rc = (t, i)=>this.oc(t, i) && this.ac(t, i) && this.lc(t, i) && this.uc(t, i), this.oc = (t, i)=>!(null == i ? void 0 : i.event) || (null == t ? void 0 : t.event) === (null == i ? void 0 : i.event);
    }
    init() {
        var t, i;
        $0fb0e9cf977607be$var$R(null === (t = this._instance) || void 0 === t ? void 0 : t._addCaptureHook) || (this.hc = null === (i = this._instance) || void 0 === i ? void 0 : i._addCaptureHook((t, i)=>{
            this.on(t, i);
        }));
    }
    dispose() {
        var t, i;
        null === (t = this.hc) || void 0 === t || t.call(this), this.hc = void 0, null === (i = this._instance) || void 0 === i || null === (i = i.autocapture) || void 0 === i || i.setElementSelectors(new Set, this), this.sc = new $0fb0e9cf977607be$var$ja;
    }
    register(t) {
        var i, e;
        if (!$0fb0e9cf977607be$var$R(null === (i = this._instance) || void 0 === i ? void 0 : i._addCaptureHook) && (t.forEach((t)=>{
            var i;
            this.ec.add(t), null === (i = t.steps) || void 0 === i || i.forEach((t)=>{
                this.nc.add((null == t ? void 0 : t.event) || "");
            });
        }), null === (e = this._instance) || void 0 === e ? void 0 : e.autocapture)) {
            const t = new Set;
            this.ec.forEach((i)=>{
                var e;
                null === (e = i.steps) || void 0 === e || e.forEach((i)=>{
                    (null == i ? void 0 : i.selector) && t.add(i.selector);
                });
            }), this._instance.autocapture.setElementSelectors(t, this);
        }
    }
    replace(t) {
        this.ec.clear(), this.nc.clear(), this.register(t);
    }
    on(t, i) {
        null != i && 0 != t.length && (this.nc.has(t) || this.nc.has(i.event)) && this.ec.forEach((t)=>{
            this.cc(i, t) && this.sc.emit("actionCaptured", t.name);
        });
    }
    dc(t) {
        this.onAction("actionCaptured", (i)=>t(i));
    }
    cc(t, i) {
        if (null == (null == i ? void 0 : i.steps)) return !1;
        for (const e of i.steps)if (this.rc(t, e)) return !0;
        return !1;
    }
    onAction(t, i) {
        return this.sc.on(t, i);
    }
    ac(t, i) {
        if (null == i ? void 0 : i.url) {
            var e;
            const s = null == t || null === (e = t.properties) || void 0 === e ? void 0 : e.$current_url;
            if (!s || "string" != typeof s) return !1;
            if (!$0fb0e9cf977607be$var$vh(s, i.url, i.url_matching || "contains")) return !1;
        }
        return !0;
    }
    lc(t, i) {
        return !!this.vc(t, i) && !!this.fc(t, i) && !!this.gc(t, i);
    }
    vc(t, i) {
        var e;
        if (!(null == i ? void 0 : i.href)) return !0;
        const s = this.mc(t);
        if (s.length > 0) return s.some((t)=>$0fb0e9cf977607be$var$vh(t.href, i.href, i.href_matching || "exact"));
        const n = (null == t || null === (e = t.properties) || void 0 === e ? void 0 : e.$elements_chain) || "";
        return !!n && $0fb0e9cf977607be$var$vh(function(t) {
            const i = t.match(/(?::|")href="(.*?)"/);
            return i ? i[1] : "";
        }(n), i.href, i.href_matching || "exact");
    }
    fc(t, i) {
        var e;
        if (!(null == i ? void 0 : i.text)) return !0;
        const s = this.mc(t);
        if (s.length > 0) return s.some((t)=>$0fb0e9cf977607be$var$vh(t.text, i.text, i.text_matching || "exact") || $0fb0e9cf977607be$var$vh(t.$el_text, i.text, i.text_matching || "exact"));
        const n = (null == t || null === (e = t.properties) || void 0 === e ? void 0 : e.$elements_chain) || "";
        var r, o, l;
        return !!n && (r = function(t) {
            const i = [], e = /(?::|")text="(.*?)"/g;
            let s;
            for(; !$0fb0e9cf977607be$var$F(s = e.exec(t));)i.includes(s[1]) || i.push(s[1]);
            return i;
        }(n), o = i.text, l = i.text_matching || "exact", r.some((t)=>$0fb0e9cf977607be$var$vh(t, o, l)));
    }
    gc(t, i) {
        var e, s;
        if (!(null == i ? void 0 : i.selector)) return !0;
        const n = null == t || null === (e = t.properties) || void 0 === e ? void 0 : e.$element_selectors;
        if (null == n ? void 0 : n.includes(i.selector)) return !0;
        const r = (null == t || null === (s = t.properties) || void 0 === s ? void 0 : s.$elements_chain) || "";
        if (i.selector_regex && r) try {
            return new RegExp(i.selector_regex).test(r);
        } catch (t) {
            return !1;
        }
        return !1;
    }
    mc(t) {
        var i;
        return null == (null == t || null === (i = t.properties) || void 0 === i ? void 0 : i.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
    uc(t, i) {
        return !(null == i ? void 0 : i.properties) || 0 === i.properties.length || $0fb0e9cf977607be$var$Ja(i.properties.reduce((t, i)=>{
            const e = $0fb0e9cf977607be$var$T(i.value) ? i.value.map(String) : null != i.value ? [
                String(i.value)
            ] : [];
            return t[i.key] = {
                values: e,
                operator: i.operator || "exact"
            }, t;
        }, {}), null == t ? void 0 : t.properties);
    }
}, $0fb0e9cf977607be$var$ph = class {
    constructor(t, i){
        var e, s;
        this.yc = [], this._instance = t, this.bc = i, this._c = new Map, this.wc = new Map, this.kc = new Map, this.Sc = null === (e = this._instance) || void 0 === e || null === (s = e.onSessionId) || void 0 === s ? void 0 : s.call(e, (t)=>this.xc(t));
    }
    $c(t) {
        return !1;
    }
    Cc() {
        return null;
    }
    Tc(t) {}
    Ic() {}
    Mc(t, i) {
        return !!t && $0fb0e9cf977607be$var$Ja(t.propertyFilters, null == i ? void 0 : i.properties);
    }
    Ec(t, i) {
        const e = new Map;
        return t.forEach((t)=>{
            var s;
            null === (s = t.conditions) || void 0 === s || null === (s = s[i]) || void 0 === s || null === (s = s.values) || void 0 === s || s.forEach((i)=>{
                if (null == i ? void 0 : i.name) {
                    const s = e.get(i.name) || [];
                    s.push(t.id), e.set(i.name, s);
                }
            });
        }), e;
    }
    Pc(t, i, e) {
        const s = (e === $0fb0e9cf977607be$export$352273f853caad57.Activation ? this._c : this.wc).get(t);
        let n = [];
        return this.Rc((t)=>{
            n = t.filter((t)=>null == s ? void 0 : s.includes(t.id));
        }), n.filter((s)=>{
            var n;
            const r = null === (n = s.conditions) || void 0 === n || null === (n = n[e]) || void 0 === n || null === (n = n.values) || void 0 === n ? void 0 : n.find((i)=>i.name === t);
            return this.Mc(r, i);
        });
    }
    register(t) {
        this.Ac(t, !1);
    }
    replace(t) {
        this.Ac(t, !0);
    }
    Ac(t, i) {
        var e;
        $0fb0e9cf977607be$var$R(null === (e = this._instance) || void 0 === e ? void 0 : e._addCaptureHook) || (this.Oc(t, i), this.Fc(t, i));
    }
    Fc(t, i) {
        const e = t.filter((t)=>{
            var i;
            return null === (i = t.conditions) || void 0 === i || null === (i = i.actions) || void 0 === i || null === (i = i.values) || void 0 === i ? void 0 : i.length;
        });
        var s;
        if (i && this.kc.clear(), 0 === e.length) return void (i && (null === (s = this.Dc) || void 0 === s || s.replace([])));
        this.Dc || (this.Dc = new $0fb0e9cf977607be$var$fh(this._instance), this.Dc.init(), this.Dc.dc((t)=>this.onAction(t)));
        const n = [];
        e.forEach((t)=>{
            var i;
            null === (i = t.conditions) || void 0 === i || null === (i = i.actions) || void 0 === i || i.values.forEach((i)=>{
                if (n.push(i), i.name) {
                    var e;
                    const s = null !== (e = this.kc.get(i.name)) && void 0 !== e ? e : [];
                    s.includes(t.id) || s.push(t.id), this.kc.set(i.name, s);
                }
            });
        }), i ? this.Dc.replace(n) : this.Dc.register(n);
    }
    Lc(t, i) {
        i.forEach((i, e)=>{
            var s;
            const n = null !== (s = t.get(e)) && void 0 !== s ? s : [];
            i.forEach((t)=>{
                n.includes(t) || n.push(t);
            }), t.set(e, n);
        });
    }
    Oc(t, i) {
        var e, s;
        const n = t.filter((t)=>{
            var i, e;
            return (null === (i = t.conditions) || void 0 === i ? void 0 : i.events) && (null === (e = t.conditions) || void 0 === e || null === (e = e.events) || void 0 === e || null === (e = e.values) || void 0 === e ? void 0 : e.length) > 0;
        }), r = t.filter((t)=>{
            var i, e;
            return (null === (i = t.conditions) || void 0 === i ? void 0 : i.cancelEvents) && (null === (e = t.conditions) || void 0 === e || null === (e = e.cancelEvents) || void 0 === e || null === (e = e.values) || void 0 === e ? void 0 : e.length) > 0;
        }), o = this.Ec(t, $0fb0e9cf977607be$export$352273f853caad57.Activation), l = this.Ec(t, $0fb0e9cf977607be$export$352273f853caad57.Cancellation);
        i ? (this._c = o, this.wc = l) : (this.Lc(this._c, o), this.Lc(this.wc, l)), (0 !== n.length || 0 !== r.length || t.some((t)=>{
            var i;
            return null === (i = t.conditions) || void 0 === i || null === (i = i.actions) || void 0 === i || null === (i = i.values) || void 0 === i ? void 0 : i.length;
        })) && (null !== (e = this.hc) && void 0 !== e || (this.hc = null === (s = this._instance) || void 0 === s ? void 0 : s._addCaptureHook((t, i)=>{
            this.onEvent(t, i);
        })));
    }
    onEvent(t, i) {
        var e, s;
        const n = this.Nc(), r = (null == i || null === (e = i.properties) || void 0 === e ? void 0 : e.$survey_id) || (null == i || null === (s = i.properties) || void 0 === s ? void 0 : s.$product_tour_id);
        if (r && this.getActivatedIds().includes(r)) {
            const e = this.qc(t, r, i);
            if ("consume" === e) return n.info("event consumed activated item, removing it", {
                event: t,
                itemId: r
            }), void this.jc([
                r
            ]);
            if ("persist" === e) return n.info("shown item promoted to persisted activation", {
                event: t,
                itemId: r
            }), this.Bc(r), void this.Hc([
                r
            ]);
        }
        if (this.wc.has(t)) {
            const e = this.Pc(t, i, $0fb0e9cf977607be$export$352273f853caad57.Cancellation);
            e.length > 0 && (n.info("cancel event matched, cancelling items", {
                event: t,
                itemsToCancel: e.map((t)=>t.id)
            }), this.jc(e.map((t)=>t.id)), e.forEach((t)=>this.zc(t.id)));
        }
        if (!this._c.has(t)) return;
        n.info("event name matched", {
            event: t,
            eventPayload: i,
            items: this._c.get(t)
        });
        const o = this.Pc(t, i, $0fb0e9cf977607be$export$352273f853caad57.Activation);
        this.Uc(o.map((t)=>t.id));
    }
    onAction(t) {
        this.kc.has(t) && this.Uc(this.kc.get(t) || []);
    }
    Uc(t) {
        var i, e;
        if (0 === t.length) return;
        const s = !!(null === (i = this._instance) || void 0 === i || null === (e = i.get_session_id) || void 0 === e ? void 0 : e.call(i)), n = [];
        for (const i of t)s && this.$c(i) ? this.Bc(i) && this.Wc(i) : n.push(i);
        n.length > 0 && (this.yc = [
            ...new Set([
                ...this.yc,
                ...n
            ])
        ]), this.Nc().info("updating activated items", {
            activatedItems: this.getActivatedIds()
        }), this.Vc();
    }
    Bc(t) {
        this.yc = this.yc.filter((i)=>i !== t);
        const i = this.Gc();
        return !i.includes(t) && (this.Qc([
            ...i,
            t
        ]), this.Jc(), !0);
    }
    jc(t) {
        const i = new Set(t);
        this.yc = this.yc.filter((t)=>!i.has(t));
        const e = this.Zc(), s = e.filter((t)=>!i.has(t));
        s.length !== e.length && (this.Qc(s), 0 === s.length && this.Kc()), this.Hc(t), this.Vc();
    }
    Vc() {
        try {
            var t;
            null === (t = this.bc) || void 0 === t || t.call(this);
        } catch (t) {
            this.Nc().error("Error while handling activated items change", t);
        }
    }
    Xc() {
        var t;
        const i = this.Cc();
        if (!i) return {};
        const e = null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t ? void 0 : t.props[i];
        return e && "object" == typeof e ? e : {};
    }
    Wc(t) {
        if (!this.Cc()) return;
        const i = this.Xc();
        this.Tc($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i), {}, {
            [t]: Date.now()
        }));
    }
    Hc(t) {
        if (!this.Cc()) return;
        const i = this.Xc(), e = {};
        let s = !1;
        for (const [n, r] of Object.entries(i))t.includes(n) ? s = !0 : e[n] = r;
        s && ($0fb0e9cf977607be$var$O(e) ? this.Ic() : this.Tc(e));
    }
    Yc() {
        this.Cc() && this.Ic();
    }
    getActivationTimestamp(t) {
        if (!this.Gc().includes(t)) return;
        const i = this.Xc()[t];
        return $0fb0e9cf977607be$var$D(i) ? i : void 0;
    }
    Zc() {
        var t;
        const i = this.td();
        return (null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t ? void 0 : t.props[i]) || [];
    }
    Gc() {
        var t, i, e;
        const s = this.Zc();
        if (0 === s.length) return [];
        const n = null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t ? void 0 : t.props[this.ed()], r = null === (i = this._instance) || void 0 === i || null === (e = i.get_session_id) || void 0 === e ? void 0 : e.call(i);
        return r && n === r ? s : [];
    }
    Jc() {
        var t, i;
        const e = null === (t = this._instance) || void 0 === t || null === (i = t.get_session_id) || void 0 === i ? void 0 : i.call(t);
        e && this.nd(e);
    }
    Kc() {
        this.sd();
    }
    xc(t) {
        var i;
        const e = null === (i = this._instance) || void 0 === i || null === (i = i.persistence) || void 0 === i ? void 0 : i.props[this.ed()];
        if (e && e !== t) {
            const t = this.Zc(), i = this.Xc();
            t.length > 0 && (this.Qc([]), t.filter((t)=>$0fb0e9cf977607be$var$D(i[t])).forEach((t)=>this.zc(t))), this.Kc(), this.Yc(), t.length > 0 && this.Vc();
        }
    }
    getActivatedIds() {
        return [
            ...new Set([
                ...this.Gc(),
                ...this.yc
            ])
        ].filter((t)=>!this.rd(t));
    }
    dispose() {
        var t, i, e;
        null === (t = this.Sc) || void 0 === t || t.call(this), this.Sc = void 0, null === (i = this.hc) || void 0 === i || i.call(this), this.hc = void 0, null === (e = this.Dc) || void 0 === e || e.dispose(), this.Dc = void 0;
    }
    reset() {
        this.yc = [], this.Zc().length > 0 && this.Qc([]), this.Kc(), this.Yc(), this.Vc();
    }
    getEventToItemsMap() {
        return this._c;
    }
    od() {
        return this.Dc;
    }
}, $0fb0e9cf977607be$var$_h = class extends $0fb0e9cf977607be$var$ph {
    constructor(t, i){
        super(t, i);
    }
    td() {
        return $0fb0e9cf977607be$var$Qs;
    }
    ed() {
        return $0fb0e9cf977607be$var$Zs;
    }
    Cc() {
        return $0fb0e9cf977607be$var$tn;
    }
    Tc(t) {
        var i;
        null === (i = this._instance) || void 0 === i || null === (i = i.persistence) || void 0 === i || i.register({
            $surveys_activated_timestamps: t
        });
    }
    Ic() {
        var t;
        null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t || t.unregister("$surveys_activated_timestamps");
    }
    $c(t) {
        var i;
        let e;
        this.Rc((i)=>{
            e = i.find((i)=>i.id === t);
        });
        const s = null == e || null === (i = e.appearance) || void 0 === i ? void 0 : i.surveyPopupDelaySeconds;
        return $0fb0e9cf977607be$var$D(s) && s > 0;
    }
    ad() {
        return $0fb0e9cf977607be$export$9d7ec1793ca1658e.SHOWN;
    }
    Rc(t) {
        var i;
        null === (i = this._instance) || void 0 === i || i.getSurveys(t);
    }
    zc(t) {
        var i;
        null === (i = this._instance) || void 0 === i || i.cancelPendingSurvey(t);
    }
    Nc() {
        return $0fb0e9cf977607be$var$eu;
    }
    Qc(t) {
        var i;
        null === (i = this._instance) || void 0 === i || null === (i = i.persistence) || void 0 === i || i.register({
            $surveys_activated: t
        });
    }
    nd(t) {
        var i;
        null === (i = this._instance) || void 0 === i || null === (i = i.persistence) || void 0 === i || i.register({
            $surveys_activated_session: t
        });
    }
    sd() {
        var t;
        null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t || t.unregister("$surveys_activated_session");
    }
    rd() {
        return !1;
    }
    qc(t, i, e) {
        var s;
        if (t === $0fb0e9cf977607be$export$9d7ec1793ca1658e.SENT && !1 === (null == e || null === (s = e.properties) || void 0 === s ? void 0 : s.$survey_completed)) return "ignore";
        let n;
        return this.Rc((t)=>{
            n = t.find((t)=>t.id === i);
        }), !n || function(t) {
            var i;
            return $0fb0e9cf977607be$var$Va(t) && !!(null === (i = t.conditions) || void 0 === i || null === (i = i.events) || void 0 === i ? void 0 : i.repeatedActivation) || "always" === t.schedule;
        }(n) ? t === $0fb0e9cf977607be$export$9d7ec1793ca1658e.SHOWN ? "consume" : "ignore" : t === $0fb0e9cf977607be$export$9d7ec1793ca1658e.SHOWN ? "persist" : t === $0fb0e9cf977607be$export$9d7ec1793ca1658e.DISMISSED || t === $0fb0e9cf977607be$export$9d7ec1793ca1658e.SENT ? "consume" : "ignore";
    }
    getSurveys() {
        return this.getActivatedIds();
    }
    getEventToSurveys() {
        return this.getEventToItemsMap();
    }
}, $0fb0e9cf977607be$var$gh = class {
    constructor(t){
        this._instance = t;
    }
    initialize() {}
    get(t) {
        if ("string" == typeof t) return this._instance.get_property(t);
        const i = {};
        for (const e of t){
            const t = this._instance.get_property(e);
            $0fb0e9cf977607be$var$R(t) || (i[e] = t);
        }
        return i;
    }
    set(t, i) {
        this._instance.register("string" == typeof t ? {
            [t]: i
        } : t);
    }
    remove(t) {
        "string" != typeof t ? t.forEach((t)=>this._instance.unregister(t)) : this._instance.unregister(t);
    }
}, $0fb0e9cf977607be$var$mh = class {
    constructor(t){
        this._instance = t;
    }
    get() {
        const t = this._instance.config;
        return {
            disableSurveys: t.disable_surveys,
            cookielessMode: !!t.cookieless_mode,
            advancedEnableSurveys: t.advanced_enable_surveys,
            requestTimeoutMs: t.surveys_request_timeout_ms
        };
    }
    isOptedOut() {
        return this._instance.consent.isOptedOut();
    }
    isCapturing() {
        return this._instance.is_capturing();
    }
    getExtensions() {
        const t = null == $0fb0e9cf977607be$var$c ? void 0 : $0fb0e9cf977607be$var$c.__PosthogExtensions__;
        if (!t) return;
        const { generateSurveys: i, loadExternalDependency: e } = t;
        return {
            generateSurveys: i ? (t)=>i(this._instance, t) : void 0,
            loadExternalDependency: e ? (t)=>e(this._instance, "surveys", t) : void 0
        };
    }
    createEventReceiver(t) {
        return new $0fb0e9cf977607be$var$_h(this._instance, t);
    }
    onMatchingConditionsChanged(i) {
        const e = this._instance._addCaptureHook((t)=>{
            "$pageview" !== t && t !== $0fb0e9cf977607be$export$9d7ec1793ca1658e.SHOWN && t !== $0fb0e9cf977607be$export$9d7ec1793ca1658e.DISMISSED && t !== $0fb0e9cf977607be$export$9d7ec1793ca1658e.SENT || i();
        }), s = ()=>i();
        $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "PHSurveyShown", s);
        let n = !1;
        const r = this._instance.onFeatureFlags(()=>{
            n && i();
        });
        return n = !0, ()=>{
            n = !1, e(), r(), null == $0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$t.removeEventListener("PHSurveyShown", s);
        };
    }
};
const $0fb0e9cf977607be$var$bh = (null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.location) ? $0fb0e9cf977607be$var$Ao($0fb0e9cf977607be$var$t.location.hash, "__posthog") || $0fb0e9cf977607be$var$Ao(location.hash, "state") : null, $0fb0e9cf977607be$var$yh = "_postHogToolbarParams", $0fb0e9cf977607be$var$wh = $0fb0e9cf977607be$var$Ye("[Toolbar]"), $0fb0e9cf977607be$var$$h = $0fb0e9cf977607be$var$Ye("[FeatureFlags]");
var $0fb0e9cf977607be$var$Sh = class {
    constructor(t, i = !1){
        this.ld = !1, this.update(t, i);
    }
    update(t, i) {
        this.ud = ((t, i)=>{
            var e, s, n, r, o, l, a, u;
            return {
                bootstrap: {
                    featureFlags: null !== (e = null === (s = t.bootstrap) || void 0 === s ? void 0 : s.featureFlags) && void 0 !== e ? e : void 0,
                    featureFlagPayloads: null !== (n = null === (r = t.bootstrap) || void 0 === r ? void 0 : r.featureFlagPayloads) && void 0 !== n ? n : void 0
                },
                remoteRequestsDisabled: i,
                featureFlagsDisabled: !!t.advanced_disable_feature_flags,
                onlyEvaluateSurveyFeatureFlags: !!t.advanced_only_evaluate_survey_feature_flags,
                deduplicateCallsPerSession: !!t.advanced_feature_flags_dedup_per_session,
                cacheTtlMs: t.feature_flag_cache_ttl_ms,
                refreshIntervalMs: null !== (o = t.remote_config_refresh_interval_ms) && void 0 !== o ? o : 3e5,
                idleRefreshBackoff: $0fb0e9cf977607be$var$R(t.remote_config_refresh_interval_ms),
                requestTimeoutMs: t.feature_flag_request_timeout_ms,
                requestMaxRetries: Math.max(0, null !== (l = t.feature_flag_request_max_retries) && void 0 !== l ? l : 1),
                compression: t.disable_compression ? void 0 : "best-available",
                evaluationContexts: null !== (a = null !== (u = t.evaluation_contexts) && void 0 !== u ? u : t.evaluation_environments) && void 0 !== a ? a : [],
                flagKeys: $0fb0e9cf977607be$var$T(t.flag_keys) ? t.flag_keys : void 0
            };
        })(t, i), !t.evaluation_environments || t.evaluation_contexts || this.ld || ($0fb0e9cf977607be$var$$h.warn("evaluation_environments is deprecated. Use evaluation_contexts instead. evaluation_environments will be removed in a future version."), this.ld = !0), $0fb0e9cf977607be$var$R(t.flag_keys) || $0fb0e9cf977607be$var$T(t.flag_keys) || $0fb0e9cf977607be$var$$h.error("Invalid flag_keys found:", t.flag_keys, "Expected array of non-empty strings");
    }
    get() {
        return this.ud;
    }
};
const $0fb0e9cf977607be$var$xh = $0fb0e9cf977607be$var$Ye("[FeatureFlags]"), $0fb0e9cf977607be$var$Eh = $0fb0e9cf977607be$var$Ye("[FeatureFlags]", {
    debugEnabled: !0
}), $0fb0e9cf977607be$var$kh = "\" failed. Feature flags didn't load in time.", $0fb0e9cf977607be$var$Th = [
    502,
    504
], $0fb0e9cf977607be$var$Ph = [
    "click",
    "keydown",
    "wheel",
    "touchstart",
    "pointerdown"
], $0fb0e9cf977607be$var$Ch = "connection_error", $0fb0e9cf977607be$var$Oh = (t)=>{
    const i = {};
    for(let e = 0; t.length > e; e++)i[t[e]] = !0;
    return i;
}, $0fb0e9cf977607be$var$Rh = (t)=>{
    const i = {};
    for (const [e, s] of $0fb0e9cf977607be$var$Gn(t || {}))s && (i[e] = s);
    return i;
}, $0fb0e9cf977607be$var$Ih = (t)=>$0fb0e9cf977607be$var$H(t) && ("RangeError" === t.name && 0 === t.message.indexOf("Maximum call stack size exceeded") || "InternalError" === t.name && "too much recursion" === t.message), $0fb0e9cf977607be$var$Mh = $0fb0e9cf977607be$var$Ye("[Error tracking]"), $0fb0e9cf977607be$var$Ah = "webkit-masked-url:", $0fb0e9cf977607be$var$Fh = [
    {
        value: "isolatedAPI.contexts.topHostname",
        exact: !1
    },
    {
        value: "No response from target",
        exact: !0
    }
], $0fb0e9cf977607be$var$Dh = [
    "chrome-extension://",
    "moz-extension://",
    "safari-extension:",
    "safari-web-extension:",
    $0fb0e9cf977607be$var$Ah
], $0fb0e9cf977607be$var$Nh = [
    "__firefox__",
    "__gCrWeb"
], $0fb0e9cf977607be$var$jh = "Refusing to render web experiment since the viewer is a likely bot", $0fb0e9cf977607be$var$Lh = {
    icontains: (t, i)=>i.toLowerCase().indexOf(t.toLowerCase()) > -1,
    not_icontains: (t, i)=>-1 === i.toLowerCase().indexOf(t.toLowerCase()),
    regex: (t, i)=>$0fb0e9cf977607be$var$Wa(i, t),
    not_regex: (t, i)=>!$0fb0e9cf977607be$var$Wa(i, t),
    exact: (t, i)=>i === t,
    is_not: (t, i)=>i !== t
}, $0fb0e9cf977607be$var$Bh = $0fb0e9cf977607be$var$Ye("[Conversations]"), $0fb0e9cf977607be$var$Uh = "Conversations not available yet.";
function $0fb0e9cf977607be$var$zh(t, i) {
    var s, n, r, o, l, a, u;
    const h = null !== (s = null == t ? void 0 : t.flushIntervalMs) && void 0 !== s ? s : 3e3, d = null !== (n = null == t ? void 0 : t.maxBufferSize) && void 0 !== n ? n : 100, c = (null == i ? void 0 : i.consoleCapture) ? void 0 : null !== (r = null == t ? void 0 : t.maxLogsPerInterval) && void 0 !== r ? r : 1e3, v = $0fb0e9cf977607be$var$R(c) ? Math.max(d, 2048) : Math.max(d, c), f = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, function() {
        let t = "", i = "";
        try {
            const s = null == $0fb0e9cf977607be$var$e ? void 0 : $0fb0e9cf977607be$var$e.userAgent;
            s && ([t, i] = $0fb0e9cf977607be$var$Zt(s));
        } catch (t) {}
        return function(t, i) {
            const e = function(t) {
                if (t) return ({}).hasOwnProperty.call($0fb0e9cf977607be$var$Me, t) ? $0fb0e9cf977607be$var$Me[t] : t;
            }(t);
            return $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, e ? {
                "os.name": e
            } : {}), i ? {
                "os.version": i
            } : {});
        }(t, i);
    }()), null == t ? void 0 : t.resourceAttributes);
    return {
        serviceName: null !== (o = null !== (l = null == f ? void 0 : f["service.name"]) && void 0 !== l ? l : null == t ? void 0 : t.serviceName) && void 0 !== o ? o : null == i ? void 0 : i.serviceNameDefault,
        serviceVersion: null !== (a = null == f ? void 0 : f["service.version"]) && void 0 !== a ? a : null == t ? void 0 : t.serviceVersion,
        environment: null !== (u = null == f ? void 0 : f["deployment.environment"]) && void 0 !== u ? u : null == t ? void 0 : t.environment,
        resourceAttributes: f,
        beforeSend: null == t ? void 0 : t.beforeSend,
        flushIntervalMs: h,
        maxBufferSize: d,
        maxQueueSize: v,
        maxBatchRecordsPerPost: 100,
        rateCapWindowMs: h,
        maxLogsPerInterval: c,
        backgroundFlushBudgetMs: 0,
        terminationFlushBudgetMs: 0
    };
}
const $0fb0e9cf977607be$var$Hh = [
    "debug",
    "log",
    "warn",
    "error",
    "info"
], $0fb0e9cf977607be$var$qh = (t)=>{
    for(; null == t ? void 0 : t.__rrweb_original__;)t = t.__rrweb_original__;
    return t;
}, $0fb0e9cf977607be$var$Vh = "console", $0fb0e9cf977607be$var$Wh = "__posthogHandledLogsRequestError", $0fb0e9cf977607be$var$Gh = (t, i)=>{
    const e = t instanceof Error ? t : new Error(i);
    return e[$0fb0e9cf977607be$var$Wh] = !0, e;
}, $0fb0e9cf977607be$var$Kh = (t)=>!!t && "object" == typeof t && !0 === t[$0fb0e9cf977607be$var$Wh], $0fb0e9cf977607be$var$Jh = $0fb0e9cf977607be$var$Ye("[NetworkMetrics]"), $0fb0e9cf977607be$var$Yh = ()=>{
    var i;
    return (null == $0fb0e9cf977607be$var$t || null === (i = $0fb0e9cf977607be$var$t.performance) || void 0 === i ? void 0 : i.now) ? $0fb0e9cf977607be$var$t.performance.now() : Date.now();
}, $0fb0e9cf977607be$var$Xh = {
    "http:": 80,
    "https:": 443
}, $0fb0e9cf977607be$var$Qh = new Set([
    "CONNECT",
    "DELETE",
    "GET",
    "HEAD",
    "OPTIONS",
    "PATCH",
    "POST",
    "PUT",
    "TRACE"
]), $0fb0e9cf977607be$var$Zh = (t, i)=>{
    var e;
    const s = String(i);
    return {
        method: String(t).toUpperCase(),
        url: (null === (e = $0fb0e9cf977607be$var$Ro(s)) || void 0 === e ? void 0 : e.href) || s
    };
}, $0fb0e9cf977607be$var$td = (t, i, e, s, n, r, o = !1)=>{
    try {
        var l, a;
        const u = n();
        if (!u) return;
        const h = e || void 0, d = $0fb0e9cf977607be$var$Yh() - s, c = $0fb0e9cf977607be$var$Ro(i.url);
        if (c && "http:" !== c.protocol && "https:" !== c.protocol) return;
        const v = {
            url: (null == c ? void 0 : c.href) || i.url,
            method: i.method
        }, f = $0fb0e9cf977607be$var$P(u.name) ? u.name(v) : $0fb0e9cf977607be$var$I(u.name) ? u.name : "http.client.request.duration";
        if (!f) return;
        const p = o && !h ? void 0 : ((t, i)=>t ? 400 > t ? void 0 : String(t) : (null == i ? void 0 : i.name) || "_OTHER")(h, r), _ = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, ((t)=>{
            const i = $0fb0e9cf977607be$var$Qh.has(t) ? t : "_OTHER";
            return $0fb0e9cf977607be$var$Ei({
                "http.request.method": i
            }, "_OTHER" === i && t !== i ? {
                "http.request.method_original": t
            } : {});
        })(v.method)), c ? ((t)=>{
            var i;
            return {
                "server.address": t.hostname.startsWith("[") && t.hostname.endsWith("]") ? t.hostname.slice(1, -1) : t.hostname,
                "server.port": Number(t.port) || $0fb0e9cf977607be$var$Xh[t.protocol],
                "url.scheme": t.protocol.slice(0, -1),
                "url.template": (i = t.pathname, i.split("/").map((t)=>((t)=>/^\d+$/.test(t) || t.length >= 8 && /^[0-9a-f-]*\d[0-9a-f-]*$/i.test(t))(t) ? ":id" : t).join("/"))
            };
        })(c) : {}), h ? {
            "http.response.status_code": h
        } : {}), p ? {
            "error.type": p
        } : {}), null === (l = u.attributes) || void 0 === l ? void 0 : l.call(u, v, {
            status: h,
            durationMs: d
        }));
        null === (a = t.metrics) || void 0 === a || a.histogram(f, d, {
            unit: "ms",
            attributes: _
        });
    } catch (t) {
        $0fb0e9cf977607be$var$Jh.error("Failed to record network metric", t);
    }
}, $0fb0e9cf977607be$var$id = ()=>{}, $0fb0e9cf977607be$var$ed = (i, e)=>$0fb0e9cf977607be$var$P(null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.fetch) ? $0fb0e9cf977607be$var$Vu($0fb0e9cf977607be$var$t, "fetch", (t)=>function(...s) {
            const n = $0fb0e9cf977607be$var$Yh(), r = t.apply(this, s);
            if (!e()) return r;
            try {
                var o, l, a;
                const [t, u] = s, h = $0fb0e9cf977607be$var$Zh(null !== (o = null !== (l = null == u ? void 0 : u.method) && void 0 !== l ? l : null == t ? void 0 : t.method) && void 0 !== o ? o : "GET", null !== (a = null == t ? void 0 : t.url) && void 0 !== a ? a : t);
                return r.then((t)=>($0fb0e9cf977607be$var$td(i, h, null == t ? void 0 : t.status, n, e, void 0, !0), t), (t)=>{
                    throw $0fb0e9cf977607be$var$td(i, h, void 0, n, e, t), t;
                });
            } catch (t) {
                return $0fb0e9cf977607be$var$Jh.error("Failed to observe fetch", t), r;
            }
        }) : $0fb0e9cf977607be$var$id, $0fb0e9cf977607be$var$sd = (i, e)=>{
    var s;
    const n = null == $0fb0e9cf977607be$var$t || null === (s = $0fb0e9cf977607be$var$t.XMLHttpRequest) || void 0 === s ? void 0 : s.prototype;
    if (!n) return $0fb0e9cf977607be$var$id;
    const r = new WeakMap, o = $0fb0e9cf977607be$var$Vu(n, "open", (t)=>function(...i) {
            try {
                (()=>$0fb0e9cf977607be$var$ca.has(this))() || r.set(this, $0fb0e9cf977607be$var$Zh(i[0], i[1]));
            } catch (t) {
                $0fb0e9cf977607be$var$Jh.error("Failed to observe XHR open", t);
            }
            return t.apply(this, i);
        }), l = $0fb0e9cf977607be$var$Vu(n, "send", (t)=>function(...s) {
            let n;
            try {
                const t = r.get(this);
                if (t && e()) {
                    const s = $0fb0e9cf977607be$var$Yh();
                    n = ()=>{
                        this.removeEventListener("loadend", n), $0fb0e9cf977607be$var$td(i, t, this.status, s, e);
                    }, $0fb0e9cf977607be$var$Zn(this, "loadend", n);
                }
            } catch (t) {
                $0fb0e9cf977607be$var$Jh.error("Failed to observe XHR send", t);
            }
            try {
                return t.apply(this, s);
            } catch (t) {
                throw n && this.removeEventListener("loadend", n), t;
            }
        });
    return ()=>{
        o(), l();
    };
}, $0fb0e9cf977607be$var$nd = {
    featureFlags: class {
        constructor(t){
            this.name = "featureFlags", this.hd = !1, this.featureFlagEventHandlers = [], this.A = $0fb0e9cf977607be$var$xh, this.dd = {}, this.vd = {}, this.fd = [], this.pd = !1, this.gd = !1, this.md = 0, this.yd = !1, this.bd = !1, this._d = !1, this.wd = !1, this.kd = 0, this.Sd = !1, this.rn = ()=>{
                const t = this.xd();
                this.kd = 0, t && this.reloadFeatureFlags();
            }, this.$d = ()=>{
                var t, i;
                const e = this.Cd, n = null !== (t = this.Td) && void 0 !== t ? t : e;
                $0fb0e9cf977607be$var$R(e) || $0fb0e9cf977607be$var$R(n) || this.Mr.remoteRequestsDisabled || !$0fb0e9cf977607be$var$s || "hidden" === $0fb0e9cf977607be$var$s.visibilityState || Date.now() - (null !== (i = this.Id) && void 0 !== i ? i : 0) < n || (this.Td = this.Sd || !this.Mr.idleRefreshBackoff ? e : Math.min(2 * n, 36e5), this.Sd = !1, this.reloadFeatureFlags(), this.Md());
            }, this.Ed = ()=>{
                this.Sd && this.Td === this.Cd || this.Pd();
            }, this.sn = ()=>{
                "visible" === (null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.visibilityState) && this.Pd();
            }, "get" in t ? this.wo = t : (this._instance = t, this.Rd = new $0fb0e9cf977607be$var$Sh(t.config, t.il()), this.wo = this.Rd);
        }
        updateConfig(t, i) {
            var e;
            null === (e = this.Rd) || void 0 === e || e.update(t, i), this.bo && this.Ad();
        }
        setup(t) {
            return this.jh = t, this.A = t.logger.createLogger("[FeatureFlags]"), $0fb0e9cf977607be$var$uh(t.kv.initialize(), ()=>{
                this.jh === t && (this.jh = void 0, this.bo = t, this.Od(t));
            });
        }
        Od(i) {
            var e;
            if (this.bo === i) return $0fb0e9cf977607be$var$t && $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "online", this.rn), this.Ad(), this.Fd = i.registerDynamicEventProperties(()=>this.Dd() ? this.dd : this.vd), this.Ld = null === (e = this._instance) || void 0 === e || null === (e = e.persistence) || void 0 === e ? void 0 : e.onCrossTabFeatureFlagChange(()=>{
                this.Nd(), this.qd(), this.jd();
            }), this.qd(), this.initialize();
        }
        Pd() {
            this.Sd = !0, this.Td = this.Cd, this.$d();
        }
        Ad() {
            const t = this.Mr.refreshIntervalMs, i = !this.Mr.remoteRequestsDisabled && $0fb0e9cf977607be$var$s && !$0fb0e9cf977607be$var$R(t) && t > 0 ? t : void 0;
            this.Mr.idleRefreshBackoff || (this.Td = i), i !== this.Cd && (this.Bd(), $0fb0e9cf977607be$var$R(i) || (this.Cd = i, this.Td = i, this.Md(), (null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.addEventListener) && ($0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, $0fb0e9cf977607be$var$jn, this.sn), $0fb0e9cf977607be$var$qn($0fb0e9cf977607be$var$Ph, (t)=>{
                $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, t, this.Ed, {
                    capture: !0
                });
            }))));
        }
        Md() {
            $0fb0e9cf977607be$var$R(this.Cd) || ($0fb0e9cf977607be$var$R(this.Hd) || clearInterval(this.Hd), this.Id = Date.now(), this.Hd = setInterval(this.$d, this.Cd));
        }
        Bd() {
            var t;
            $0fb0e9cf977607be$var$R(this.Hd) || (clearInterval(this.Hd), this.Hd = void 0, null == $0fb0e9cf977607be$var$s || null === (t = $0fb0e9cf977607be$var$s.removeEventListener) || void 0 === t || t.call($0fb0e9cf977607be$var$s, "visibilitychange", this.sn), $0fb0e9cf977607be$var$qn($0fb0e9cf977607be$var$Ph, (t)=>{
                var i;
                null == $0fb0e9cf977607be$var$s || null === (i = $0fb0e9cf977607be$var$s.removeEventListener) || void 0 === i || i.call($0fb0e9cf977607be$var$s, t, this.Ed, {
                    capture: !0
                });
            })), this.Cd = void 0, this.Td = void 0, this.Sd = !1, this.Id = void 0;
        }
        destroy() {
            this.zd();
        }
        dispose() {
            this.zd();
        }
        zd() {
            var i, e;
            this.Bd(), this.md++, this.bd = !1, this.jh = void 0, this.bo && (this.Ud(), null === (i = this.Fd) || void 0 === i || i.dispose(), this.Fd = void 0, null === (e = this.Ld) || void 0 === e || e.call(this), this.Ld = void 0, this.fd = [], null == $0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$t.removeEventListener("online", this.rn), this.bo = void 0);
        }
        get Mr() {
            return this.wo.get();
        }
        Wd(t) {
            var i;
            return this.Vd && t in this.Vd ? this.Vd[t] : null === (i = this.bo) || void 0 === i ? void 0 : i.kv.get(t);
        }
        Nd() {
            return !!this.Vd && (this.Vd = void 0, !0);
        }
        Gd() {
            var t;
            return !$0fb0e9cf977607be$var$R(null === (t = this.bo) || void 0 === t ? void 0 : t.kv.get("$enabled_feature_flags")) && this.Nd();
        }
        $t(t) {
            this.Qd(()=>{
                var i;
                return null === (i = this.bo) || void 0 === i ? void 0 : i.kv.set(t);
            });
        }
        Jd(t, i, e) {
            var s;
            if (!(null === (s = this._instance) || void 0 === s ? void 0 : s.persistence) || !t.$enabled_feature_flags) return;
            const n = this.Wd("$enabled_feature_flags") || {}, r = t.$enabled_feature_flags || {}, o = i.flags || i.featureFlags, l = i.flags ? Object.entries(i.flags).filter(([, t])=>!(null == t ? void 0 : t.failed)).map(([t])=>t) : [], a = !!i.errorsWhileComputingFlags && !!i.flags, u = a ? l : e && !$0fb0e9cf977607be$var$T(o) ? Object.keys(o || {}) : Array.from(new Set([
                ...Object.keys(n),
                ...Object.keys(r)
            ])), h = this.Wd("$feature_flag_payloads") || {}, d = t.$feature_flag_payloads || {}, c = a || e ? u : Array.from(new Set([
                ...Object.keys(h),
                ...Object.keys(d)
            ])), v = !a && !e, f = !!v || u, p = !!v || c, _ = {
                [$0fb0e9cf977607be$var$Ls]: f,
                [$0fb0e9cf977607be$var$js]: f,
                [$0fb0e9cf977607be$var$zs]: p
            };
            t.$feature_flag_details && (_[$0fb0e9cf977607be$var$Us] = f);
            for (const i of [
                $0fb0e9cf977607be$var$Hs,
                $0fb0e9cf977607be$var$cn,
                $0fb0e9cf977607be$var$qs
            ])$0fb0e9cf977607be$var$R(t[i]) || (_[i] = !0);
            this._instance.persistence.markCrossTabFeatureFlagChanges(_);
        }
        Pt(t) {
            this.Qd(()=>{
                var i;
                return null === (i = this.bo) || void 0 === i ? void 0 : i.kv.remove(t);
            });
        }
        Qd(t) {
            try {
                t();
            } catch (t) {
                this.A.error("Failed to update feature flag persistence", t);
            }
        }
        qd() {
            const t = {};
            for (const i of [
                $0fb0e9cf977607be$var$Ls,
                $0fb0e9cf977607be$var$zs,
                $0fb0e9cf977607be$var$Hs,
                $0fb0e9cf977607be$var$Vs
            ]){
                const e = this.Wd(i);
                $0fb0e9cf977607be$var$R(e) || (t[i] = e);
            }
            this.dd = t;
            const i = $0fb0e9cf977607be$var$Ei({}, t), e = this.Wd($0fb0e9cf977607be$var$js);
            if (e) for (const [t, s] of Object.entries(e))i[`$feature/${t}`] = s;
            this.vd = i;
        }
        Dd() {
            const t = this.Mr.cacheTtlMs;
            if (!t || 0 >= t) return !1;
            const i = this.Wd($0fb0e9cf977607be$var$cn);
            return "number" != typeof i || Date.now() - i > t;
        }
        Zd() {
            return !!this.Dd() && (this.wd || this.gd || (this.wd = !0, this.A.warn("Feature flag cache is stale, triggering refresh..."), this.reloadFeatureFlags()), !0);
        }
        Kd() {
            const t = this.Mr.evaluationContexts;
            return (null == t ? void 0 : t.length) ? t.filter((t)=>{
                const i = t && "string" == typeof t && t.trim().length > 0;
                return i || this.A.error("Invalid evaluation context found:", t, "Expected non-empty string"), i;
            }) : [];
        }
        Xd() {
            const t = this.Mr.flagKeys;
            if (!$0fb0e9cf977607be$var$R(t)) return t.filter((t)=>{
                const i = t && "string" == typeof t && t.trim().length > 0;
                return i || this.A.error("Invalid flag key found:", t, "Expected non-empty string"), i;
            });
        }
        initialize() {
            var t, i;
            const e = this.Mr, s = null !== (t = null === (i = e.bootstrap) || void 0 === i ? void 0 : i.featureFlags) && void 0 !== t ? t : {};
            if (Object.keys(s).length) {
                var n, r;
                const t = null !== (n = null === (r = e.bootstrap) || void 0 === r ? void 0 : r.featureFlagPayloads) && void 0 !== n ? n : {}, i = Object.keys(s).filter((t)=>!$0fb0e9cf977607be$var$R(s[t])).reduce((t, i)=>(t[i] = s[i], t), {}), o = Object.keys(t).filter((t)=>i[t]).reduce((i, e)=>(i[e] = t[e], i), {});
                return this.Yd({
                    featureFlags: i,
                    featureFlagPayloads: o
                }, void 0, {
                    persist: !1
                });
            }
        }
        updateFlags(t, i, e) {
            var s, n;
            const r = (null == e ? void 0 : e.merge) && null !== (s = this.Wd("$enabled_feature_flags")) && void 0 !== s ? s : {}, o = (null == e ? void 0 : e.merge) && null !== (n = this.Wd("$feature_flag_payloads")) && void 0 !== n ? n : {}, l = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, r), t), a = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, o), i), u = {};
            for (const [t, i] of Object.entries(l))u[t] = {
                key: t,
                enabled: $0fb0e9cf977607be$var$ce(i),
                variant: $0fb0e9cf977607be$var$ve(i),
                reason: void 0,
                metadata: $0fb0e9cf977607be$var$R(null == a ? void 0 : a[t]) ? void 0 : {
                    id: 0,
                    version: void 0,
                    description: void 0,
                    payload: a[t]
                }
            };
            this.Yd({
                flags: u
            });
        }
        get hasLoadedFlags() {
            return this.pd;
        }
        getFlags() {
            return Object.keys(this.getFlagVariants());
        }
        getFlagsWithDetails() {
            const t = this.Wd($0fb0e9cf977607be$var$Us), i = this.Wd($0fb0e9cf977607be$var$Vs), e = this.Wd($0fb0e9cf977607be$var$Ws);
            if (!e && !i) return t || {};
            const s = $0fb0e9cf977607be$var$Wn({}, t || {}), n = [
                ...new Set([
                    ...Object.keys(e || {}),
                    ...Object.keys(i || {})
                ])
            ];
            for (const t of n){
                var r;
                const n = s[t], l = null == i ? void 0 : i[t], a = $0fb0e9cf977607be$var$R(l) ? null !== (r = null == n ? void 0 : n.enabled) && void 0 !== r && r : !!l, u = $0fb0e9cf977607be$var$R(l) ? null == n ? void 0 : n.variant : "string" == typeof l ? l : void 0, h = null == e ? void 0 : e[t], d = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, n), {}, {
                    enabled: a,
                    variant: a ? null != u ? u : null == n ? void 0 : n.variant : void 0
                });
                var o;
                a !== (null == n ? void 0 : n.enabled) && (d.original_enabled = null == n ? void 0 : n.enabled), u !== (null == n ? void 0 : n.variant) && (d.original_variant = null == n ? void 0 : n.variant), h && (d.metadata = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, null == n ? void 0 : n.metadata), {}, {
                    payload: h,
                    original_payload: null == n || null === (o = n.metadata) || void 0 === o ? void 0 : o.payload
                })), s[t] = d;
            }
            return this.hd || (this.A.warn(" Overriding feature flag details!", {
                flagDetails: t,
                overriddenPayloads: e,
                finalDetails: s
            }), this.hd = !0), s;
        }
        getAllFeatureFlags() {
            const t = this.getFlagVariants(), i = this.getFlagPayloads();
            return Object.keys(t).map((e)=>{
                const s = t[e];
                return {
                    key: e,
                    enabled: $0fb0e9cf977607be$var$ce(s),
                    variant: $0fb0e9cf977607be$var$ve(s),
                    payload: $0fb0e9cf977607be$var$de(i[e])
                };
            });
        }
        getFlagVariants() {
            const t = this.Wd($0fb0e9cf977607be$var$js), i = this.Wd($0fb0e9cf977607be$var$Vs);
            if (!i) return t || {};
            const e = $0fb0e9cf977607be$var$Wn({}, t || {}), s = Object.keys(i);
            for(let t = 0; s.length > t; t++)e[s[t]] = i[s[t]];
            return this.hd || (this.A.warn(" Overriding feature flags!", {
                enabledFlags: t,
                overriddenFlags: i,
                finalFlags: e
            }), this.hd = !0), e;
        }
        getFlagPayloads() {
            const t = this.Wd($0fb0e9cf977607be$var$zs), i = this.Wd($0fb0e9cf977607be$var$Ws);
            if (!i) return t || {};
            const e = $0fb0e9cf977607be$var$Wn({}, t || {}), s = Object.keys(i);
            for(let t = 0; s.length > t; t++)e[s[t]] = i[s[t]];
            return this.hd || (this.A.warn(" Overriding feature flag payloads!", {
                flagPayloads: t,
                overriddenPayloads: i,
                finalPayloads: e
            }), this.hd = !0), e;
        }
        reloadFeatureFlags() {
            this.yd || this.Mr.featureFlagsDisabled || this.xd() || (this.gd && (this.bd = !0), this.tv || (this.fd.slice().forEach((t)=>{
                try {
                    t();
                } catch (t) {
                    this.A.error("Error while running feature flags reloading callback", t);
                }
            }), this.tv = setTimeout(()=>{
                this.ev();
            }, 5)));
        }
        Ud() {
            clearTimeout(this.tv), this.tv = void 0;
        }
        onReloading(t) {
            return this.fd.push(t), ()=>{
                this.fd = this.fd.filter((i)=>i !== t);
            };
        }
        ensureFlagsLoaded() {
            this.pd || this.gd || this.tv || this.reloadFeatureFlags();
        }
        setAnonymousDistinctId(t) {
            this.$anon_distinct_id = t;
        }
        setReloadingPaused(t) {
            this.yd = t;
        }
        resetFlagCallReported() {
            this.Pt($0fb0e9cf977607be$var$un);
        }
        ev(t) {
            this.Ud();
            const i = this.bo;
            if (!i || this.Mr.remoteRequestsDisabled || this.xd()) return;
            if (this.gd) return void (this.bd = !0);
            const e = {
                token: i.projectToken,
                distinct_id: i.distinctId,
                groups: i.groups,
                $anon_distinct_id: this.$anon_distinct_id,
                person_properties: $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i.initialPersonProperties), this.Wd("$stored_person_properties") || {}), {}, {
                    $lib: i.library.name,
                    $lib_version: i.library.version
                }),
                group_properties: this.Wd($0fb0e9cf977607be$var$Ks),
                timezone: $0fb0e9cf977607be$var$Yo()
            };
            $0fb0e9cf977607be$var$R(i.deviceId) || (e.$device_id = i.deviceId), ((null == t ? void 0 : t.disableFlags) || this.Mr.featureFlagsDisabled) && (e.disable_flags = !0);
            const s = this.Kd();
            s.length && (e.evaluation_contexts = s);
            const n = this.Xd();
            $0fb0e9cf977607be$var$R(n) || (e.flag_keys = n);
            const r = this.Mr.onlyEvaluateSurveyFeatureFlags, o = "/flags/?v=2" + (r ? "&only_evaluate_survey_feature_flags=true" : ""), l = this.md;
            this.gd = !0;
            const a = ()=>{
                this.bd && (this.bd = !1, this.ev());
            }, u = (t)=>{
                var i, s;
                const n = null !== (i = t.json) && void 0 !== i ? i : {}, o = 200 !== t.statusCode;
                if (this.gd = !1, l !== this.md) return void a();
                if (this.iv(t.statusCode), o || this.bd || (this.$anon_distinct_id = void 0), e.disable_flags && !this.bd) return;
                this._d = !o;
                const u = [];
                t.error ? u.push(t.error instanceof Error && "AbortError" === t.error.name ? "timeout" : t.error instanceof Error ? $0fb0e9cf977607be$var$Ch : "unknown_error") : 200 !== t.statusCode && u.push(`api_error_${t.statusCode}`), n.errorsWhileComputingFlags && u.push("errors_while_computing_flags");
                const h = !!(null === (s = n.quotaLimited) || void 0 === s ? void 0 : s.includes("feature_flags"));
                h && u.push("quota_limited"), this.$t({
                    [$0fb0e9cf977607be$var$dn]: u
                }), h ? this.A.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.") : e.disable_flags || this.Yd(n, o, {
                    partialResponse: r
                }), a();
            }, h = (t)=>{
                this.gd = !1, l === this.md ? (this.$t({
                    [$0fb0e9cf977607be$var$dn]: [
                        $0fb0e9cf977607be$var$Ch
                    ]
                }), this.A.error("Feature flag request failed", t), this.Gd() && this.jd(!0), a()) : a();
            };
            let d = this.Mr.requestMaxRetries;
            const c = ()=>d > 0 && l === this.md, v = ()=>{
                if (l !== this.md || !this.bo || this.Mr.remoteRequestsDisabled) return this.gd = !1, void a();
                try {
                    i.sendRequest(o, {
                        target: "flags",
                        method: "POST",
                        body: e,
                        compression: this.Mr.compression,
                        sentAt: "body",
                        timeoutMs: this.Mr.requestTimeoutMs
                    }).then((t)=>{
                        if (((t)=>$0fb0e9cf977607be$var$Th.includes(t.statusCode) || ((t)=>0 === t.statusCode && t.error instanceof Error && "AbortError" === t.error.name)(t))(t) && c()) return d--, void setTimeout(v, 500);
                        u(t);
                    }).catch(h);
                } catch (t) {
                    h(t);
                }
            };
            v();
        }
        xd() {
            return $0fb0e9cf977607be$var$Fo(this.kd, 3);
        }
        iv(t) {
            this.kd = $0fb0e9cf977607be$var$Do(t, this.kd, 3, ()=>this.A.warn("Feature flag requests are failing before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped refreshing feature flags; will try again when connectivity changes."));
        }
        getFeatureFlag(t, i = {}) {
            var e;
            if (i.fresh && !this._d) return;
            if (!(this.pd || this.getFlags() && this.getFlags().length > 0)) return void this.A.warn('getFeatureFlag for key "' + t + $0fb0e9cf977607be$var$kh);
            if (this.Zd()) return;
            const s = this.getFeatureFlagResult(t, i);
            return null !== (e = null == s ? void 0 : s.variant) && void 0 !== e ? e : null == s ? void 0 : s.enabled;
        }
        getFeatureFlagDetails(t) {
            return this.getFlagsWithDetails()[t];
        }
        getFeatureFlagPayload(t) {
            const i = this.getFeatureFlagResult(t, {
                send_event: !1
            });
            return null == i ? void 0 : i.payload;
        }
        getFeatureFlagResult(t, i = {}) {
            if (i.fresh && !this._d) return;
            if (!(this.pd || this.getFlags() && this.getFlags().length > 0)) return void this.A.warn('getFeatureFlagResult for key "' + t + $0fb0e9cf977607be$var$kh);
            if (this.Zd()) return;
            const e = this.getFlagVariants(), s = t in e, n = e[t], r = this.getFlagPayloads()[t], o = String(n), l = this.Wd("$feature_flag_request_id") || void 0, a = this.Wd("$feature_flag_evaluated_at") || void 0;
            let u, h = this.Wd("$flag_call_reported") || {};
            if (this.Mr.deduplicateCallsPerSession) {
                var d;
                const t = null === (d = this.bo) || void 0 === d ? void 0 : d.session.sessionId, i = this.Wd($0fb0e9cf977607be$var$hn);
                t && t !== i && (h = {}, u = t);
            }
            if (i.send_event || !("send_event" in i)) {
                if (t in h && h[t].includes(o)) u && this.$t({
                    [$0fb0e9cf977607be$var$un]: h,
                    [$0fb0e9cf977607be$var$hn]: u
                });
                else {
                    var c, v, f, p, _, g, m, b, y, w, S, x;
                    $0fb0e9cf977607be$var$T(h[t]) ? h[t].push(o) : h[t] = [
                        o
                    ], this.$t($0fb0e9cf977607be$var$Ei({
                        [$0fb0e9cf977607be$var$un]: h
                    }, u ? {
                        [$0fb0e9cf977607be$var$hn]: u
                    } : {}));
                    const i = this.getFeatureFlagDetails(t), e = [
                        ...null !== (c = this.Wd("$feature_flag_errors")) && void 0 !== c ? c : []
                    ];
                    $0fb0e9cf977607be$var$R(n) && e.push("flag_missing");
                    const s = {
                        $feature_flag: t,
                        $feature_flag_response: n,
                        $feature_flag_payload: null != r ? r : null,
                        $feature_flag_request_id: l,
                        $feature_flag_evaluated_at: a,
                        $feature_flag_bootstrapped_response: null !== (v = null === (f = this.Mr.bootstrap) || void 0 === f || null === (f = f.featureFlags) || void 0 === f ? void 0 : f[t]) && void 0 !== v ? v : null,
                        $feature_flag_bootstrapped_payload: null !== (p = null === (_ = this.Mr.bootstrap) || void 0 === _ || null === (_ = _.featureFlagPayloads) || void 0 === _ ? void 0 : _[t]) && void 0 !== p ? p : null,
                        $used_bootstrap_value: !this._d
                    };
                    $0fb0e9cf977607be$var$R(null == i || null === (g = i.metadata) || void 0 === g ? void 0 : g.has_experiment) || (s.$feature_flag_has_experiment = i.metadata.has_experiment), $0fb0e9cf977607be$var$R(null == i || null === (m = i.metadata) || void 0 === m ? void 0 : m.version) || (s.$feature_flag_version = i.metadata.version);
                    const d = null !== (b = null == i || null === (y = i.reason) || void 0 === y ? void 0 : y.description) && void 0 !== b ? b : null == i || null === (w = i.reason) || void 0 === w ? void 0 : w.code;
                    var E;
                    d && (s.$feature_flag_reason = d), (null == i || null === (S = i.metadata) || void 0 === S ? void 0 : S.id) && (s.$feature_flag_id = i.metadata.id), $0fb0e9cf977607be$var$R(null == i ? void 0 : i.original_variant) && $0fb0e9cf977607be$var$R(null == i ? void 0 : i.original_enabled) || (s.$feature_flag_original_response = $0fb0e9cf977607be$var$R(i.original_variant) ? i.original_enabled : i.original_variant), (null == i || null === (x = i.metadata) || void 0 === x ? void 0 : x.original_payload) && (s.$feature_flag_original_payload = null == i || null === (E = i.metadata) || void 0 === E ? void 0 : E.original_payload), e.length && (s.$feature_flag_error = e.join(",")), this.nv(s);
                }
            } else u && this.$t({
                [$0fb0e9cf977607be$var$un]: h,
                [$0fb0e9cf977607be$var$hn]: u
            });
            return s ? {
                key: t,
                enabled: !!n,
                variant: "string" == typeof n ? n : void 0,
                payload: $0fb0e9cf977607be$var$de(r)
            } : void 0;
        }
        nv(t) {
            try {
                var i;
                null === (i = this.bo) || void 0 === i || i.capture("$feature_flag_called", t);
            } catch (t) {
                this.A.error("Failed to capture feature flag call", t);
            }
        }
        getRemoteConfigPayload(t, i) {
            this.sv(t, i);
        }
        sv(t, i) {
            var e = this;
            return $0fb0e9cf977607be$var$Y(function*() {
                const s = e.bo;
                if (!s) return;
                const n = {
                    distinct_id: s.distinctId,
                    token: s.projectToken,
                    person_properties: {
                        $lib: s.library.name,
                        $lib_version: s.library.version
                    }
                }, r = e.Kd();
                r.length && (n.evaluation_contexts = r);
                const o = e.Xd();
                let l;
                $0fb0e9cf977607be$var$R(o) || (n.flag_keys = o);
                try {
                    var a;
                    const i = null === (a = (yield s.sendRequest("/flags/?v=2", {
                        target: "flags",
                        method: "POST",
                        body: n,
                        compression: e.Mr.compression,
                        sentAt: "body",
                        timeoutMs: e.Mr.requestTimeoutMs
                    })).json) || void 0 === a ? void 0 : a.featureFlagPayloads;
                    l = (null == i ? void 0 : i[t]) || void 0;
                } catch (t) {
                    return void e.A.error("Remote config feature flag request failed", t);
                }
                try {
                    i(l);
                } catch (t) {
                    e.A.error("Remote config feature flag callback failed", t);
                }
            })();
        }
        isFeatureEnabled(t, i = {}) {
            if (i.fresh && !this._d) return i.defaultValue;
            if (!(this.pd || this.getFlags() && this.getFlags().length > 0)) return this.A.warn('isFeatureEnabled for key "' + t + $0fb0e9cf977607be$var$kh), i.defaultValue;
            const e = this.getFeatureFlag(t, i);
            return $0fb0e9cf977607be$var$R(e) ? i.defaultValue : !!e;
        }
        addFeatureFlagsHandler(t) {
            this.featureFlagEventHandlers.push(t);
        }
        removeFeatureFlagsHandler(t) {
            this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((i)=>i !== t);
        }
        receivedFeatureFlags(t, i, e) {
            this.Yd(t, i, e);
        }
        Yd(t, i, e) {
            if (!this.bo) return;
            this.pd = !0;
            const s = ((t, i = {}, e = {}, s = {}, n, r = $0fb0e9cf977607be$var$xh)=>{
                const o = ((t, i)=>{
                    const e = t.flags;
                    if (e) {
                        const i = Object.fromEntries(Object.keys(e).map((t)=>{
                            var i;
                            return [
                                t,
                                null !== (i = e[t].variant) && void 0 !== i ? i : e[t].enabled
                            ];
                        })), s = Object.fromEntries(Object.keys(e).filter((t)=>e[t].enabled).filter((t)=>{
                            var i;
                            return !$0fb0e9cf977607be$var$R(null === (i = e[t].metadata) || void 0 === i ? void 0 : i.payload);
                        }).map((t)=>{
                            var i;
                            return [
                                t,
                                null === (i = e[t].metadata) || void 0 === i ? void 0 : i.payload
                            ];
                        }));
                        return $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                            featureFlags: i,
                            featureFlagPayloads: s
                        });
                    }
                    return t.featureFlags && i.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
                })(t, r), l = o.flags, a = o.featureFlags, u = o.featureFlagPayloads;
                if (!a) return;
                const h = t.requestId, d = t.evaluatedAt;
                if ($0fb0e9cf977607be$var$T(a)) {
                    r.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                    const t = {};
                    if (a) for(let i = 0; a.length > i; i++)t[a[i]] = !0;
                    return {
                        [$0fb0e9cf977607be$var$Ls]: a,
                        [$0fb0e9cf977607be$var$js]: t,
                        [$0fb0e9cf977607be$var$qs]: !1
                    };
                }
                let c = a, v = u, f = l;
                if (null == n ? void 0 : n.partialResponse) {
                    const t = Object.keys(c), n = v || {};
                    c = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i), c), v = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, e), n), t.forEach((t)=>{
                        t in n || null == v || delete v[t];
                    }), f = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, s), f);
                } else if (t.errorsWhileComputingFlags) {
                    if (l) {
                        const t = new Set(Object.keys(l).filter((t)=>{
                            var i;
                            return !(null === (i = l[t]) || void 0 === i ? void 0 : i.failed);
                        }));
                        c = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i), Object.fromEntries(Object.entries(c).filter(([i])=>t.has(i))));
                        const n = Object.fromEntries(Object.entries(v || {}).filter(([i])=>t.has(i)));
                        v = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, e), n), t.forEach((t)=>{
                            t in n || null == v || delete v[t];
                        }), f = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, s), Object.fromEntries(Object.entries(f || {}).filter(([i])=>t.has(i))));
                    } else c = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i), c), v = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, e), v), f = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, s), f);
                }
                return $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({
                    [$0fb0e9cf977607be$var$Ls]: Object.keys($0fb0e9cf977607be$var$Rh(c)),
                    [$0fb0e9cf977607be$var$js]: c || {},
                    [$0fb0e9cf977607be$var$zs]: v || {},
                    [$0fb0e9cf977607be$var$Us]: f || {},
                    [$0fb0e9cf977607be$var$qs]: !0 === t.minimalFlagCalledEvents
                }, h ? {
                    [$0fb0e9cf977607be$var$Hs]: h
                } : {}), d ? {
                    [$0fb0e9cf977607be$var$cn]: d
                } : {});
            })(t, this.getFlagVariants(), this.getFlagPayloads(), this.getFlagsWithDetails(), e, this.A);
            if (s) {
                if (!1 === (null == e ? void 0 : e.persist)) {
                    const t = !$0fb0e9cf977607be$var$R(this.bo.kv.get($0fb0e9cf977607be$var$js));
                    this.Vd = s, t || this.$t(s);
                } else this.Nd(), this.Jd(s, t, !!(null == e ? void 0 : e.partialResponse)), this.$t(s);
            } else i && this.Gd();
            i || (this.wd = !1), this.jd(i);
        }
        override(t, i = !1) {
            this.A.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
                flags: t,
                suppressWarning: i
            });
        }
        overrideFeatureFlags(t) {
            this.rv(t);
        }
        rv(t) {
            if (this.bo) {
                if (!1 === t) return this.Pt([
                    $0fb0e9cf977607be$var$Vs,
                    $0fb0e9cf977607be$var$Ws
                ]), this.jd(), void $0fb0e9cf977607be$var$Eh.info("All overrides cleared");
                if ($0fb0e9cf977607be$var$T(t)) return this.$t({
                    [$0fb0e9cf977607be$var$Vs]: $0fb0e9cf977607be$var$Oh(t)
                }), this.jd(), void $0fb0e9cf977607be$var$Eh.info("Flag overrides set", {
                    flags: t
                });
                if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
                    var i;
                    const e = t;
                    this.hd = Boolean(null !== (i = e.suppressWarning) && void 0 !== i && i);
                    const s = {}, n = e.flags, r = e.payloads;
                    return n && (s[$0fb0e9cf977607be$var$Vs] = $0fb0e9cf977607be$var$T(n) ? $0fb0e9cf977607be$var$Oh(n) : n), r && (s[$0fb0e9cf977607be$var$Ws] = r), Object.keys(s).length && this.$t(s), !1 === n && !1 === r ? this.Pt([
                        $0fb0e9cf977607be$var$Vs,
                        $0fb0e9cf977607be$var$Ws
                    ]) : !1 === n ? this.Pt($0fb0e9cf977607be$var$Vs) : !1 === r && this.Pt($0fb0e9cf977607be$var$Ws), this.jd(), !1 === n ? $0fb0e9cf977607be$var$Eh.info("Flag overrides cleared") : n && $0fb0e9cf977607be$var$Eh.info("Flag overrides set", {
                        flags: n
                    }), void (!1 === r ? $0fb0e9cf977607be$var$Eh.info("Payload overrides cleared") : r && $0fb0e9cf977607be$var$Eh.info("Payload overrides set", {
                        payloads: r
                    }));
                }
                if (t && "object" == typeof t) return this.$t({
                    [$0fb0e9cf977607be$var$Vs]: t
                }), this.jd(), void $0fb0e9cf977607be$var$Eh.info("Flag overrides set", {
                    flags: t
                });
                this.A.warn("Invalid overrideOptions provided to overrideFeatureFlags", {
                    overrideOptions: t
                });
            } else this.A.warn("posthog.featureFlags.overrideFeatureFlags called before feature flags were ready");
        }
        onFeatureFlags(t) {
            if (this.addFeatureFlagsHandler(t), this.pd) {
                const { flags: i, flagVariants: e } = this.ov();
                try {
                    t(i, e);
                } catch (t) {
                    this.A.error("Error while running feature flags callback", t);
                }
            }
            return ()=>this.removeFeatureFlagsHandler(t);
        }
        updateEarlyAccessFeatureEnrollment(t, i, e) {
            var s;
            const n = (this.Wd("$early_access_features") || []).find((i)=>i.flagKey === t), r = {
                [`$feature_enrollment/${t}`]: i
            }, o = {
                $feature_flag: t,
                $feature_enrollment: i,
                $set: r
            };
            n && (o.$early_access_feature_name = n.name), e && (o.$feature_enrollment_stage = e);
            const l = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, this.getFlagVariants()), {}, {
                [t]: i
            });
            null === (s = this._instance) || void 0 === s || null === (s = s.persistence) || void 0 === s || s.markCrossTabFeatureFlagChanges({
                $active_feature_flags: [
                    t
                ],
                $enabled_feature_flags: [
                    t
                ],
                $stored_person_properties: Object.keys(r)
            }), this.$t({
                [$0fb0e9cf977607be$var$Ls]: Object.keys($0fb0e9cf977607be$var$Rh(l)),
                [$0fb0e9cf977607be$var$js]: l,
                [$0fb0e9cf977607be$var$Gs]: $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, this.Wd("$stored_person_properties") || {}), r)
            }), this.jd();
            try {
                var a;
                null === (a = this.bo) || void 0 === a || a.capture("$feature_enrollment_update", o);
            } catch (t) {
                this.A.error("Failed to capture early access feature enrollment", t);
            }
        }
        getEarlyAccessFeatures(t, i = !1, e) {
            const s = this.Wd($0fb0e9cf977607be$var$Bs);
            !s || i ? this.av(t, e) : t(s);
        }
        av(t, i) {
            var e = this;
            return $0fb0e9cf977607be$var$Y(function*() {
                const s = e.bo;
                if (!s) return;
                const n = i ? `&${i.map((t)=>`stage=${t}`).join("&")}` : "";
                let r;
                try {
                    const t = yield s.sendRequest(`/api/early_access_features/?token=${s.projectToken}${n}`, {
                        target: "api",
                        method: "GET",
                        sentAt: "query"
                    });
                    if (!t.json) return;
                    r = t.json.earlyAccessFeatures, e.$t({
                        [$0fb0e9cf977607be$var$Bs]: r
                    });
                } catch (t) {
                    return void e.A.error("Early access feature request failed", t);
                }
                try {
                    t(r);
                } catch (t) {
                    e.A.error("Early access feature callback failed", t);
                }
            })();
        }
        ov() {
            const t = this.getFlags(), i = this.getFlagVariants();
            return {
                flags: t.filter((t)=>i[t]),
                flagVariants: Object.keys(i).filter((t)=>i[t]).reduce((t, e)=>(t[e] = i[e], t), {})
            };
        }
        jd(t) {
            this.qd();
            const { flags: i, flagVariants: e } = this.ov();
            this.featureFlagEventHandlers.forEach((s)=>{
                try {
                    s(i, e, {
                        errorsLoading: t
                    });
                } catch (t) {
                    this.A.error("Error while running feature flags callback", t);
                }
            });
        }
        setPersonPropertiesForFlags(t, i = !0) {
            this.lv(t, i);
        }
        lv(t, i = !0) {
            const e = this.Wd("$stored_person_properties") || {}, s = (null == t ? void 0 : t.$set) || ((null == t ? void 0 : t.$set_once) ? {} : t), n = null == t ? void 0 : t.$set_once, r = {};
            if (n) for(const t in n)({}).hasOwnProperty.call(n, t) && (t in e || (r[t] = n[t]));
            this.$t({
                [$0fb0e9cf977607be$var$Gs]: $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, e), r), s)
            }), i && this.reloadFeatureFlags();
        }
        unsetPersonPropertiesForFlags(t, i = !0) {
            const e = $0fb0e9cf977607be$var$Ei({}, this.Wd("$stored_person_properties") || {});
            t.forEach((t)=>{
                delete e[t];
            }), this.$t({
                [$0fb0e9cf977607be$var$Gs]: e
            }), i && this.reloadFeatureFlags();
        }
        resetPersonPropertiesForFlags(t = !0) {
            this.Pt($0fb0e9cf977607be$var$Gs), t && this.reloadFeatureFlags();
        }
        setGroupPropertiesForFlags(t, i = !0) {
            const e = this.Wd("$stored_group_properties") || {}, s = $0fb0e9cf977607be$var$Ei({}, e);
            for (const i of Object.keys(t))s[i] = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, e[i]), t[i]);
            this.$t({
                [$0fb0e9cf977607be$var$Ks]: s
            }), i && this.reloadFeatureFlags();
        }
        resetGroupPropertiesForFlags(t) {
            if (t) {
                const i = this.Wd("$stored_group_properties") || {};
                this.$t({
                    [$0fb0e9cf977607be$var$Ks]: $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i), {}, {
                        [t]: {}
                    })
                });
            } else this.Pt($0fb0e9cf977607be$var$Ks);
        }
        reset() {
            this.md++, this.bd = !1, this.dd = {}, this.vd = {}, this.Vd = void 0, this.pd = !1, this.yd = !1, this._d = !1, this.$anon_distinct_id = void 0, this.Ud(), this.hd = !1, this.kd = 0;
        }
    }
}, $0fb0e9cf977607be$var$rd = {
    sessionRecording: class {
        get Mr() {
            return this._instance.config;
        }
        get Il() {
            return this._instance.persistence;
        }
        get started() {
            var t;
            return !!(null === (t = this.uv) || void 0 === t ? void 0 : t.isStarted);
        }
        get status() {
            var t, i;
            return "awaiting_config" === this.hv || "missing_config" === this.hv ? this.hv : null !== (t = null === (i = this.uv) || void 0 === i ? void 0 : i.status) && void 0 !== t ? t : this.hv;
        }
        constructor(i){
            if (this._instance = i, this._forceAllowLocalhostNetworkCapture = !1, this.hv = $0fb0e9cf977607be$var$Qu, this.dv = void 0, this.vv = !1, this.Je = (()=>{
                var i, e;
                if (!(null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.visibilityState) || "visible" === $0fb0e9cf977607be$var$s.visibilityState) return !0;
                const n = null == $0fb0e9cf977607be$var$t || null === (i = $0fb0e9cf977607be$var$t.performance) || void 0 === i || null === (e = i.getEntriesByType) || void 0 === e ? void 0 : e.call(i, "visibility-state");
                return !(null == n ? void 0 : n.length) || n.some((t)=>"visible" === t.name);
            })(), this.sn = ()=>{
                var t, i;
                "visible" === (null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.visibilityState) && (this.Je = !0, null === (t = this.uv) || void 0 === t || null === (i = t.setDocumentWasEverVisible) || void 0 === i || i.call(t, !0));
            }, !this._instance.sessionManager) throw $0fb0e9cf977607be$var$th.error("started without valid sessionManager"), new Error("[SessionRecording] started without valid sessionManager. This is a bug.");
            if ("always" === this.Mr.cookieless_mode) throw new Error('[SessionRecording] cannot be used with cookieless_mode="always"');
            (null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.addEventListener) && $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, "visibilitychange", this.sn);
        }
        initialize() {
            this.startIfEnabledOrStop();
        }
        dispose({ discardBufferedEvents: t = !1 } = {}) {
            var i;
            this.vv = !0, null == $0fb0e9cf977607be$var$s || null === (i = $0fb0e9cf977607be$var$s.removeEventListener) || void 0 === i || i.call($0fb0e9cf977607be$var$s, "visibilitychange", this.sn), t ? this.fv(!0) : this.stopRecording();
        }
        get pv() {
            var i;
            const e = !!(null === (i = this._instance.get_property("$session_recording_remote_config")) || void 0 === i ? void 0 : i.enabled), s = !this.Mr.disable_session_recording, n = this.Mr.disable_session_recording || this._instance.consent.isOptedOut();
            return $0fb0e9cf977607be$var$t && e && s && !n;
        }
        startIfEnabledOrStop(t) {
            var i;
            if (this.vv) return;
            if (this.pv && (null === (i = this.uv) || void 0 === i ? void 0 : i.isStarted)) return;
            const e = !$0fb0e9cf977607be$var$R(Object.assign) && !$0fb0e9cf977607be$var$R(Array.from);
            this.pv && e ? (this.gv(t), $0fb0e9cf977607be$var$th.info("starting")) : (this.hv = $0fb0e9cf977607be$var$Qu, this.stopRecording());
        }
        gv(t) {
            var i, e;
            if (this.pv) {
                if ("awaiting_config" !== this.hv && "missing_config" !== this.hv && (this.hv = $0fb0e9cf977607be$var$Zu), (null == $0fb0e9cf977607be$var$c || null === (i = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === i || null === (i = i.rrweb) || void 0 === i ? void 0 : i.record) && (null === (e = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === e ? void 0 : e.initSessionRecording)) this.mv(t);
                else {
                    var s, n;
                    const i = this._instance.sessionManager;
                    null === (s = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === s || null === (n = s.loadExternalDependency) || void 0 === n || n.call(s, this._instance, this.yv, (e)=>{
                        if (!this.vv && this.pv && this._instance.sessionManager === i) return e ? (this._instance.register_for_session({
                            $sdk_debug_recording_script_not_loaded: !0
                        }), $0fb0e9cf977607be$var$th.error("could not load recorder", e)) : void this.mv(t);
                        this.hv = "disabled";
                    });
                }
            }
        }
        stopRecording() {
            var t, i;
            null === (t = this.dv) || void 0 === t || t.call(this), this.dv = void 0, null === (i = this.uv) || void 0 === i || i.stop();
        }
        fv(t = !1) {
            var i, e;
            null === (i = this.dv) || void 0 === i || i.call(this), this.dv = void 0, null === (e = this.uv) || void 0 === e || e.discard({
                discardProducerEvents: t
            });
        }
        bv() {
            var t, i;
            null === (t = this.Il) || void 0 === t || t.unregister("$session_is_sampled"), null === (i = this.Il) || void 0 === i || i.unregister("$replay_sample_rate");
        }
        _v(t, i) {
            if ($0fb0e9cf977607be$var$F(t)) return null;
            const e = $0fb0e9cf977607be$var$D(t) ? t : parseFloat(t);
            var s;
            return "number" != typeof (s = e) || !Number.isFinite(s) || 0 > s || s > 1 ? ($0fb0e9cf977607be$var$th.warn(`${i} must be between 0 and 1. Ignoring invalid value:`, t), null) : e;
        }
        wv(t) {
            if (this.Il) {
                var i, e;
                const s = this.Il, n = ()=>{
                    var i;
                    const e = !1 === t.sessionRecording ? void 0 : t.sessionRecording, n = this._v(null === (i = this.Mr.session_recording) || void 0 === i ? void 0 : i.sampleRate, "session_recording.sampleRate"), r = this._v(null == e ? void 0 : e.sampleRate, "remote config sampleRate"), o = null != n ? n : r;
                    $0fb0e9cf977607be$var$F(o) && this.bv();
                    const l = null == e ? void 0 : e.minimumDurationMilliseconds;
                    s.register({
                        [$0fb0e9cf977607be$var$xs]: $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({
                            cache_timestamp: Date.now(),
                            enabled: !!e
                        }, e), {}, {
                            networkPayloadCapture: $0fb0e9cf977607be$var$Ei({
                                capturePerformance: t.capturePerformance
                            }, null == e ? void 0 : e.networkPayloadCapture),
                            canvasRecording: {
                                enabled: null == e ? void 0 : e.recordCanvas,
                                fps: null == e ? void 0 : e.canvasFps,
                                quality: null == e ? void 0 : e.canvasQuality
                            },
                            sampleRate: o,
                            minimumDurationMilliseconds: $0fb0e9cf977607be$var$R(l) ? null : l,
                            endpoint: null == e ? void 0 : e.endpoint,
                            triggerMatchType: null == e ? void 0 : e.triggerMatchType,
                            masking: null == e ? void 0 : e.masking,
                            urlTriggers: null == e ? void 0 : e.urlTriggers,
                            version: null == e ? void 0 : e.version,
                            triggerGroups: null == e ? void 0 : e.triggerGroups
                        })
                    });
                };
                n(), null === (i = this.dv) || void 0 === i || i.call(this), this.dv = null === (e = this._instance.sessionManager) || void 0 === e ? void 0 : e.onSessionId(n);
            }
        }
        onRemoteConfig(t) {
            const i = t.ok ? t.config : void 0;
            return i && "sessionRecording" in i ? !1 === i.sessionRecording ? (this.wv(i), void this.fv()) : (this.wv(i), void this.startIfEnabledOrStop()) : ("awaiting_config" === this.hv && (this.hv = "missing_config", this._instance.register_for_session({
                [$0fb0e9cf977607be$var$En]: !0
            }), $0fb0e9cf977607be$var$th.warn("config refresh failed, recording will not start until page reload")), void this.startIfEnabledOrStop());
        }
        log(t, i = "log") {
            var e;
            (null === (e = this.uv) || void 0 === e ? void 0 : e.log) ? this.uv.log(t, i) : $0fb0e9cf977607be$var$th.warn("log called before recorder was ready");
        }
        get yv() {
            var t, i;
            const e = null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t ? void 0 : t.get_property($0fb0e9cf977607be$var$xs);
            return (null == e || null === (i = e.scriptConfig) || void 0 === i ? void 0 : i.script) || "lazy-recorder";
        }
        Sv() {
            const t = this._instance.get_property($0fb0e9cf977607be$var$xs);
            if (!t) return !1;
            let i;
            try {
                i = "object" == typeof t ? t : JSON.parse(t);
            } catch (t) {
                return $0fb0e9cf977607be$var$th.warn("persisted remote config for session recording is invalid and will be ignored", t), !1;
            }
            return !$0fb0e9cf977607be$var$F(i.cache_timestamp) && 36e5 >= Date.now() - i.cache_timestamp;
        }
        mv(t) {
            var i, e, s;
            if (!this.vv && this.pv && this._instance.sessionManager) {
                if (!(null === (i = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.initSessionRecording)) return $0fb0e9cf977607be$var$th.warn("Called on script loaded before session recording is available. This can be caused by adblockers."), void this._instance.register_for_session({
                    [$0fb0e9cf977607be$var$xn]: !0
                });
                var n;
                if (this.uv || (this.uv = null === (n = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === n ? void 0 : n.initSessionRecording(this._instance, this.Je), this.uv._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture), !this.Sv()) {
                    if ("missing_config" === this.hv || "awaiting_config" === this.hv) return;
                    return this.hv = "awaiting_config", $0fb0e9cf977607be$var$th.info("persisted remote config is stale, requesting fresh config before starting"), void new $0fb0e9cf977607be$var$Ol(this._instance).load();
                }
                this.hv = $0fb0e9cf977607be$var$Zu, null === (e = (s = this.uv).setDocumentWasEverVisible) || void 0 === e || e.call(s, this.Je), this.uv.start(t);
            } else this.hv = $0fb0e9cf977607be$var$Qu;
        }
        onRRwebEmit(t) {
            var i, e;
            null === (i = this.uv) || void 0 === i || null === (e = i.onRRwebEmit) || void 0 === e || e.call(i, t);
        }
        overrideLinkedFlag() {
            var t, i;
            this.uv || null === (i = this.Il) || void 0 === i || i.register({
                $replay_override_linked_flag: !0
            }), null === (t = this.uv) || void 0 === t || t.overrideLinkedFlag();
        }
        overrideSampling() {
            var t, i;
            this.uv || null === (i = this.Il) || void 0 === i || i.register({
                $replay_override_sampling: !0
            }), null === (t = this.uv) || void 0 === t || t.overrideSampling();
        }
        overrideTrigger(t) {
            var i, e;
            this.uv || null === (e = this.Il) || void 0 === e || e.register({
                ["url" === t ? "$replay_override_url_trigger" : "$replay_override_event_trigger"]: !0
            }), null === (i = this.uv) || void 0 === i || i.overrideTrigger(t);
        }
        get sdkDebugProperties() {
            var t;
            const i = {};
            for (const t of $0fb0e9cf977607be$var$ih){
                var e;
                const s = null === (e = this._instance.sessionPersistence) || void 0 === e ? void 0 : e.get_property(t);
                $0fb0e9cf977607be$var$R(s) || (i[t] = s);
            }
            return $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i), (null === (t = this.uv) || void 0 === t ? void 0 : t.sdkDebugProperties) || {
                $recording_status: this.status
            });
        }
        tryAddCustomEvent(t, i) {
            var e;
            return !!(null === (e = this.uv) || void 0 === e ? void 0 : e.tryAddCustomEvent(t, i));
        }
        flushBeforeIdentityReset() {
            var t, i;
            null === (t = this.uv) || void 0 === t || null === (i = t.flushBeforeIdentityReset) || void 0 === i || i.call(t);
        }
    }
}, $0fb0e9cf977607be$var$od = {
    autocapture: class extends $0fb0e9cf977607be$var$Bu {
        constructor(t){
            super(new $0fb0e9cf977607be$var$Uu(t)), this.instance = t;
        }
    },
    historyAutocapture: class {
        constructor(t){
            this.xv = !1, this._instance = t, this.$v = this.Cv();
        }
        initialize() {
            this.startIfEnabled();
        }
        get isEnabled() {
            const t = this.Tv();
            return !!(t.path || t.search || this.Iv(t));
        }
        startIfEnabled() {
            this.isEnabled && ($0fb0e9cf977607be$var$Je.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
        }
        startIfEnabledOrStop() {
            this.stop(), this.$v = this.Cv(), this.startIfEnabled();
        }
        stop() {
            this.Mv && this.Mv(), this.Mv = void 0, this.Ev && this.Ev(), this.Ev = void 0, $0fb0e9cf977607be$var$Je.info("History API monitoring stopped");
        }
        monitorHistoryChanges() {
            $0fb0e9cf977607be$var$t && $0fb0e9cf977607be$var$t.history && (this.Pv("pushState"), this.Pv("replaceState"), this.Rv(), this.Iv() && this.Av());
        }
        Pv(i) {
            var e;
            if (!$0fb0e9cf977607be$var$t || (null === (e = $0fb0e9cf977607be$var$t.history[i]) || void 0 === e ? void 0 : e.__posthog_wrapped__)) return;
            const s = this;
            $0fb0e9cf977607be$var$Vu($0fb0e9cf977607be$var$t.history, i, (e)=>function(n, r, o) {
                    var l;
                    s.Ov(o) && s.Fv(), e.call(this, n, r, o), s.Dv(i, !s.xv && "popstate" !== (null == $0fb0e9cf977607be$var$t || null === (l = $0fb0e9cf977607be$var$t.event) || void 0 === l ? void 0 : l.type));
                });
        }
        Cv() {
            const i = null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.location;
            if (null == i ? void 0 : i.pathname) return {
                pathname: i.pathname,
                search: i.search,
                hash: i.hash
            };
        }
        Tv() {
            const t = this._instance.config.capture_pageview;
            return "history_change" === t ? {
                path: !0
            } : $0fb0e9cf977607be$var$C(t) ? t : {};
        }
        Iv(t = this.Tv()) {
            return !!t.hash && !this._instance.config.disable_capture_url_hashes;
        }
        Lv(t) {
            const i = this.Tv(), e = this.$v;
            return !(!e || !(i.path && t.pathname !== e.pathname || i.search && t.search !== e.search || this.Iv(i) && t.hash !== e.hash));
        }
        Dv(t, i = !1) {
            try {
                i || this.Fv();
                const e = this.Cv();
                if (!e) return;
                if (this.Lv(e)) {
                    const e = ()=>this._instance.capture($0fb0e9cf977607be$var$Bn, {
                            navigation_type: t
                        });
                    i ? (this.Nv = e, Promise.resolve().then(()=>this.Fv())) : e();
                }
                this.$v = e;
            } catch (i) {
                $0fb0e9cf977607be$var$Je.error(`Error capturing ${t} pageview`, i);
            }
        }
        Ov(i) {
            var e, s;
            return !($0fb0e9cf977607be$var$F(i) || !$0fb0e9cf977607be$var$t) && (null === (e = $0fb0e9cf977607be$var$Ro(String(i))) || void 0 === e ? void 0 : e.href) !== (null === (s = $0fb0e9cf977607be$var$t.location) || void 0 === s ? void 0 : s.href);
        }
        Fv() {
            const t = this.Nv;
            if (t) {
                this.Nv = void 0, this.xv = !0;
                try {
                    t();
                } catch (t) {
                    $0fb0e9cf977607be$var$Je.error("Error capturing deferred pageview", t);
                } finally{
                    this.xv = !1;
                }
                this.$v = this.Cv();
            }
        }
        Rv() {
            if (this.Mv) return;
            const i = ()=>{
                this.Dv("popstate");
            };
            $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "popstate", i), this.Mv = ()=>{
                $0fb0e9cf977607be$var$t && $0fb0e9cf977607be$var$t.removeEventListener("popstate", i);
            };
        }
        Av() {
            if (this.Ev) return;
            const i = ()=>{
                this.Dv("hashchange");
            };
            $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "hashchange", i), this.Ev = ()=>{
                $0fb0e9cf977607be$var$t && $0fb0e9cf977607be$var$t.removeEventListener("hashchange", i);
            };
        }
    },
    heatmaps: class {
        get Mr() {
            return this.instance.config;
        }
        constructor(t){
            var i;
            this.qv = !1, this.ko = !1, this.jv = null, this.instance = t, this.qv = !!(null === (i = this.instance.persistence) || void 0 === i ? void 0 : i.props[$0fb0e9cf977607be$var$ps]), this.rageclicks = new $0fb0e9cf977607be$var$Au(t.config.rageclick);
        }
        initialize() {
            this.startIfEnabled();
        }
        get flushIntervalMilliseconds() {
            let t = 5e3;
            return $0fb0e9cf977607be$var$C(this.Mr.capture_heatmaps) && this.Mr.capture_heatmaps.flush_interval_milliseconds && (t = this.Mr.capture_heatmaps.flush_interval_milliseconds), t;
        }
        get isEnabled() {
            return $0fb0e9cf977607be$var$F(this.Mr.capture_heatmaps) ? $0fb0e9cf977607be$var$F(this.Mr.enable_heatmaps) ? this.qv : this.Mr.enable_heatmaps : !1 !== this.Mr.capture_heatmaps;
        }
        startIfEnabled() {
            if (this.isEnabled) {
                if (this.ko) return;
                $0fb0e9cf977607be$var$eh.info("starting..."), this.Bv(), this.sn();
            } else {
                var t;
                clearInterval(null !== (t = this.jv) && void 0 !== t ? t : void 0), this.Hv(), this.getAndClearBuffer();
            }
        }
        onRemoteConfig(t) {
            if (!t.ok) return;
            const i = t.config;
            if (!("heatmaps" in i)) return;
            const e = !!i.heatmaps;
            this.instance.persistence && this.instance.persistence.register({
                [$0fb0e9cf977607be$var$ps]: e
            }), this.qv = e, this.startIfEnabled();
        }
        getAndClearBuffer() {
            const t = this.Rt;
            return this.Rt = void 0, t;
        }
        zv(t) {
            $0fb0e9cf977607be$var$sh(t.originalEvent) && this.Ir(t.originalEvent, "deadclick");
        }
        sn() {
            this.jv && clearInterval(this.jv), this.jv = "visible" === (null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.visibilityState) ? setInterval(this.yl.bind(this), this.flushIntervalMilliseconds) : null;
        }
        Bv() {
            $0fb0e9cf977607be$var$t && $0fb0e9cf977607be$var$s && (this.Uv = this.yl.bind(this), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, $0fb0e9cf977607be$var$Ln, this.Uv), this.Wv = (i)=>this.Ir(i || (null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.event)), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, "click", this.Wv, {
                capture: !0
            }), this.Vv = (i)=>this.Gv(i || (null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.event)), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, "mousemove", this.Vv, {
                capture: !0
            }), this.Qv = new $0fb0e9cf977607be$var$bo(this.instance, $0fb0e9cf977607be$var$go, this.zv.bind(this)), this.Qv.startIfEnabledOrStop(), this.Jv = this.sn.bind(this), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, $0fb0e9cf977607be$var$jn, this.Jv), this.ko = !0);
        }
        Hv() {
            var i;
            $0fb0e9cf977607be$var$t && $0fb0e9cf977607be$var$s && (this.Uv && $0fb0e9cf977607be$var$t.removeEventListener($0fb0e9cf977607be$var$Ln, this.Uv), this.Wv && $0fb0e9cf977607be$var$s.removeEventListener("click", this.Wv, {
                capture: !0
            }), this.Vv && $0fb0e9cf977607be$var$s.removeEventListener("mousemove", this.Vv, {
                capture: !0
            }), this.Jv && $0fb0e9cf977607be$var$s.removeEventListener($0fb0e9cf977607be$var$jn, this.Jv), clearTimeout(this.Zv), null === (i = this.Qv) || void 0 === i || i.stop(), this.ko = !1);
        }
        Kv(i, e) {
            const s = this.instance.scrollManager.scrollY(), n = this.instance.scrollManager.scrollX(), r = this.instance.scrollManager.scrollElement(), o = function(i, e, s) {
                let n = i;
                for(; n && $0fb0e9cf977607be$var$Ir(n) && !$0fb0e9cf977607be$var$Mr(n, "body");){
                    if (n === s) return !1;
                    let i;
                    try {
                        var r, o, l;
                        i = null === (r = null !== (o = null === (l = n.ownerDocument) || void 0 === l ? void 0 : l.defaultView) && void 0 !== o ? o : $0fb0e9cf977607be$var$t) || void 0 === r ? void 0 : r.getComputedStyle(n).position;
                    } catch (t) {
                        return !1;
                    }
                    if ($0fb0e9cf977607be$var$b(e, i)) return !0;
                    n = $0fb0e9cf977607be$var$Vr(n);
                }
                return !1;
            }($0fb0e9cf977607be$var$Ur(i), [
                "fixed",
                "sticky"
            ], r);
            return {
                x: i.clientX + (o ? 0 : n),
                y: i.clientY + (o ? 0 : s),
                target_fixed: o,
                type: e
            };
        }
        Ir(t, i = "click") {
            var e;
            if ($0fb0e9cf977607be$var$Rr(t.target) || !$0fb0e9cf977607be$var$sh(t)) return;
            const s = this.Kv(t, i);
            (null === (e = this.rageclicks) || void 0 === e ? void 0 : e.isRageClick(t.clientX, t.clientY, (new Date).getTime())) && $0fb0e9cf977607be$var$Qr($0fb0e9cf977607be$var$Ur(t), this.instance.config.rageclick) && this.Qs($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, s), {}, {
                type: "rageclick"
            })), this.Qs(s);
        }
        Gv(t) {
            !$0fb0e9cf977607be$var$Rr(t.target) && $0fb0e9cf977607be$var$sh(t) && (clearTimeout(this.Zv), this.Zv = setTimeout(()=>{
                this.Qs(this.Kv(t, "mousemove"));
            }, 500));
        }
        Qs(i) {
            if (!$0fb0e9cf977607be$var$t) return;
            const e = this.Mr.disable_capture_url_hashes ? $0fb0e9cf977607be$var$vi($0fb0e9cf977607be$var$t.location.href) : $0fb0e9cf977607be$var$t.location.href, s = this.Mr.custom_personal_data_properties, n = this.Mr.mask_personal_data_properties ? [
                ...$0fb0e9cf977607be$var$No,
                ...s || []
            ] : [], r = $0fb0e9cf977607be$var$Mo(e, n, $0fb0e9cf977607be$var$Lo);
            this.Rt = this.Rt || {}, this.Rt[r] || (this.Rt[r] = []), this.Rt[r].push(i);
        }
        yl() {
            this.Rt && !$0fb0e9cf977607be$var$O(this.Rt) && this.instance.capture("$$heatmap", {
                $heatmap_data: this.getAndClearBuffer()
            });
        }
    },
    deadClicksAutocapture: $0fb0e9cf977607be$var$bo,
    webVitalsAutocapture: class {
        constructor(t){
            var i;
            this._instance = t, this.qv = !1, this.ko = !1, this.Rt = {
                navigationKey: void 0,
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            }, this.Xv = ()=>{
                clearTimeout(this.Yv), this.Yv = void 0, 0 !== this.Rt.metrics.length && (this._instance.capture("$web_vitals", $0fb0e9cf977607be$var$Ei({
                    $current_url: this.Rt.url
                }, this.Rt.metrics.reduce((t, i)=>$0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                        [`$web_vitals_${i.name}_event`]: $0fb0e9cf977607be$var$Ei({}, i),
                        [`$web_vitals_${i.name}_value`]: i.value
                    }), {}))), this.Rt = {
                    navigationKey: void 0,
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                });
            }, this.tf = (t)=>{
                var i;
                if (this.Rt = this.Rt || {
                    navigationKey: void 0,
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                }, $0fb0e9cf977607be$var$F(null == t ? void 0 : t.name) || $0fb0e9cf977607be$var$F(null == t ? void 0 : t.value)) return void $0fb0e9cf977607be$var$Gu.error("Invalid metric received", t);
                const e = "string" == typeof t.navigationURL ? t.navigationURL : void 0, s = this.ef(e);
                if ($0fb0e9cf977607be$var$R(s)) return;
                const n = $0fb0e9cf977607be$var$D(t.navigationId) || "string" == typeof t.navigationId ? `navigation:${t.navigationId}` : `url:${s}`;
                if (this.if && t.value >= this.if) return void $0fb0e9cf977607be$var$Gu.error("Ignoring metric with value >= " + this.if, t);
                this.Rt.navigationKey !== n && (this.Xv(), this.Yv = setTimeout(this.Xv, this.flushToCaptureTimeoutMs)), $0fb0e9cf977607be$var$R(this.Rt.navigationKey) && (this.Rt.navigationKey = n, this.Rt.url = s), this.Rt.firstMetricTimestamp = $0fb0e9cf977607be$var$R(this.Rt.firstMetricTimestamp) ? Date.now() : this.Rt.firstMetricTimestamp;
                const r = null === (i = this._instance.sessionManager) || void 0 === i ? void 0 : i.checkAndGetSessionAndWindowId(!0), o = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), e ? {
                    navigationURL: s
                } : {}), {}, {
                    $current_url: s,
                    timestamp: Date.now()
                });
                if (delete o.entries, $0fb0e9cf977607be$var$C(t.attribution) && this.attributionMetrics.indexOf(t.name) > -1) {
                    const i = {};
                    for (const e of $0fb0e9cf977607be$var$Xu){
                        const s = "url" === e && "string" == typeof t.attribution[e] ? this.ef(t.attribution[e]) : t.attribution[e];
                        $0fb0e9cf977607be$var$R(s) || (i[e] = s);
                    }
                    o.attribution = i;
                } else delete o.attribution;
                $0fb0e9cf977607be$var$R(r) || (o.$session_id = r.sessionId, o.$window_id = r.windowId), this.Rt.metrics.push(o), this.Rt.metrics.length === this.allowedMetrics.length && this.Xv();
            }, this.nf = ()=>{
                if (this.ko) return;
                let t, i, e, s, n = !1;
                const r = $0fb0e9cf977607be$var$c.__PosthogExtensions__, o = null == r ? void 0 : r.postHogWebVitalsCallbacksByFlavor, l = (null == o ? void 0 : o[this.sf]) || ("web-vitals" === this.sf && $0fb0e9cf977607be$var$R(o) ? null == r ? void 0 : r.postHogWebVitalsCallbacks : void 0);
                if (!$0fb0e9cf977607be$var$R(l)) {
                    const r = l.withoutAttribution, o = this.attributionMetrics;
                    n = !$0fb0e9cf977607be$var$R(r), t = o.indexOf("LCP") > -1 ? l.onLCP : (null == r ? void 0 : r.onLCP) || l.onLCP, i = o.indexOf("CLS") > -1 ? l.onCLS : (null == r ? void 0 : r.onCLS) || l.onCLS, e = o.indexOf("FCP") > -1 ? l.onFCP : (null == r ? void 0 : r.onFCP) || l.onFCP, s = o.indexOf("INP") > -1 ? l.onINP : (null == r ? void 0 : r.onINP) || l.onINP;
                }
                if (!(t && i && e && s)) return void $0fb0e9cf977607be$var$Gu.error("web vitals callbacks not loaded - not starting");
                const a = {
                    reportSoftNavs: this.useSoftNavs
                }, u = n && this.attributionMetrics.indexOf("INP") > -1 ? $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, a), {}, {
                    includeProcessedEventEntries: !1
                }) : a;
                this.allowedMetrics.indexOf("LCP") > -1 && t(this.tf.bind(this), a), this.allowedMetrics.indexOf("CLS") > -1 && i(this.tf.bind(this), a), this.allowedMetrics.indexOf("FCP") > -1 && e(this.tf.bind(this), a), this.allowedMetrics.indexOf("INP") > -1 && s(this.tf.bind(this), u), this.ko = !0;
            }, this.qv = !!(null === (i = this._instance.persistence) || void 0 === i ? void 0 : i.props[$0fb0e9cf977607be$var$bs]), this.startIfEnabled();
        }
        get rf() {
            return this._instance.config.capture_performance;
        }
        get allowedMetrics() {
            var t, i;
            const e = $0fb0e9cf977607be$var$C(this.rf) ? null === (t = this.rf) || void 0 === t ? void 0 : t.web_vitals_allowed_metrics : void 0;
            return $0fb0e9cf977607be$var$F(e) ? (null === (i = this._instance.persistence) || void 0 === i ? void 0 : i.props.$web_vitals_allowed_metrics) || $0fb0e9cf977607be$var$Ju : e;
        }
        get flushToCaptureTimeoutMs() {
            return ($0fb0e9cf977607be$var$C(this.rf) ? this.rf.web_vitals_delayed_flush_ms : void 0) || 5e3;
        }
        get attributionMetrics() {
            const t = $0fb0e9cf977607be$var$C(this.rf) ? this.rf.web_vitals_attribution : void 0;
            return $0fb0e9cf977607be$var$j(t) ? t ? $0fb0e9cf977607be$var$Ju : [] : $0fb0e9cf977607be$var$T(t) ? t : $0fb0e9cf977607be$var$Yu;
        }
        get useAttribution() {
            return this.attributionMetrics.length > 0;
        }
        get useSoftNavs() {
            const t = $0fb0e9cf977607be$var$C(this.rf) ? this.rf.__preview_web_vitals_soft_navs : void 0;
            return null != t && t;
        }
        get if() {
            const t = $0fb0e9cf977607be$var$C(this.rf) && $0fb0e9cf977607be$var$D(this.rf.__web_vitals_max_value) ? this.rf.__web_vitals_max_value : $0fb0e9cf977607be$var$Ku;
            return t > 0 && 6e4 >= t ? $0fb0e9cf977607be$var$Ku : t;
        }
        get isEnabled() {
            const t = null == $0fb0e9cf977607be$var$n ? void 0 : $0fb0e9cf977607be$var$n.protocol;
            if ("http:" !== t && "https:" !== t) return $0fb0e9cf977607be$var$Gu.info("Web Vitals are disabled on non-http/https protocols"), !1;
            const i = $0fb0e9cf977607be$var$C(this.rf) ? this.rf.web_vitals : $0fb0e9cf977607be$var$j(this.rf) ? this.rf : void 0;
            return $0fb0e9cf977607be$var$j(i) ? i : this.qv;
        }
        startIfEnabled() {
            this.isEnabled && !this.ko && ($0fb0e9cf977607be$var$Gu.info("enabled, starting..."), this.Ho(this.nf));
        }
        onRemoteConfig(t) {
            if (!t.ok) return;
            const i = t.config;
            if (!("capturePerformance" in i)) return;
            const e = $0fb0e9cf977607be$var$C(i.capturePerformance) && !!i.capturePerformance.web_vitals, s = $0fb0e9cf977607be$var$C(i.capturePerformance) ? i.capturePerformance.web_vitals_allowed_metrics : void 0;
            this._instance.persistence && (this._instance.persistence.register({
                [$0fb0e9cf977607be$var$bs]: e
            }), this._instance.persistence.register({
                [$0fb0e9cf977607be$var$Ss]: s
            })), this.qv = e, this.startIfEnabled();
        }
        get sf() {
            return this.useSoftNavs ? this.useAttribution ? "web-vitals-with-attribution-soft-navs" : "web-vitals-soft-navs" : this.useAttribution ? "web-vitals-with-attribution" : "web-vitals";
        }
        Ho(t) {
            var i;
            const e = $0fb0e9cf977607be$var$c.__PosthogExtensions__, s = this.sf, n = null == e ? void 0 : e.postHogWebVitalsCallbacksByFlavor;
            (null == n ? void 0 : n[s]) || "web-vitals" === s && $0fb0e9cf977607be$var$R(n) && (null == e ? void 0 : e.postHogWebVitalsCallbacks) ? t() : null == e || null === (i = e.loadExternalDependency) || void 0 === i || i.call(e, this._instance, s, (i)=>{
                i ? $0fb0e9cf977607be$var$Gu.error("failed to load script", i) : t();
            });
        }
        ef(i) {
            const e = i || (null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.location.href);
            if (!e) return void $0fb0e9cf977607be$var$Gu.error("Could not determine current URL");
            const s = this._instance.config.disable_capture_url_hashes ? $0fb0e9cf977607be$var$vi(e) : e, n = this._instance.config.custom_personal_data_properties, r = this._instance.config.mask_personal_data_properties ? [
                ...$0fb0e9cf977607be$var$No,
                ...n || []
            ] : [];
            return $0fb0e9cf977607be$var$Mo(s, r, $0fb0e9cf977607be$var$Lo);
        }
    }
}, $0fb0e9cf977607be$var$ld = {
    exceptionObserver: class {
        constructor(i){
            var e;
            this.nf = ()=>{
                var i;
                if (!$0fb0e9cf977607be$var$t || !this.isEnabled || !(null === (i = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.errorWrappingFunctions)) return;
                const e = $0fb0e9cf977607be$var$c.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, s = $0fb0e9cf977607be$var$c.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, n = $0fb0e9cf977607be$var$c.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                try {
                    !this.af && this.Mr.capture_unhandled_errors && (this.af = e(this.captureException.bind(this))), !this.lf && this.Mr.capture_unhandled_rejections && (this.lf = s(this.captureException.bind(this))), !this.uf && this.Mr.capture_console_errors && (this.uf = n(this.captureException.bind(this)));
                } catch (t) {
                    $0fb0e9cf977607be$var$zu.error("failed to start", t), this.hf();
                }
            }, this._instance = i, this.cf = !!(null === (e = this._instance.persistence) || void 0 === e ? void 0 : e.props[$0fb0e9cf977607be$var$_s]), this.wt = new $0fb0e9cf977607be$var$tt($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, function(t = {}) {
                var i, e, s, n;
                return {
                    refillRate: null !== (i = null !== (e = t.exceptionRateLimiterRefillRate) && void 0 !== e ? e : t.__exceptionRateLimiterRefillRate) && void 0 !== i ? i : 1,
                    bucketSize: null !== (s = null !== (n = t.exceptionRateLimiterBucketSize) && void 0 !== n ? n : t.__exceptionRateLimiterBucketSize) && void 0 !== s ? s : 10
                };
            }(this._instance.config.error_tracking)), {}, {
                refillInterval: 1e4,
                A: $0fb0e9cf977607be$var$zu
            })), this.Mr = this.df(), this.startIfEnabledOrStop();
        }
        df() {
            const t = this._instance.config.capture_exceptions;
            let i = {
                capture_unhandled_errors: !1,
                capture_unhandled_rejections: !1,
                capture_console_errors: !1
            };
            return $0fb0e9cf977607be$var$C(t) ? i = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i), t) : ($0fb0e9cf977607be$var$R(t) ? this.cf : t) && (i = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, i), {}, {
                capture_unhandled_errors: !0,
                capture_unhandled_rejections: !0
            })), i;
        }
        get isEnabled() {
            return this.Mr.capture_console_errors || this.Mr.capture_unhandled_errors || this.Mr.capture_unhandled_rejections;
        }
        startIfEnabledOrStop() {
            this.isEnabled ? ($0fb0e9cf977607be$var$zu.info("enabled"), this.hf(), this.Ho(this.nf)) : this.hf();
        }
        Ho(t) {
            var i, e, s;
            (null === (i = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.errorWrappingFunctions) ? t() : null === (e = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === e || null === (s = e.loadExternalDependency) || void 0 === s || s.call(e, this._instance, "exception-autocapture", (i)=>{
                if (i) return $0fb0e9cf977607be$var$zu.error("failed to load script", i);
                t();
            });
        }
        hf() {
            var t, i, e;
            null === (t = this.af) || void 0 === t || t.call(this), this.af = void 0, null === (i = this.lf) || void 0 === i || i.call(this), this.lf = void 0, null === (e = this.uf) || void 0 === e || e.call(this), this.uf = void 0;
        }
        onRemoteConfig(t) {
            if (!t.ok) return;
            const i = t.config;
            "autocaptureExceptions" in i && (this.cf = !!i.autocaptureExceptions || !1, this._instance.persistence && this._instance.persistence.register({
                [$0fb0e9cf977607be$var$_s]: this.cf
            }), this.Mr = this.df(), this.startIfEnabledOrStop());
        }
        onConfigChange() {
            this.Mr = this.df();
        }
        captureException(t) {
            try {
                var i, e, s;
                const n = null !== (i = null == t || null === (e = t.$exception_list) || void 0 === e || null === (e = e[0]) || void 0 === e ? void 0 : e.type) && void 0 !== i ? i : "Exception";
                if (this.wt.consumeRateLimit(n)) return void $0fb0e9cf977607be$var$zu.info("Skipping exception capture because of client rate limiting.", {
                    exception: n
                });
                null === (s = this._instance.exceptions) || void 0 === s || s.sendExceptionEvent(t);
            } catch (t) {}
        }
    },
    exceptions: class {
        constructor(t){
            var i, e;
            this.vf = [], this.ff = new $0fb0e9cf977607be$var$ki([
                new $0fb0e9cf977607be$var$Gi,
                new $0fb0e9cf977607be$var$se,
                new $0fb0e9cf977607be$var$Ji,
                new $0fb0e9cf977607be$var$Ki,
                new $0fb0e9cf977607be$var$ie,
                new $0fb0e9cf977607be$var$te,
                new $0fb0e9cf977607be$var$Xi,
                new $0fb0e9cf977607be$var$ee
            ], function(t, ...i) {
                return (e, s = 0)=>{
                    const n = [], r = e.split("\n"), o = Math.min(r.length, s + 1e3), l = [];
                    for(let e = s; o > e; e++){
                        const s = r[e];
                        if (s.length > 1024) continue;
                        const o = $0fb0e9cf977607be$var$Li.test(s) ? s.replace($0fb0e9cf977607be$var$Li, "$1") : s;
                        if (!o.match(/\S*Error: /)) {
                            for (const e of i){
                                const i = e(o, t);
                                if (i) {
                                    n.push(i);
                                    const t = $0fb0e9cf977607be$var$Ui(n);
                                    if (t) {
                                        for(let i = l.length - 1; i >= 0; i--){
                                            const e = l[i];
                                            if (t.start >= e.start + e.length) break;
                                            l.pop();
                                        }
                                        l.push(t);
                                    }
                                    break;
                                }
                            }
                            if ($0fb0e9cf977607be$var$Vi(n, l) >= 50) break;
                        }
                    }
                    const a = [
                        ...l
                    ].sort((t, i)=>i.start - t.start), u = a[a.length - 1];
                    if (u) {
                        const t = $0fb0e9cf977607be$var$Hi(n, u);
                        n.splice(u.start - t, t);
                        for (const i of a)i.start -= t;
                    }
                    for (const t of a)$0fb0e9cf977607be$var$zi(n, t);
                    return l.some((t)=>0 === t.start && n.length === t.length) && function(t) {
                        const i = t.map((t)=>`${t.function}|${t.filename}|${t.lineno}|${t.colno}|${t.module}`);
                        let e = 0;
                        for(let t = 1; i.length > t; t++)$0fb0e9cf977607be$var$Wi(i, t, e) && (e = t);
                        t.push(...t.splice(0, e));
                    }(n), function(t) {
                        if (!t.length) return [];
                        const i = Array.from(t);
                        return i.reverse(), i.slice(0, 50).map((t)=>{
                            var e;
                            return $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                                filename: t.filename || (e = i, e[e.length - 1] || {}).filename,
                                function: t.function || "?"
                            });
                        });
                    }(n);
                };
            }("web:javascript", $0fb0e9cf977607be$var$Fi, $0fb0e9cf977607be$var$ji)), this._instance = t, this.vf = null !== (i = null === (e = this._instance.persistence) || void 0 === e ? void 0 : e.get_property("$error_tracking_suppression_rules")) && void 0 !== i ? i : [], this.pf = $0fb0e9cf977607be$var$ae(this.gf()), this.mf = new $0fb0e9cf977607be$var$ue(this.pf);
        }
        onConfigChange() {
            this.pf = $0fb0e9cf977607be$var$ae(this.gf()), this.mf.setConfig(this.pf);
        }
        onRemoteConfig(t) {
            var i, e, s;
            if (!t.ok) return;
            const n = t.config;
            if (!("errorTracking" in n)) return;
            const r = null !== (i = null === (e = n.errorTracking) || void 0 === e ? void 0 : e.suppressionRules) && void 0 !== i ? i : [], o = null === (s = n.errorTracking) || void 0 === s ? void 0 : s.captureExtensionExceptions;
            this.vf = r, this._instance.persistence && this._instance.persistence.register({
                [$0fb0e9cf977607be$var$gs]: this.vf,
                [$0fb0e9cf977607be$var$ms]: o
            });
        }
        get yf() {
            var t;
            const i = !!this._instance.get_property($0fb0e9cf977607be$var$ms), e = this._instance.config.error_tracking.captureExtensionExceptions;
            return null !== (t = null != e ? e : i) && void 0 !== t && t;
        }
        buildProperties(t, i) {
            return this.ff.buildFromUnknown(t, {
                syntheticException: null == i ? void 0 : i.syntheticException,
                mechanism: {
                    handled: null == i ? void 0 : i.handled
                }
            });
        }
        addExceptionStep(t, i) {
            if (this.pf.enabled) try {
                if (!$0fb0e9cf977607be$var$I(t) || 0 === t.trim().length) return void $0fb0e9cf977607be$var$Mh.warn("Ignoring exception step because message must be a non-empty string");
                const { sanitizedProperties: e, droppedKeys: s } = function(t) {
                    if (!t) return {
                        sanitizedProperties: {},
                        droppedKeys: []
                    };
                    const i = [];
                    return {
                        sanitizedProperties: Object.keys(t).reduce((e, s)=>$0fb0e9cf977607be$var$oe.has(s) ? (i.push(s), e) : (e[s] = t[s], e), {}),
                        droppedKeys: i
                    };
                }(this.bf(i));
                s.length > 0 && $0fb0e9cf977607be$var$Mh.warn("Ignoring reserved exception step fields", {
                    droppedKeys: s
                }), this.mf.add($0fb0e9cf977607be$var$Ei({
                    [$0fb0e9cf977607be$var$ne]: t,
                    [$0fb0e9cf977607be$var$re]: (new Date).toISOString()
                }, e));
            } catch (t) {
                $0fb0e9cf977607be$var$Mh.error("Failed to add exception step. Ignoring breadcrumb.", t);
            }
        }
        sendExceptionEvent(t) {
            try {
                const i = t.$exception_list;
                if (this._f(i)) {
                    if (this.wf(i)) return this.kf("Exception dropped: matched a suppression rule"), void $0fb0e9cf977607be$var$Mh.info("Skipping exception capture because a suppression rule matched");
                    if (!this.yf && this.Sf(i)) return this.kf("Exception dropped: thrown by a browser extension"), void $0fb0e9cf977607be$var$Mh.info("Skipping exception capture because it was thrown by an extension");
                    if (!this.yf && this.xf(i)) return this.kf("Exception dropped: thrown by an injected browser script"), void $0fb0e9cf977607be$var$Mh.info("Skipping exception capture because it was thrown by an injected browser script");
                    if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.$f(i)) return this.kf("Exception dropped: thrown by the PostHog SDK"), void $0fb0e9cf977607be$var$Mh.info("Skipping exception capture because it was thrown by the PostHog SDK");
                }
                const e = this.pf.enabled && $0fb0e9cf977607be$var$F(t.$exception_steps) ? this.Cf(t) : t, s = function() {
                    const t = globalThis._posthogReleaseId;
                    return "string" == typeof t && t.length > 0 ? t : void 0;
                }();
                s && (e.$release_id = s);
                try {
                    const t = this._instance.capture("$exception", e, {
                        _noTruncate: !0,
                        _batchKey: "exceptionEvent",
                        gh: !0
                    });
                    return t && this.mf.clear(), t;
                } catch (t) {
                    return $0fb0e9cf977607be$var$Ih(t) || $0fb0e9cf977607be$var$Mh.error("Failed to capture exception event. Dropping this exception.", t), void this.mf.clear();
                }
            } catch (t) {
                return void ($0fb0e9cf977607be$var$Ih(t) || $0fb0e9cf977607be$var$Mh.error("Failed to process exception event. Ignoring this exception.", t));
            }
        }
        Cf(t) {
            try {
                const i = this.mf.getAttachable();
                return 0 === i.length ? t : $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t), {}, {
                    $exception_steps: i
                });
            } catch (i) {
                return $0fb0e9cf977607be$var$Mh.error("Failed to read buffered exception steps. Capturing exception without steps.", i), t;
            }
        }
        kf(t) {
            this.pf.enabled && this.mf.add({
                [$0fb0e9cf977607be$var$ne]: t,
                [$0fb0e9cf977607be$var$re]: (new Date).toISOString()
            });
        }
        bf(t) {
            return $0fb0e9cf977607be$var$C(t) ? $0fb0e9cf977607be$var$Ei({}, t) : {};
        }
        gf() {
            var t, i;
            return null !== (t = null === (i = this._instance.config.error_tracking) || void 0 === i ? void 0 : i.exception_steps) && void 0 !== t ? t : {};
        }
        wf(t) {
            if (0 === t.length) return !1;
            try {
                const i = t.reduce((t, { type: i, value: e })=>($0fb0e9cf977607be$var$I(i) && i.length > 0 && t.$exception_types.push(i), $0fb0e9cf977607be$var$I(e) && e.length > 0 && t.$exception_values.push(e), t), {
                    $exception_types: [],
                    $exception_values: []
                });
                return this.vf.some((t)=>{
                    const e = t.values.map((t)=>{
                        const e = $0fb0e9cf977607be$var$Ka[t.operator], s = i[t.key];
                        if (!e || !s) return !1;
                        const n = $0fb0e9cf977607be$var$T(t.value) ? t.value : [
                            t.value
                        ];
                        return n.length > 0 && e(n, s);
                    });
                    return "OR" === t.type ? e.some(Boolean) : e.every(Boolean);
                });
            } catch (t) {
                return $0fb0e9cf977607be$var$Mh.warn("Failed to evaluate suppression rules. Capturing the exception.", t), !1;
            }
        }
        Sf(t) {
            const i = t.flatMap((t)=>{
                var i, e;
                return null !== (i = null === (e = t.stacktrace) || void 0 === e ? void 0 : e.frames) && void 0 !== i ? i : [];
            }), e = i.filter(({ filename: t })=>!!t && $0fb0e9cf977607be$var$Dh.some((i)=>t.startsWith(i)));
            return 0 !== e.length && (!e.every(({ filename: t })=>!!t && t.startsWith($0fb0e9cf977607be$var$Ah)) || t.some(({ type: t, value: i })=>"NoResponse" === t || $0fb0e9cf977607be$var$I(i) && $0fb0e9cf977607be$var$Fh.some(({ value: t, exact: e })=>e ? i === t : i.includes(t))) && !i.some(({ in_app: t, filename: i })=>t && !(null == i ? void 0 : i.startsWith($0fb0e9cf977607be$var$Ah))));
        }
        xf(t) {
            return t.some(({ value: t })=>$0fb0e9cf977607be$var$I(t) && $0fb0e9cf977607be$var$Nh.some((i)=>t.includes(i)));
        }
        $f(t) {
            if (t.length > 0) {
                var i, e, s, n;
                const r = null !== (i = null === (e = t[0].stacktrace) || void 0 === e ? void 0 : e.frames) && void 0 !== i ? i : [], o = r[r.length - 1];
                return null !== (s = null == o || null === (n = o.filename) || void 0 === n ? void 0 : n.includes("posthog.com/static")) && void 0 !== s && s;
            }
            return !1;
        }
        _f(t) {
            return !$0fb0e9cf977607be$var$F(t) && $0fb0e9cf977607be$var$T(t);
        }
    }
}, $0fb0e9cf977607be$var$ad = $0fb0e9cf977607be$var$Ei({
    productTours: class {
        get Il() {
            return this._instance.persistence;
        }
        constructor(t){
            this.Tf = null, this.If = null, this._instance = t;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (!t.ok) return;
            const i = t.config;
            if ("productTours" in i) {
                var e, s;
                if (this.Il && this.Il.register({
                    [$0fb0e9cf977607be$var$ws]: !!i.productTours
                }), !$0fb0e9cf977607be$var$rh(this._instance)) return !this.Tf && $0fb0e9cf977607be$var$F(null === (e = this.Il) || void 0 === e ? void 0 : e.props.ph_product_tours) || $0fb0e9cf977607be$var$nh.info("product tours disabled; stopping and clearing cached tours"), null === (s = this.Tf) || void 0 === s || s.stop(), this.Tf = null, void this.clearCache();
                this.loadIfEnabled();
            }
        }
        loadIfEnabled() {
            !this.Tf && $0fb0e9cf977607be$var$rh(this._instance) && this.Ho(()=>this.Mf());
        }
        Ho(t) {
            var i, e, s;
            (null === (i = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.generateProductTours) ? t() : null === (e = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === e || null === (s = e.loadExternalDependency) || void 0 === s || s.call(e, this._instance, "product-tours", (i)=>{
                i ? $0fb0e9cf977607be$var$nh.error("Could not load product tours script", i) : t();
            });
        }
        Mf() {
            var t;
            !this.Tf && (null === (t = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === t ? void 0 : t.generateProductTours) && (this.Tf = $0fb0e9cf977607be$var$c.__PosthogExtensions__.generateProductTours(this._instance, !0));
        }
        getProductTours(t, i = !1) {
            if ($0fb0e9cf977607be$var$T(this.If) && !i) return void t(this.If, {
                isLoaded: !0
            });
            const e = this.Il;
            if (e) {
                const s = e.props[$0fb0e9cf977607be$var$en];
                if ($0fb0e9cf977607be$var$T(s) && !i) return this.If = s, void t(s, {
                    isLoaded: !0
                });
            }
            this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", `/api/product_tours/?token=${this._instance.config.token}`),
                method: "GET",
                timestampMode: "query",
                callback: (i)=>{
                    if (!$0fb0e9cf977607be$var$rh(this._instance)) return void t([], {
                        isLoaded: !0
                    });
                    const s = i.statusCode;
                    if (200 !== s || !i.json) {
                        const e = `Product Tours API could not be loaded, status: ${s}`;
                        return 0 === s ? i.error || $0fb0e9cf977607be$var$nh.warn(e) : $0fb0e9cf977607be$var$nh.error(e), void t([], {
                            isLoaded: !1,
                            error: e
                        });
                    }
                    const n = $0fb0e9cf977607be$var$T(i.json.product_tours) ? i.json.product_tours : [];
                    this.If = n, e && e.register({
                        [$0fb0e9cf977607be$var$en]: n
                    }), t(n, {
                        isLoaded: !0
                    });
                }
            });
        }
        getActiveProductTours(t) {
            $0fb0e9cf977607be$var$F(this.Tf) ? t([], {
                isLoaded: !1,
                error: "Product tours not loaded"
            }) : this.Tf.getActiveProductTours(t);
        }
        showProductTour(t) {
            var i;
            null === (i = this.Tf) || void 0 === i || i.showTourById(t);
        }
        previewTour(t) {
            this.Tf ? this.Tf.previewTour(t) : this.Ho(()=>{
                var i;
                this.Mf(), null === (i = this.Tf) || void 0 === i || i.previewTour(t);
            });
        }
        dismissProductTour() {
            var t;
            null === (t = this.Tf) || void 0 === t || t.dismissTour("user_clicked_skip");
        }
        nextStep() {
            var t;
            null === (t = this.Tf) || void 0 === t || t.nextStep();
        }
        previousStep() {
            var t;
            null === (t = this.Tf) || void 0 === t || t.previousStep();
        }
        clearCache() {
            var t;
            this.If = null, null === (t = this.Il) || void 0 === t || t.unregister("ph_product_tours");
        }
        resetTour(t) {
            var i;
            null === (i = this.Tf) || void 0 === i || i.resetTour(t);
        }
        resetAllTours() {
            var t;
            null === (t = this.Tf) || void 0 === t || t.resetAllTours();
        }
        cancelPendingTour(t) {
            var i;
            null === (i = this.Tf) || void 0 === i || i.cancelPendingTour(t);
        }
    }
}, $0fb0e9cf977607be$var$nd), $0fb0e9cf977607be$var$ud = {
    siteApps: class {
        constructor(t){
            this._instance = t, this.Ef = 0, this.Pf = [], this.apps = {};
        }
        get isEnabled() {
            return !!this._instance.config.opt_in_site_apps;
        }
        Rf(t, i) {
            if (!i) return;
            const e = this.globalsForEvent(i);
            this.Pf.push(e), this.Pf.length > 1e3 && (this.Pf = this.Pf.slice(10));
        }
        get siteAppLoaders() {
            var t;
            return null === (t = $0fb0e9cf977607be$var$c._POSTHOG_REMOTE_CONFIG) || void 0 === t || null === (t = t[this._instance.config.token]) || void 0 === t ? void 0 : t.siteApps;
        }
        initialize() {
            if (this.isEnabled) {
                const t = this._instance._addCaptureHook(this.Rf.bind(this));
                this.Af = ()=>{
                    t(), this.Pf = [], this.Af = void 0;
                };
            }
        }
        globalsForEvent(t) {
            var i, e, s, n, r, o, l;
            if (!t) throw new Error("Event payload is required");
            const a = {}, u = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
            for (const [t, i] of Object.entries(h))a[t] = {
                id: u[t],
                type: t,
                properties: i
            };
            const { $set_once: d, $set: c } = t;
            return {
                event: $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, $0fb0e9cf977607be$var$xe(t, $0fb0e9cf977607be$var$oh)), {}, {
                    properties: $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, t.properties), c ? {
                        $set: $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, null !== (i = null === (e = t.properties) || void 0 === e ? void 0 : e.$set) && void 0 !== i ? i : {}), c)
                    } : {}), d ? {
                        $set_once: $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, null !== (s = null === (n = t.properties) || void 0 === n ? void 0 : n.$set_once) && void 0 !== s ? s : {}), d)
                    } : {}),
                    elements_chain: null !== (r = null === (o = t.properties) || void 0 === o ? void 0 : o.$elements_chain) && void 0 !== r ? r : "",
                    distinct_id: null === (l = t.properties) || void 0 === l ? void 0 : l.distinct_id
                }),
                person: {
                    properties: this._instance.get_property("$stored_person_properties")
                },
                groups: a
            };
        }
        Of(t) {
            var i;
            const e = null === (i = t.tagName) || void 0 === i ? void 0 : i.toLowerCase();
            if ("style" === e && this._instance.config.prepare_external_dependency_stylesheet) return this._instance.config.prepare_external_dependency_stylesheet(t) || ($0fb0e9cf977607be$var$lh.error("prepare_external_dependency_stylesheet returned null"), null);
            if ("script" === e && this._instance.config.prepare_external_dependency_script) return this._instance.config.prepare_external_dependency_script(t) || ($0fb0e9cf977607be$var$lh.error("prepare_external_dependency_script returned null"), null);
            return t;
        }
        Ff() {
            var t, i, e, n, r, o, l, a;
            if (!this._instance.config.prepare_external_dependency_stylesheet && !this._instance.config.prepare_external_dependency_script) return ()=>{};
            const u = null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.defaultView, h = null == u || null === (t = u.Node) || void 0 === t ? void 0 : t.prototype;
            if (!u || !h) return ()=>{};
            if (this.Ef++, this.Df) return this.Lf();
            const d = [], c = this, v = new WeakSet, f = (t, i, e)=>{
                if (!(null == t ? void 0 : t[i])) return;
                const s = t[i];
                t[i] = e(s), d.push(()=>{
                    t[i] = s;
                });
            }, p = (t)=>{
                if (v.has(t)) return t;
                const i = c.Of(t);
                return i && v.add(i), i;
            }, _ = (t)=>t.map((t)=>"string" == typeof t ? t : p(t)).filter((t)=>!$0fb0e9cf977607be$var$A(t));
            return f(h, "appendChild", (t)=>function(i) {
                    const e = p(i);
                    return e ? t.call(this, e) : i;
                }), f(h, "insertBefore", (t)=>function(i, e) {
                    const s = p(i);
                    return s ? t.call(this, s, e) : i;
                }), f(h, "replaceChild", (t)=>function(i, e) {
                    const s = p(i);
                    return s ? t.call(this, s, e) : e;
                }), [
                null === (i = u.Element) || void 0 === i ? void 0 : i.prototype,
                null === (e = u.Document) || void 0 === e ? void 0 : e.prototype,
                null === (n = u.DocumentFragment) || void 0 === n ? void 0 : n.prototype
            ].forEach((t)=>{
                f(t, "append", (t)=>function(...i) {
                        return t.apply(this, _(i));
                    }), f(t, "prepend", (t)=>function(...i) {
                        return t.apply(this, _(i));
                    });
            }), [
                null === (r = u.Element) || void 0 === r ? void 0 : r.prototype,
                null === (o = u.CharacterData) || void 0 === o ? void 0 : o.prototype,
                null === (l = u.DocumentType) || void 0 === l ? void 0 : l.prototype
            ].forEach((t)=>{
                f(t, "before", (t)=>function(...i) {
                        return t.apply(this, _(i));
                    }), f(t, "after", (t)=>function(...i) {
                        return t.apply(this, _(i));
                    }), f(t, "replaceWith", (t)=>function(...i) {
                        const e = _(i);
                        return i.length && !e.length ? void 0 : t.apply(this, e);
                    });
            }), f(null === (a = u.Element) || void 0 === a ? void 0 : a.prototype, "insertAdjacentElement", (t)=>function(i, e) {
                    const s = p(e);
                    return s ? t.call(this, i, s) : null;
                }), this.Df = ()=>{
                d.forEach((t)=>t()), this.Df = void 0;
            }, this.Lf();
        }
        Lf() {
            let t = !1;
            return ()=>{
                var i;
                t || (t = !0, this.Ef--, 0 === this.Ef && (null === (i = this.Df) || void 0 === i || i.call(this)));
            };
        }
        Nf(t, i = !0) {
            const e = this.Ff();
            try {
                const s = t(e);
                return i && e(), s;
            } catch (t) {
                throw e(), t;
            }
        }
        setupSiteApp(t) {
            const i = this.apps[t.id], e = ()=>{
                var e;
                !i.errored && this.Pf.length && ($0fb0e9cf977607be$var$lh.info(`Processing ${this.Pf.length} events for site app with id ${t.id}`), this.Pf.forEach((t)=>this.Nf(()=>{
                        var e;
                        return null === (e = i.processEvent) || void 0 === e ? void 0 : e.call(i, t);
                    })), i.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored) && (null === (e = this.Af) || void 0 === e || e.call(this));
            };
            let s = !1;
            const n = (n)=>{
                i.errored = !n, i.loaded = !0, $0fb0e9cf977607be$var$lh.info(`Site app with id ${t.id} ${n ? "loaded" : "errored"}`), s && e();
            };
            try {
                const { processEvent: e } = this.Nf((i)=>t.init({
                        posthog: this._instance,
                        callback (t) {
                            i(), n(t);
                        }
                    }), !1);
                e && (i.processEvent = e), s = !0;
            } catch (i) {
                $0fb0e9cf977607be$var$lh.error($0fb0e9cf977607be$var$ah + t.id, i), n(!1);
            }
            if (s && i.loaded) try {
                e();
            } catch (e) {
                $0fb0e9cf977607be$var$lh.error(`Error while processing buffered events PostHog app with config id ${t.id}`, e), i.errored = !0;
            }
        }
        qf() {
            const t = this.siteAppLoaders || [];
            for (const i of t)this.apps[i.id] = {
                id: i.id,
                loaded: !1,
                errored: !1,
                processedBuffer: !1
            };
            for (const i of t)this.setupSiteApp(i);
        }
        jf(t) {
            if (0 === Object.keys(this.apps).length) return;
            const i = this.globalsForEvent(t);
            for (const e of Object.values(this.apps))try {
                this.Nf(()=>{
                    var t;
                    return null === (t = e.processEvent) || void 0 === t ? void 0 : t.call(e, i);
                });
            } catch (i) {
                $0fb0e9cf977607be$var$lh.error(`Error while processing event ${t.event} for site app ${e.id}`, i);
            }
        }
        onRemoteConfig(t) {
            var i, e, s;
            if (null === (i = this.siteAppLoaders) || void 0 === i ? void 0 : i.length) return this.isEnabled ? (this.qf(), void this._instance.on("eventCaptured", (t)=>this.jf(t))) : void $0fb0e9cf977607be$var$lh.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            if (null === (e = this.Af) || void 0 === e || e.call(this), !t.ok) return;
            const n = t.config;
            if (null === (s = n.siteApps) || void 0 === s ? void 0 : s.length) {
                if (this.isEnabled) for (const { id: t, url: i } of n.siteApps){
                    var r, o;
                    $0fb0e9cf977607be$var$c[`__$$ph_site_app_${t}`] = this._instance, null === (r = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === r || null === (o = r.loadSiteApp) || void 0 === o || o.call(r, this._instance, i, (i)=>{
                        if (i) return $0fb0e9cf977607be$var$lh.error($0fb0e9cf977607be$var$ah + t, i);
                    });
                }
                else $0fb0e9cf977607be$var$lh.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            }
        }
    }
}, $0fb0e9cf977607be$var$hd = {
    tracingHeaders: class {
        constructor(t){
            this._instance = t, this.Bf = void 0, this.Hf = void 0, this.zf = void 0, this.nf = ()=>{
                const t = this.Uf();
                var i, e;
                t ? ($0fb0e9cf977607be$var$R(this.Bf) && (this.Bf = null === (i = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === i || null === (i = i.tracingHeadersPatchFns) || void 0 === i ? void 0 : i._patchXHR(t, ()=>this._instance.get_distinct_id(), this._instance.sessionManager)), $0fb0e9cf977607be$var$R(this.Hf) && (this.Hf = null === (e = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === e || null === (e = e.tracingHeadersPatchFns) || void 0 === e ? void 0 : e._patchFetch(t, ()=>this._instance.get_distinct_id(), this._instance.sessionManager))) : this.hf();
            };
        }
        initialize() {
            this.startIfEnabledOrStop();
        }
        Ho(t) {
            var i, e, s;
            (null === (i = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.tracingHeadersPatchFns) ? t() : null === (e = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === e || null === (s = e.loadExternalDependency) || void 0 === s || s.call(e, this._instance, "tracing-headers", (i)=>{
                if (i) return $0fb0e9cf977607be$var$Wu.error("failed to load script", i);
                t();
            });
        }
        Wf() {
            var t, i;
            return null !== (t = null !== (i = this._instance.config.tracing_headers) && void 0 !== i ? i : this._instance.config.addTracingHeaders) && void 0 !== t ? t : this._instance.config.__add_tracing_headers;
        }
        Uf() {
            const t = this.Wf();
            return $0fb0e9cf977607be$var$T(t) ? ($0fb0e9cf977607be$var$T(this.zf) ? this.zf.splice(0, this.zf.length, ...t) : this.zf = [
                ...t
            ], t.length > 0 ? this.zf : void 0) : ($0fb0e9cf977607be$var$T(this.zf) && this.zf.splice(0), this.zf = t || void 0, this.zf);
        }
        hf() {
            var t, i;
            null === (t = this.Bf) || void 0 === t || t.call(this), null === (i = this.Hf) || void 0 === i || i.call(this), this.Bf = void 0, this.Hf = void 0;
        }
        startIfEnabledOrStop() {
            this.Uf() ? this.Ho(this.nf) : this.hf();
        }
    }
}, $0fb0e9cf977607be$var$dd = $0fb0e9cf977607be$var$Ei({
    surveys: class extends $0fb0e9cf977607be$var$ch {
        constructor(t){
            var i;
            super(new $0fb0e9cf977607be$var$mh(t), (i = t, {
                get projectToken () {
                    return i.config.token;
                },
                kv: new $0fb0e9cf977607be$var$gh(i)
            })), this._instance = t;
        }
        Qh(t, i) {
            const e = i.query ? $0fb0e9cf977607be$var$ga(t, i.query) : t;
            return new Promise((t)=>{
                var s;
                this._instance._send_request({
                    method: i.method,
                    url: this._instance.requestRouter.endpointFor(null !== (s = i.target) && void 0 !== s ? s : "api", e),
                    data: i.body,
                    headers: i.headers,
                    timeout: i.timeoutMs,
                    fireCallbackOnDrop: !0,
                    transport: i.transport,
                    compression: i.compression,
                    timestampMode: i.sentAt,
                    callback: t
                });
            });
        }
    }
}, $0fb0e9cf977607be$var$nd), $0fb0e9cf977607be$var$cd = {
    toolbar: class {
        constructor(t){
            this.instance = t;
        }
        Vf(t) {
            $0fb0e9cf977607be$var$c.ph_toolbar_state = t;
        }
        Gf() {
            var t;
            return null !== (t = $0fb0e9cf977607be$var$c.ph_toolbar_state) && void 0 !== t ? t : 0;
        }
        initialize() {
            return this.maybeLoadToolbar();
        }
        maybeLoadToolbar(i, e, n) {
            var r, o;
            if ($0fb0e9cf977607be$var$tr(this.instance.config)) return !1;
            if (!$0fb0e9cf977607be$var$t || !$0fb0e9cf977607be$var$s) return !1;
            i = null !== (r = i) && void 0 !== r ? r : $0fb0e9cf977607be$var$t.location, n = null !== (o = n) && void 0 !== o ? o : $0fb0e9cf977607be$var$t.history;
            try {
                if (!e) {
                    try {
                        $0fb0e9cf977607be$var$t.localStorage.setItem("test", "test"), $0fb0e9cf977607be$var$t.localStorage.removeItem("test");
                    } catch (t) {
                        return !1;
                    }
                    e = null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.localStorage;
                }
                const s = $0fb0e9cf977607be$var$bh || $0fb0e9cf977607be$var$Ao(i.hash, "__posthog") || $0fb0e9cf977607be$var$Ao(i.hash, "state");
                let r;
                const o = s ? $0fb0e9cf977607be$var$fi(()=>JSON.parse(atob(decodeURIComponent(s)))) || $0fb0e9cf977607be$var$fi(()=>JSON.parse(decodeURIComponent(s))) : null;
                return o && "ph_authorize" === o.action ? (r = o, r.source = "url", r && Object.keys(r).length > 0 && (o.desiredHash ? i.hash = o.desiredHash : n ? n.replaceState(n.state, "", i.pathname + i.search) : i.hash = "")) : (r = JSON.parse(e.getItem($0fb0e9cf977607be$var$yh) || "{}"), r.source = "localstorage", delete r.userIntent), !(!r.token || this.instance.config.token !== r.token || (this.loadToolbar(r), 0));
            } catch (t) {
                return !1;
            }
        }
        Qf(t) {
            const i = $0fb0e9cf977607be$var$c.ph_load_toolbar || $0fb0e9cf977607be$var$c.ph_load_editor;
            !$0fb0e9cf977607be$var$F(i) && $0fb0e9cf977607be$var$P(i) ? i(t, this.instance) : $0fb0e9cf977607be$var$wh.warn("No toolbar load function found");
        }
        loadToolbar(i) {
            const e = !!(null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.getElementById("__POSTHOG_TOOLBAR__"));
            if (!$0fb0e9cf977607be$var$t || e) return !1;
            const n = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, r = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({
                token: this.instance.config.token
            }, i), {}, {
                apiURL: this.instance.requestRouter.endpointFor("ui")
            }, n ? {
                instrument: !1
            } : {});
            if ($0fb0e9cf977607be$var$t.localStorage.setItem($0fb0e9cf977607be$var$yh, JSON.stringify($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, r), {}, {
                source: void 0
            }))), 2 === this.Gf()) this.Qf(r);
            else if (0 === this.Gf()) {
                var o, l;
                this.Vf(1), null === (o = $0fb0e9cf977607be$var$c.__PosthogExtensions__) || void 0 === o || null === (l = o.loadExternalDependency) || void 0 === l || l.call(o, this.instance, "toolbar", (t)=>{
                    if (t) return $0fb0e9cf977607be$var$wh.error("[Toolbar] Failed to load", t), void this.Vf(0);
                    this.Vf(2), this.Qf(r);
                }), $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "turbolinks:load", ()=>{
                    this.Vf(0), this.loadToolbar(r);
                });
            }
            return !0;
        }
        Jf(t) {
            return this.loadToolbar(t);
        }
        maybeLoadEditor(t, i, e) {
            return this.maybeLoadToolbar(t, i, e);
        }
    }
}, $0fb0e9cf977607be$var$vd = $0fb0e9cf977607be$var$Ei({
    experiments: class i {
        get Mr() {
            return this._instance.config;
        }
        constructor(t){
            this._instance = t, this.getWebExperimentsAndEvaluateDisplayLogic = (t = !1)=>{
                this.getWebExperiments((t)=>{
                    i.Zf("retrieved web experiments from the server"), this.Kf = new Map, t.forEach((t)=>{
                        if (t.feature_flag_key) {
                            var e;
                            this.Kf && (i.Zf("setting flag key ", t.feature_flag_key, " to web experiment ", t), null === (e = this.Kf) || void 0 === e || e.set(t.feature_flag_key, t));
                            const s = this._instance.getFeatureFlag(t.feature_flag_key);
                            $0fb0e9cf977607be$var$I(s) && t.variants[s] && this.Xf(t.name, s, t.variants[s].transforms);
                        } else if (t.variants) for(const e in t.variants){
                            const s = t.variants[e];
                            i.Yf(s, this._instance) && this.Xf(t.name, e, s.transforms);
                        }
                    });
                }, t);
            }, this._instance.onFeatureFlags((t)=>{
                this.onFeatureFlags(t);
            });
        }
        initialize() {}
        onFeatureFlags(t) {
            if (this._is_bot()) i.Zf($0fb0e9cf977607be$var$jh);
            else if (!this.Mr.disable_web_experiments) {
                if ($0fb0e9cf977607be$var$F(this.Kf)) return this.Kf = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
                i.Zf("applying feature flags", t), t.forEach((t)=>{
                    var i;
                    if (this.Kf && (null === (i = this.Kf) || void 0 === i ? void 0 : i.has(t))) {
                        var e;
                        const i = this._instance.getFeatureFlag(t), s = null === (e = this.Kf) || void 0 === e ? void 0 : e.get(t);
                        i && (null == s ? void 0 : s.variants[i]) && this.Xf(s.name, i, s.variants[i].transforms);
                    }
                });
            }
        }
        previewWebExperiment() {
            const t = i.getWindowLocation();
            if (null == t ? void 0 : t.search) {
                const e = $0fb0e9cf977607be$var$Io(null == t ? void 0 : t.search, "__experiment_id"), s = $0fb0e9cf977607be$var$Io(null == t ? void 0 : t.search, "__experiment_variant");
                e && s && (i.Zf(`previewing web experiments ${e} && ${s}`), this.getWebExperiments((t)=>{
                    this.tp(parseInt(e), s, t);
                }, !1, !0));
            }
        }
        loadIfEnabled() {
            this.Mr.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
        }
        getWebExperiments(t, i, e) {
            if (this.Mr.disable_web_experiments && !e) return t([]);
            const s = this._instance.get_property("$web_experiments");
            if (s && !i) return t(s);
            this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", `/api/web_experiments/?token=${this.Mr.token}`),
                method: "GET",
                timestampMode: "query",
                callback: (i)=>t(200 === i.statusCode && i.json && i.json.experiments || [])
            });
        }
        tp(t, e, s) {
            const n = s.filter((i)=>i.id === t);
            n && n.length > 0 && (i.Zf(`Previewing web experiment [${n[0].name}] with variant [${e}]`), this.Xf(n[0].name, e, n[0].variants[e].transforms));
        }
        static Yf(t, e) {
            return !$0fb0e9cf977607be$var$F(t.conditions) && i.ep(t, e) && i.np(t);
        }
        static ep(t, e) {
            var s;
            if ($0fb0e9cf977607be$var$F(t.conditions) || $0fb0e9cf977607be$var$F(null === (s = t.conditions) || void 0 === s ? void 0 : s.url)) return !0;
            const n = i.getWindowLocation();
            if (n) {
                var r, o, l;
                const i = $0fb0e9cf977607be$var$Or(e, n.href);
                return !(null === (r = t.conditions) || void 0 === r ? void 0 : r.url) || $0fb0e9cf977607be$var$Lh[null !== (o = null === (l = t.conditions) || void 0 === l ? void 0 : l.urlMatchType) && void 0 !== o ? o : "icontains"](t.conditions.url, i);
            }
            return !1;
        }
        static getWindowLocation() {
            return null == $0fb0e9cf977607be$var$t ? void 0 : $0fb0e9cf977607be$var$t.location;
        }
        static np(t) {
            var i;
            if ($0fb0e9cf977607be$var$F(t.conditions) || $0fb0e9cf977607be$var$F(null === (i = t.conditions) || void 0 === i ? void 0 : i.utm)) return !0;
            const e = $0fb0e9cf977607be$var$Uo();
            if (e.utm_source) {
                var s, n, r, o, l, a, u, h;
                const i = !(null === (s = t.conditions) || void 0 === s || null === (s = s.utm) || void 0 === s ? void 0 : s.utm_campaign) || (null === (n = t.conditions) || void 0 === n || null === (n = n.utm) || void 0 === n ? void 0 : n.utm_campaign) == e.utm_campaign, d = !(null === (r = t.conditions) || void 0 === r || null === (r = r.utm) || void 0 === r ? void 0 : r.utm_source) || (null === (o = t.conditions) || void 0 === o || null === (o = o.utm) || void 0 === o ? void 0 : o.utm_source) == e.utm_source, c = !(null === (l = t.conditions) || void 0 === l || null === (l = l.utm) || void 0 === l ? void 0 : l.utm_medium) || (null === (a = t.conditions) || void 0 === a || null === (a = a.utm) || void 0 === a ? void 0 : a.utm_medium) == e.utm_medium, v = !(null === (u = t.conditions) || void 0 === u || null === (u = u.utm) || void 0 === u ? void 0 : u.utm_term) || (null === (h = t.conditions) || void 0 === h || null === (h = h.utm) || void 0 === h ? void 0 : h.utm_term) == e.utm_term;
                return i && c && v && d;
            }
            return !1;
        }
        static Zf(t, ...i) {
            $0fb0e9cf977607be$var$Je.info(`[WebExperiments] ${t}`, i);
        }
        Xf(t, e, s) {
            this._is_bot() ? i.Zf($0fb0e9cf977607be$var$jh) : "control" !== e ? s.forEach((s)=>{
                if (s.selector) {
                    var n;
                    i.Zf(`applying transform of variant ${e} for experiment ${t} `, s);
                    const r = null === (n = document) || void 0 === n ? void 0 : n.querySelectorAll(s.selector);
                    null == r || r.forEach((t)=>{
                        const i = t;
                        s.html && (i.innerHTML = s.html), s.css && i.setAttribute("style", s.css);
                    });
                }
            }) : i.Zf("Control variants leave the page unmodified.");
        }
        _is_bot() {
            return $0fb0e9cf977607be$var$e && this._instance ? $0fb0e9cf977607be$var$za($0fb0e9cf977607be$var$e, this.Mr.custom_blocked_useragents) : void 0;
        }
    }
}, $0fb0e9cf977607be$var$nd), $0fb0e9cf977607be$var$fd = {
    conversations: class {
        constructor(t){
            this._instance = t, this.sp = void 0, this._conversationsManager = null, this.rp = !1, this.ne = null, this.op = !1;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (this._instance.config.disable_conversations) return;
            if (this.ap = t.ok, !t.ok) return;
            const i = t.config.conversations;
            $0fb0e9cf977607be$var$F(i) || ($0fb0e9cf977607be$var$j(i) ? this.sp = i : (this.sp = i.enabled, this.ne = i), this.loadIfEnabled());
        }
        reset() {
            var t;
            null === (t = this._conversationsManager) || void 0 === t || t.reset(), this._conversationsManager = null, this.sp = void 0, this.ne = null, this.ap = void 0, this.op = !1;
        }
        loadIfEnabled() {
            if (this._conversationsManager) return;
            if (this.rp) return;
            if (this._instance.config.disable_conversations) return;
            if ($0fb0e9cf977607be$var$tr(this._instance.config)) return;
            if (this._instance.config.cookieless_mode && this._instance.consent.isOptedOut()) return;
            const t = null == $0fb0e9cf977607be$var$c ? void 0 : $0fb0e9cf977607be$var$c.__PosthogExtensions__;
            if (t && !$0fb0e9cf977607be$var$R(this.sp) && this.sp) {
                if (this.ne && this.ne.token) {
                    this.rp = !0;
                    try {
                        const i = t.initConversations;
                        if (i) return this.lp(i), void (this.rp = !1);
                        const e = t.loadExternalDependency;
                        if (!e) return void this.up($0fb0e9cf977607be$var$An);
                        e(this._instance, "conversations", (i)=>{
                            i || !t.initConversations ? this.up("Could not load conversations script", i) : this.lp(t.initConversations), this.rp = !1;
                        });
                    } catch (t) {
                        this.up("Error initializing conversations", t), this.rp = !1;
                    }
                } else $0fb0e9cf977607be$var$Bh.error("Conversations enabled but missing token in remote config.");
            }
        }
        lp(t) {
            if (this.ne) try {
                this._conversationsManager = t(this.ne, this._instance), this.op = !1, $0fb0e9cf977607be$var$Bh.info("Conversations loaded successfully");
            } catch (t) {
                this.up("Error completing conversations initialization", t);
            }
            else $0fb0e9cf977607be$var$Bh.error("Cannot complete initialization: remote config is null");
        }
        up(t, i) {
            $0fb0e9cf977607be$var$Bh.error(t, i), this._conversationsManager = null, this.rp = !1, this.op = !0;
        }
        show() {
            this._conversationsManager ? this._conversationsManager.show() : $0fb0e9cf977607be$var$Bh.warn("Conversations not loaded yet.");
        }
        hide() {
            this._conversationsManager && this._conversationsManager.hide();
        }
        isAvailable() {
            return !0 === this.sp && !$0fb0e9cf977607be$var$A(this._conversationsManager);
        }
        getUnavailableReason() {
            return this.isAvailable() ? null : this._instance.config.disable_conversations ? "disabled_by_config" : $0fb0e9cf977607be$var$tr(this._instance.config) ? "disabled_for_toolbar" : this._instance.config.cookieless_mode && this._instance.consent.isOptedOut() ? "consent_opted_out" : !1 === this.ap ? "remote_config_failed" : $0fb0e9cf977607be$var$R(this.sp) ? this.ap ? "disabled_in_project" : "remote_config_pending" : this.sp ? $0fb0e9cf977607be$var$F(this.ne) || !this.ne.token ? "missing_token" : (null == $0fb0e9cf977607be$var$c ? void 0 : $0fb0e9cf977607be$var$c.__PosthogExtensions__) ? this.rp ? "initializing" : this.op ? "load_failed" : "not_loaded" : "extensions_unavailable" : "disabled_in_project";
        }
        isVisible() {
            var t, i;
            return null !== (t = null === (i = this._conversationsManager) || void 0 === i ? void 0 : i.isVisible()) && void 0 !== t && t;
        }
        sendMessage(t, i, e) {
            var s = this;
            return $0fb0e9cf977607be$var$Y(function*() {
                return s._conversationsManager ? s._conversationsManager.sendMessage(t, i, e) : ($0fb0e9cf977607be$var$Bh.warn($0fb0e9cf977607be$var$Uh), null);
            })();
        }
        getMessages(t, i) {
            var e = this;
            return $0fb0e9cf977607be$var$Y(function*() {
                return e._conversationsManager ? e._conversationsManager.getMessages(t, i) : ($0fb0e9cf977607be$var$Bh.warn($0fb0e9cf977607be$var$Uh), null);
            })();
        }
        markAsRead(t) {
            var i = this;
            return $0fb0e9cf977607be$var$Y(function*() {
                return i._conversationsManager ? i._conversationsManager.markAsRead(t) : ($0fb0e9cf977607be$var$Bh.warn($0fb0e9cf977607be$var$Uh), null);
            })();
        }
        getTickets(t) {
            var i = this;
            return $0fb0e9cf977607be$var$Y(function*() {
                return i._conversationsManager ? i._conversationsManager.getTickets(t) : ($0fb0e9cf977607be$var$Bh.warn($0fb0e9cf977607be$var$Uh), null);
            })();
        }
        requestRestoreLink(t) {
            var i = this;
            return $0fb0e9cf977607be$var$Y(function*() {
                return i._conversationsManager ? i._conversationsManager.requestRestoreLink(t) : ($0fb0e9cf977607be$var$Bh.warn($0fb0e9cf977607be$var$Uh), null);
            })();
        }
        restoreFromToken(t) {
            var i = this;
            return $0fb0e9cf977607be$var$Y(function*() {
                return i._conversationsManager ? i._conversationsManager.restoreFromToken(t) : ($0fb0e9cf977607be$var$Bh.warn($0fb0e9cf977607be$var$Uh), null);
            })();
        }
        restoreFromUrlToken() {
            var t = this;
            return $0fb0e9cf977607be$var$Y(function*() {
                return t._conversationsManager ? t._conversationsManager.restoreFromUrlToken() : ($0fb0e9cf977607be$var$Bh.warn($0fb0e9cf977607be$var$Uh), null);
            })();
        }
        getCurrentTicketId() {
            var t, i;
            return null !== (t = null === (i = this._conversationsManager) || void 0 === i ? void 0 : i.getCurrentTicketId()) && void 0 !== t ? t : null;
        }
        getWidgetSessionId() {
            var t, i;
            return null !== (t = null === (i = this._conversationsManager) || void 0 === i ? void 0 : i.getWidgetSessionId()) && void 0 !== t ? t : null;
        }
        $h() {
            var t;
            null === (t = this._conversationsManager) || void 0 === t || t.setIdentity();
        }
        Ch() {
            var t;
            null === (t = this._conversationsManager) || void 0 === t || t.clearIdentity();
        }
    }
}, $0fb0e9cf977607be$var$pd = {
    logs: class {
        constructor(i){
            var e;
            this._instance = i, this.name = "logs", this.hp = !1, this.cp = !1, this.dp = !1, this.A = $0fb0e9cf977607be$var$Ye("[logs]"), this.vp = $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, this.A), {}, {
                error: (...t)=>{
                    t.some($0fb0e9cf977607be$var$Kh) || this.A.error(...t);
                }
            }), this.ol = [], this.fp = [], this.kd = 0, this.To = !1, this.pp = [], this.gp = [], this.mp = !1, this.yp = !1, this.bp = ()=>{
                var t, i;
                this.To || (this.kd = 0, null === (t = this._p) || void 0 === t || t.onReconnect(), null === (i = this.wp) || void 0 === i || i.onReconnect());
            }, this._instance && (null === (e = this._instance.config.logs) || void 0 === e ? void 0 : e.captureConsoleLogs) && (this.hp = !0), $0fb0e9cf977607be$var$t && $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$t, "online", this.bp);
        }
        kp(t, i, e, s) {
            var n;
            const r = $0fb0e9cf977607be$var$zh(null === (n = this._instance) || void 0 === n || null === (n = n.config) || void 0 === n ? void 0 : n.logs, e);
            return [
                new $0fb0e9cf977607be$var$He(this.Sp(t, i), r, this.vp, ()=>this.xp(), (t)=>t(), void 0, s),
                r
            ];
        }
        $p() {
            var t;
            const i = null === (t = this._instance) || void 0 === t || null === (t = t.config) || void 0 === t ? void 0 : t.logs;
            var e;
            return this._p && this.Cp === i || (null === (e = this._p) || void 0 === e || e.reset(), this.Cp = i, [this._p, this.Tp] = this.kp(()=>this.ol, (t)=>{
                this.ol = t;
            })), this._p;
        }
        Ip() {
            var t;
            const i = null === (t = this._instance) || void 0 === t || null === (t = t.config) || void 0 === t ? void 0 : t.logs;
            var e;
            return this.wp && this.Mp === i || (null === (e = this.wp) || void 0 === e || e.reset(), this.Mp = i, [this.wp, this.Ep] = this.kp(()=>this.fp, (t)=>{
                this.fp = t;
            }, {
                serviceNameDefault: "posthog-browser-logs",
                consoleCapture: !0
            }, $0fb0e9cf977607be$var$Vh)), this.wp;
        }
        setup(t) {
            var i;
            if (this.To) return;
            this.bo = t, (null === (i = this._instance) || void 0 === i || null === (i = i.config) || void 0 === i || null === (i = i.logs) || void 0 === i ? void 0 : i.captureConsoleLogs) && (this.hp = !0), (this.hp || this.Pp() && this.Rp()) && this.Ap();
            let e = !1;
            const s = t.onRemoteConfig((t)=>{
                var i;
                e = t.ok && !0 === (null === (i = t.config.logs) || void 0 === i ? void 0 : i.captureConsoleLogs), this.onRemoteConfig(t);
            });
            this.To ? s.dispose() : (this.Eo = s, e || this.loadIfEnabled());
        }
        dispose() {
            var i, e, s, n;
            this.To || (this.To = !0, this.Op(), null === (i = this.Eo) || void 0 === i || i.dispose(), this.Eo = void 0, this.bo = void 0, this.dp = !1, null == $0fb0e9cf977607be$var$t || $0fb0e9cf977607be$var$t.removeEventListener("online", this.bp), null === (e = this.Fp) || void 0 === e || e.call(this), this.Fp = void 0, null === (s = this._p) || void 0 === s || s.reset(), null === (n = this.wp) || void 0 === n || n.reset());
        }
        onRemoteConfig(t) {
            var i, e;
            if (this.To) return;
            const s = t.ok ? null === (i = t.config.logs) || void 0 === i ? void 0 : i.captureConsoleLogs : void 0;
            $0fb0e9cf977607be$var$F(s) ? this.Dp() : (null === (e = this._instance) || void 0 === e || null === (e = e.persistence) || void 0 === e || e.register({
                $logs_capture_enabled_server_side: !!s
            }), s ? (this.hp = !0, this.cp || this.Ap(), this.loadIfEnabled()) : this.Dp());
        }
        reset() {
            var t, i, e, s;
            this.Op(), null === (t = this._p) || void 0 === t || t.clearQueue(), this.ol = [], null === (i = this._p) || void 0 === i || i.reset(), null === (e = this.wp) || void 0 === e || e.clearQueue(), this.fp = [], null === (s = this.wp) || void 0 === s || s.reset(), this.kd = 0;
        }
        captureLog(t) {
            this.To || this.$p().captureLog(t);
        }
        captureConsoleLog(t) {
            this.To || this.Ip().captureLog(t);
        }
        captureBufferedConsoleLog(t, i, e) {
            this.To || this.Ip().captureLog(t, {
                context: i,
                occurredAtMs: e
            });
        }
        Rp() {
            var t;
            return !!(null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t || null === (t = t.props) || void 0 === t ? void 0 : t[$0fb0e9cf977607be$var$$s]);
        }
        Pp() {
            var t, i, e;
            return !(null === (t = this._instance) || void 0 === t || null === (i = t.il) || void 0 === i ? void 0 : i.call(t)) || !!(null === (e = $0fb0e9cf977607be$var$c._POSTHOG_REMOTE_CONFIG) || void 0 === e || null === (e = e[this._instance.config.token]) || void 0 === e ? void 0 : e.config);
        }
        Ih() {
            var t;
            this.Op(), null === (t = this.wp) || void 0 === t || t.clearQueue(), this.fp = [];
        }
        Dp() {
            this.hp || this.Op();
        }
        Ap() {
            var t;
            if (this.mp || !(null == $0fb0e9cf977607be$var$c ? void 0 : $0fb0e9cf977607be$var$c.console)) return;
            const i = $0fb0e9cf977607be$var$zh(null === (t = this._instance) || void 0 === t || null === (t = t.config) || void 0 === t ? void 0 : t.logs).maxBufferSize;
            let e = !0;
            this.gp.push(()=>{
                e = !1;
            });
            for (const t of $0fb0e9cf977607be$var$Hh){
                let s;
                try {
                    s = $0fb0e9cf977607be$var$qh($0fb0e9cf977607be$var$c.console[t]);
                } catch (t) {
                    continue;
                }
                s && this.gp.push($0fb0e9cf977607be$var$Vu($0fb0e9cf977607be$var$c.console, t, (n)=>{
                    const r = (...s)=>{
                        try {
                            e && this.Lp(t, s, i);
                        } catch (t) {}
                        return n.apply($0fb0e9cf977607be$var$c.console, s);
                    };
                    return r.__rrweb_original__ = s, r;
                }));
            }
            this.mp = !0, this.Np = setTimeout(()=>{
                this.Op();
            }, 3e4);
        }
        Lp(t, i, e) {
            var s;
            if (this.mp && !this.yp && 0 !== i.length) {
                if (null === (s = this._instance) || void 0 === s ? void 0 : s.is_capturing()) {
                    if (e > this.pp.length) {
                        this.yp = !0;
                        try {
                            this.pp.push({
                                level: t,
                                args: i,
                                occurredAtMs: Date.now(),
                                context: this.xp()
                            });
                        } finally{
                            this.yp = !1;
                        }
                    }
                } else this.Op();
            }
        }
        Op() {
            if (this.pp = [], this.mp) {
                this.mp = !1, this.Np && (clearTimeout(this.Np), this.Np = void 0);
                for (const t of this.gp)t();
                this.gp = [];
            }
        }
        qp() {
            const t = this.pp;
            return this.Op(), t;
        }
        get logger() {
            return this.jp || (this.jp = {
                trace: (t, i)=>this.captureLog({
                        body: t,
                        level: "trace",
                        attributes: i
                    }),
                debug: (t, i)=>this.captureLog({
                        body: t,
                        level: "debug",
                        attributes: i
                    }),
                info: (t, i)=>this.captureLog({
                        body: t,
                        level: "info",
                        attributes: i
                    }),
                warn: (t, i)=>this.captureLog({
                        body: t,
                        level: "warn",
                        attributes: i
                    }),
                error: (t, i)=>this.captureLog({
                        body: t,
                        level: "error",
                        attributes: i
                    }),
                fatal: (t, i)=>this.captureLog({
                        body: t,
                        level: "fatal",
                        attributes: i
                    })
            }), this.jp;
        }
        flushLogs(t) {
            t ? this.Bp(t) : (this._p && this._p.flush().catch((t)=>this.Hp(t)), this.wp && this.wp.flush().catch((t)=>this.Hp(t)));
        }
        Hp(t) {
            $0fb0e9cf977607be$var$Kh(t) || this.A.error("PostHog logs flush failed:", t);
        }
        loadIfEnabled() {
            if (this.To || !this.hp || this.cp || this.dp) return;
            const t = null == $0fb0e9cf977607be$var$c ? void 0 : $0fb0e9cf977607be$var$c.__PosthogExtensions__;
            if (!t) return this.A.error("PostHog Extensions not found."), void this.Op();
            const i = t.loadExternalDependency;
            if (!i) return this.A.error($0fb0e9cf977607be$var$An), void this.Op();
            this.dp = !0;
            try {
                i(this._instance, "logs", (i)=>{
                    if (this.dp = !1, this.To || !this.hp) return;
                    const e = t.logs;
                    if (i || !(null == e ? void 0 : e.initializeLogs)) this.A.error("Could not load logs script", i), this.Op();
                    else {
                        var s;
                        const t = this.qp();
                        var n, r;
                        this.Fp = e.initializeLogs(null !== (s = this.bo) && void 0 !== s ? s : this._instance), this.cp = !0, t.length > 0 && (null === (n = e.replayConsoleBuffer) || void 0 === n || n.call(e, null !== (r = this.bo) && void 0 !== r ? r : this._instance, t));
                    }
                });
            } catch (t) {
                throw this.dp = !1, t;
            }
        }
        Sp(t, i) {
            const e = this._instance;
            return {
                get isDisabled () {
                    return !1;
                },
                get optedOut () {
                    return !e.is_capturing();
                },
                getPersistedProperty: (i)=>i === $0fb0e9cf977607be$var$p.LogsQueue ? t() : void 0,
                setPersistedProperty (t, e) {
                    var s;
                    t === $0fb0e9cf977607be$var$p.LogsQueue && i(null !== (s = e) && void 0 !== s ? s : []);
                },
                js: (t)=>this.js(t),
                getLibraryId: ()=>$0fb0e9cf977607be$var$es.LIB_NAME,
                getLibraryVersion: ()=>$0fb0e9cf977607be$var$es.LIB_VERSION
            };
        }
        js(t) {
            return new Promise((i)=>{
                if ($0fb0e9cf977607be$var$Fo(this.kd, 3)) return void i({
                    kind: "fatal",
                    error: $0fb0e9cf977607be$var$Gh(void 0, "logs endpoint is unreachable, dropping batch")
                });
                let e = !1;
                const s = (t)=>{
                    e || (e = !0, clearTimeout(n), i(t));
                }, n = setTimeout(()=>{
                    this.A.warn("Logs request timed out before receiving a response"), s({
                        kind: "retry-later",
                        error: $0fb0e9cf977607be$var$Gh(void 0, "logs request timed out")
                    });
                }, 9e4);
                this._instance._send_request({
                    method: "POST",
                    url: this.zp(),
                    data: t,
                    compression: "best-available",
                    batchKey: "logs",
                    fireCallbackOnDrop: !0,
                    callback: (t)=>{
                        const i = t.statusCode;
                        if (this.Up(i), i >= 200 && 300 > i) s({
                            kind: "ok"
                        });
                        else if (413 === i) s({
                            kind: "too-large"
                        });
                        else if (0 !== i && 408 !== i && 429 !== i && 500 > i) s({
                            kind: "fatal",
                            error: new Error(`logs request failed with status ${i}`)
                        });
                        else {
                            var e;
                            0 === i ? (t.error || this.A.warn("Logs request failed before receiving an HTTP response"), s({
                                kind: "retry-later",
                                error: $0fb0e9cf977607be$var$Gh(t.error, "logs request failed before receiving an HTTP response")
                            })) : s({
                                kind: "retry-later",
                                error: null !== (e = t.error) && void 0 !== e ? e : new Error(`logs request failed with status ${i}`)
                            });
                        }
                    }
                });
            });
        }
        Up(t) {
            (0 !== t || this._instance.__loaded) && (this.kd = $0fb0e9cf977607be$var$Do(t, this.kd, 3, ()=>this.A.warn("Log requests are failing before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped sending logs; will try again when connectivity changes.")));
        }
        Bp(t) {
            this.ol.length > 0 && this.Wp(t, this.ol, this.Tp, $0fb0e9cf977607be$var$es.LIB_NAME, (t)=>{
                this.ol = t;
            }), this.fp.length > 0 && this.Wp(t, this.fp, this.Ep, $0fb0e9cf977607be$var$Vh, (t)=>{
                this.fp = t;
            });
        }
        Wp(t, i, e, s, n) {
            if (0 === i.length) return;
            const r = i.map((t)=>t.record);
            n([]);
            const o = $0fb0e9cf977607be$var$Le(r, $0fb0e9cf977607be$var$je(e, $0fb0e9cf977607be$var$es.LIB_NAME, $0fb0e9cf977607be$var$es.LIB_VERSION), s, $0fb0e9cf977607be$var$es.LIB_VERSION);
            this._instance._send_request({
                method: "POST",
                url: this.zp(),
                data: o,
                compression: "best-available",
                batchKey: "logs",
                transport: t
            });
        }
        zp() {
            return this._instance.requestRouter.endpointFor("api", "/i/v1/logs") + "?token=" + encodeURIComponent(this._instance.config.token);
        }
        xp() {
            var t;
            const i = {};
            if (i.distinctId = this._instance.get_distinct_id(), this._instance.sessionManager) {
                const { sessionId: t, windowId: e, sessionStartTimestamp: s, lastActivityTimestamp: n } = this._instance.sessionManager.checkAndGetSessionAndWindowId(!0);
                i.sessionId = t, i.windowId = e, $0fb0e9cf977607be$var$F(s) || (i.sessionStartTimestamp = s), $0fb0e9cf977607be$var$F(n) || (i.lastActivityTimestamp = n);
            }
            if ((null == $0fb0e9cf977607be$var$c || null === (t = $0fb0e9cf977607be$var$c.location) || void 0 === t ? void 0 : t.href) && (i.currentUrl = this._instance.config.disable_capture_url_hashes ? $0fb0e9cf977607be$var$vi($0fb0e9cf977607be$var$c.location.href) : $0fb0e9cf977607be$var$c.location.href), this._instance.featureFlags) {
                const t = this._instance.featureFlags.getFlags();
                t && t.length > 0 && (i.activeFeatureFlags = t);
            }
            return i;
        }
    }
}, $0fb0e9cf977607be$var$_d = {
    metrics: class {
        constructor(t){
            this._instance = t, this.A = $0fb0e9cf977607be$var$Ye("[metrics]"), this.To = !1;
        }
        initialize() {
            this.onConfigChange();
        }
        onConfigChange() {
            var t;
            if (this.To) return;
            const i = !!(null === (t = this._instance.config.metrics) || void 0 === t ? void 0 : t.network);
            i && !this.Vp ? this.Vp = ((t)=>{
                let i = !0;
                const e = ()=>i ? ((t)=>{
                        var i;
                        const e = null === (i = t.config.metrics) || void 0 === i ? void 0 : i.network;
                        return !0 === e ? {} : e || void 0;
                    })(t) : void 0, s = $0fb0e9cf977607be$var$ed(t, e), n = $0fb0e9cf977607be$var$sd(t, e);
                return ()=>{
                    i = !1, s(), n();
                };
            })(this._instance) : !i && this.Vp && (this.Vp(), this.Vp = void 0);
        }
        $p() {
            var t;
            const i = null === (t = this._instance) || void 0 === t || null === (t = t.config) || void 0 === t ? void 0 : t.metrics;
            var e;
            return this._p && this.Cp === i || (null === (e = this._p) || void 0 === e || e.reset(), this.Cp = i, this._p = new $0fb0e9cf977607be$var$Ge(this.Sp(), function(t) {
                var i, e, s, n, r;
                const o = null == t ? void 0 : t.resourceAttributes;
                return {
                    serviceName: null !== (i = null == o ? void 0 : o["service.name"]) && void 0 !== i ? i : null == t ? void 0 : t.serviceName,
                    serviceVersion: null !== (e = null == o ? void 0 : o["service.version"]) && void 0 !== e ? e : null == t ? void 0 : t.serviceVersion,
                    environment: null !== (s = null == o ? void 0 : o["deployment.environment"]) && void 0 !== s ? s : null == t ? void 0 : t.environment,
                    resourceAttributes: o,
                    beforeSend: null == t ? void 0 : t.beforeSend,
                    flushIntervalMs: null !== (n = null == t ? void 0 : t.flushIntervalMs) && void 0 !== n ? n : 1e4,
                    maxSeriesPerFlush: null !== (r = null == t ? void 0 : t.maxSeriesPerFlush) && void 0 !== r ? r : 1e3
                };
            }(i), this.A)), this._p;
        }
        count(t, i = 1, e) {
            this.$p().count(t, i, e);
        }
        gauge(t, i, e) {
            this.$p().gauge(t, i, e);
        }
        histogram(t, i, e) {
            this.$p().histogram(t, i, e);
        }
        flush(t) {
            if (!this._p) return Promise.resolve();
            if (t) {
                const i = this._p.drainWindow();
                return i && this.Ys(i, t), Promise.resolve();
            }
            return this._p.flush().catch((t)=>this.A.error("PostHog metrics flush failed:", t));
        }
        reset() {
            var t;
            null === (t = this._p) || void 0 === t || t.reset();
        }
        dispose() {
            var t, i;
            this.To = !0, null === (t = this.Vp) || void 0 === t || t.call(this), this.Vp = void 0, null === (i = this._p) || void 0 === i || i.reset();
        }
        Sp() {
            const t = this._instance, i = this;
            return {
                get isDisabled () {
                    return !1;
                },
                get optedOut () {
                    return !t.is_capturing();
                },
                Ys: (t)=>i.Ys(t),
                getLibraryId: ()=>$0fb0e9cf977607be$var$es.LIB_NAME,
                getLibraryVersion: ()=>$0fb0e9cf977607be$var$es.LIB_VERSION
            };
        }
        Ys(t, i) {
            return new Promise((e)=>{
                let s = !1;
                const n = (t)=>{
                    s || (s = !0, clearTimeout(r), e(t));
                }, r = setTimeout(()=>n({
                        kind: "retry-later",
                        error: new Error("metrics request timed out")
                    }), 9e4);
                this._instance._send_request($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({
                    method: "POST",
                    url: this.Gp(),
                    data: t,
                    compression: "best-available",
                    batchKey: "metrics"
                }, i && {
                    transport: i
                }), {}, {
                    fireCallbackOnDrop: !0,
                    callback (t) {
                        const i = t.statusCode;
                        if (i >= 200 && 300 > i) n({
                            kind: "ok"
                        });
                        else if (413 === i) n({
                            kind: "too-large"
                        });
                        else if (0 !== i && 408 !== i && 429 !== i && 500 > i) n({
                            kind: "fatal",
                            error: new Error(`metrics request failed with status ${i}`)
                        });
                        else {
                            var e;
                            n({
                                kind: "retry-later",
                                error: null !== (e = t.error) && void 0 !== e ? e : new Error(`metrics request failed with status ${i}`)
                            });
                        }
                    }
                }));
            });
        }
        Gp() {
            return this._instance.requestRouter.endpointFor("api", "/i/v1/metrics") + "?token=" + encodeURIComponent(this._instance.config.token);
        }
    }
};
$0fb0e9cf977607be$export$a9d6b9cbf49b8241.__defaultExtensionClasses = $0fb0e9cf977607be$var$Ei({}, $0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei($0fb0e9cf977607be$var$Ei({}, $0fb0e9cf977607be$var$nd), $0fb0e9cf977607be$var$rd), $0fb0e9cf977607be$var$od), $0fb0e9cf977607be$var$ld), $0fb0e9cf977607be$var$ad), $0fb0e9cf977607be$var$ud), $0fb0e9cf977607be$var$dd), $0fb0e9cf977607be$var$hd), $0fb0e9cf977607be$var$cd), $0fb0e9cf977607be$var$vd), $0fb0e9cf977607be$var$fd), $0fb0e9cf977607be$var$pd), $0fb0e9cf977607be$var$_d));
const $0fb0e9cf977607be$export$6a8fcb530589c217 = function() {
    $0fb0e9cf977607be$var$es.SDK_DIST_CHANNEL = "npm";
    const i = $0fb0e9cf977607be$var$vu[$0fb0e9cf977607be$var$Tu] = new $0fb0e9cf977607be$export$a9d6b9cbf49b8241;
    return function() {
        function i() {
            i.done || (i.done = !0, $0fb0e9cf977607be$var$Oa = !1, $0fb0e9cf977607be$var$Vn($0fb0e9cf977607be$var$vu, function(t) {
                t._dom_loaded();
            }));
        }
        (null == $0fb0e9cf977607be$var$s ? void 0 : $0fb0e9cf977607be$var$s.addEventListener) ? "complete" === $0fb0e9cf977607be$var$s.readyState ? i() : $0fb0e9cf977607be$var$Zn($0fb0e9cf977607be$var$s, "DOMContentLoaded", i, {
            capture: !1
        }) : $0fb0e9cf977607be$var$t && $0fb0e9cf977607be$var$Je.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
    }(), i;
}();
var $0fb0e9cf977607be$export$2e2bcd8739ae039 = $0fb0e9cf977607be$export$6a8fcb530589c217;

});

parcelRegister("35uzy", function(module, exports) {
$parcel$export(module.exports, "onCLS", function () { return (parcelRequire("3tWZA")).onCLS; });
/*
 Copyright 2022 Google LLC
 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ // Creates the `web-vitals/attribution` import in node-based bundlers.
// This will not be needed when export maps are widely supported.
parcelRequire("3tWZA");

});
parcelRegister("3tWZA", function(module, exports) {

$parcel$export(module.exports, "onCLS", function () { return $2891d72e75a77115$export$a7873055838e5ad8; });
class $2891d72e75a77115$var$t {
    t;
    o = 0;
    i = [];
    u(t) {
        if (t.hadRecentInput) return;
        const e = this.i[0], n = this.i.at(-1);
        this.o && e && n && t.startTime - n.startTime < 1e3 && t.startTime - e.startTime < 5e3 ? (this.o += t.value, this.i.push(t)) : (this.o = t.value, this.i = [
            t
        ]), this.t?.(t);
    }
}
const $2891d72e75a77115$var$e = ()=>{
    const t = performance.getEntriesByType("navigation")[0];
    if (t && t.responseStart > 0 && t.responseStart < performance.now()) return t;
}, $2891d72e75a77115$var$n = (t)=>{
    if ("loading" === document.readyState) return "loading";
    const n = $2891d72e75a77115$var$e();
    if (n) {
        if (t < n.domInteractive) return "loading";
        if (0 === n.domContentLoadedEventStart || t < n.domContentLoadedEventStart) return "dom-interactive";
        if (0 === n.domComplete || t < n.domComplete) return "dom-content-loaded";
    }
    return "complete";
}, $2891d72e75a77115$var$o = (t)=>{
    const e = t.nodeName;
    return 1 === t.nodeType ? e.toLowerCase() : e.toUpperCase().replace(/^#/, "");
}, $2891d72e75a77115$var$i = (t)=>{
    let e = "";
    try {
        for(; 9 !== t?.nodeType;){
            const n = t, i = n.id ? "#" + n.id : [
                $2891d72e75a77115$var$o(n),
                ...Array.from(n.classList).sort()
            ].join(".");
            if (e.length + i.length > 99) return e || i;
            if (e = e ? i + ">" + e : i, n.id) break;
            t = n.parentNode;
        }
    } catch  {}
    return e;
}, $2891d72e75a77115$var$r = new WeakMap;
function $2891d72e75a77115$var$s(t, e) {
    let n = $2891d72e75a77115$var$r.get(e);
    return n || (n = new WeakMap, $2891d72e75a77115$var$r.set(e, n)), n.get(t) || n.set(t, new e), n.get(t);
}
let $2891d72e75a77115$var$a = -1;
const $2891d72e75a77115$var$c = ()=>$2891d72e75a77115$var$a, $2891d72e75a77115$var$u = (t)=>{
    addEventListener("pageshow", (e)=>{
        e.persisted && ($2891d72e75a77115$var$a = e.timeStamp, t(e));
    }, !0);
}, $2891d72e75a77115$var$f = (t, e, n, o)=>{
    let i, r;
    return (s)=>{
        e.value >= 0 && (s || o) && (r = e.value - (i ?? 0), (r || void 0 === i) && (i = e.value, e.delta = r, e.rating = ((t, e)=>t > e[1] ? "poor" : t > e[0] ? "needs-improvement" : "good")(e.value, n), t(e)));
    };
}, $2891d72e75a77115$var$l = (t)=>{
    requestAnimationFrame(()=>requestAnimationFrame(t));
}, $2891d72e75a77115$var$d = ()=>$2891d72e75a77115$var$e()?.activationStart ?? 0, $2891d72e75a77115$var$h = (t, n = -1)=>{
    const o = $2891d72e75a77115$var$e();
    let i = "navigate";
    $2891d72e75a77115$var$c() >= 0 ? i = "back-forward-cache" : o && (document.prerendering || $2891d72e75a77115$var$d() > 0 ? i = "prerender" : document.wasDiscarded ? i = "restore" : o.type && (i = o.type.replace(/_/g, "-")));
    return {
        name: t,
        value: n,
        rating: "good",
        delta: 0,
        entries: [],
        id: `v5-${Date.now()}-${Math.floor(8999999999999 * Math.random()) + 1e12}`,
        navigationType: i
    };
}, $2891d72e75a77115$var$m = (t, e, n = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(t)) {
            const o = new PerformanceObserver((t)=>{
                queueMicrotask(()=>{
                    e(t.getEntries());
                });
            });
            return o.observe({
                type: t,
                buffered: !0,
                ...n
            }), o;
        }
    } catch  {}
}, $2891d72e75a77115$var$g = (t)=>{
    let e = !1;
    return ()=>{
        e || (t(), e = !0);
    };
};
let $2891d72e75a77115$var$p = -1;
const $2891d72e75a77115$var$y = new Set, $2891d72e75a77115$var$v = ()=>"hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0, $2891d72e75a77115$var$b = (t)=>{
    if ("hidden" === document.visibilityState) {
        if ("visibilitychange" === t.type) for (const t of $2891d72e75a77115$var$y)t();
        isFinite($2891d72e75a77115$var$p) || ($2891d72e75a77115$var$p = "visibilitychange" === t.type ? t.timeStamp : 0, removeEventListener("prerenderingchange", $2891d72e75a77115$var$b, !0));
    }
}, $2891d72e75a77115$var$M = ()=>{
    if ($2891d72e75a77115$var$p < 0) {
        const t = $2891d72e75a77115$var$d(), e = document.prerendering ? void 0 : globalThis.performance.getEntriesByType("visibility-state").find((e)=>"hidden" === e.name && e.startTime >= t)?.startTime;
        $2891d72e75a77115$var$p = e ?? $2891d72e75a77115$var$v(), addEventListener("visibilitychange", $2891d72e75a77115$var$b, !0), addEventListener("prerenderingchange", $2891d72e75a77115$var$b, !0), $2891d72e75a77115$var$u(()=>{
            setTimeout(()=>{
                $2891d72e75a77115$var$p = $2891d72e75a77115$var$v();
            });
        });
    }
    return {
        get firstHiddenTime () {
            return $2891d72e75a77115$var$p;
        },
        onHidden (t) {
            $2891d72e75a77115$var$y.add(t);
        }
    };
}, $2891d72e75a77115$var$T = (t)=>{
    document.prerendering ? addEventListener("prerenderingchange", t, !0) : t();
}, $2891d72e75a77115$export$e610c735b5510cec = [
    1800,
    3e3
], $2891d72e75a77115$var$D = (t, e = {})=>{
    $2891d72e75a77115$var$T(()=>{
        const n = $2891d72e75a77115$var$M();
        let o, i = $2891d72e75a77115$var$h("FCP");
        const r = $2891d72e75a77115$var$m("paint", (t)=>{
            for (const e of t)"first-contentful-paint" === e.name && (r.disconnect(), e.startTime < n.firstHiddenTime && (i.value = Math.max(e.startTime - $2891d72e75a77115$var$d(), 0), i.entries.push(e), o(!0)));
        });
        r && (o = $2891d72e75a77115$var$f(t, i, $2891d72e75a77115$export$e610c735b5510cec, e.reportAllChanges), $2891d72e75a77115$var$u((n)=>{
            i = $2891d72e75a77115$var$h("FCP"), o = $2891d72e75a77115$var$f(t, i, $2891d72e75a77115$export$e610c735b5510cec, e.reportAllChanges), $2891d72e75a77115$var$l(()=>{
                i.value = performance.now() - n.timeStamp, o(!0);
            });
        }));
    });
}, $2891d72e75a77115$export$3f20d8e089ac35b2 = [
    .1,
    .25
], $2891d72e75a77115$var$S = (t)=>t.find((t)=>1 === t.node?.nodeType) || t[0], $2891d72e75a77115$export$a7873055838e5ad8 = (e, o = {})=>{
    const r = $2891d72e75a77115$var$s(o = Object.assign({}, o), $2891d72e75a77115$var$t), a = new WeakMap;
    r.t = (t)=>{
        if (t?.sources?.length) {
            const e = $2891d72e75a77115$var$S(t.sources), n = e?.node;
            if (n) {
                const t = o.generateTarget?.(n) ?? $2891d72e75a77115$var$i(n);
                a.set(e, t);
            }
        }
    };
    ((e, n = {})=>{
        const o = $2891d72e75a77115$var$M();
        $2891d72e75a77115$var$D($2891d72e75a77115$var$g(()=>{
            let i, r = $2891d72e75a77115$var$h("CLS", 0);
            const a = $2891d72e75a77115$var$s(n, $2891d72e75a77115$var$t), c = (t)=>{
                for (const e of t)a.u(e);
                a.o > r.value && (r.value = a.o, r.entries = a.i, i());
            }, d = $2891d72e75a77115$var$m("layout-shift", c);
            d && (i = $2891d72e75a77115$var$f(e, r, $2891d72e75a77115$export$3f20d8e089ac35b2, n.reportAllChanges), o.onHidden(()=>{
                c(d.takeRecords()), i(!0);
            }), $2891d72e75a77115$var$u(()=>{
                a.o = 0, r = $2891d72e75a77115$var$h("CLS", 0), i = $2891d72e75a77115$var$f(e, r, $2891d72e75a77115$export$3f20d8e089ac35b2, n.reportAllChanges), $2891d72e75a77115$var$l(i);
            }), setTimeout(i));
        }));
    })((t)=>{
        e(((t)=>{
            let e = {};
            if (t.entries.length) {
                const o = t.entries.reduce((t, e)=>t.value > e.value ? t : e);
                if (o?.sources?.length) {
                    const t = $2891d72e75a77115$var$S(o.sources);
                    t && (e = {
                        largestShiftTarget: a.get(t),
                        largestShiftTime: o.startTime,
                        largestShiftValue: o.value,
                        largestShiftSource: t,
                        largestShiftEntry: o,
                        loadState: $2891d72e75a77115$var$n(o.startTime)
                    });
                }
            }
            return Object.assign(t, {
                attribution: e
            });
        })(t));
    }, o);
}, $2891d72e75a77115$export$fe3c86b74e15d5de = (t, o = {})=>{
    $2891d72e75a77115$var$D((o)=>{
        t(((t)=>{
            let o = {
                timeToFirstByte: 0,
                firstByteToFCP: t.value,
                loadState: $2891d72e75a77115$var$n($2891d72e75a77115$var$c())
            };
            if (t.entries.length) {
                const i = $2891d72e75a77115$var$e(), r = t.entries.at(-1);
                if (i) {
                    const e = i.activationStart || 0, s = Math.max(0, i.responseStart - e);
                    o = {
                        timeToFirstByte: s,
                        firstByteToFCP: t.value - s,
                        loadState: $2891d72e75a77115$var$n(t.entries[0].startTime),
                        navigationEntry: i,
                        fcpEntry: r
                    };
                }
            }
            return Object.assign(t, {
                attribution: o
            });
        })(o));
    }, o);
};
let $2891d72e75a77115$var$k = 0, $2891d72e75a77115$var$_ = 1 / 0, $2891d72e75a77115$var$F = 0;
const $2891d72e75a77115$var$B = (t)=>{
    for (const e of t)e.interactionId && ($2891d72e75a77115$var$_ = Math.min($2891d72e75a77115$var$_, e.interactionId), $2891d72e75a77115$var$F = Math.max($2891d72e75a77115$var$F, e.interactionId), $2891d72e75a77115$var$k = $2891d72e75a77115$var$F ? ($2891d72e75a77115$var$F - $2891d72e75a77115$var$_) / 7 + 1 : 0);
};
let $2891d72e75a77115$var$C;
const $2891d72e75a77115$var$O = ()=>$2891d72e75a77115$var$C ? $2891d72e75a77115$var$k : performance.interactionCount ?? 0, $2891d72e75a77115$var$j = ()=>{
    "interactionCount" in performance || $2891d72e75a77115$var$C || ($2891d72e75a77115$var$C = $2891d72e75a77115$var$m("event", $2891d72e75a77115$var$B, {
        durationThreshold: 0
    }));
};
let $2891d72e75a77115$var$I = 0;
class $2891d72e75a77115$var$A {
    l = [];
    h = new Map;
    m;
    p;
    v() {
        $2891d72e75a77115$var$I = $2891d72e75a77115$var$O(), this.l.length = 0, this.h.clear();
    }
    M() {
        const t = Math.min(this.l.length - 1, Math.floor(($2891d72e75a77115$var$O() - $2891d72e75a77115$var$I) / 50));
        return this.l[t];
    }
    u(t) {
        if (this.m?.(t), !t.interactionId && "first-input" !== t.entryType) return;
        const e = this.l.at(-1);
        let n = this.h.get(t.interactionId);
        if (n || this.l.length < 10 || t.duration > e.T) {
            if (n ? t.duration > n.T ? (n.entries = [
                t
            ], n.T = t.duration) : t.duration === n.T && t.startTime === n.entries[0].startTime && n.entries.push(t) : (n = {
                id: t.interactionId,
                entries: [
                    t
                ],
                T: t.duration
            }, this.h.set(n.id, n), this.l.push(n)), this.l.sort((t, e)=>e.T - t.T), this.l.length > 10) {
                const t = this.l.splice(10);
                for (const e of t)this.h.delete(e.id);
            }
            this.p?.(n);
        }
    }
}
const $2891d72e75a77115$var$W = (t)=>{
    const e = globalThis.requestIdleCallback || setTimeout, n = globalThis.cancelIdleCallback || clearTimeout;
    if ("hidden" === document.visibilityState) t();
    else {
        const o = $2891d72e75a77115$var$g(t);
        let i = -1;
        const r = ()=>{
            n(i), o();
        };
        addEventListener("visibilitychange", r, {
            once: !0,
            capture: !0
        }), i = e(()=>{
            removeEventListener("visibilitychange", r, {
                capture: !0
            }), o();
        });
    }
}, $2891d72e75a77115$export$7f4cb060ded9173c = [
    200,
    500
], $2891d72e75a77115$export$7df4b36ecaed99e1 = (t, e = {})=>{
    const o = $2891d72e75a77115$var$s(e = Object.assign({}, e), $2891d72e75a77115$var$A);
    let r = [], a = [], c = 0;
    const l = new WeakMap, d = new WeakMap;
    let g = !1;
    const p = ()=>{
        g || ($2891d72e75a77115$var$W(y), g = !0);
    }, y = ()=>{
        const t = new Set(o.l.map((t)=>l.get(t.entries[0]))), e = a.length - 10;
        a = a.filter((n, o)=>o >= e || t.has(n));
        const n = new Set;
        for (const t of a){
            const e = v(t.startTime, t.processingEnd);
            for (const t of e)n.add(t);
        }
        r = r.filter((t)=>t.startTime > c || n.has(t)), g = !1;
    };
    o.m = (t)=>{
        const n = t.startTime + t.duration;
        let o;
        c = Math.max(c, t.processingEnd);
        for(let i = a.length - 1; i >= 0; i--){
            const r = a[i];
            if (Math.abs(n - r.renderTime) <= 8) {
                o = r, o.startTime = Math.min(t.startTime, o.startTime), o.processingStart = Math.min(t.processingStart, o.processingStart), o.processingEnd = Math.max(t.processingEnd, o.processingEnd), !1 !== e.includeProcessedEventEntries && o.entries.push(t);
                break;
            }
        }
        o || (o = {
            startTime: t.startTime,
            processingStart: t.processingStart,
            processingEnd: t.processingEnd,
            renderTime: n,
            entries: !1 !== e.includeProcessedEventEntries ? [
                t
            ] : []
        }, a.push(o)), (t.interactionId || "first-input" === t.entryType) && l.set(t, o), p();
    }, o.p = (t)=>{
        if (!d.get(t)) {
            const n = t.entries.find((t)=>t.target)?.target;
            if (n) {
                const o = e.generateTarget?.(n) ?? $2891d72e75a77115$var$i(n);
                d.set(t, o);
            } else {
                const e = t.entries.find((t)=>t.targetSelector)?.targetSelector;
                e && d.set(t, e);
            }
        }
    };
    const v = (t, e)=>{
        const n = [];
        for (const o of r)if (!(o.startTime + o.duration < t)) {
            if (o.startTime > e) break;
            n.push(o);
        }
        return n;
    }, b = (t)=>{
        const e = t.entries[0], i = l.get(e), r = e.processingStart, s = Math.max(e.startTime + e.duration, r), a = Math.min(i.processingEnd, s), c = i.entries.sort((t, e)=>t.processingStart - e.processingStart), u = v(e.startTime, a), f = o.h.get(e.interactionId), h = {
            interactionTarget: d.get(f),
            interactionType: e.name.startsWith("key") ? "keyboard" : "pointer",
            interactionTime: e.startTime,
            nextPaintTime: s,
            processedEventEntries: c,
            longAnimationFrameEntries: u,
            inputDelay: r - e.startTime,
            processingDuration: a - r,
            presentationDelay: s - a,
            loadState: $2891d72e75a77115$var$n(e.startTime),
            longestScript: void 0,
            totalScriptDuration: void 0,
            totalStyleAndLayoutDuration: void 0,
            totalPaintDuration: void 0,
            totalUnattributedDuration: void 0
        };
        return ((t)=>{
            if (!t.longAnimationFrameEntries?.length) return;
            const e = t.interactionTime, n = t.inputDelay, o = t.processingDuration;
            let i, r, s = 0, a = 0, c = 0, u = 0;
            for (const c of t.longAnimationFrameEntries){
                a = a + c.startTime + c.duration - c.styleAndLayoutStart;
                for (const t of c.scripts){
                    const c = t.startTime + t.duration;
                    if (c < e) continue;
                    const f = c - Math.max(e, t.startTime), l = t.duration ? f / t.duration * t.forcedStyleAndLayoutDuration : 0;
                    s += f - l, a += l, f > u && (r = t.startTime < e + n ? "input-delay" : t.startTime >= e + n + o ? "presentation-delay" : "processing-duration", i = t, u = f);
                }
            }
            const f = t.longAnimationFrameEntries.at(-1), l = f ? f.startTime + f.duration : 0;
            l >= e + n + o && (c = t.nextPaintTime - l), i && r && (t.longestScript = {
                entry: i,
                subpart: r,
                intersectingDuration: u
            }), t.totalScriptDuration = s, t.totalStyleAndLayoutDuration = a, t.totalPaintDuration = c, t.totalUnattributedDuration = t.nextPaintTime - e - s - a - c;
        })(h), Object.assign(t, {
            attribution: h
        });
    };
    $2891d72e75a77115$var$m("long-animation-frame", (t)=>{
        r = r.concat(t), p();
    }), ((t, e = {})=>{
        if (!globalThis.PerformanceEventTiming || !("interactionId" in PerformanceEventTiming.prototype)) return;
        const n = $2891d72e75a77115$var$M();
        $2891d72e75a77115$var$T(()=>{
            $2891d72e75a77115$var$j();
            let o, i = $2891d72e75a77115$var$h("INP");
            const r = $2891d72e75a77115$var$s(e, $2891d72e75a77115$var$A), a = (t)=>{
                $2891d72e75a77115$var$W(()=>{
                    for (const e of t)r.u(e);
                    const e = r.M();
                    e && e.T !== i.value && (i.value = e.T, i.entries = e.entries, o());
                });
            }, c = $2891d72e75a77115$var$m("event", a, {
                durationThreshold: e.durationThreshold ?? 40
            });
            o = $2891d72e75a77115$var$f(t, i, $2891d72e75a77115$export$7f4cb060ded9173c, e.reportAllChanges), c && (c.observe({
                type: "first-input",
                buffered: !0
            }), n.onHidden(()=>{
                a(c.takeRecords()), o(!0);
            }), $2891d72e75a77115$var$u(()=>{
                r.v(), i = $2891d72e75a77115$var$h("INP"), o = $2891d72e75a77115$var$f(t, i, $2891d72e75a77115$export$7f4cb060ded9173c, e.reportAllChanges);
            }));
        });
    })((e)=>{
        t(b(e));
    }, e);
};
class $2891d72e75a77115$var$N {
    m;
    u(t) {
        this.m?.(t);
    }
}
const $2891d72e75a77115$export$948521ca5b0e1b17 = [
    2500,
    4e3
], $2891d72e75a77115$export$947b1626ab8d5632 = (t, n = {})=>{
    const o = $2891d72e75a77115$var$s(n = Object.assign({}, n), $2891d72e75a77115$var$N), r = new WeakMap;
    o.m = (t)=>{
        const e = t.element;
        if (e) {
            const o = n.generateTarget?.(e) ?? $2891d72e75a77115$var$i(e);
            r.set(t, o);
        } else t.id && r.set(t, `#${t.id}`);
    };
    ((t, e = {})=>{
        $2891d72e75a77115$var$T(()=>{
            const n = $2891d72e75a77115$var$M();
            let o, i = $2891d72e75a77115$var$h("LCP");
            const r = $2891d72e75a77115$var$s(e, $2891d72e75a77115$var$N), a = (t)=>{
                e.reportAllChanges || (t = t.slice(-1));
                for (const e of t)r.u(e), e.startTime < n.firstHiddenTime && (i.value = Math.max(e.startTime - $2891d72e75a77115$var$d(), 0), i.entries = [
                    e
                ], o());
            }, c = $2891d72e75a77115$var$m("largest-contentful-paint", a);
            if (c) {
                o = $2891d72e75a77115$var$f(t, i, $2891d72e75a77115$export$948521ca5b0e1b17, e.reportAllChanges);
                const n = $2891d72e75a77115$var$g(()=>{
                    a(c.takeRecords()), c.disconnect(), o(!0);
                }), r = (t)=>{
                    t.isTrusted && ($2891d72e75a77115$var$W(n), removeEventListener(t.type, r, {
                        capture: !0
                    }));
                };
                for (const t of [
                    "keydown",
                    "click",
                    "visibilitychange"
                ])addEventListener(t, r, {
                    capture: !0
                });
                $2891d72e75a77115$var$u((n)=>{
                    i = $2891d72e75a77115$var$h("LCP"), o = $2891d72e75a77115$var$f(t, i, $2891d72e75a77115$export$948521ca5b0e1b17, e.reportAllChanges), $2891d72e75a77115$var$l(()=>{
                        i.value = performance.now() - n.timeStamp, o(!0);
                    });
                });
            }
        });
    })((n)=>{
        t(((t)=>{
            let n = {
                timeToFirstByte: 0,
                resourceLoadDelay: 0,
                resourceLoadDuration: 0,
                elementRenderDelay: t.value
            };
            if (t.entries.length) {
                const o = t.entries.at(-1), i = o.url && performance.getEntriesByType("resource").find((t)=>t.name === o.url);
                n.target = r.get(o), n.lcpEntry = o, o.url && (n.url = o.url), i && (n.lcpResourceEntry = i);
                const s = $2891d72e75a77115$var$e();
                if (s) {
                    const e = s.activationStart || 0, o = Math.max(0, s.responseStart - e), r = Math.max(o, i ? (i.requestStart || i.startTime) - e : 0), a = Math.min(t.value, Math.max(r, i ? i.responseEnd - e : 0));
                    n = {
                        ...n,
                        timeToFirstByte: o,
                        resourceLoadDelay: r - o,
                        resourceLoadDuration: a - r,
                        elementRenderDelay: t.value - a,
                        navigationEntry: s
                    };
                }
            }
            return Object.assign(t, {
                attribution: n
            });
        })(n));
    }, n);
}, $2891d72e75a77115$export$65c59ea8064668fc = [
    800,
    1800
], $2891d72e75a77115$var$U = (t)=>{
    document.prerendering ? $2891d72e75a77115$var$T(()=>$2891d72e75a77115$var$U(t)) : "complete" !== document.readyState ? addEventListener("load", ()=>$2891d72e75a77115$var$U(t), !0) : setTimeout(t);
}, $2891d72e75a77115$export$33a01e6c5f2c7e33 = (t, n = {})=>{
    ((t, n = {})=>{
        let o = $2891d72e75a77115$var$h("TTFB"), i = $2891d72e75a77115$var$f(t, o, $2891d72e75a77115$export$65c59ea8064668fc, n.reportAllChanges);
        $2891d72e75a77115$var$U(()=>{
            const r = $2891d72e75a77115$var$e();
            r && (o.value = Math.max(r.responseStart - $2891d72e75a77115$var$d(), 0), o.entries = [
                r
            ], i(!0), $2891d72e75a77115$var$u(()=>{
                o = $2891d72e75a77115$var$h("TTFB", 0), i = $2891d72e75a77115$var$f(t, o, $2891d72e75a77115$export$65c59ea8064668fc, n.reportAllChanges), i(!0);
            }));
        });
    })((e)=>{
        t(((t)=>{
            let e = {
                waitingDuration: 0,
                cacheDuration: 0,
                dnsDuration: 0,
                connectionDuration: 0,
                requestDuration: 0
            };
            if (t.entries.length) {
                const n = t.entries[0], o = n.activationStart || 0, i = Math.max((n.workerStart || n.fetchStart) - o, 0), r = Math.max(n.domainLookupStart - o, 0), s = Math.max(n.connectStart - o, 0), a = Math.max(n.connectEnd - o, 0);
                e = {
                    waitingDuration: i,
                    cacheDuration: r - i,
                    dnsDuration: s - r,
                    connectionDuration: a - s,
                    requestDuration: t.value - a,
                    navigationEntry: n
                };
            }
            return Object.assign(t, {
                attribution: e
            });
        })(e));
    }, n);
};

});


parcelRegister("2ySnN", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $1dd8f109fee0e28f$export$83d89fbfd8236492; });
// Generated by CI.
const $1dd8f109fee0e28f$export$83d89fbfd8236492 = '9.2.362+ec7b016';

});

parcelRegister("9f8N2", function(module, exports) {

$parcel$export(module.exports, "shouldDropChunkException", function () { return $6bac553fb09cd324$export$57893fe4c03dc899; });
$parcel$export(module.exports, "install", function () { return $6bac553fb09cd324$export$4b3e715f166fdd78; });
/**
 * Auto-reload once when a dynamic-import chunk or hashed dist/ asset
 * fails to load. Parcel rewrites all code-split chunks to hashed
 * filenames (see package.json parcel-namer-rewrite), and Pagely
 * deploys replace dist/ wholesale — so tabs open across a deploy,
 * or pages served from a stale Cloudflare HTML cache, reference
 * hashes that no longer exist on disk.
 *
 * Gated by sessionStorage so a genuinely missing chunk can't loop.
 *
 * Duplicate-event suppression for the $exception kill metric lives in
 * util/posthog.js's `before_send` hook, which calls `shouldDropChunkException`
 * (exported below). posthog-js captures unhandled rejections via
 * `window.onunhandledrejection` (property assignment) rather than
 * addEventListener, so preventDefault/stopImmediatePropagation in the
 * listeners here cannot stop PostHog from sending the event — only
 * before_send can. See MTN-228 / MTN-366.
 */ 
var $99uU9 = parcelRequire("99uU9");
const $6bac553fb09cd324$var$RELOAD_FLAG_KEY = "mtn-chunk-reload-attempted";
const $6bac553fb09cd324$var$STALE_CHUNK_MESSAGE = /Failed to fetch dynamically imported module|Importing a module script failed|^Cannot find module '[^']+'$/i;
const $6bac553fb09cd324$var$DIST_ASSET = /\/dist\/[^/?#]+\.(?:js|mjs|css)(?:\?|#|$)/i;
let $6bac553fb09cd324$var$reloaded = (()=>{
    try {
        return sessionStorage.getItem($6bac553fb09cd324$var$RELOAD_FLAG_KEY) === "1";
    } catch  {
        return false;
    }
})();
// In-memory; once true, `before_send` drops parallel chunk failures from the
// same page load so PostHog only sees the first one. Distinct from `reloaded`,
// which persists across page loads — a post-reload page where the chunk still
// fails gets one real kill-metric event, then `postReloadFailureReported`
// drops the same-load duplicates too.
let $6bac553fb09cd324$var$reloadInFlight = false;
let $6bac553fb09cd324$var$postReloadFailureReported = false;
const $6bac553fb09cd324$var$reload = (reason)=>{
    if ($6bac553fb09cd324$var$reloaded) return false;
    // Persist the loop guard before doing anything reload-adjacent. If storage
    // throws (private mode, disabled), skip the reload — a broken page is
    // better than a reload loop we can't guard across page loads.
    try {
        sessionStorage.setItem($6bac553fb09cd324$var$RELOAD_FLAG_KEY, "1");
    } catch  {
        $6bac553fb09cd324$var$reloaded = true;
        $6bac553fb09cd324$var$reloadInFlight = true;
        return false;
    }
    $6bac553fb09cd324$var$reloaded = true;
    $6bac553fb09cd324$var$reloadInFlight = true;
    try {
        (0, $99uU9.capture)("chunk_reload_triggered", {
            reason: reason
        });
    } catch  {
    // Swallow — we're reloading anyway.
    }
    // Small delay so the capture request has a chance to leave the tab.
    setTimeout(()=>window.location.reload(), 50);
    return true;
};
const $6bac553fb09cd324$export$57893fe4c03dc899 = (exceptionValue)=>{
    if (!$6bac553fb09cd324$var$STALE_CHUNK_MESSAGE.test(String(exceptionValue))) return false;
    // Same-page-load duplicates after reload() has armed. The kill metric on
    // this page is the `chunk_reload_triggered` event, not the underlying
    // exceptions.
    if ($6bac553fb09cd324$var$reloadInFlight) return true;
    // Post-reload page where the chunk STILL fails. Let the first event through
    // as the genuine "reload didn't fix it" kill metric; drop the rest.
    if ($6bac553fb09cd324$var$reloaded) {
        if ($6bac553fb09cd324$var$postReloadFailureReported) return true;
        $6bac553fb09cd324$var$postReloadFailureReported = true;
        return false;
    }
    // Fresh page where the `unhandledrejection` handler has not yet run for this
    // chunk. The handler fires reload() immediately after; later events
    // hit the `reloadInFlight` branch above. Drop conservatively — we're about
    // to reload, the exception itself has no diagnostic value here.
    return true;
};
const $6bac553fb09cd324$export$4b3e715f166fdd78 = ()=>{
    window.addEventListener("unhandledrejection", (event)=>{
        const message = event.reason?.message ?? event.reason ?? "";
        if (!$6bac553fb09cd324$var$STALE_CHUNK_MESSAGE.test(String(message))) return;
        // Silence the browser's "Unhandled Promise Rejection" console warning.
        // Does NOT stop posthog-js (it captures via window.onunhandledrejection,
        // a property assignment) — that suppression is in before_send via
        // shouldDropChunkException above.
        event.preventDefault();
        if ($6bac553fb09cd324$var$reloaded) return;
        $6bac553fb09cd324$var$reload("unhandledrejection");
    });
    // <link>/<script> load failures don't bubble — listen on capture phase.
    // posthog-js's autocapture doesn't observe these (window.onerror only fires
    // for script execution errors, not resource load failures), so this listener
    // needs no suppression beyond the reload-loop guard.
    window.addEventListener("error", (event)=>{
        const { target: target } = event;
        if (!target || target === window) return;
        const url = target.href ?? target.src ?? "";
        if (!$6bac553fb09cd324$var$DIST_ASSET.test(url)) return;
        if ($6bac553fb09cd324$var$reloaded) return;
        $6bac553fb09cd324$var$reload("resource_error");
    }, true);
};

});

parcelRegister("f3UsM", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $af72ef432cafb93d$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $af72ef432cafb93d$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "remove", function () { return $af72ef432cafb93d$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "setIfChanged", function () { return $af72ef432cafb93d$export$9be1301193883bb5; });
// Single write/delete path for MTN-owned cookies (MTN-321): every write
// carries Secure, SameSite=Lax, and Path=/, host-only by default. Pass
// `parent: true` only for a cookie with a named cross-subdomain consumer
// (MTN-1434 browser-storage disposition).
const $af72ef432cafb93d$var$PARENT_ATTRIBUTE = "; domain=.moneytalksnews.com";
const $af72ef432cafb93d$export$3988ae62b71be9a3 = (name)=>{
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[2]) : undefined;
};
const $af72ef432cafb93d$export$adaa4cf7ef1b65be = (name, value, { days: days, parent: parent = false } = {})=>{
    // Drop the other-scope copy a past writer may have left: at equal path,
    // the older cookie sorts first, so a stale value from the old scope would
    // shadow this write.
    document.cookie = `${name}=${parent ? "" : $af72ef432cafb93d$var$PARENT_ATTRIBUTE}; max-age=0; path=/; Secure; SameSite=Lax`;
    const maxAge = days === undefined ? "" : `; max-age=${Math.round(days * 86400)}`;
    document.cookie = `${name}=${encodeURIComponent(value)}${parent ? $af72ef432cafb93d$var$PARENT_ATTRIBUTE : ""}${maxAge}; path=/; Secure; SameSite=Lax`;
};
const $af72ef432cafb93d$export$cd7f480d6b8286c3 = (name)=>{
    document.cookie = `${name}=; max-age=0; path=/; Secure; SameSite=Lax`;
    document.cookie = `${name}=${$af72ef432cafb93d$var$PARENT_ATTRIBUTE}; max-age=0; path=/; Secure; SameSite=Lax`;
};
const $af72ef432cafb93d$export$9be1301193883bb5 = (name, value, options)=>{
    if ($af72ef432cafb93d$export$3988ae62b71be9a3(name) === String(value)) return;
    $af72ef432cafb93d$export$adaa4cf7ef1b65be(name, value, options);
};

});

parcelRegister("eE0qw", function(module, exports) {

$parcel$export(module.exports, "getEnvironment", function () { return $aa9521dd1ec9fe7d$export$57570b1603cf6adb; });
$parcel$export(module.exports, "isLocalDevelopment", function () { return $aa9521dd1ec9fe7d$export$96081e27c2a95b0; });
$parcel$export(module.exports, "shouldProxyExternalUrl", function () { return $aa9521dd1ec9fe7d$export$ccbcbe54ed442d8d; });
// Shared host classification for environment-conditional code.
// JS mirror of the PHP Environment module (app/Controllers/environment.php);
// both classifiers are pinned to tests/fixtures/host-environments.json, so
// change them together (MTN-613).
const $aa9521dd1ec9fe7d$var$stripPort = (host)=>host.split(":")[0];
const $aa9521dd1ec9fe7d$var$isHostOrSubdomain = (host, domain)=>host === domain || host.endsWith(`.${domain}`);
const $aa9521dd1ec9fe7d$var$hostnameLabelPattern = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i;
const $aa9521dd1ec9fe7d$var$invalidAuthorityCharacterPattern = /[@/\\?#\s]/;
const $aa9521dd1ec9fe7d$var$hostAuthorityPattern = /^([^:]+)(?::([0-9]{1,5}))?$/;
const $aa9521dd1ec9fe7d$var$parseHostAuthority = (host)=>{
    if (host === "" || host !== host.trim() || $aa9521dd1ec9fe7d$var$invalidAuthorityCharacterPattern.test(host)) return null;
    const authority = $aa9521dd1ec9fe7d$var$hostAuthorityPattern.exec(host);
    // biome-ignore lint/suspicious/noUnnecessaryConditions: exec() returns null on no match; Biome 2.5.14 types it non-null (biomejs/biome#11278).
    if (authority === null) return null;
    const [, hostname, port] = authority;
    if (hostname.length > 253 || port !== undefined && Number(port) > 65535 || !hostname.split(".").every((label)=>$aa9521dd1ec9fe7d$var$hostnameLabelPattern.test(label))) return null;
    return hostname.toLowerCase();
};
const $aa9521dd1ec9fe7d$var$currentHost = ()=>typeof window === "undefined" ? "" : window.location.host;
const $aa9521dd1ec9fe7d$export$7c04a3d1d6db1f9c = (host)=>{
    if (typeof host !== "string" || host === "") return "unknown";
    const normalized = $aa9521dd1ec9fe7d$var$stripPort(host).toLowerCase();
    if (normalized.endsWith(".ddev.site") || normalized.endsWith(".test") || normalized === "localhost") return "development";
    if (normalized === "beta.moneytalksnews.com") return "staging";
    if (normalized === "www.moneytalksnews.com" || normalized === "moneytalksnews.com") return "production";
    return "unknown";
};
const $aa9521dd1ec9fe7d$export$57570b1603cf6adb = ()=>$aa9521dd1ec9fe7d$export$7c04a3d1d6db1f9c($aa9521dd1ec9fe7d$var$currentHost());
const $aa9521dd1ec9fe7d$export$96081e27c2a95b0 = ()=>$aa9521dd1ec9fe7d$export$7c04a3d1d6db1f9c($aa9521dd1ec9fe7d$var$currentHost()) === "development";
const $aa9521dd1ec9fe7d$export$f06708ccf24917a0 = (linkHost = $aa9521dd1ec9fe7d$var$currentHost())=>{
    if (typeof linkHost !== "string") return false;
    const normalized = $aa9521dd1ec9fe7d$var$parseHostAuthority(linkHost);
    if (normalized === null) return false;
    if (normalized === "localhost") return true;
    if ($aa9521dd1ec9fe7d$var$isHostOrSubdomain(normalized, "moneytalksnews.com") || $aa9521dd1ec9fe7d$var$isHostOrSubdomain(normalized, "moneytalksnews.test")) return true;
    return normalized.endsWith(".ddev.site");
};
const $aa9521dd1ec9fe7d$export$ccbcbe54ed442d8d = (url)=>(url.protocol === "http:" || url.protocol === "https:") && !$aa9521dd1ec9fe7d$export$f06708ccf24917a0(url.hostname);

});

parcelRegister("H9wys", function(module, exports) {

$parcel$export(module.exports, "CATEGORIES", function () { return $081b678ccaa38056$export$a513ea61a7bee91c; });
$parcel$export(module.exports, "ADVERTISING_COOKIES", function () { return $081b678ccaa38056$export$e6dc33c528158865; });
$parcel$export(module.exports, "allowCookie", function () { return $081b678ccaa38056$export$740e2db3feda276c; });
$parcel$export(module.exports, "ready", function () { return $081b678ccaa38056$export$28ee1007e174a2a6; });
$parcel$export(module.exports, "allowAnalytics", function () { return $081b678ccaa38056$export$7d5e1bb079b711c5; });
$parcel$export(module.exports, "allowAdvertising", function () { return $081b678ccaa38056$export$e49d832173b98276; });
$parcel$export(module.exports, "isAllowedCookie", function () { return $081b678ccaa38056$export$a4c2db7d1bbada26; });
$parcel$export(module.exports, "hasCategory", function () { return $081b678ccaa38056$export$d2fc16bad1f24e08; });
$parcel$export(module.exports, "doNotSell", function () { return $081b678ccaa38056$export$80f69ef8235e8cea; });
$parcel$export(module.exports, "allowsDataSale", function () { return $081b678ccaa38056$export$863bc46a2f49a2c9; });
$parcel$export(module.exports, "allowAdvertisingSale", function () { return $081b678ccaa38056$export$6aaf4936b9926984; });
$parcel$export(module.exports, "allowPerformance", function () { return $081b678ccaa38056$export$53dc2d55e9021567; });
$parcel$export(module.exports, "allowSocialNetworking", function () { return $081b678ccaa38056$export$5fafb07194ea16b; });
$parcel$export(module.exports, "allowUnclassified", function () { return $081b678ccaa38056$export$2251e8b198f98497; });
$parcel$export(module.exports, "setTermlyUUIDCookie", function () { return $081b678ccaa38056$export$c20a79f3a0e4bbc1; });
$parcel$export(module.exports, "watchCategory", function () { return $081b678ccaa38056$export$8d7d2176310c8344; });
$parcel$export(module.exports, "onUnavailable", function () { return $081b678ccaa38056$export$75f4035ea1b94a94; });
// These functions run a callback if or when the user allows a category
// Example:
//
//  const termly = await import('../util/termly')
//  termly.allowPerformance(() => {
//    console.log('performance allowed')
//  })

var $f3UsM = parcelRequire("f3UsM");
const $081b678ccaa38056$export$a513ea61a7bee91c = Object.freeze({
    ADVERTISING: "advertising",
    ANALYTICS: "analytics",
    ESSENTIAL: "essential",
    PERFORMANCE: "performance",
    SOCIAL_NETWORKING: "social_networking",
    UNCLASSIFIED: "unclassified"
});
const $081b678ccaa38056$export$e6dc33c528158865 = Object.freeze([
    "_rc_uuid",
    "_obcid",
    "_tbcid",
    "_dicid",
    "_sacid",
    "_sncid",
    "_gclid",
    "_gbraid",
    "_wbraid",
    "_msclkid",
    "_fbclid",
    "_fbp",
    "_fbc"
]);
const $081b678ccaa38056$export$740e2db3feda276c = (cookie, callback)=>{
    $081b678ccaa38056$export$28ee1007e174a2a6(()=>{
        // Analytics cookies. (mtn-subscriber-status and the modal seen-flags
        // left this map when MTN-1444 reclassified them as functional/Essential
        // and routed them through the storage adapter.)
        if ([
            "mtn-ga4-client-id",
            "mtn-ga4-session-id",
            "mtn-user-id",
            "mtn-recommender-user-id"
        ].includes(cookie)) $081b678ccaa38056$export$7d5e1bb079b711c5(callback);
        else if ($081b678ccaa38056$export$e6dc33c528158865.includes(cookie)) // Advertising Cookies
        $081b678ccaa38056$export$e49d832173b98276(callback);
        else if ($081b678ccaa38056$export$a4c2db7d1bbada26(cookie)) // console.log(`${cookie} is allowed`)
        callback();
        else document.addEventListener("termlyDataUpdate", ()=>$081b678ccaa38056$export$740e2db3feda276c(cookie, callback), {
            once: true
        });
    });
};
const $081b678ccaa38056$export$a4c2db7d1bbada26 = (cookie)=>{
    // Check the cookie whitelist
    const cookies = window.termlyData?.cookies || [];
    if (cookies.some((e)=>e.name === cookie)) return true;
    // Check window.termlyCookies, which holds every cookie Termly knows about,
    // and see whether the user allowed the given cookie's category
    if (window.termlyCookies) {
        const found = Object.values(window.termlyCookies).flatMap((array)=>array.filter((item)=>item.name === cookie));
        // The cookie counts as allowed only if the user consented to its category
        if (found.length > 0 && $081b678ccaa38056$export$d2fc16bad1f24e08(found[0].category)) return true;
    }
    return false;
};
// Run callback once `condition` holds. If it doesn't yet, wait for the next
// termlyDataUpdate and re-check. {once: true} keeps the listener set
// bounded — the recursive call re-registers a fresh listener only while the
// condition still fails.
const $081b678ccaa38056$var$onCondition = (condition, callback)=>{
    $081b678ccaa38056$export$28ee1007e174a2a6(()=>{
        if (condition()) callback();
        else document.addEventListener("termlyDataUpdate", ()=>$081b678ccaa38056$var$onCondition(condition, callback), {
            once: true
        });
    });
};
const $081b678ccaa38056$var$onAllowed = (category, callback)=>$081b678ccaa38056$var$onCondition(()=>$081b678ccaa38056$export$d2fc16bad1f24e08(category), callback);
const $081b678ccaa38056$export$80f69ef8235e8cea = ()=>Boolean(window.termlyData?.consentState?.do_not_sell);
const $081b678ccaa38056$export$863bc46a2f49a2c9 = ()=>Array.isArray(window.termlyData?.categories) && !$081b678ccaa38056$export$80f69ef8235e8cea();
const $081b678ccaa38056$export$6aaf4936b9926984 = (callback)=>$081b678ccaa38056$var$onCondition(()=>$081b678ccaa38056$export$d2fc16bad1f24e08($081b678ccaa38056$export$a513ea61a7bee91c.ADVERTISING) && $081b678ccaa38056$export$863bc46a2f49a2c9(), callback);
const $081b678ccaa38056$export$53dc2d55e9021567 = (callback)=>$081b678ccaa38056$var$onAllowed($081b678ccaa38056$export$a513ea61a7bee91c.PERFORMANCE, callback);
const $081b678ccaa38056$export$7d5e1bb079b711c5 = (callback)=>$081b678ccaa38056$var$onAllowed($081b678ccaa38056$export$a513ea61a7bee91c.ANALYTICS, callback);
const $081b678ccaa38056$export$e49d832173b98276 = (callback)=>$081b678ccaa38056$var$onAllowed($081b678ccaa38056$export$a513ea61a7bee91c.ADVERTISING, callback);
const $081b678ccaa38056$export$5fafb07194ea16b = (callback)=>$081b678ccaa38056$var$onAllowed($081b678ccaa38056$export$a513ea61a7bee91c.SOCIAL_NETWORKING, callback);
const $081b678ccaa38056$export$2251e8b198f98497 = (callback)=>$081b678ccaa38056$var$onAllowed($081b678ccaa38056$export$a513ea61a7bee91c.UNCLASSIFIED, callback);
const $081b678ccaa38056$export$c20a79f3a0e4bbc1 = ()=>{
    if (window.termlyData?.uuid) (0, $f3UsM.setIfChanged)("mtn-termly-uuid", window.termlyData.uuid, {
        days: 90,
        parent: true
    });
    else document.addEventListener("termlyDataUpdate", $081b678ccaa38056$export$c20a79f3a0e4bbc1, {
        once: true
    });
};
const $081b678ccaa38056$export$28ee1007e174a2a6 = (callback)=>{
    if (window.termlyData === null) document.addEventListener("termlyDataUpdate", callback, {
        once: true
    });
    else callback();
};
const $081b678ccaa38056$export$d2fc16bad1f24e08 = (category)=>{
    // Array check fails closed on a malformed report: a string value would
    // otherwise substring-match category names via String.includes.
    const categories = window.termlyData?.categories;
    return Array.isArray(categories) && categories.includes(category);
};
const $081b678ccaa38056$export$8d7d2176310c8344 = (category, callback)=>{
    let hasReported = false;
    let lastState;
    const report = ()=>{
        if (window.termlyData === null) return;
        const state = $081b678ccaa38056$export$d2fc16bad1f24e08(category);
        if (hasReported && state === lastState) return;
        hasReported = true;
        lastState = state;
        callback(state);
    };
    document.addEventListener("termlyDataUpdate", report);
    report();
    return ()=>document.removeEventListener("termlyDataUpdate", report);
};
const $081b678ccaa38056$export$75f4035ea1b94a94 = (callback, { timeoutMs: timeoutMs })=>{
    if (window.termlyData !== null) return ()=>undefined;
    let settled = false;
    let timeoutId;
    const cleanup = ()=>{
        clearTimeout(timeoutId);
        document.removeEventListener("termlyDataUpdate", handleDataUpdate);
        document.removeEventListener("termlyLoadFailed", handleLoadFailed);
    };
    const settle = (reason)=>{
        if (settled) return;
        settled = true;
        cleanup();
        callback(reason);
    };
    const handleDataUpdate = ()=>{
        if (window.termlyData !== null) {
            settled = true;
            cleanup();
        }
    };
    const handleLoadFailed = ()=>settle("termly_load_failed");
    document.addEventListener("termlyDataUpdate", handleDataUpdate);
    document.addEventListener("termlyLoadFailed", handleLoadFailed);
    timeoutId = setTimeout(()=>settle("fallback_timer"), timeoutMs);
    return ()=>{
        settled = true;
        cleanup();
    };
};

});


parcelRegister("6XKmh", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $511c36956b466e73$export$2cd8252107eb640b; });
$parcel$export(module.exports, "decorateTuneLinkClickIds", function () { return $511c36956b466e73$export$1f87f9d3c0ee3e18; });
$parcel$export(module.exports, "advertisingUtmValues", function () { return $511c36956b466e73$export$9cc6b2ad869c9455; });
$parcel$export(module.exports, "initTuneLinkClickIdHandler", function () { return $511c36956b466e73$export$cf3b576e6a262121; });
$parcel$export(module.exports, "decorateLinks", function () { return $511c36956b466e73$export$6b24be58d17e9904; });
$parcel$export(module.exports, "source", function () { return $511c36956b466e73$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "medium", function () { return $511c36956b466e73$export$649ecc744817b5c7; });
$parcel$export(module.exports, "campaign", function () { return $511c36956b466e73$export$b98c010fcdebc6be; });
$parcel$export(module.exports, "content", function () { return $511c36956b466e73$export$a7db06668cad9adb; });
$parcel$export(module.exports, "term", function () { return $511c36956b466e73$export$be3eabeed0f5400e; });

var $jEV3M = parcelRequire("jEV3M");

var $f3UsM = parcelRequire("f3UsM");

var $99uU9 = parcelRequire("99uU9");

var $H9wys = parcelRequire("H9wys");
// Parse current URL
const $511c36956b466e73$var$url = new URL(window.location.href);
const $511c36956b466e73$var$UTM_PARAMS = [
    "source",
    "medium",
    "campaign",
    "content",
    "term"
];
// UTM values carried by this navigation itself (query parameters, or the
// Google-referrer heuristic). Current-request data, not storage, so they
// flow to every consumer regardless of consent category (MTN-1444).
const $511c36956b466e73$var$landing = {
    campaign: null,
    content: null,
    medium: null,
    source: null,
    term: null
};
// Populated at import so a click that beats init() (audit state 12) still
// carries this navigation's own values from memory.
try {
    if (document.referrer) {
        const referrerURL = new URL(document.referrer);
        if (referrerURL.host.includes("google")) $511c36956b466e73$var$landing.source = "google";
    }
} catch (error) {
    console.error(error);
    (0, $99uU9.captureException)(error, {
        source: "utm:referrer-source"
    });
}
for (const param of $511c36956b466e73$var$UTM_PARAMS)if ($511c36956b466e73$var$url.searchParams.has(`utm_${param}`)) {
    const rawValue = $511c36956b466e73$var$url.searchParams.get(`utm_${param}`);
    try {
        $511c36956b466e73$var$landing[param] = decodeURIComponent(rawValue);
    } catch  {
        // Not double-encoded after all — keep the once-decoded value.
        $511c36956b466e73$var$landing[param] = rawValue;
    }
}
// Persisted UTMs split by sink (MTN-1444 disposition):
//   * mtn-utm-* cookies — Advertising; cross-page affiliate attribution for
//     Tune-link decoration and the PHP short-link redirect.
//   * mtn-newsletter-utm localforage record — Analytics; newsletter signup
//     attribution (7-day envelope TTL in the storage adapter).
const $511c36956b466e73$var$NEWSLETTER_UTM_KEY = "mtn-newsletter-utm";
let $511c36956b466e73$var$didInit = false;
let $511c36956b466e73$var$recordPromise;
// Read any advertising click IDs from the URL or their cookies. `landing`
// marks values carried by this navigation itself — the only ones the
// restricted transport below may pass. `recovered` marks cookie-sourced
// Google IDs for the google_attribution_recovered signal.
const $511c36956b466e73$var$readParamOrCookie = (name)=>{
    const landingValue = $511c36956b466e73$var$url.searchParams.get(name);
    return landingValue ? {
        landing: true,
        value: landingValue
    } : {
        landing: false,
        value: (0, $f3UsM.get)(`_${name}`)
    };
};
const $511c36956b466e73$var$advertisingClickIds = [
    ...[
        "fbclid",
        "fbc",
        "fbp",
        "msclkid",
        "sncid"
    ].map((name)=>({
            name: name,
            ...$511c36956b466e73$var$readParamOrCookie(name)
        })),
    ...[
        "gclid",
        "gbraid",
        "wbraid"
    ].map((name)=>{
        const read = $511c36956b466e73$var$readParamOrCookie(name);
        return {
            name: name,
            ...read,
            recovered: !read.landing && Boolean(read.value)
        };
    })
];
const $511c36956b466e73$var$landingClickIds = $511c36956b466e73$var$advertisingClickIds.filter((id)=>id.landing);
// Params this module added, per link, so a state change (revocation, or a
// different transport at the next click) can strip exactly what we added
// and never touch author-written values. Entries for links removed from
// the DOM linger until revocation clears them — small objects, page
// lifetime; switch to per-link data attributes if that ever matters.
const $511c36956b466e73$var$decorations = new Map();
const $511c36956b466e73$var$TUNE_TRANSPORT = Object.freeze({
    CLEAN: "clean",
    FULL: "full",
    RESTRICTED: "restricted"
});
/**
 * Which attribution may ride a Tune /out/ navigation right now (MTN-1447):
 *
 * - full: Termly resolved with Advertising allowed — landing and
 *   cookie-recovered values pass (the normal flow).
 * - restricted: Advertising not allowed (denied, or Termly unresolved) on
 *   a US region profile — only this page's own click IDs and UTMs pass,
 *   held in memory and placed once on the first-party /out/ GET; the edge
 *   strips them before the outbound hop.
 * - clean: everywhere else (EEA/UK profile, or no region information) —
 *   no ad identifiers ride at all.
 *
 * Region comes from Termly's `initialized` region profile
 * (window.termlyRegionSettings, stashed by head.blade.php); a missing
 * profile fails closed to clean. do_not_sell needs no branch here: Termly
 * couples it with declining every non-essential category, so it lands in
 * restricted, navigation continues, and the server reads the opt-out from
 * the consent envelope (enforcement is server-side).
 */ const $511c36956b466e73$var$tuneTransport = ()=>{
    if ((0, $H9wys.hasCategory)((0, $H9wys.CATEGORIES).ADVERTISING)) return $511c36956b466e73$var$TUNE_TRANSPORT.FULL;
    return window.termlyRegionSettings?.region === "us" ? $511c36956b466e73$var$TUNE_TRANSPORT.RESTRICTED : $511c36956b466e73$var$TUNE_TRANSPORT.CLEAN;
};
const $511c36956b466e73$export$2cd8252107eb640b = async ()=>{
    // Only init once
    if ($511c36956b466e73$var$didInit) return;
    $511c36956b466e73$var$didInit = true;
    // Drop the saved parameters when this URL carries any UTM parameter of its own
    if ($511c36956b466e73$var$UTM_PARAMS.some((param)=>$511c36956b466e73$var$url.searchParams.has(`utm_${param}`))) await $511c36956b466e73$var$clear();
    await $511c36956b466e73$var$save();
};

/**
 * Persist the landing UTMs into their category-owned stores. Each write
 * waits for its category's grant, so a consent given moments after the
 * landing still captures the attribution.
 */ const $511c36956b466e73$var$save = async ()=>{
    const values = {};
    for (const param of $511c36956b466e73$var$UTM_PARAMS)if ($511c36956b466e73$var$landing[param]) values[param] = $511c36956b466e73$var$landing[param];
    if (Object.keys(values).length === 0) return;
    const termly = await Promise.resolve((parcelRequire("H9wys")));
    termly.allowAdvertising(()=>{
        for (const [param, value] of Object.entries(values))// 7-day affiliate-attribution window (MTN-1434 disposition). Host-only:
        // Tune-link decoration and the PHP short-link redirect both read these
        // on the page's own host.
        (0, $f3UsM.set)(`mtn-utm-${param}`, value, {
            days: 7
        });
    });
    termly.allowAnalytics(()=>{
        // Same-page readers see the post-save record at once; the adapter write
        // lands in the background.
        $511c36956b466e73$var$recordPromise = Promise.resolve(values);
        (0, $jEV3M.setItem)($511c36956b466e73$var$NEWSLETTER_UTM_KEY, values).catch((error)=>console.error(error));
    });
};
const $511c36956b466e73$var$clear = async ()=>{
    for (const param of $511c36956b466e73$var$UTM_PARAMS)(0, $f3UsM.remove)(`mtn-utm-${param}`);
    $511c36956b466e73$var$recordPromise = undefined;
    await (0, $jEV3M.removeItem)($511c36956b466e73$var$NEWSLETTER_UTM_KEY);
};
const $511c36956b466e73$var$addAdvertisingClickIdParams = (linkUrl, clickIds)=>{
    const added = [];
    for (const clickId of clickIds)if (clickId.value && !linkUrl.searchParams.has(clickId.name)) {
        linkUrl.searchParams.set(clickId.name, clickId.value);
        added.push(clickId);
    }
    return added;
};
const $511c36956b466e73$var$trackDecoration = (link, addition)=>{
    const decoration = $511c36956b466e73$var$decorations.get(link) ?? {
        addedMarker: false,
        clickIds: [],
        utmParams: []
    };
    $511c36956b466e73$var$decorations.set(link, {
        addedMarker: addition.addedMarker ?? decoration.addedMarker,
        clickIds: [
            ...decoration.clickIds,
            ...addition.clickIds ?? []
        ],
        utmParams: [
            ...decoration.utmParams,
            ...addition.utmParams ?? []
        ]
    });
};
// Remove exactly what this module added to the link, leaving
// author-written parameters alone.
const $511c36956b466e73$var$stripTrackedParams = (link, linkUrl)=>{
    const decoration = $511c36956b466e73$var$decorations.get(link);
    if (!decoration) return;
    for (const clickId of decoration.clickIds)if (linkUrl.searchParams.get(clickId.name) === clickId.value) linkUrl.searchParams.delete(clickId.name);
    if (decoration.addedMarker && linkUrl.searchParams.get("google_attribution_recovered") === "1") linkUrl.searchParams.delete("google_attribution_recovered");
    for (const [name, value] of decoration.utmParams)if (linkUrl.searchParams.get(name) === value) linkUrl.searchParams.delete(name);
    $511c36956b466e73$var$decorations.delete(link);
};
const $511c36956b466e73$var$clearDecorations = ()=>{
    for (const link of [
        ...$511c36956b466e73$var$decorations.keys()
    ]){
        const linkUrl = new URL(link.href);
        $511c36956b466e73$var$stripTrackedParams(link, linkUrl);
        link.href = linkUrl.href;
    }
};
const $511c36956b466e73$export$1f87f9d3c0ee3e18 = (event)=>{
    const link = event.target?.closest?.("a.tune");
    if (!link) return;
    try {
        const linkUrl = new URL(link.href);
        // Re-classify on every click (audit state 12): strip whatever an
        // earlier state added, then decorate for the transport in force now.
        linkUrl.searchParams.delete("google_attribution_recovered");
        $511c36956b466e73$var$stripTrackedParams(link, linkUrl);
        const transport = $511c36956b466e73$var$tuneTransport();
        if (transport !== $511c36956b466e73$var$TUNE_TRANSPORT.CLEAN) {
            const addedClickIds = $511c36956b466e73$var$addAdvertisingClickIdParams(linkUrl, transport === $511c36956b466e73$var$TUNE_TRANSPORT.FULL ? $511c36956b466e73$var$advertisingClickIds : $511c36956b466e73$var$landingClickIds);
            const addedMarker = addedClickIds.some((clickId)=>clickId.recovered);
            if (addedMarker) linkUrl.searchParams.set("google_attribution_recovered", "1");
            const utmParams = $511c36956b466e73$var$hasExistingUtmParams(linkUrl) ? [] : $511c36956b466e73$var$addUtmParams(linkUrl, $511c36956b466e73$export$9cc6b2ad869c9455());
            if (addedClickIds.length > 0 || addedMarker || utmParams.length > 0) $511c36956b466e73$var$trackDecoration(link, {
                addedMarker: addedMarker,
                clickIds: addedClickIds,
                utmParams: utmParams
            });
        }
        link.href = linkUrl.href;
    } catch (error) {
        console.error(error);
        (0, $99uU9.captureException)(error, {
            source: "utm:decorate-click-ids"
        });
    }
};
const $511c36956b466e73$export$cf3b576e6a262121 = ()=>{
    // Installed before Termly resolves, so a pre-resolve click classifies
    // against the live transport instead of losing this page's own IDs
    // (audit state 12). On revocation every tracked decoration is stripped;
    // links a lower transport still allows re-decorate on their next click,
    // and rendered UTMs come back through decorateLink right away.
    document.addEventListener("click", $511c36956b466e73$export$1f87f9d3c0ee3e18, true);
    const stopWatching = (0, $H9wys.watchCategory)((0, $H9wys.CATEGORIES).ADVERTISING, (allowed)=>{
        if (allowed) return;
        const links = [
            ...$511c36956b466e73$var$decorations.keys()
        ];
        $511c36956b466e73$var$clearDecorations();
        const utmValues = $511c36956b466e73$var$tuneTransport() === $511c36956b466e73$var$TUNE_TRANSPORT.CLEAN ? {} : $511c36956b466e73$export$9cc6b2ad869c9455();
        for (const link of links)$511c36956b466e73$var$decorateLink(link, utmValues);
    });
    return ()=>{
        document.removeEventListener("click", $511c36956b466e73$export$1f87f9d3c0ee3e18, true);
        stopWatching();
    };
};
/**
 * Check if URL already has UTM parameters
 */ const $511c36956b466e73$var$hasExistingUtmParams = (linkUrl)=>$511c36956b466e73$var$UTM_PARAMS.some((param)=>linkUrl.searchParams.has(`utm_${param}`));
/**
 * Add UTM parameters to URL, reporting what was added so it can be
 * stripped again on a state change.
 */ const $511c36956b466e73$var$addUtmParams = (linkUrl, utmValues)=>{
    const added = [];
    for (const param of $511c36956b466e73$var$UTM_PARAMS)if (utmValues[param]) {
        linkUrl.searchParams.set(`utm_${param}`, utmValues[param]);
        added.push([
            `utm_${param}`,
            utmValues[param]
        ]);
    }
    return added;
};
const $511c36956b466e73$export$9cc6b2ad869c9455 = ()=>{
    const advertisingAllowed = (0, $H9wys.hasCategory)((0, $H9wys.CATEGORIES).ADVERTISING);
    const values = {};
    for (const param of $511c36956b466e73$var$UTM_PARAMS)values[param] = $511c36956b466e73$var$landing[param] ?? (advertisingAllowed ? (0, $f3UsM.get)(`mtn-utm-${param}`) ?? null : null);
    return values;
};
/**
 * Decorate a single link with UTM parameters
 */ const $511c36956b466e73$var$decorateLink = (link, utmValues)=>{
    try {
        const linkUrl = new URL(link.href);
        if (!$511c36956b466e73$var$hasExistingUtmParams(linkUrl)) {
            const utmParams = $511c36956b466e73$var$addUtmParams(linkUrl, utmValues);
            if (utmParams.length > 0) $511c36956b466e73$var$trackDecoration(link, {
                utmParams: utmParams
            });
        }
        link.href = linkUrl.href;
    } catch (error) {
        console.error(error);
        (0, $99uU9.captureException)(error, {
            source: "utm:decorate-link"
        });
    }
};

const $511c36956b466e73$export$6b24be58d17e9904 = async (element)=>{
    const mtn = await (parcelRequire("8CECY"));
    mtn.ready(async ()=>{
        if (!$511c36956b466e73$var$didInit) await $511c36956b466e73$export$2cd8252107eb640b();
        const links = Array.from(element.querySelectorAll("a.tune"));
        if (links.length === 0) return;
        // Clean transport renders undecorated links; a click re-classifies
        // against whatever state holds by then.
        const utmValues = $511c36956b466e73$var$tuneTransport() === $511c36956b466e73$var$TUNE_TRANSPORT.CLEAN ? {} : $511c36956b466e73$export$9cc6b2ad869c9455();
        for (const link of links)$511c36956b466e73$var$decorateLink(link, utmValues);
    });
};
// Newsletter-attribution readers: this navigation's own value, else the
// Analytics-gated record (the adapter returns nothing when Analytics is
// denied or the 7-day window has passed).
const $511c36956b466e73$var$savedValue = async (param)=>{
    $511c36956b466e73$var$recordPromise ??= (0, $jEV3M.getItem)($511c36956b466e73$var$NEWSLETTER_UTM_KEY).catch(()=>null);
    return (await $511c36956b466e73$var$recordPromise)?.[param] ?? null;
};
const $511c36956b466e73$export$b4d5da5f34fb77ad = async ()=>$511c36956b466e73$var$landing.source ?? await $511c36956b466e73$var$savedValue("source");
const $511c36956b466e73$export$649ecc744817b5c7 = async ()=>$511c36956b466e73$var$landing.medium ?? await $511c36956b466e73$var$savedValue("medium");
const $511c36956b466e73$export$b98c010fcdebc6be = async ()=>$511c36956b466e73$var$landing.campaign ?? await $511c36956b466e73$var$savedValue("campaign");
const $511c36956b466e73$export$a7db06668cad9adb = async ()=>$511c36956b466e73$var$landing.content ?? await $511c36956b466e73$var$savedValue("content");
const $511c36956b466e73$export$be3eabeed0f5400e = async ()=>$511c36956b466e73$var$landing.term ?? await $511c36956b466e73$var$savedValue("term");

});
parcelRegister("jEV3M", function(module, exports) {

$parcel$export(module.exports, "getItem", function () { return $e4fe03af942fe409$export$f92dfeb71e9bb569; });
$parcel$export(module.exports, "setItem", function () { return $e4fe03af942fe409$export$8a8216c44337cd5; });
$parcel$export(module.exports, "removeItem", function () { return $e4fe03af942fe409$export$fe2d9b4e03920b4c; });
$parcel$export(module.exports, "getSessionItem", function () { return $e4fe03af942fe409$export$fdf7104ff19cc288; });
$parcel$export(module.exports, "setSessionItem", function () { return $e4fe03af942fe409$export$a5376dd4adeb0fbf; });
$parcel$export(module.exports, "removeSessionItem", function () { return $e4fe03af942fe409$export$28dca8ac7b96d4da; });
$parcel$export(module.exports, "canPersist", function () { return $e4fe03af942fe409$export$9175ceb633dbb466; });
$parcel$export(module.exports, "normalizeReadId", function () { return $e4fe03af942fe409$export$c0c249aa3ab98509; });
$parcel$export(module.exports, "pruneReadHistory", function () { return $e4fe03af942fe409$export$67e6dd3531a9933e; });
$parcel$export(module.exports, "initConsentStorage", function () { return $e4fe03af942fe409$export$9982333e87fc5215; });
/**
 * Category-owned storage manifest and adapter (MTN-1444).
 *
 * Consent attaches to a value's lifecycle, not just its writer: every
 * MTN-owned browser-storage key is listed here with its Termly category,
 * stores, scope, and lifetime, matching the MTN-1434 decision addendum.
 * Reads of a denied category return nothing; a restrictive consent change
 * purges every non-essential entry (hook registered with the MTN-1443
 * revocation lifecycle, which also runs it once at page init).
 *
 * The manifest is the single source of truth: the storage-manifest scan test
 * fails when a writer uses a key that is not listed, and the adapter throws
 * for unlisted keys at runtime.
 */ 
var $kxaTZ = parcelRequire("kxaTZ");

var $bbD2C = parcelRequire("bbD2C");

var $f3UsM = parcelRequire("f3UsM");

var $H9wys = parcelRequire("H9wys");
const $e4fe03af942fe409$var$DAY_MS = 86400000;
const $e4fe03af942fe409$export$949b1cfcb9d54a0d = Object.freeze([
    // --- Essential -------------------------------------------------------
    // Termly consent-record enforcement bridge (MTN-1439 disposition:
    // enforcement-only, never sent to vendors).
    {
        category: (0, $H9wys.CATEGORIES).ESSENTIAL,
        key: "mtn-termly-uuid",
        lifetime: "90d",
        scope: "parent",
        stores: [
            "cookie"
        ]
    },
    // Versioned consent envelope for edge consumers (MTN-1439) — consent
    // metadata only, written by util/consent-envelope.js under the key
    // exported from @moneytalksnews/privacy-shared.
    {
        category: (0, $H9wys.CATEGORIES).ESSENTIAL,
        key: "mtn-consent-envelope",
        lifetime: "session",
        scope: "parent",
        stores: [
            "cookie"
        ]
    },
    // Consent mirror read by the PHP short-link redirect (see below).
    {
        category: (0, $H9wys.CATEGORIES).ESSENTIAL,
        key: "mtn-consent-categories",
        lifetime: "90d",
        scope: "host",
        stores: [
            "cookie"
        ]
    },
    // Chunk-load and consent-reload loop guards.
    {
        category: (0, $H9wys.CATEGORIES).ESSENTIAL,
        key: "mtn-chunk-reload-attempted",
        lifetime: "tab",
        scope: "host",
        stores: [
            "session"
        ]
    },
    {
        category: (0, $H9wys.CATEGORIES).ESSENTIAL,
        key: "mtn-consent-reload",
        lifetime: "tab",
        scope: "host",
        stores: [
            "session"
        ]
    },
    // One-shot migration marker for this module.
    {
        category: (0, $H9wys.CATEGORIES).ESSENTIAL,
        key: "mtn-storage-migration",
        lifetime: "persistent",
        scope: "host",
        stores: [
            "local"
        ]
    },
    // Address-free newsletter signup handoff, consumed by /thank-you/;
    // replacement with a server token is MTN-1453.
    {
        category: (0, $H9wys.CATEGORIES).ESSENTIAL,
        key: "mtn-newsletter-signup-completion",
        lifetime: "tab",
        scope: "host",
        stores: [
            "session"
        ]
    },
    // Functional flags honoring the visitor's own choice (ratified
    // 2026-08-12): no identity, no cross-context tracking, retention-capped.
    // Subscriber status refreshes on a confirmed subscription or a
    // newsletter-link arrival (revised 2026-08-13 — see newsletter.js). In
    // localStorage so the head.blade.php snippet can read it before first
    // paint (MTN-1825); that snippet repeats lifetimeDays.
    {
        category: (0, $H9wys.CATEGORIES).ESSENTIAL,
        key: "mtn-subscriber-status",
        lifetime: "13m",
        lifetimeDays: 396,
        scope: "origin",
        stores: [
            "local"
        ]
    },
    // Modal suppression windows are enforced by modal-lifecycle date math
    // (newsletter 90d, membership 7d), so no adapter envelope here.
    {
        category: (0, $H9wys.CATEGORIES).ESSENTIAL,
        key: "mtn-newsletter-modal",
        lifetime: "90d",
        scope: "origin",
        stores: [
            "session",
            "localforage"
        ]
    },
    {
        category: (0, $H9wys.CATEGORIES).ESSENTIAL,
        key: "mtn-membership-modal",
        lifetime: "7d",
        scope: "origin",
        stores: [
            "session",
            "localforage"
        ]
    },
    // --- Performance -----------------------------------------------------
    // Recommender identifier (MTN-1445): minted by the head snippet (gated
    // on this module's consent mirror) or util/mtn-id.js on an in-page
    // grant; the theme sends it only to the ranking endpoints, transiently.
    // Parent scope because the Worker pipelines (Tune-Out, Newsletter,
    // Ledger, DSR) still read/mint the cookie server-side until their own
    // MTN-1434 follow-ups land. Listing it here makes the purge machinery
    // delete it on Performance withdrawal.
    {
        category: (0, $H9wys.CATEGORIES).PERFORMANCE,
        key: "mtn-id",
        lifetime: "13m",
        scope: "parent",
        stores: [
            "cookie"
        ]
    },
    // Read-history maps ({id: last-seen ms}, path/ID only, expiry and caps
    // enforced by ledger.js).
    {
        category: (0, $H9wys.CATEGORIES).PERFORMANCE,
        key: "mtn-read-articles",
        lifetime: "30d/200 entries",
        scope: "origin",
        stores: [
            "localforage"
        ]
    },
    {
        category: (0, $H9wys.CATEGORIES).PERFORMANCE,
        key: "mtn-read-blocks",
        lifetime: "30d",
        scope: "origin",
        stores: [
            "localforage"
        ]
    },
    // Recommendation attribution, consumed on the next page load.
    {
        category: (0, $H9wys.CATEGORIES).PERFORMANCE,
        key: "mtn-recid",
        lifetime: "one navigation",
        scope: "host",
        stores: [
            "session"
        ]
    },
    // --- Analytics -------------------------------------------------------
    // Host-only since MTN-321 (Tune-Out reads it on the page's own host);
    // legacy parent-domain copies age out.
    {
        category: (0, $H9wys.CATEGORIES).ANALYTICS,
        key: "mtn-posthog-distinct-id",
        lifetime: "91d",
        scope: "host",
        stores: [
            "cookie"
        ]
    },
    // Legacy GA mirrors; removal in favor of native Consent Mode is MTN-319.
    {
        category: (0, $H9wys.CATEGORIES).ANALYTICS,
        key: "mtn-ga4-client-id",
        lifetime: "session",
        scope: "host",
        stores: [
            "cookie"
        ]
    },
    {
        category: (0, $H9wys.CATEGORIES).ANALYTICS,
        key: "mtn-ga4-session-id",
        lifetime: "session",
        scope: "host",
        stores: [
            "cookie"
        ]
    },
    // Newsletter signup attribution record (separate from the Advertising
    // cookies below).
    {
        category: (0, $H9wys.CATEGORIES).ANALYTICS,
        key: "mtn-newsletter-utm",
        lifetime: "7d",
        lifetimeDays: 7,
        scope: "origin",
        stores: [
            "localforage"
        ]
    },
    // --- Advertising -----------------------------------------------------
    // Cross-page affiliate attribution (Tune links and PHP short links);
    // host-only since MTN-321 — every consumer reads from the page's host.
    {
        category: (0, $H9wys.CATEGORIES).ADVERTISING,
        key: "mtn-utm-source",
        lifetime: "7d",
        scope: "host",
        stores: [
            "cookie"
        ]
    },
    {
        category: (0, $H9wys.CATEGORIES).ADVERTISING,
        key: "mtn-utm-medium",
        lifetime: "7d",
        scope: "host",
        stores: [
            "cookie"
        ]
    },
    {
        category: (0, $H9wys.CATEGORIES).ADVERTISING,
        key: "mtn-utm-campaign",
        lifetime: "7d",
        scope: "host",
        stores: [
            "cookie"
        ]
    },
    {
        category: (0, $H9wys.CATEGORIES).ADVERTISING,
        key: "mtn-utm-content",
        lifetime: "7d",
        scope: "host",
        stores: [
            "cookie"
        ]
    },
    {
        category: (0, $H9wys.CATEGORIES).ADVERTISING,
        key: "mtn-utm-term",
        lifetime: "7d",
        scope: "host",
        stores: [
            "cookie"
        ]
    },
    // First-party ad click-ID copies: 30-day cap per the MTN-1434
    // disposition (MTN-321). Host-only, except _fbp/_fbc, which keep the
    // parent domain for Meta's eTLD+1 matching convention — and whose cap
    // governs only our pre-seed copies; Meta's pixel re-mints them on its
    // own 90-day schedule once Advertising consent lets it load (see
    // routes/common.js).
    ...(0, $H9wys.ADVERTISING_COOKIES).map((key)=>({
            category: (0, $H9wys.CATEGORIES).ADVERTISING,
            key: key,
            // "seed": MTN's cap applies until Meta's pixel re-mints on its own
            // 90-day schedule (see above).
            lifetime: [
                "_fbp",
                "_fbc"
            ].includes(key) ? "30d seed / 90d Meta" : "30d",
            scope: [
                "_fbp",
                "_fbc"
            ].includes(key) ? "parent" : "host",
            stores: [
                "cookie"
            ]
        }))
].map(Object.freeze));
const $e4fe03af942fe409$var$requireEntry = (key)=>{
    const entry = $e4fe03af942fe409$export$949b1cfcb9d54a0d.find((candidate)=>candidate.key === key);
    if (!entry) throw new Error(`Storage key "${key}" is not in the storage manifest`);
    return entry;
};
const $e4fe03af942fe409$var$allowed = (entry)=>entry.category === (0, $H9wys.CATEGORIES).ESSENTIAL || (0, $H9wys.hasCategory)(entry.category);
// "local" entries go to localStorage directly, JSON-encoded, rather than
// through local-storage-fallback, which would store them in a cookie where
// web storage is blocked.
const $e4fe03af942fe409$var$localStore = {
    getItem: (key)=>JSON.parse(localStorage.getItem(key)),
    removeItem: (key)=>localStorage.removeItem(key),
    setItem: (key, value)=>localStorage.setItem(key, JSON.stringify(value))
};

const $e4fe03af942fe409$var$storeFor = (entry)=>entry.stores.includes("local") ? $e4fe03af942fe409$var$localStore : (parcelRequire("jOk2B"));
const $e4fe03af942fe409$export$f92dfeb71e9bb569 = async (key)=>{
    const entry = $e4fe03af942fe409$var$requireEntry(key);
    if (!$e4fe03af942fe409$var$allowed(entry)) return null;
    const store = await $e4fe03af942fe409$var$storeFor(entry);
    try {
        const stored = await store.getItem(key);
        if (stored === null || stored === undefined) return null;
        if (!entry.lifetimeDays) return stored;
        if (stored && typeof stored === "object" && "v" in stored) {
            // No timestamp means no enforceable cap, so it counts as expired.
            if (typeof stored.t !== "number" || Date.now() - stored.t > entry.lifetimeDays * $e4fe03af942fe409$var$DAY_MS) {
                await store.removeItem(key);
                return null;
            }
            return stored.v;
        }
        // Raw localforage value written by a pre-manifest bundle during a deploy
        // transition; the next write converts it to the envelope shape.
        return stored;
    } catch  {
        return null;
    }
};
const $e4fe03af942fe409$export$8a8216c44337cd5 = async (key, value)=>{
    const entry = $e4fe03af942fe409$var$requireEntry(key);
    if (!$e4fe03af942fe409$var$allowed(entry)) return;
    const store = await $e4fe03af942fe409$var$storeFor(entry);
    if (!$e4fe03af942fe409$var$allowed(entry)) return;
    try {
        await store.setItem(key, entry.lifetimeDays ? {
            t: Date.now(),
            v: value
        } : value);
    } catch  {
    // Store unavailable — the write is dropped.
    }
};
const $e4fe03af942fe409$export$fe2d9b4e03920b4c = async (key)=>{
    const store = await $e4fe03af942fe409$var$storeFor($e4fe03af942fe409$var$requireEntry(key));
    try {
        await store.removeItem(key);
    } catch  {
    // Store unavailable — nothing to remove.
    }
};
const $e4fe03af942fe409$export$fdf7104ff19cc288 = (key)=>{
    const entry = $e4fe03af942fe409$var$requireEntry(key);
    if (!$e4fe03af942fe409$var$allowed(entry)) return null;
    try {
        return sessionStorage.getItem(key);
    } catch  {
        return null;
    }
};
const $e4fe03af942fe409$export$a5376dd4adeb0fbf = (key, value)=>{
    const entry = $e4fe03af942fe409$var$requireEntry(key);
    if (!$e4fe03af942fe409$var$allowed(entry)) return;
    try {
        sessionStorage.setItem(key, value);
    } catch  {
    // Storage unavailable (private mode, policy) — nothing to enforce.
    }
};
const $e4fe03af942fe409$export$28dca8ac7b96d4da = (key)=>{
    $e4fe03af942fe409$var$requireEntry(key);
    try {
        sessionStorage.removeItem(key);
    } catch  {
    // Storage unavailable — nothing to remove.
    }
};

const $e4fe03af942fe409$export$9175ceb633dbb466 = async ()=>{
    if ((0, $kxaTZ.isSupported)("sessionStorage")) return true;
    const localforage = await (parcelRequire("jOk2B"));
    try {
        await localforage.ready();
        return true;
    } catch  {
        return false;
    }
};

const $e4fe03af942fe409$var$purgeEntry = async (entry)=>{
    for (const store of entry.stores){
        if (store === "cookie") // removeCookie covers both scopes every writer has used; extra
        // attempts are no-ops.
        (0, $f3UsM.remove)(entry.key);
        else if (store === "session") try {
            sessionStorage.removeItem(entry.key);
        } catch  {
        // Storage unavailable — nothing stored, nothing to purge.
        }
        else if (store === "local") (0, (/*@__PURE__*/$parcel$interopDefault($kxaTZ))).removeItem(entry.key);
    }
    if (entry.stores.includes("localforage")) {
        const localforage = await (parcelRequire("jOk2B"));
        try {
            await localforage.removeItem(entry.key);
        } catch  {
        // Store unavailable — nothing stored, nothing to purge.
        }
    }
};
const $e4fe03af942fe409$export$e2c41d000074bb31 = async ()=>{
    const denied = $e4fe03af942fe409$export$949b1cfcb9d54a0d.filter((entry)=>entry.category !== (0, $H9wys.CATEGORIES).ESSENTIAL && !(0, $H9wys.hasCategory)(entry.category));
    await Promise.all(denied.map($e4fe03af942fe409$var$purgeEntry));
};
// --- Consent mirror for the PHP short-link redirect ------------------------
// links.php forwards consent-dependent cookies only when this mirror
// explicitly lists advertising; no mirror means forward nothing. The mirror
// can only restrict relative to the pre-MTN-1444 behavior (unconditional
// forwarding); Termly stays the consent authority, and MTN-1447 removes
// short-link cookie recovery entirely.
const $e4fe03af942fe409$var$CONSENT_COOKIE = "mtn-consent-categories";
const $e4fe03af942fe409$var$writeConsentCookie = ()=>{
    if (window.termlyData === null) // Unresolved is not a record: keep the previous mirror.
    return;
    const categories = (window.termlyData?.categories || []).join(",");
    // setIfChanged: a page load alone must not renew the mirror's 90-day
    // retention (MTN-321); it rewrites on a consent change or after expiry.
    (0, $f3UsM.setIfChanged)($e4fe03af942fe409$var$CONSENT_COOKIE, categories, {
        days: 90
    });
};
// --- One-time disposition migrations (MTN-1434 addendum) --------------------
const $e4fe03af942fe409$var$MIGRATION_KEY = "mtn-storage-migration";
const $e4fe03af942fe409$var$MIGRATION_VERSION = "1";
const $e4fe03af942fe409$export$c0c249aa3ab98509 = (id)=>{
    try {
        return new URL(id).pathname;
    } catch  {
        return String(id);
    }
};
const $e4fe03af942fe409$var$READ_HISTORY_MAX_ENTRIES = 200;
const $e4fe03af942fe409$var$READ_HISTORY_MAX_AGE_DAYS = 30;
const $e4fe03af942fe409$export$67e6dd3531a9933e = (map, now = Date.now())=>{
    const fresh = Object.entries(map).filter(([, t])=>now - t <= $e4fe03af942fe409$var$READ_HISTORY_MAX_AGE_DAYS * $e4fe03af942fe409$var$DAY_MS);
    fresh.sort(([, a], [, b])=>b - a);
    return Object.fromEntries(fresh.slice(0, $e4fe03af942fe409$var$READ_HISTORY_MAX_ENTRIES));
};
const $e4fe03af942fe409$var$migrateReadHistory = async (localforage, oldKey, newKey)=>{
    const old = await localforage.getItem(oldKey);
    if (Array.isArray(old) && old.length > 0 && (0, $H9wys.hasCategory)((0, $H9wys.CATEGORIES).PERFORMANCE)) {
        const now = Date.now();
        const map = {};
        for (const id of old)map[$e4fe03af942fe409$export$c0c249aa3ab98509(id)] = now;
        await localforage.setItem(newKey, $e4fe03af942fe409$export$67e6dd3531a9933e(map, now));
    }
    await localforage.removeItem(oldKey);
};
const $e4fe03af942fe409$var$LEGACY_UTM_KEYS = [
    "mtn-utm-source",
    "mtn-utm-medium",
    "mtn-utm-campaign",
    "mtn-utm-content",
    "mtn-utm-term"
];
const $e4fe03af942fe409$var$migrateUtmRecord = async (localforage)=>{
    // mtn-utm-last-updated held unix seconds; only a record still inside the
    // 7-day attribution window is worth carrying over.
    const updated = await localforage.getItem("mtn-utm-last-updated");
    const fresh = typeof updated === "number" && Date.now() - updated * 1000 <= 7 * $e4fe03af942fe409$var$DAY_MS;
    if (fresh && (0, $H9wys.hasCategory)((0, $H9wys.CATEGORIES).ANALYTICS)) {
        const values = {};
        for (const key of $e4fe03af942fe409$var$LEGACY_UTM_KEYS){
            // biome-ignore lint/performance/noAwaitInLoops: five small sequential reads, once per browser ever.
            const value = await localforage.getItem(key);
            if (value) values[key.replace("mtn-utm-", "")] = value;
        }
        if (Object.keys(values).length > 0) await localforage.setItem("mtn-newsletter-utm", {
            t: updated * 1000,
            v: values
        });
    }
    for (const key of [
        ...$e4fe03af942fe409$var$LEGACY_UTM_KEYS,
        "mtn-utm-last-updated"
    ])// biome-ignore lint/performance/noAwaitInLoops: six removals, once per browser ever.
    await localforage.removeItem(key);
};
const $e4fe03af942fe409$var$SUBSCRIBER_KEY = "mtn-subscriber-status";
// The subscriber flag moved from IndexedDB to localStorage (MTN-1825). Carry
// a subscribed flag across with its timestamp; one without (a raw
// "subscribed" from a pre-manifest bundle) starts its 13-month cap now.
// Anything else is dropped.
// ponytail: an IndexedDB read on every load; delete after November 2027,
// once every IndexedDB copy is past its 396-day cap.
const $e4fe03af942fe409$var$moveSubscriberFlag = async (localforage)=>{
    const stored = await localforage.getItem($e4fe03af942fe409$var$SUBSCRIBER_KEY);
    if (stored === null) return;
    const subscribed = stored === "subscribed" || stored?.v === "subscribed";
    if (subscribed && localStorage.getItem($e4fe03af942fe409$var$SUBSCRIBER_KEY) === null) $e4fe03af942fe409$var$localStore.setItem($e4fe03af942fe409$var$SUBSCRIBER_KEY, {
        t: typeof stored.t === "number" ? stored.t : Date.now(),
        v: "subscribed"
    });
    await localforage.removeItem($e4fe03af942fe409$var$SUBSCRIBER_KEY);
};

// Runs before the modal/newsletter modules read their stores, so moved and
// converted values are in place on the same page load (routes/common.js
// holds the newsletter and membership inits until it settles).
// Idempotent: the subscriber move runs every load, and the rest reruns
// harmlessly until migrateConsentGated sets the marker (which waits for
// Termly, so a Termly-blocked visitor reruns this part).
const $e4fe03af942fe409$var$migrateImmediate = async ()=>{
    const localforage = await (parcelRequire("jOk2B"));
    try {
        await $e4fe03af942fe409$var$moveSubscriberFlag(localforage);
    } catch  {
    // Store unavailable — the flag stays put and the next load retries.
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($kxaTZ))).getItem($e4fe03af942fe409$var$MIGRATION_KEY) === $e4fe03af942fe409$var$MIGRATION_VERSION) return;
    // Removed outright by the disposition table; aggregate PostHog/Plausible
    // reporting replaces them.
    for (const key of [
        "mtn-page-views",
        "mtn-topics",
        "mtn-categories"
    ])(0, (/*@__PURE__*/$parcel$interopDefault($kxaTZ))).removeItem(key);
    try {
        localStorage.removeItem("clicks_debug");
    } catch  {
    // Storage unavailable — nothing to remove.
    }
    try {
        // Newsletter modal seen-flag: legacy `true` → timestamp, so the new
        // 90-day re-show window has date math to work from (an unparseable value
        // counts as "not seen" and would re-show the modal to everyone).
        const newsletterSeen = await localforage.getItem("mtn-newsletter-modal");
        if (newsletterSeen === true) await localforage.setItem("mtn-newsletter-modal", new Date().toISOString());
    } catch  {
    // Store unavailable — skip the conversions.
    }
};

// Copies of consent-gated data must wait for Termly to resolve — copying
// while unresolved would drop a consenting visitor's data (hasCategory is
// false until Termly reports).
const $e4fe03af942fe409$var$migrateConsentGated = async ()=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($kxaTZ))).getItem($e4fe03af942fe409$var$MIGRATION_KEY) === $e4fe03af942fe409$var$MIGRATION_VERSION) return;
    const localforage = await (parcelRequire("jOk2B"));
    try {
        await $e4fe03af942fe409$var$migrateReadHistory(localforage, "articles", "mtn-read-articles");
        await $e4fe03af942fe409$var$migrateReadHistory(localforage, "blocks", "mtn-read-blocks");
        await $e4fe03af942fe409$var$migrateUtmRecord(localforage);
    } catch  {
        // Store unavailable — leave the marker unset so a later load retries.
        return;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kxaTZ))).setItem($e4fe03af942fe409$var$MIGRATION_KEY, $e4fe03af942fe409$var$MIGRATION_VERSION);
};
let $e4fe03af942fe409$var$initialized = false;
const $e4fe03af942fe409$export$9982333e87fc5215 = async ()=>{
    if ($e4fe03af942fe409$var$initialized) return;
    $e4fe03af942fe409$var$initialized = true;
    $e4fe03af942fe409$var$writeConsentCookie();
    document.addEventListener("termlyDataUpdate", $e4fe03af942fe409$var$writeConsentCookie);
    (0, $bbD2C.registerPurgeHook)($e4fe03af942fe409$export$e2c41d000074bb31);
    await $e4fe03af942fe409$var$migrateImmediate();
    (0, $H9wys.ready)(()=>{
        $e4fe03af942fe409$var$migrateConsentGated().catch((error)=>console.error(error));
    });
};

});
parcelRegister("kxaTZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "CookieStorage", {
    enumerable: true,
    get: function get() {
        return $ef2f589eae9a8873$var$_CookieStorage["default"];
    }
});
Object.defineProperty(module.exports, "MemoryStorage", {
    enumerable: true,
    get: function get() {
        return $ef2f589eae9a8873$var$_MemoryStorage["default"];
    }
});
module.exports["default"] = void 0;
Object.defineProperty(module.exports, "isSupported", {
    enumerable: true,
    get: function get() {
        return $ef2f589eae9a8873$var$_isSupported["default"];
    }
});
module.exports.storage = void 0;

var $ef2f589eae9a8873$var$_isSupported = $ef2f589eae9a8873$var$_interopRequireDefault((parcelRequire("haNeH")));

var $ef2f589eae9a8873$var$_CookieStorage = $ef2f589eae9a8873$var$_interopRequireDefault((parcelRequire("jWOvq")));

var $ef2f589eae9a8873$var$_MemoryStorage = $ef2f589eae9a8873$var$_interopRequireDefault((parcelRequire("6DYYl")));
function $ef2f589eae9a8873$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $ef2f589eae9a8873$var$storage = module.exports.storage = null;
if ((0, $ef2f589eae9a8873$var$_isSupported["default"])("localStorage")) // use localStorage
module.exports.storage = $ef2f589eae9a8873$var$storage = window.localStorage;
else if ((0, $ef2f589eae9a8873$var$_isSupported["default"])("sessionStorage")) // use sessionStorage
module.exports.storage = $ef2f589eae9a8873$var$storage = window.sessionStorage;
else if ((0, $ef2f589eae9a8873$var$_isSupported["default"])("cookieStorage")) // use cookies
module.exports.storage = $ef2f589eae9a8873$var$storage = new $ef2f589eae9a8873$var$_CookieStorage["default"]();
else // use memory
module.exports.storage = $ef2f589eae9a8873$var$storage = new $ef2f589eae9a8873$var$_MemoryStorage["default"]();
var $ef2f589eae9a8873$var$_default = module.exports["default"] = $ef2f589eae9a8873$var$storage;

});
parcelRegister("haNeH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c809901ab7a9d75b$var$isSupported;

var $jWOvq = parcelRequire("jWOvq");
var $c809901ab7a9d75b$var$TEST_KEY = "__test";
function $c809901ab7a9d75b$var$hasStorage(name) {
    try {
        var storage = window[name];
        storage.setItem($c809901ab7a9d75b$var$TEST_KEY, "1");
        storage.removeItem($c809901ab7a9d75b$var$TEST_KEY);
        return true;
    } catch (e) {
        return false;
    }
}
function $c809901ab7a9d75b$var$isSupported() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "localStorage";
    var storage = String(name).replace(/storage$/i, "").toLowerCase();
    if (storage === "local") return $c809901ab7a9d75b$var$hasStorage("localStorage");
    if (storage === "session") return $c809901ab7a9d75b$var$hasStorage("sessionStorage");
    if (storage === "cookie") return (0, $jWOvq.hasCookies)();
    if (storage === "memory") return true;
    throw new Error("Storage method `".concat(name, "` is not available.\n    Please use one of the following: localStorage, sessionStorage, cookieStorage, memoryStorage."));
}

});
parcelRegister("jWOvq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
module.exports.hasCookies = $e85a9c7e8b74a9e2$var$hasCookies;

var $e85a9c7e8b74a9e2$var$cookie = $e85a9c7e8b74a9e2$var$_interopRequireWildcard((parcelRequire("6opBw")));
function $e85a9c7e8b74a9e2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e85a9c7e8b74a9e2$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e85a9c7e8b74a9e2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $e85a9c7e8b74a9e2$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $e85a9c7e8b74a9e2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e85a9c7e8b74a9e2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e85a9c7e8b74a9e2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e85a9c7e8b74a9e2$var$_typeof(o);
}
function $e85a9c7e8b74a9e2$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $e85a9c7e8b74a9e2$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $e85a9c7e8b74a9e2$var$_toPropertyKey(o.key), o);
    }
}
function $e85a9c7e8b74a9e2$var$_createClass(e, r, t) {
    return r && $e85a9c7e8b74a9e2$var$_defineProperties(e.prototype, r), t && $e85a9c7e8b74a9e2$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $e85a9c7e8b74a9e2$var$_toPropertyKey(t) {
    var i = $e85a9c7e8b74a9e2$var$_toPrimitive(t, "string");
    return "symbol" == $e85a9c7e8b74a9e2$var$_typeof(i) ? i : i + "";
}
function $e85a9c7e8b74a9e2$var$_toPrimitive(t, r) {
    if ("object" != $e85a9c7e8b74a9e2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e85a9c7e8b74a9e2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $e85a9c7e8b74a9e2$var$prefix = "lS_";
var $e85a9c7e8b74a9e2$var$CookieStorage = module.exports["default"] = /*#__PURE__*/ function() {
    function CookieStorage() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $e85a9c7e8b74a9e2$var$_classCallCheck(this, CookieStorage);
        this.cookieOptions = Object.assign({
            path: "/"
        }, options);
        $e85a9c7e8b74a9e2$var$prefix = options.prefix === undefined ? $e85a9c7e8b74a9e2$var$prefix : options.prefix;
    }
    return $e85a9c7e8b74a9e2$var$_createClass(CookieStorage, [
        {
            key: "getItem",
            value: function getItem(key) {
                var cookies = $e85a9c7e8b74a9e2$var$cookie.parse(document.cookie);
                if (!cookies || !cookies[$e85a9c7e8b74a9e2$var$prefix + key]) return null;
                return cookies[$e85a9c7e8b74a9e2$var$prefix + key];
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                document.cookie = $e85a9c7e8b74a9e2$var$cookie.serialize($e85a9c7e8b74a9e2$var$prefix + key, value, this.cookieOptions);
                return value;
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                var options = Object.assign({}, this.cookieOptions, {
                    maxAge: -1
                });
                document.cookie = $e85a9c7e8b74a9e2$var$cookie.serialize($e85a9c7e8b74a9e2$var$prefix + key, "", options);
                return null;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var cookies = $e85a9c7e8b74a9e2$var$cookie.parse(document.cookie);
                for(var key in cookies)if (key.indexOf($e85a9c7e8b74a9e2$var$prefix) === 0) this.removeItem(key.substr($e85a9c7e8b74a9e2$var$prefix.length));
                return null;
            }
        }
    ]);
}();
function $e85a9c7e8b74a9e2$var$hasCookies() {
    var storage = new $e85a9c7e8b74a9e2$var$CookieStorage();
    try {
        var TEST_KEY = "__test";
        storage.setItem(TEST_KEY, "1");
        var value = storage.getItem(TEST_KEY);
        storage.removeItem(TEST_KEY);
        return value === "1";
    } catch (e) {
        return false;
    }
}

});
parcelRegister("6opBw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCookie = $4a78d86f7cfb49e5$var$parseCookie;
module.exports.parse = $4a78d86f7cfb49e5$var$parseCookie;
module.exports.stringifyCookie = $4a78d86f7cfb49e5$var$stringifyCookie;
module.exports.stringifySetCookie = $4a78d86f7cfb49e5$var$stringifySetCookie;
module.exports.serialize = $4a78d86f7cfb49e5$var$stringifySetCookie;
module.exports.parseSetCookie = $4a78d86f7cfb49e5$var$parseSetCookie;
module.exports.stringifySetCookie = $4a78d86f7cfb49e5$var$stringifySetCookie;
module.exports.serialize = $4a78d86f7cfb49e5$var$stringifySetCookie;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $4a78d86f7cfb49e5$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $4a78d86f7cfb49e5$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $4a78d86f7cfb49e5$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $4a78d86f7cfb49e5$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
/**
 * RegExp to match max-age-value in RFC 6265 sec 5.6.2
 */ const $4a78d86f7cfb49e5$var$maxAgeRegExp = /^-?\d+$/;
const $4a78d86f7cfb49e5$var$__toString = Object.prototype.toString;
const $4a78d86f7cfb49e5$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a `Cookie` header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $4a78d86f7cfb49e5$var$parseCookie(str, options) {
    const obj = new $4a78d86f7cfb49e5$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $4a78d86f7cfb49e5$var$decode;
    let index = 0;
    do {
        const eqIdx = $4a78d86f7cfb49e5$var$eqIndex(str, index, len);
        if (eqIdx === -1) break; // No more cookie pairs.
        const endIdx = $4a78d86f7cfb49e5$var$endIndex(str, index, len);
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = $4a78d86f7cfb49e5$var$valueSlice(str, index, eqIdx);
        // only assign once
        if (obj[key] === undefined) obj[key] = dec($4a78d86f7cfb49e5$var$valueSlice(str, eqIdx + 1, endIdx));
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
/**
 * Stringifies an object into an HTTP `Cookie` header.
 */ function $4a78d86f7cfb49e5$var$stringifyCookie(cookie, options) {
    const enc = options?.encode || encodeURIComponent;
    const cookieStrings = [];
    for (const name of Object.keys(cookie)){
        const val = cookie[name];
        if (val === undefined) continue;
        if (!$4a78d86f7cfb49e5$var$cookieNameRegExp.test(name)) throw new TypeError(`cookie name is invalid: ${name}`);
        const value = enc(val);
        if (!$4a78d86f7cfb49e5$var$cookieValueRegExp.test(value)) throw new TypeError(`cookie val is invalid: ${val}`);
        cookieStrings.push(`${name}=${value}`);
    }
    return cookieStrings.join("; ");
}
function $4a78d86f7cfb49e5$var$stringifySetCookie(_name, _val, _opts) {
    const cookie = typeof _name === "object" ? _name : {
        ..._opts,
        name: _name,
        value: String(_val)
    };
    const options = typeof _val === "object" ? _val : _opts;
    const enc = options?.encode || encodeURIComponent;
    if (!$4a78d86f7cfb49e5$var$cookieNameRegExp.test(cookie.name)) throw new TypeError(`argument name is invalid: ${cookie.name}`);
    const value = cookie.value ? enc(cookie.value) : "";
    if (!$4a78d86f7cfb49e5$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${cookie.value}`);
    let str = cookie.name + "=" + value;
    if (cookie.maxAge !== undefined) {
        if (!Number.isInteger(cookie.maxAge)) throw new TypeError(`option maxAge is invalid: ${cookie.maxAge}`);
        str += "; Max-Age=" + cookie.maxAge;
    }
    if (cookie.domain) {
        if (!$4a78d86f7cfb49e5$var$domainValueRegExp.test(cookie.domain)) throw new TypeError(`option domain is invalid: ${cookie.domain}`);
        str += "; Domain=" + cookie.domain;
    }
    if (cookie.path) {
        if (!$4a78d86f7cfb49e5$var$pathValueRegExp.test(cookie.path)) throw new TypeError(`option path is invalid: ${cookie.path}`);
        str += "; Path=" + cookie.path;
    }
    if (cookie.expires) {
        if (!$4a78d86f7cfb49e5$var$isDate(cookie.expires) || !Number.isFinite(cookie.expires.valueOf())) throw new TypeError(`option expires is invalid: ${cookie.expires}`);
        str += "; Expires=" + cookie.expires.toUTCString();
    }
    if (cookie.httpOnly) str += "; HttpOnly";
    if (cookie.secure) str += "; Secure";
    if (cookie.partitioned) str += "; Partitioned";
    if (cookie.priority) {
        const priority = typeof cookie.priority === "string" ? cookie.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${cookie.priority}`);
        }
    }
    if (cookie.sameSite) {
        const sameSite = typeof cookie.sameSite === "string" ? cookie.sameSite.toLowerCase() : cookie.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${cookie.sameSite}`);
        }
    }
    return str;
}
/**
 * Deserialize a `Set-Cookie` header into an object.
 *
 * deserialize('foo=bar; httpOnly')
 *   => { name: 'foo', value: 'bar', httpOnly: true }
 */ function $4a78d86f7cfb49e5$var$parseSetCookie(str, options) {
    const dec = options?.decode || $4a78d86f7cfb49e5$var$decode;
    const len = str.length;
    const endIdx = $4a78d86f7cfb49e5$var$endIndex(str, 0, len);
    const eqIdx = $4a78d86f7cfb49e5$var$eqIndex(str, 0, endIdx);
    const setCookie = eqIdx === -1 ? {
        name: "",
        value: dec($4a78d86f7cfb49e5$var$valueSlice(str, 0, endIdx))
    } : {
        name: $4a78d86f7cfb49e5$var$valueSlice(str, 0, eqIdx),
        value: dec($4a78d86f7cfb49e5$var$valueSlice(str, eqIdx + 1, endIdx))
    };
    let index = endIdx + 1;
    while(index < len){
        const endIdx = $4a78d86f7cfb49e5$var$endIndex(str, index, len);
        const eqIdx = $4a78d86f7cfb49e5$var$eqIndex(str, index, endIdx);
        const attr = eqIdx === -1 ? $4a78d86f7cfb49e5$var$valueSlice(str, index, endIdx) : $4a78d86f7cfb49e5$var$valueSlice(str, index, eqIdx);
        const val = eqIdx === -1 ? undefined : $4a78d86f7cfb49e5$var$valueSlice(str, eqIdx + 1, endIdx);
        switch(attr.toLowerCase()){
            case "httponly":
                setCookie.httpOnly = true;
                break;
            case "secure":
                setCookie.secure = true;
                break;
            case "partitioned":
                setCookie.partitioned = true;
                break;
            case "domain":
                setCookie.domain = val;
                break;
            case "path":
                setCookie.path = val;
                break;
            case "max-age":
                if (val && $4a78d86f7cfb49e5$var$maxAgeRegExp.test(val)) setCookie.maxAge = Number(val);
                break;
            case "expires":
                if (!val) break;
                const date = new Date(val);
                if (Number.isFinite(date.valueOf())) setCookie.expires = date;
                break;
            case "priority":
                if (!val) break;
                const priority = val.toLowerCase();
                if (priority === "low" || priority === "medium" || priority === "high") setCookie.priority = priority;
                break;
            case "samesite":
                if (!val) break;
                const sameSite = val.toLowerCase();
                if (sameSite === "lax" || sameSite === "strict" || sameSite === "none") setCookie.sameSite = sameSite;
                break;
        }
        index = endIdx + 1;
    }
    return setCookie;
}
/**
 * Find the `;` character between `min` and `len` in str.
 */ function $4a78d86f7cfb49e5$var$endIndex(str, min, len) {
    const index = str.indexOf(";", min);
    return index === -1 ? len : index;
}
/**
 * Find the `=` character between `min` and `max` in str.
 */ function $4a78d86f7cfb49e5$var$eqIndex(str, min, max) {
    const index = str.indexOf("=", min);
    return index < max ? index : -1;
}
/**
 * Slice out a value between startPod to max.
 */ function $4a78d86f7cfb49e5$var$valueSlice(str, min, max) {
    let start = min;
    let end = max;
    do {
        const code = str.charCodeAt(start);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
    }while (++start < end);
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
        end--;
    }
    return str.slice(start, end);
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $4a78d86f7cfb49e5$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $4a78d86f7cfb49e5$var$isDate(val) {
    return $4a78d86f7cfb49e5$var$__toString.call(val) === "[object Date]";
}

});



parcelRegister("6DYYl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
function $4d65ae6aa13ffd8c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4d65ae6aa13ffd8c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4d65ae6aa13ffd8c$var$_typeof(o);
}
function $4d65ae6aa13ffd8c$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $4d65ae6aa13ffd8c$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $4d65ae6aa13ffd8c$var$_toPropertyKey(o.key), o);
    }
}
function $4d65ae6aa13ffd8c$var$_createClass(e, r, t) {
    return r && $4d65ae6aa13ffd8c$var$_defineProperties(e.prototype, r), t && $4d65ae6aa13ffd8c$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $4d65ae6aa13ffd8c$var$_toPropertyKey(t) {
    var i = $4d65ae6aa13ffd8c$var$_toPrimitive(t, "string");
    return "symbol" == $4d65ae6aa13ffd8c$var$_typeof(i) ? i : i + "";
}
function $4d65ae6aa13ffd8c$var$_toPrimitive(t, r) {
    if ("object" != $4d65ae6aa13ffd8c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4d65ae6aa13ffd8c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4d65ae6aa13ffd8c$var$MemoryStorage = module.exports["default"] = /*#__PURE__*/ function() {
    function MemoryStorage() {
        $4d65ae6aa13ffd8c$var$_classCallCheck(this, MemoryStorage);
        this._data = {};
    }
    return $4d65ae6aa13ffd8c$var$_createClass(MemoryStorage, [
        {
            key: "getItem",
            value: function getItem(key) {
                return this._data.hasOwnProperty(key) ? this._data[key] : null;
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                return this._data[key] = String(value);
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                return delete this._data[key];
            }
        },
        {
            key: "clear",
            value: function clear() {
                return this._data = {};
            }
        }
    ]);
}();

});


parcelRegister("bbD2C", function(module, exports) {

$parcel$export(module.exports, "registerPurgeHook", function () { return $824f01924d6958b1$export$6bd01ef7e462cf77; });
$parcel$export(module.exports, "initConsentLifecycle", function () { return $824f01924d6958b1$export$e3b94b82a300e9fb; });
/**
 * Revocation lifecycle (MTN-1443).
 *
 * On a full-page-reload site the controlled reload is the teardown: when the
 * visitor makes a restrictive consent change (a previously allowed Termly
 * category disappears, or do_not_sell turns on), this module runs the
 * registered purge hooks (the storage adapters that own the actual deletion
 * live in the storage manifest — MTN-1444), then reloads the page once —
 * killing timers, listeners, SDKs, and iframes without per-consumer
 * teardown code — but only when the revoked categories left vendor code
 * running that has no in-place downgrade (see needsReload).
 *
 * Each purge hook also runs once at page init, after Termly resolves, so a
 * straggler write that landed between revoke and reload is deleted on the
 * next load. An unresolved Termly is not a denial, so no purge runs then;
 * consent-gated readers already return nothing while unresolved.
 *
 * In-flight writes need no machinery here: window.termlyData updates
 * synchronously before the consent event dispatches, so the storage
 * adapter re-checks the entry's category immediately before committing and
 * drops the write when it changed mid-flight (MTN-1444).
 *
 * Vendor opt-outs stay where they are: PostHog opt-out and Tune-decoration
 * removal run from their own watchCategory handlers on the same
 * termlyDataUpdate event. Advertising-cookie deletion belongs to the
 * storage-manifest purge hook (MTN-1444).
 */ 
var $99uU9 = parcelRequire("99uU9");

var $H9wys = parcelRequire("H9wys");
// The `consent` event is itself the overlay-closed signal, so no DOM
// watching is needed. Termly's embed dispatches exactly two events,
// `initialized` and `consent` (verified in the shipped resource-blocker
// source, 2026-08-13); the overlay closes synchronously on the save click,
// while `consent` dispatches only after the save POST to Termly's API
// resolves — verified live 2026-08-13: at the instant `consent` fired, the
// overlay was already out of the DOM.
//
// Termly also reloads the page itself — synchronously, right after
// dispatching `consent` — whenever a previously allowed category is denied
// AND the page contains a matching `data-categories` blocked element (same
// source). Our delayed reload is the fallback for pages where that markup
// is absent; when Termly reloads first, ours never runs, the pending purge
// is cut short, and the init purge-check on the next load finishes the
// deletion. The grace delay exists only to let Termly's own reload win and
// any closing animation settle.
const $824f01924d6958b1$var$RELOAD_GRACE_MS = 1000;
const $824f01924d6958b1$var$PURGE_WAIT_CAP_MS = 5000;
const $824f01924d6958b1$var$RELOAD_GUARD_KEY = "mtn-consent-reload";
const $824f01924d6958b1$var$RELOAD_GUARD_WINDOW_MS = 30000;
const $824f01924d6958b1$var$purgeHooks = new Set();
const $824f01924d6958b1$var$runHook = async (hook)=>{
    try {
        await hook();
    } catch (error) {
        console.error(error);
        (0, $99uU9.captureException)(error, {
            source: "consent-lifecycle:purge"
        });
    }
};
const $824f01924d6958b1$export$6bd01ef7e462cf77 = (hook)=>{
    $824f01924d6958b1$var$purgeHooks.add(hook);
    (0, $H9wys.ready)(()=>$824f01924d6958b1$var$runHook(hook));
};
const $824f01924d6958b1$var$runPurgeHooks = ()=>Promise.all([
        ...$824f01924d6958b1$var$purgeHooks
    ].map($824f01924d6958b1$var$runHook));
let $824f01924d6958b1$var$reloadScheduled = false;
const $824f01924d6958b1$var$scheduleReload = ()=>{
    if ($824f01924d6958b1$var$reloadScheduled) return;
    $824f01924d6958b1$var$reloadScheduled = true;
    // Reload-loop guard (chunk-reload precedent): a second restrictive change
    // within the window purges but does not reload again, and if the guard
    // can't persist the reload is skipped entirely — read gating and the init
    // purge sweep still apply either way.
    try {
        const last = Number(sessionStorage.getItem($824f01924d6958b1$var$RELOAD_GUARD_KEY));
        if (Date.now() - last < $824f01924d6958b1$var$RELOAD_GUARD_WINDOW_MS) return;
        sessionStorage.setItem($824f01924d6958b1$var$RELOAD_GUARD_KEY, String(Date.now()));
    } catch  {
        return;
    }
    setTimeout(()=>window.location.reload(), $824f01924d6958b1$var$RELOAD_GRACE_MS);
};
const $824f01924d6958b1$var$snapshot = ()=>({
        categories: window.termlyData?.categories || [],
        doNotSell: Boolean(window.termlyData?.consentState?.do_not_sell)
    });
/**
 * A reload is the teardown only for revoked categories whose vendor code
 * has no in-place downgrade; everything else respects the new preference
 * without one (purge, read gating, and commit-time re-checks always run):
 *
 * - Advertising, or do_not_sell turning on: the Meta pixel initializes on
 *   every page while Advertising is granted (plus Quantcast/SmartAsset/ads),
 *   and none expose an un-init — and "revoked" implies it was granted on
 *   this page, so the pixel is live. Always reload.
 * - Performance: Tally's embed has no un-init. Reload only while it is live.
 * - Analytics: PostHog opts out via its own watchCategory handler and Google
 *   downgrades through the Consent Mode bridge — official in-place paths.
 * - Social Networking / Unclassified: only data-categories iframes, which is
 *   exactly the case where Termly reloads the page itself.
 *
 * Adding an allow* consumer that initializes vendor code with no in-place
 * teardown means updating this policy (the consent-reload-policy scan test
 * fails on unacknowledged consumers).
 */ const $824f01924d6958b1$var$needsReload = (revoked, dnsFlipped)=>{
    if (dnsFlipped || revoked.includes((0, $H9wys.CATEGORIES).ADVERTISING)) return true;
    if (revoked.includes((0, $H9wys.CATEGORIES).PERFORMANCE)) return window.Tally !== undefined || document.querySelector('script[src="https://tally.so/widgets/embed.js"]') !== null;
    return false;
};
let $824f01924d6958b1$var$installed = false;
const $824f01924d6958b1$export$e3b94b82a300e9fb = ()=>{
    if ($824f01924d6958b1$var$installed) return;
    $824f01924d6958b1$var$installed = true;
    // Termly's initial report is a starting state, not a change: only a
    // transition observed within this page's lifetime counts as restrictive.
    let prev = window.termlyData === null ? null : $824f01924d6958b1$var$snapshot();
    document.addEventListener("termlyDataUpdate", ()=>{
        const next = $824f01924d6958b1$var$snapshot();
        const previous = prev;
        prev = next;
        if (previous === null) return;
        const kept = new Set(next.categories);
        const revoked = previous.categories.filter((category)=>!kept.has(category));
        const dnsFlipped = next.doNotSell && !previous.doNotSell;
        if (revoked.length === 0 && !dnsFlipped) return;
        if (!$824f01924d6958b1$var$needsReload(revoked, dnsFlipped)) {
            // Everything on this page already respects the downgrade in place;
            // the purge sweep is the whole teardown.
            $824f01924d6958b1$var$runPurgeHooks();
            return;
        }
        // Purge before reloading so the fresh page lands on cleaned storage, but
        // cap the wait: a hung hook must not block the teardown reload. The init
        // sweep on the next load deletes stragglers.
        Promise.race([
            $824f01924d6958b1$var$runPurgeHooks(),
            new Promise((resolve)=>setTimeout(resolve, $824f01924d6958b1$var$PURGE_WAIT_CAP_MS))
        ]).then($824f01924d6958b1$var$scheduleReload);
    });
};

});

parcelRegister("jOk2B", function(module, exports) {

module.exports = (parcelRequire("3WFuy"))($parcel$resolve("fBZoF")).then(()=>parcelRequire('10Z3s'));

});
parcelRegister("3WFuy", function(module, exports) {
"use strict";

var $667pM = parcelRequire("667pM");
module.exports = $667pM(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("667pM", function(module, exports) {
"use strict";
var $47090e09928e24bd$var$cachedBundles = {};
var $47090e09928e24bd$var$cachedPreloads = {};
var $47090e09928e24bd$var$cachedPrefetches = {};
function $47090e09928e24bd$var$getCache(type) {
    switch(type){
        case 'preload':
            return $47090e09928e24bd$var$cachedPreloads;
        case 'prefetch':
            return $47090e09928e24bd$var$cachedPrefetches;
        default:
            return $47090e09928e24bd$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $47090e09928e24bd$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("8CECY", function(module, exports) {

module.exports = (parcelRequire("3WFuy"))($parcel$resolve("13MeU")).then(()=>parcelRequire('25SEH'));

});


parcelRegister("e7Fk4", function(module, exports) {

module.exports = (parcelRequire("3WFuy"))($parcel$resolve("dCsKz")).then(()=>parcelRequire('bQy9H'));

});

parcelRegister("4udSq", function(module, exports) {

module.exports = (parcelRequire("3WFuy"))($parcel$resolve("fUJVf")).then(()=>parcelRequire('7paHO'));

});

parcelRegister("n2M6R", function(module, exports) {

module.exports = (parcelRequire("3WFuy"))($parcel$resolve("alx7V")).then(()=>parcelRequire('k5HIc'));

});

parcelRegister("1TkTM", function(module, exports) {

module.exports = (parcelRequire("3WFuy"))($parcel$resolve("i0U32")).then(()=>parcelRequire('8MEh4'));

});

parcelRegister("kyJ9C", function(module, exports) {

module.exports = (parcelRequire("3WFuy"))($parcel$resolve("lXBqt")).then(()=>parcelRequire('hw82l'));

});

parcelRegister("dUEk9", function(module, exports) {

module.exports = (parcelRequire("3WFuy"))($parcel$resolve("eXy0m")).then(()=>parcelRequire('313ts'));

});

parcelRegister("6BtLT", function(module, exports) {

module.exports = (parcelRequire("3WFuy"))($parcel$resolve("gRaqt")).then(()=>parcelRequire('1QCti'));

});

parcelRegister("idaNn", function(module, exports) {

module.exports = (parcelRequire("3WFuy"))($parcel$resolve("6gENh")).then(()=>parcelRequire('1CFjW'));

});

parcelRegister("iorie", function(module, exports) {

module.exports = (parcelRequire("3WFuy"))($parcel$resolve("b6Tps")).then(()=>parcelRequire('7f8x6'));

});

parcelRegister("liFcM", function(module, exports) {

module.exports = (parcelRequire("3WFuy"))($parcel$resolve("6i1Jf")).then(()=>parcelRequire('hSldr'));

});

var $c2a2b7bc16f82b3a$exports = {};
$parcel$extendImportMap({
    "fBZoF": "localforage.94f8dd86.js",
    "13MeU": "mtn.9c16e6c3.js",
    "dCsKz": "recommender.49ce9415.js",
    "jINl7": "uuid-by-string.7b56e093.js",
    "fUJVf": "common.ff9bf010.js",
    "7PVzq": "newsletter.c1d57fcf.js",
    "8hwuC": "bootstrap-modal.2caef6ac.js",
    "gGj4p": "modal-lifecycle.a9aadf53.js",
    "UBfx6": "membership.5632df54.js",
    "deZw9": "ledger.ea26d88c.js",
    "kD0tK": "mtn-id.e25e4ff0.js",
    "5LV6g": "memberful-embed.bb749d1a.js",
    "cz5VV": "widgets.a3ea6d6f.js",
    "5q6h7": "solutions.2f3fad84.js",
    "i9Lbu": "clicks.5db9278c.js",
    "kvT1c": "blocks.50682c01.js",
    "iCbUd": "tally.0bf124ee.js",
    "7QZfI": "collapse.8b60414e.js",
    "1b2gS": "util.8e996420.js",
    "87rJ6": "bootstrap-popover.47132092.js",
    "5ejvp": "bootstrap-popover.60c7dc66.js",
    "8Pj6B": "dropdown.b6a93947.js",
    "a096V": "facebook-pixel.0271d6cf.js",
    "eGNvk": "quantcast-pixel.463a62b1.js",
    "cZ96A": "lozad.min.e6a5b50f.js",
    "alx7V": "home.a5d67000.js",
    "6gENh": "read-next.00d19f4d.js",
    "i0U32": "single.70a47a80.js",
    "8fu4r": "block-positioning.2431457a.js",
    "4smuw": "infinite-articles.ac39ea4e.js",
    "6i1Jf": "amazon.a3365c4f.js",
    "fRVrq": "membership-promo.8d2eaeec.js",
    "lXBqt": "single_sfwd_lessons.82ba56e8.js",
    "i3DSr": "modal.75c044b4.js",
    "eXy0m": "advertise.aa3587ec.js",
    "ai1BE": "chartjs-plugin-datalabels.esm.ae02d30a.js",
    "b66gi": "chart.83696c0b.js",
    "gRaqt": "thank-you.a750fbd7.js",
    "b6Tps": "carousel.7d635f61.js",
    "6hIjN": "carousel.49bd878e.js"
});


var $9f8N2 = parcelRequire("9f8N2");
/**
 * Consent-envelope emission (MTN-1439).
 *
 * Serializes the versioned consent envelope — the canonical record of Termly
 * consent state defined in @moneytalksnews/privacy-shared — into the
 * mtn-consent-envelope parent-domain session cookie on every Termly update,
 * so edge consumers (MTN-Tally click capture, and MTN-Tune-Postback through
 * the click record) can distinguish a valid US default-on record from "no
 * trustworthy consent evidence" (MTN-1434 P1-2).
 *
 * Emission points:
 * - once at init, before Termly resolves — a navigation in that window
 *   carries an honest `unresolved` envelope instead of the previous page's
 *   stale state (audit state 12);
 * - on every termlyDataUpdate, with a bumped generation counter;
 * - when Termly's loader fails or the resolution deadline passes.
 *
 * The module also carries the runtime tripwire for Termly's undocumented
 * do_not_sell coupling contract (MTN-1439 consequence 2):
 * - a resolved record grants a non-essential category alongside
 *   do_not_sell: true (the coupling invariant that makes the server-side
 *   category lookup a faithful do-not-sell proxy) → PostHog error
 *   "termly_do_not_sell_coupling_violation". Edge consumers must enforce
 *   the envelope's explicit doNotSell field rather than infer it from the
 *   categories.
 */ /**
 * Versioned consent envelope — the canonical record of Termly consent state
 * at the browser-to-edge boundary (MTN-1439, MTN-1434 decision addendum).
 *
 * The envelope lets downstream consumers (MTN-Tally click capture,
 * MTN-Tune-Postback conversion gates) distinguish a valid US default-on
 * record from "no trustworthy consent evidence". Today both arrive as a bare
 * category list or `null` and are indistinguishable (audit finding P1-2).
 *
 * Contract rules, encoded in the authority helpers below:
 *
 * 1. The resolved category list is the SOLE authority for category
 *    processing: presence allows, omission denies.
 * 2. `region`, `country`, `mode`, `source`, `gpc`, and default provenance
 *    (whether a region profile granted categories by default rather than by
 *    choice) explain the result but NEVER grant a category or override its
 *    omission. `gpc` additionally denies, as `do_not_sell` always has: on
 *    any observed envelope each reduces a consumer's grant to essential
 *    only (MTN-1474 for `gpc`).
 * 3. A missing, failed, slow, or malformed Termly result is never a valid
 *    default-on record (`status !== 'resolved'` grants nothing).
 * 4. An unsigned browser value may deny or restrict but never grant. Inside
 *    the emitting page, a resolved envelope is Termly's own report and
 *    `envelopeAllowsCategory` is authoritative. An envelope TRANSPORTED
 *    from the browser (the cookie) is unsigned: an edge consumer may use it
 *    to deny, restrict, or explain, but must confirm any grant with its own
 *    server-side Termly lookup keyed by the UUID. One exception (MTN-1488,
 *    MTN-1527): when that lookup is unknown for a US request, the strictly
 *    parsed resolved envelope is the grant — the US profile is opt-out and
 *    Termly records nothing for a visitor who never touched the banner, so
 *    the envelope is the only record. `effectiveConsent` in
 *    `consent-rule.ts` is the one place that applies it.
 * 5. Essential processing is not consent-gated: `envelopeAllowsCategory`
 *    returns true for `essential` regardless of envelope state.
 *
 * `do_not_sell` is Termly's sale/share opt-out flag, observed from
 * `window.Termly.getConsentState()`. Termly does not document the field
 * publicly, so it is a runtime dependency guarded by contract tests and the
 * coupling tripwire (`violatesDoNotSellCoupling`): Termly couples
 * `do_not_sell: true` with declining every non-essential category
 * (live-verified 2026-08-12), which is what makes the server-side category
 * lookup a faithful do-not-sell proxy. If that coupling ever breaks, the
 * tripwire fires and a server-side do-not-sell mirror becomes necessary.
 *
 * Schema versioning: bump {@link CONSENT_ENVELOPE_VERSION} on any breaking
 * field change; `parseConsentEnvelope` rejects unknown versions so edge
 * consumers degrade to "no trustworthy evidence" instead of misreading.
 */ /**
 * Cookie header parsing + UUID validation, used by the mtn-id worker
 * and the DSR worker's verification flow.
 */ const $448435569005ede5$var$UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function $448435569005ede5$export$d2e637738f5e6ae8(header) {
    if (!header) return {};
    const result = {};
    for (const pair of header.split(';')){
        const eq = pair.indexOf('=');
        if (eq === -1) continue;
        const name = pair.slice(0, eq).trim();
        const value = pair.slice(eq + 1).trim();
        if (name && value) result[name] = value;
    }
    return result;
}
function $448435569005ede5$export$6ad459db9a6bcc76(value) {
    return typeof value === 'string' && $448435569005ede5$var$UUID_RE.test(value);
}


const $ea9dd907f5e146eb$export$dd7d9570fe73052 = 1;
const $ea9dd907f5e146eb$export$686dcd50e8fedde3 = 'mtn-consent-envelope';
const $ea9dd907f5e146eb$export$12d20ee36c1967c8 = [
    'essential',
    'performance',
    'analytics',
    'advertising',
    'social_networking',
    'unclassified'
];
const $ea9dd907f5e146eb$var$EMPTY_FLAGS = Object.freeze({
    essential: false,
    performance: false,
    analytics: false,
    advertising: false,
    social_networking: false,
    unclassified: false
});
function $ea9dd907f5e146eb$var$isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function $ea9dd907f5e146eb$var$isStringArray(value) {
    return Array.isArray(value) && value.every((v)=>typeof v === 'string');
}
function $ea9dd907f5e146eb$var$deriveStatus(termlyData, loadFailed) {
    if (termlyData === null || termlyData === undefined) return loadFailed ? 'failed' : 'unresolved';
    if ($ea9dd907f5e146eb$var$isRecord(termlyData) && $ea9dd907f5e146eb$var$isStringArray(termlyData.categories)) return 'resolved';
    return 'malformed';
}
function $ea9dd907f5e146eb$var$deriveCategories(status, termlyData) {
    const categories = {
        ...$ea9dd907f5e146eb$var$EMPTY_FLAGS
    };
    if (status === 'resolved') {
        const list = termlyData.categories;
        for (const category of $ea9dd907f5e146eb$export$12d20ee36c1967c8)categories[category] = list.includes(category);
    }
    return categories;
}
// Deny-side signal, read from whatever is observable, resolved or not — an
// unsigned value may deny but never grant (rule 4). Truthy, not === true,
// so a type drift ("true", 1) still reads as opted out.
function $ea9dd907f5e146eb$var$deriveDoNotSell(termlyData, record) {
    const consentState = $ea9dd907f5e146eb$var$isRecord(termlyData) ? termlyData.consentState : null;
    return Boolean($ea9dd907f5e146eb$var$isRecord(consentState) && consentState.do_not_sell || record?.do_not_sell);
}
function $ea9dd907f5e146eb$export$687f2daa52b51ea7(input) {
    const { termlyData: termlyData, loadFailed: loadFailed = false } = input;
    const record = $ea9dd907f5e146eb$var$isRecord(input.consentRecord) ? input.consentRecord : null;
    const status = $ea9dd907f5e146eb$var$deriveStatus(termlyData, loadFailed);
    const gpc = status === 'resolved' && record ? Boolean(record.gpc) : Boolean(record?.gpc || input.gpcSignal);
    const rawUuid = $ea9dd907f5e146eb$var$isRecord(termlyData) ? termlyData.uuid : null;
    const uuid = (0, $448435569005ede5$export$6ad459db9a6bcc76)(rawUuid) ? rawUuid : null;
    const rawPolicyVersion = record?.template_version_id;
    const policyVersion = typeof rawPolicyVersion === 'string' || typeof rawPolicyVersion === 'number' ? String(rawPolicyVersion) : null;
    const rawSource = record?.event_type;
    const source = typeof rawSource === 'string' ? rawSource : null;
    const settings = $ea9dd907f5e146eb$var$isRecord(input.regionSettings) ? input.regionSettings : null;
    const region = typeof settings?.region === 'string' ? settings.region : null;
    const mode = typeof settings?.consent_mode === 'string' ? settings.consent_mode : null;
    return {
        v: $ea9dd907f5e146eb$export$dd7d9570fe73052,
        status: status,
        country: input.country ?? null,
        region: region,
        mode: mode,
        source: source,
        categories: $ea9dd907f5e146eb$var$deriveCategories(status, termlyData),
        doNotSell: $ea9dd907f5e146eb$var$deriveDoNotSell(termlyData, record),
        gpc: gpc,
        uuid: uuid,
        policyVersion: policyVersion,
        observedAt: input.observedAt,
        generation: input.generation
    };
}
function $ea9dd907f5e146eb$export$db0473ac22160d6a(envelope) {
    return envelope != null && envelope.v === $ea9dd907f5e146eb$export$dd7d9570fe73052 && envelope.status === 'resolved';
}
function $ea9dd907f5e146eb$export$40118f8aba806023(envelope, category) {
    if (category === 'essential') return true;
    return $ea9dd907f5e146eb$export$db0473ac22160d6a(envelope) && envelope.categories[category] === true;
}
function $ea9dd907f5e146eb$export$89e9ffda65ee3de5(envelope) {
    return envelope != null && Boolean(envelope.doNotSell);
}
function $ea9dd907f5e146eb$export$de89d6d00389dd4e(envelope) {
    return envelope != null && Boolean(envelope.gpc);
}
function $ea9dd907f5e146eb$export$4979007e3493d98b(envelope) {
    if (!$ea9dd907f5e146eb$export$db0473ac22160d6a(envelope) || !envelope.doNotSell) return false;
    return $ea9dd907f5e146eb$export$12d20ee36c1967c8.some((category)=>category !== 'essential' && envelope.categories[category]);
}
function $ea9dd907f5e146eb$export$45300c855297219b(envelope) {
    if (!$ea9dd907f5e146eb$export$db0473ac22160d6a(envelope)) return null;
    return $ea9dd907f5e146eb$export$12d20ee36c1967c8.filter((category)=>envelope.categories[category]);
}
function $ea9dd907f5e146eb$export$78c9c309e1c76d28(envelope) {
    return encodeURIComponent(JSON.stringify(envelope));
}
const $ea9dd907f5e146eb$var$ENVELOPE_STATUSES = [
    'resolved',
    'unresolved',
    'failed',
    'malformed'
];
function $ea9dd907f5e146eb$var$hasValidScalarFields(candidate) {
    if (typeof candidate.doNotSell !== 'boolean' || typeof candidate.gpc !== 'boolean' || typeof candidate.observedAt !== 'string' || typeof candidate.generation !== 'number' || !Number.isFinite(candidate.generation)) return false;
    if (candidate.uuid !== null && !(0, $448435569005ede5$export$6ad459db9a6bcc76)(candidate.uuid)) return false;
    return [
        'country',
        'region',
        'mode',
        'source',
        'policyVersion'
    ].every((field)=>{
        const value = candidate[field];
        return value === null || typeof value === 'string';
    });
}
function $ea9dd907f5e146eb$var$isWellFormedEnvelope(candidate) {
    if (candidate.v !== $ea9dd907f5e146eb$export$dd7d9570fe73052) return false;
    if (!$ea9dd907f5e146eb$var$ENVELOPE_STATUSES.includes(candidate.status)) return false;
    if (!$ea9dd907f5e146eb$var$isRecord(candidate.categories)) return false;
    const flags = candidate.categories;
    return $ea9dd907f5e146eb$export$12d20ee36c1967c8.every((category)=>typeof flags[category] === 'boolean') && $ea9dd907f5e146eb$var$hasValidScalarFields(candidate);
}
function $ea9dd907f5e146eb$export$ff041225e1a09248(raw) {
    if (!raw) return null;
    let parsed;
    try {
        parsed = JSON.parse(decodeURIComponent(raw));
    } catch  {
        return null;
    }
    if (!$ea9dd907f5e146eb$var$isRecord(parsed) || !$ea9dd907f5e146eb$var$isWellFormedEnvelope(parsed)) return null;
    const candidate = parsed;
    const flags = candidate.categories;
    const categories = {
        ...$ea9dd907f5e146eb$var$EMPTY_FLAGS
    };
    for (const category of $ea9dd907f5e146eb$export$12d20ee36c1967c8)categories[category] = flags[category];
    return {
        v: $ea9dd907f5e146eb$export$dd7d9570fe73052,
        status: candidate.status,
        country: candidate.country,
        region: candidate.region,
        mode: candidate.mode,
        source: candidate.source,
        categories: categories,
        doNotSell: candidate.doNotSell,
        gpc: candidate.gpc,
        uuid: candidate.uuid,
        policyVersion: candidate.policyVersion,
        observedAt: candidate.observedAt,
        generation: candidate.generation
    };
}



var $f3UsM = parcelRequire("f3UsM");

var $99uU9 = parcelRequire("99uU9");

var $H9wys = parcelRequire("H9wys");
// Matches the PostHog wrapper's own Termly deadline: after this long with no
// Termly result the envelope reports `failed` rather than `unresolved`.
const $bc5bdab3dbfacc0c$var$RESOLVE_TIMEOUT_MS = 8000;
let $bc5bdab3dbfacc0c$var$generation = 0;
let $bc5bdab3dbfacc0c$var$loadFailed = false;
let $bc5bdab3dbfacc0c$var$firedCouplingTripwire = false;
/**
 * Termly's own stored consent record, which carries fields
 * getConsentState() omits (do_not_sell, gpc, event_type,
 * template_version_id). Vendor
 * localStorage read defensively — absence or a shape change degrades the
 * envelope's optional fields to null instead of breaking emission.
 */ const $bc5bdab3dbfacc0c$var$readTermlyConsentRecord = ()=>{
    try {
        const cache = JSON.parse(window.localStorage.getItem("TERMLY_API_CACHE") || "{}");
        const record = cache?.TERMLY_COOKIE_CONSENT?.value;
        if (!record || typeof record !== "object" || Array.isArray(record)) return null;
        if (typeof record.do_not_sell === "boolean") return record;
        return {
            ...record,
            do_not_sell: undefined
        };
    } catch  {
        return null;
    }
};
const $bc5bdab3dbfacc0c$var$fireTripwires = (envelope)=>{
    if (!$bc5bdab3dbfacc0c$var$firedCouplingTripwire && (0, $ea9dd907f5e146eb$export$4979007e3493d98b)(envelope)) {
        $bc5bdab3dbfacc0c$var$firedCouplingTripwire = true;
        (0, $99uU9.captureMessage)("termly_do_not_sell_coupling_violation", {
            categories: JSON.stringify(envelope.categories),
            source: "consent-envelope"
        });
        // A coupling breach may leave Analytics granted or denied. Mirror the
        // alarm onto the always-on identifier-free Plausible baseline (MTN-334)
        // so it stays audible in either case.
        window.mtnPlausible?.("Termly Coupling Violation");
    }
};
const $bc5bdab3dbfacc0c$var$emit = ()=>{
    const envelope = (0, $ea9dd907f5e146eb$export$687f2daa52b51ea7)({
        consentRecord: $bc5bdab3dbfacc0c$var$readTermlyConsentRecord(),
        generation: $bc5bdab3dbfacc0c$var$generation,
        gpcSignal: navigator.globalPrivacyControl === true,
        loadFailed: $bc5bdab3dbfacc0c$var$loadFailed,
        observedAt: new Date().toISOString(),
        regionSettings: window.termlyRegionSettings,
        termlyData: window.termlyData
    });
    // set() URI-encodes the value, so the wire format equals
    // serializeConsentEnvelope(envelope) and parseConsentEnvelope reads it
    // back directly (locked by the wire-format test). Session-lifetime on
    // purpose: consent evidence should not outlive the browsing session —
    // the edge re-checks via mtn-termly-uuid for anything longer-lived.
    (0, $f3UsM.setIfChanged)((0, $ea9dd907f5e146eb$export$686dcd50e8fedde3), JSON.stringify(envelope), {
        parent: true
    });
    $bc5bdab3dbfacc0c$var$fireTripwires(envelope);
};
const $bc5bdab3dbfacc0c$export$a5231bebc30972bc = ()=>{
    document.addEventListener("termlyDataUpdate", ()=>{
        $bc5bdab3dbfacc0c$var$generation += 1;
        $bc5bdab3dbfacc0c$var$emit();
    });
    // Region settings arrive on Termly's `initialized` event (stashed by
    // head.blade.php), usually between the unresolved init emission and the
    // first consent event. Metadata only — the generation counts consent
    // changes, so it does not bump here.
    document.addEventListener("termlyRegionSettings", $bc5bdab3dbfacc0c$var$emit);
    // Loader failure or the resolution deadline — one settled callback,
    // canceled if Termly resolves first (util/termly.js). Late resolution
    // after a failure still recovers: termlyDataUpdate above re-emits.
    (0, $H9wys.onUnavailable)(()=>{
        $bc5bdab3dbfacc0c$var$loadFailed = true;
        $bc5bdab3dbfacc0c$var$emit();
    }, {
        timeoutMs: $bc5bdab3dbfacc0c$var$RESOLVE_TIMEOUT_MS
    });
    $bc5bdab3dbfacc0c$var$emit();
};



var $bbD2C = parcelRequire("bbD2C");

var $99uU9 = parcelRequire("99uU9");

var $99uU9 = parcelRequire("99uU9");
const $2723ab7b4ecb8b66$var$AB_FLAG = "solutions-icon-style-v1";
const $2723ab7b4ecb8b66$var$AA_FLAG = "solutions-icon-aa-v1";
let $2723ab7b4ecb8b66$var$started = false;
const $2723ab7b4ecb8b66$export$69c79b9849f99d4 = ()=>{
    const experiment = window.mtnSolutionsIconExperiment;
    if ($2723ab7b4ecb8b66$var$started || !experiment || experiment.preview || document.documentElement.dataset.scIcons !== "pending") return;
    $2723ab7b4ecb8b66$var$started = true;
    const flag = experiment.aa ? $2723ab7b4ecb8b66$var$AA_FLAG : $2723ab7b4ecb8b66$var$AB_FLAG;
    const validVariants = experiment.aa ? [
        "control",
        "test"
    ] : [
        "control",
        "emoji"
    ];
    let stop = ()=>undefined;
    const cleanup = ()=>{
        stop();
        document.removeEventListener("mtn-solutions-icons-settled", cleanup);
    };
    document.addEventListener("mtn-solutions-icons-settled", cleanup);
    stop = (0, $99uU9.watchFeatureFlagVariant)(flag, (variant)=>{
        if (!validVariants.includes(variant)) {
            experiment.settle();
            return;
        }
        if (experiment.settle(experiment.aa ? "control" : variant)) // The first read was silent. Only applied assignments record exposure.
        (0, $99uU9.getFeatureFlagVariant)(flag, null);
    });
    // onFeatureFlags may synchronously report an already-loaded assignment.
    if (document.documentElement.dataset.scIcons !== "pending") cleanup();
};



var $6XKmh = parcelRequire("6XKmh");
(0, $9f8N2.install)();
(0, $bc5bdab3dbfacc0c$export$a5231bebc30972bc)();
(0, $bbD2C.initConsentLifecycle)();
(0, $6XKmh.initTuneLinkClickIdHandler)();
(0, $99uU9.init)();
(0, $2723ab7b4ecb8b66$export$69c79b9849f99d4)();
/**
 * Load a route, then call its two lifecycle methods.
 * @param {Promise} routeImport - A dynamic import promise
 * @returns {Promise} - A promise
 */ const $437a138dbcb38a22$var$fire = async (routeImport)=>{
    const { default: route } = await routeImport;
    route.init();
    route.finalize();
};











(()=>{
    // Recommender (deferred - doesn't block page load)
    // Auto-initializes on first use, all calls safely wait for initialization
    (parcelRequire("e7Fk4")).then((recommender)=>recommender.recommenderUserID());
    // Common JS
    $437a138dbcb38a22$var$fire((parcelRequire("4udSq")));
    // Look for page specific JS
    if (document.body.classList.contains("home")) $437a138dbcb38a22$var$fire((parcelRequire("n2M6R")));
    if (document.body.classList.contains("single")) $437a138dbcb38a22$var$fire((parcelRequire("1TkTM")));
    if (document.body.classList.contains("single-sfwd-lessons")) $437a138dbcb38a22$var$fire((parcelRequire("kyJ9C")));
    if (document.body.classList.contains("page") && document.body.classList.contains("advertise")) $437a138dbcb38a22$var$fire((parcelRequire("dUEk9")));
    if (document.body.classList.contains("page") && document.body.classList.contains("thank-you")) $437a138dbcb38a22$var$fire((parcelRequire("6BtLT")));
    // Visitor-keyed "For You" box for any non-home, non-single page that
    // renders the sidebar (for example, /popular/, /category/*, /tag/*,
    // /author/*).
    // routes/home.js and routes/single.js populate #sidebar-read-next on
    // their own; this catches the rest so the sidebar isn't empty for
    // newsletter subscribers / paying members.
    if (document.getElementById("sidebar-read-next") && !document.body.classList.contains("home") && !document.body.classList.contains("single")) (parcelRequire("idaNn")).then((m)=>m.initForVisitor());
    // When the document is ready, dynamically load modules for items present in the DOM
    (parcelRequire("8CECY")).then((mtn)=>{
        mtn.ready(()=>{
            // Fire any routes that are dependent on items in the page being present
            const carousel = document.querySelector(".carousel");
            if (carousel !== null) $437a138dbcb38a22$var$fire((parcelRequire("iorie")));
            const amazonBoxes = document.querySelectorAll(".amazon-box:not(.loading):not(.loaded)");
            if (amazonBoxes.length > 0) $437a138dbcb38a22$var$fire((parcelRequire("liFcM")));
        });
    });
})();

})();
//# sourceMappingURL=main.b6faf251.js.map
